/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * OfferType
 * An enumeration.
 */
export enum AghanimOffersSchemasOfferType {
  Sequential = 'sequential',
  Rolling = 'rolling',
  Range = 'range',
  PickOne = 'pick_one',
}

/**
 * OfferType
 * An enumeration.
 */
export enum AghanimEnumsOfferType {
  ItemDiscount = 'item_discount',
  ItemBonus = 'item_bonus',
  General = 'general',
}

/**
 * WebsiteFont
 * An enumeration.
 */
export enum WebsiteFont {
  NotoSans = 'noto-sans',
  Roboto = 'roboto',
  OpenSans = 'open-sans',
  Lato = 'lato',
  Montserrat = 'montserrat',
  Oswald = 'oswald',
  Raleway = 'raleway',
  Merriweather = 'merriweather',
  ConcertOne = 'concert-one',
  Prompt = 'prompt',
  WorkSans = 'work-sans',
  Rubik = 'rubik',
  RussoOne = 'russo-one',
  Inter = 'inter',
  Outfit = 'outfit',
}

/**
 * WebhookMethod
 * An enumeration.
 */
export enum WebhookMethod {
  GET = 'GET',
  POST = 'POST',
}

/**
 * WebhookEventType
 * An enumeration.
 */
export enum WebhookEventType {
  PlayerVerify = 'player.verify',
  ItemAdd = 'item.add',
  ItemRemove = 'item.remove',
  Order = 'order.*',
  OrderPaid = 'order.paid',
  OrderCanceled = 'order.canceled',
  OrderRefunded = 'order.refunded',
  Payment = 'payment.*',
  PaymentSucceeded = 'payment.succeeded',
  PaymentCanceled = 'payment.canceled',
  PaymentChargeback = 'payment.chargeback',
  PaymentDeclined = 'payment.declined',
  PaymentDispute = 'payment.dispute',
  PaymentExpired = 'payment.expired',
  PaymentPending = 'payment.pending',
  PaymentRefunded = 'payment.refunded',
  PaymentRejected = 'payment.rejected',
  PaymentVoided = 'payment.voided',
  CouponRedeemed = 'coupon.redeemed',
  IngamePush = 'ingame.push',
  IngamePopup = 'ingame.popup',
  PlayerIsIdle = 'player.is_idle',
  CampaignCustom = 'campaign.custom',
  PlayerLookup = 'player.lookup',
  StoreGet = 'store.get',
}

/**
 * WebhookEventTrigger
 * An enumeration.
 */
export enum WebhookEventTrigger {
  CouponRedeemed = 'coupon.redeemed',
  OrderPaid = 'order.paid',
  OrderCanceled = 'order.canceled',
  OrderRefunded = 'order.refunded',
  OrderCaptured = 'order.captured',
  HubLogin = 'hub.login',
  HubInteract = 'hub.interact',
  HubRedeem = 'hub.redeem',
  HubPurchase = 'hub.purchase',
  HubFreeItemClaim = 'hub.free_item_claim',
  HubDailyRewardClaim = 'hub.daily_reward_claim',
  HubLoyaltyClaim = 'hub.loyalty_claim',
  HubStoreOpen = 'hub.store.open',
  HubProgressionRewardClaimed = 'hub.progression_reward_claimed',
  HubRollingOfferClaimed = 'hub.rolling_offer_claimed',
  HubPickOneOfferClaimed = 'hub.pick_one_offer_claimed',
  HubLootboxOpen = 'hub.lootbox.open',
  CheckoutPurchase = 'checkout.purchase',
  CheckoutRefund = 'checkout.refund',
  CheckoutCancel = 'checkout.cancel',
  LiveopsExecuteAction = 'liveops.execute_action',
  Test = 'test',
}

/**
 * VideoPlatform
 * An enumeration.
 */
export enum VideoPlatform {
  Youtube = 'youtube',
  Twitch = 'twitch',
}

/**
 * VerifyState
 * An enumeration.
 */
export enum VerifyState {
  Unverified = 'unverified',
  UnderReview = 'under_review',
  Verified = 'verified',
}

/**
 * UserSourceType
 * An enumeration.
 */
export enum UserSourceType {
  S2S = 's2s',
  Hub = 'hub',
  Sdk = 'sdk',
  CheckoutLink = 'checkout_link',
}

/**
 * UnsetType
 * An enumeration.
 */
export enum UnsetType {
  Unset = 'unset',
}

/**
 * UnitedStates
 * An enumeration.
 */
export enum UnitedStates {
  USAL = 'US-AL',
  USMS = 'US-MS',
  USNE = 'US-NE',
  USPR = 'US-PR',
}

/**
 * TokenType
 * An enumeration.
 */
export enum TokenType {
  Attribute = 'attribute',
  CustomAttribute = 'custom_attribute',
  EventAttribute = 'event_attribute',
  CustomEventAttribute = 'custom_event_attribute',
  Operator = 'operator',
  Number = 'number',
  Date = 'date',
  String = 'string',
  Boolean = 'boolean',
  List = 'list',
  Variable = 'variable',
}

/**
 * ThemeRawType
 * An enumeration.
 */
export enum ThemeRawType {
  ColorLight = 'color-light',
  ColorDark = 'color-dark',
  NeutralLight = 'neutral-light',
  NeutralDark = 'neutral-dark',
}

/**
 * TaskStatus
 * An enumeration.
 */
export enum TaskStatus {
  Todo = 'todo',
  Completed = 'completed',
}

/**
 * StoreType
 * An enumeration.
 */
export enum StoreType {
  Default = 'default',
  Special = 'special',
  Rotation = 'rotation',
  LimitedStock = 'limited_stock',
  Webhook = 'webhook',
}

/**
 * StoreTextSize
 * An enumeration.
 */
export enum StoreTextSize {
  Auto = 'auto',
  Small = 'small',
  Normal = 'normal',
  Large = 'large',
}

/**
 * StoreItemBenefitType
 * An enumeration.
 */
export enum StoreItemBenefitType {
  Base = 'base',
  Promotion = 'promotion',
  UserPromotion = 'user_promotion',
  VirtualSku = 'virtual_sku',
  ExtraPromotion = 'extra_promotion',
}

/**
 * StoreImageSize
 * An enumeration.
 */
export enum StoreImageSize {
  Contain = 'contain',
  Cover = 'cover',
  Fill = 'fill',
  None = 'none',
  ScaleDown = 'scale-down',
}

/**
 * StoreCategoryRenderType
 * An enumeration.
 */
export enum StoreCategoryRenderType {
  Default = 'default',
  Carousel = 'carousel',
}

/**
 * StoreCardVersion
 * An enumeration.
 */
export enum StoreCardVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
  New = 'new',
}

/**
 * StoreCardType
 * An enumeration.
 */
export enum StoreCardType {
  Default = 'default',
  Featured = 'featured',
}

/**
 * State
 * An enumeration.
 */
export enum State {
  New = 'new',
  Fuzzy = 'fuzzy',
  Done = 'done',
  Warning = 'warning',
}

/**
 * SortStoreType
 * An enumeration.
 */
export enum SortStoreType {
  Price = 'price',
  Name = 'name',
  Discount = 'discount',
  Position = 'position',
}

/**
 * SortOrder
 * An enumeration.
 */
export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

/**
 * SocialMediaName
 * An enumeration.
 */
export enum SocialMediaName {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Twitter = 'twitter',
  Discord = 'discord',
  Youtube = 'youtube',
  Tiktok = 'tiktok',
  Custom = 'custom',
  Telegram = 'telegram',
  Reddit = 'reddit',
  Linkedin = 'linkedin',
  Twitch = 'twitch',
  Threads = 'threads',
  KakaoTalks = 'kakao_talks',
  Naver = 'naver',
  Line = 'line',
  Vk = 'vk',
}

/**
 * SendStatus
 * An enumeration.
 */
export enum SendStatus {
  Success = 'success',
  Error = 'error',
}

/**
 * SegmentGroupType
 * An enumeration.
 */
export enum SegmentGroupType {
  Static = 'static',
  Dynamic = 'dynamic',
}

/**
 * SectionType
 * An enumeration.
 */
export enum SectionType {
  Home = 'home',
  Store = 'store',
  RedeemCode = 'redeem_code',
  News = 'news',
  Updates = 'updates',
  Events = 'events',
  Watch = 'watch',
  Play = 'play',
  Leaderboard = 'leaderboard',
  Achievement = 'achievement',
  Chat = 'chat',
  Forum = 'forum',
  About = 'about',
  Merch = 'merch',
  Page = 'page',
  Campaign = 'campaign',
}

/**
 * SectionObjectType
 * An enumeration.
 */
export enum SectionObjectType {
  Page = 'page',
  Link = 'link',
}

/**
 * ScreenshotFormFactor
 * An enumeration.
 */
export enum ScreenshotFormFactor {
  Wide = 'wide',
  Narrow = 'narrow',
}

/**
 * SalesChannel
 * An enumeration.
 */
export enum SalesChannel {
  GameHub = 'game_hub',
  Checkout = 'checkout',
  AndroidSdk = 'android_sdk',
  CheckoutLink = 'checkout_link',
}

/**
 * RotationType
 * An enumeration.
 */
export enum RotationType {
  Random = 'random',
  RandomByWeight = 'random_by_weight',
  RoundRobin = 'round_robin',
}

/**
 * Role
 * An enumeration.
 */
export enum Role {
  Admin = 'admin',
  Developer = 'developer',
  Editor = 'editor',
  User = 'user',
  Viewer = 'viewer',
}

/**
 * RewardPointsPriceSource
 * An enumeration.
 */
export enum RewardPointsPriceSource {
  LocalPrice = 'local_price',
  BasePrice = 'base_price',
}

/**
 * ResourceState
 * An enumeration.
 */
export enum ResourceState {
  Active = 'active',
  Archived = 'archived',
}

/**
 * RangeField
 * An enumeration.
 */
export enum RangeField {
  CreatedAt = 'created_at',
  ModifiedAt = 'modified_at',
  StatusUpdatedAt = 'status_updated_at',
}

/**
 * RPIssueStatus
 * An enumeration.
 */
export enum RPIssueStatus {
  Issued = 'issued',
  Revoked = 'revoked',
  Skipped = 'skipped',
  IssueFailed = 'issue_failed',
  RevokeFailed = 'revoke_failed',
}

/**
 * QuickStoreButtonMode
 * An enumeration.
 */
export enum QuickStoreButtonMode {
  Hidden = 'hidden',
  ShowForAll = 'show_for_all',
  ShowForUs = 'show_for_us',
}

/**
 * PublicPaymentMethod
 * Payment methods exposed to customers.
 */
export enum PublicPaymentMethod {
  Card = 'card',
  Paypal = 'paypal',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  Cashapp = 'cashapp',
  Klarna = 'klarna',
  Venmo = 'venmo',
}

/**
 * PrivatePaymentMethod
 * Payment methods used in billing.
 */
export enum PrivatePaymentMethod {
  Cards = 'cards',
  Paypal = 'paypal',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  Cashapppay = 'cashapppay',
  KlarnaAccount = 'klarna_account',
  KlarnaPaynow = 'klarna_paynow',
  Venmo = 'venmo',
}

/**
 * PriceCategory
 * An enumeration.
 */
export enum PriceCategory {
  None = 'none',
  Platform = 'platform',
}

/**
 * PluginType
 * An enumeration.
 */
export enum PluginType {
  Configuration = 'configuration',
  Cron = 'cron',
  Analytics = 'analytics',
  SocialLogin = 'social_login',
  WebhookAdapter = 'webhook_adapter',
  Notification = 'notification',
}

/**
 * PluginFieldType
 * An enumeration.
 */
export enum PluginFieldType {
  Email = 'email',
  String = 'string',
  Textarea = 'textarea',
  Int = 'int',
  Url = 'url',
  List = 'list',
  Boolean = 'boolean',
  Dict = 'dict',
  Select = 'select',
  MultiSelect = 'multi_select',
}

/**
 * PluginCategory
 * An enumeration.
 */
export enum PluginCategory {
  Marketing = 'marketing',
  Accounting = 'accounting',
  Advertising = 'advertising',
  Analytics = 'analytics',
  Productivity = 'productivity',
  Storage = 'storage',
  Monitoring = 'monitoring',
  NewsAndMedia = 'news_and_media',
  Utilities = 'utilities',
  Communication = 'communication',
  SocialLogin = 'social_login',
}

/**
 * Platform
 * An enumeration.
 */
export enum Platform {
  Any = 'any',
  Ios = 'ios',
  Android = 'android',
  Other = 'other',
}

/**
 * PeriodType
 * An enumeration.
 */
export enum PeriodType {
  Month = 'month',
  Week = 'week',
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Second = 'second',
}

/**
 * PayoutRequestStatus
 * An enumeration.
 */
export enum PayoutRequestStatus {
  Review = 'review',
  Approved = 'approved',
}

/**
 * PaymentStatus
 * An enumeration.
 */
export enum PaymentStatus {
  Created = 'created',
  Failed = 'failed',
  Expired = 'expired',
  Voided = 'voided',
  Rejected = 'rejected',
  Done = 'done',
  RefundRequested = 'refund_requested',
  Refunded = 'refunded',
  Dispute = 'dispute',
  Chargeback = 'chargeback',
  Canceled = 'canceled',
}

/**
 * PageLayoutType
 * An enumeration.
 */
export enum PageLayoutType {
  Content = 'content',
  Article = 'article',
  Collection = 'collection',
  Blocks = 'blocks',
}

/**
 * OrderStatus
 * An enumeration.
 */
export enum OrderStatus {
  Created = 'created',
  Captured = 'captured',
  Paid = 'paid',
  Canceled = 'canceled',
  Refunded = 'refunded',
  RefundRequested = 'refund_requested',
  Reattempted = 'reattempted',
  Disputed = 'disputed',
}

/**
 * OrderSourceType
 * An enumeration.
 */
export enum OrderSourceType {
  S2S = 's2s',
  Hub = 'hub',
  Sdk = 'sdk',
  CheckoutLink = 'checkout_link',
}

/**
 * ObjectType
 * An enumeration.
 */
export enum ObjectType {
  Achievement = 'Achievement',
  News = 'News',
  Item = 'Item',
  Leaderboard = 'Leaderboard',
  PageSeo = 'PageSeo',
  Page = 'Page',
  ItemCategory = 'ItemCategory',
  GameSettings = 'GameSettings',
  ItemProperty = 'ItemProperty',
  StoreItem = 'StoreItem',
  DailyReward = 'DailyReward',
  LoyaltySettings = 'LoyaltySettings',
  LoyaltyTier = 'LoyaltyTier',
  Campaign = 'Campaign',
  CreatorProgram = 'CreatorProgram',
  Lootbox = 'Lootbox',
  Website = 'Website',
  RangeOffer = 'RangeOffer',
  SequentialOffer = 'SequentialOffer',
  RollingOffer = 'RollingOffer',
  PickOneOffer = 'PickOneOffer',
  ProgressionProgram = 'ProgressionProgram',
}

/**
 * NormalizationMethod
 * An enumeration.
 */
export enum NormalizationMethod {
  Lower = 'lower',
  Upper = 'upper',
}

/**
 * NewsSortField
 * An enumeration.
 */
export enum NewsSortField {
  Slug = 'slug',
  Title = 'title',
  Description = 'description',
  Date = 'date',
  Datetime = 'datetime',
  Tags = 'tags',
  Category = 'category',
}

/**
 * NewsGroup
 * An enumeration.
 */
export enum NewsGroup {
  Event = 'event',
  Update = 'update',
  Other = 'other',
}

/**
 * NewsCategory
 * An enumeration.
 */
export enum NewsCategory {
  Bugfix = 'bugfix',
  CompanyNews = 'company_news',
  Event = 'event',
  Maintenance = 'maintenance',
  Update = 'update',
}

/**
 * Mode
 * An enumeration.
 */
export enum Mode {
  Dark = 'dark',
  Light = 'light',
  Auto = 'auto',
}

/**
 * MaxPurchaseLimitPeriodType
 * An enumeration.
 */
export enum MaxPurchaseLimitPeriodType {
  Global = 'global',
  Personal = 'personal',
}

/**
 * Marketplace
 * An enumeration.
 */
export enum Marketplace {
  None = 'none',
  AppStore = 'app_store',
  GooglePlay = 'google_play',
  Aghanim = 'aghanim',
  Other = 'other',
}

/**
 * LoyaltyProgramBlockVariant
 * An enumeration.
 */
export enum LoyaltyProgramBlockVariant {
  Standard = 'standard',
  Expanded = 'expanded',
}

/**
 * LootboxViewType
 * An enumeration.
 */
export enum LootboxViewType {
  Default = 'default',
  Roulette = 'roulette',
}

/**
 * LoginType
 * An enumeration.
 */
export enum LoginType {
  UserId = 'user_id',
  Apple = 'apple',
  Discord = 'discord',
  Facebook = 'facebook',
  Google = 'google',
  Telegram = 'telegram',
  CompositeUserId = 'composite_user_id',
  GameLink = 'game_link',
  MultiStepForm = 'multi_step_form',
}

/**
 * LocaleStatus
 * An enumeration.
 */
export enum LocaleStatus {
  Clean = 'clean',
  Translating = 'translating',
  Synchronization = 'synchronization',
  Fuzzy = 'fuzzy',
}

/**
 * Locale
 * Language codes according to ISO 639-1.
 */
export enum Locale {
  Cs = 'cs',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Hi = 'hi',
  Id = 'id',
  It = 'it',
  Ja = 'ja',
  Ko = 'ko',
  Pl = 'pl',
  Pt = 'pt',
  PtBR = 'pt-BR',
  Ru = 'ru',
  Th = 'th',
  Tr = 'tr',
  Uk = 'uk',
  Vi = 'vi',
  Zh = 'zh',
  ZhHant = 'zh-Hant',
}

/**
 * LimitedStockType
 * An enumeration.
 */
export enum LimitedStockType {
  EmulatingRemainder = 'emulating_remainder',
  RealRemainder = 'real_remainder',
}

/**
 * LeaderboardVisibility
 * An enumeration.
 */
export enum LeaderboardVisibility {
  General = 'general',
  Personal = 'personal',
}

/**
 * LatestNewsBlockVariant
 * An enumeration.
 */
export enum LatestNewsBlockVariant {
  Standard = 'standard',
  Carousel = 'carousel',
}

/**
 * JobStatus
 * An enumeration.
 */
export enum JobStatus {
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
  Terminated = 'terminated',
  Canceled = 'canceled',
}

/**
 * JobFunctionName
 * An enumeration.
 */
export enum JobFunctionName {
  Test = 'test',
  TranslateTranslateAll = 'translate.translate_all',
  TranslateSyncAll = 'translate.sync_all',
  TranslateTranslateAndSyncAll = 'translate.translate_and_sync_all',
  StoreImport = 'store.import',
  CalculateStaticSegmentGroup = 'calculate_static_segment_group',
}

/**
 * ItemViewOption
 * An enumeration.
 */
export enum ItemViewOption {
  Default = 'default',
  Skeleton = 'skeleton',
}

/**
 * ItemType
 * An enumeration.
 */
export enum ItemType {
  Item = 'item',
  Currency = 'currency',
  Bundle = 'bundle',
  Lootbox = 'lootbox',
}

/**
 * ItemSource
 * An enumeration.
 */
export enum ItemSource {
  Order = 'order',
  Bonus = 'bonus',
  Bundle = 'bundle',
  Coupon = 'coupon',
  Lootbox = 'lootbox',
}

/**
 * ItemOrderType
 * An enumeration.
 */
export enum ItemOrderType {
  CreatedAt = 'created_at',
  Name = 'name',
  Position = 'position',
}

/**
 * ItemClaimedType
 * An enumeration.
 */
export enum ItemClaimedType {
  StoreItem = 'store_item',
  DailyReward = 'daily_reward',
  LoyaltyProgram = 'loyalty_program',
  Lootbox = 'lootbox',
  ProgressionProgram = 'progression_program',
  RollingProgram = 'rolling_program',
}

/**
 * ImageUsageContext
 * An enumeration.
 */
export enum ImageUsageContext {
  Store = 'store',
  FeaturedBannerMain = 'featured_banner_main',
  FeaturedBannerStore = 'featured_banner_store',
  PaymentReceipt = 'payment_receipt',
}

/**
 * HubPopupContentType
 * An enumeration.
 */
export enum HubPopupContentType {
  Custom = 'custom',
  Item = 'item',
  EventItem = 'event_item',
}

/**
 * GameTaskType
 * An enumeration.
 */
export enum GameTaskType {
  ConfigureApiKeys = 'configure_api_keys',
  ConfigureWebhooks = 'configure_webhooks',
  IntegrateGame = 'integrate_game',
}

/**
 * GameStoreName
 * An enumeration.
 */
export enum GameStoreName {
  AppStore = 'app_store',
  GooglePlay = 'google_play',
  GooglePlayPc = 'google_play_pc',
  Steam = 'steam',
  Amazon = 'amazon',
  Huawei = 'huawei',
  OneStore = 'one_store',
  Custom = 'custom',
  MicrosoftStore = 'microsoft_store',
  GalaxyStore = 'galaxy_store',
  MacAppStore = 'mac_app_store',
  DownloadApk = 'download_apk',
  PlayNow = 'play_now',
}

/**
 * FilterType
 * An enumeration.
 */
export enum FilterType {
  All = 'all',
  Period = 'period',
  Last = 'last',
  Today = 'today',
  Yesterday = 'yesterday',
}

/**
 * FileType
 * An enumeration.
 */
export enum FileType {
  Json = 'json',
  Png = 'png',
  Jpg = 'jpg',
  Jpeg = 'jpeg',
  Webm = 'webm',
  Webp = 'webp',
  Mov = 'mov',
  Gif = 'gif',
  Svg = 'svg',
}

/**
 * DisplayLevelType
 * An enumeration.
 */
export enum DisplayLevelType {
  All = 'all',
  Current = 'current',
}

/**
 * DeviceType
 * An enumeration.
 */
export enum DeviceType {
  Apple = 'Apple',
  Android = 'Android',
  Unknown = 'Unknown',
  Other = 'Other',
}

/**
 * DataGranularity
 * An enumeration.
 */
export enum DataGranularity {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
}

/**
 * DashboardLocale
 * An enumeration.
 */
export enum DashboardLocale {
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
}

/**
 * DailyRewardsBlockVariant
 * An enumeration.
 */
export enum DailyRewardsBlockVariant {
  Expanded = 'expanded',
  Compact = 'compact',
  CompactMobile = 'compact_mobile',
}

/**
 * DailyRewardType
 * An enumeration.
 */
export enum DailyRewardType {
  Basic = 'basic',
  Seasonal = 'seasonal',
}

/**
 * DailyRewardStatus
 * An enumeration.
 */
export enum DailyRewardStatus {
  Active = 'active',
  Paused = 'paused',
  Stopped = 'stopped',
  Scheduled = 'scheduled',
  Completed = 'completed',
}

/**
 * DailyRewardMode
 * An enumeration.
 */
export enum DailyRewardMode {
  Soft = 'soft',
  Hard = 'hard',
}

/**
 * CustomerType
 * An enumeration.
 */
export enum CustomerType {
  SuperAdmin = 'super_admin',
  Staff = 'staff',
  Regular = 'regular',
  Outsourcer = 'outsourcer',
}

/**
 * Currency
 * An enumeration.
 */
export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  AED = 'AED',
  AUD = 'AUD',
  BDT = 'BDT',
  BGN = 'BGN',
  BOB = 'BOB',
  BRL = 'BRL',
  CAD = 'CAD',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CZK = 'CZK',
  DKK = 'DKK',
  DZD = 'DZD',
  EGP = 'EGP',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  HKD = 'HKD',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KRW = 'KRW',
  KZT = 'KZT',
  LKR = 'LKR',
  MAD = 'MAD',
  MMK = 'MMK',
  MOP = 'MOP',
  MXN = 'MXN',
  MYR = 'MYR',
  NGN = 'NGN',
  NOK = 'NOK',
  NZD = 'NZD',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  SAR = 'SAR',
  SEK = 'SEK',
  SGD = 'SGD',
  THB = 'THB',
  TRY = 'TRY',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  VND = 'VND',
  ZAR = 'ZAR',
  RP = 'RP',
}

/**
 * CreatorSocialPlatform
 * An enumeration.
 */
export enum CreatorSocialPlatform {
  Tiktok = 'tiktok',
  Youtube = 'youtube',
  Instagram = 'instagram',
  Threads = 'threads',
  XTwitter = 'x_twitter',
  Facebook = 'facebook',
  Reddit = 'reddit',
  Twitch = 'twitch',
  Other = 'other',
}

/**
 * CouponType
 * An enumeration.
 */
export enum CouponType {
  Bonus = 'bonus',
  Discount = 'discount',
  FreeItem = 'free_item',
  NonBenefit = 'non_benefit',
  DiscountFixed = 'discount_fixed',
  DiscountRewardPoint = 'discount_reward_point',
}

/**
 * CouponGeneratedType
 * An enumeration.
 */
export enum CouponGeneratedType {
  Campaign = 'campaign',
  Receipt = 'receipt',
}

/**
 * Country
 * An enumeration.
 */
export enum Country {
  VA = 'VA',
  MM = 'MM',
  PE = 'PE',
  DK = 'DK',
  PY = 'PY',
  SV = 'SV',
  US = 'US',
  SI = 'SI',
  SG = 'SG',
  CZ = 'CZ',
  KE = 'KE',
  JP = 'JP',
  KR = 'KR',
  NZ = 'NZ',
  KZ = 'KZ',
  AE = 'AE',
  IQ = 'IQ',
  AU = 'AU',
  CL = 'CL',
  QA = 'QA',
  NL = 'NL',
  IN = 'IN',
  GE = 'GE',
  EE = 'EE',
  BM = 'BM',
  AT = 'AT',
  VN = 'VN',
  LI = 'LI',
  KW = 'KW',
  TC = 'TC',
  BR = 'BR',
  PL = 'PL',
  MY = 'MY',
  HK = 'HK',
  MC = 'MC',
  VG = 'VG',
  GI = 'GI',
  SE = 'SE',
  EG = 'EG',
  GH = 'GH',
  CH = 'CH',
  LK = 'LK',
  SA = 'SA',
  SM = 'SM',
  PK = 'PK',
  DE = 'DE',
  TW = 'TW',
  LU = 'LU',
  BO = 'BO',
  FM = 'FM',
  CA = 'CA',
  SK = 'SK',
  LT = 'LT',
  FR = 'FR',
  KY = 'KY',
  LV = 'LV',
  CY = 'CY',
  MX = 'MX',
  RO = 'RO',
  TZ = 'TZ',
  HU = 'HU',
  PH = 'PH',
  MO = 'MO',
  FI = 'FI',
  RS = 'RS',
  EC = 'EC',
  IE = 'IE',
  ID = 'ID',
  OM = 'OM',
  BD = 'BD',
  PA = 'PA',
  UA = 'UA',
  ZA = 'ZA',
  ES = 'ES',
  PT = 'PT',
  NO = 'NO',
  NG = 'NG',
  TH = 'TH',
  IL = 'IL',
  GB = 'GB',
  JO = 'JO',
  IT = 'IT',
  BG = 'BG',
  TR = 'TR',
  BH = 'BH',
  CR = 'CR',
  MA = 'MA',
  HR = 'HR',
  GR = 'GR',
  KH = 'KH',
  CO = 'CO',
  BE = 'BE',
  DZ = 'DZ',
  CN = 'CN',
  AD = 'AD',
  AL = 'AL',
  BA = 'BA',
  IS = 'IS',
  MD = 'MD',
  ME = 'ME',
  MK = 'MK',
  MT = 'MT',
}

/**
 * CommunicationType
 * An enumeration.
 */
export enum CommunicationType {
  Email = 'email',
  AppPush = 'app_push',
  AppPopup = 'app_popup',
  HubPush = 'hub_push',
  HubPopup = 'hub_popup',
  HupLootboxPopup = 'hup_lootbox_popup',
  HubPurchasePopup = 'hub_purchase_popup',
}

/**
 * CarouselDisplayType
 * An enumeration.
 */
export enum CarouselDisplayType {
  Default = 'default',
  Compact = 'compact',
  Alone = 'alone',
}

/**
 * CarouselBlockType
 * An enumeration.
 */
export enum CarouselBlockType {
  Offers = 'offers',
}

/**
 * CardType
 * An enumeration.
 */
export enum CardType {
  Item = 'item',
  ItemBonus = 'item_bonus',
  ItemFeatured = 'item_featured',
  ItemFeaturedBonus = 'item_featured_bonus',
  Bundle = 'bundle',
  BundleBonus = 'bundle_bonus',
  BundleFeatured = 'bundle_featured',
  BundleFeaturedBonus = 'bundle_featured_bonus',
  Lootbox = 'lootbox',
  LootboxBonus = 'lootbox_bonus',
  LootboxFeatured = 'lootbox_featured',
  LootboxFeaturedBonus = 'lootbox_featured_bonus',
  Reward = 'reward',
  Loyalty = 'loyalty',
  Popup = 'popup',
}

/**
 * CampaignUserStatus
 * An enumeration.
 */
export enum CampaignUserStatus {
  Success = 'success',
  Failure = 'failure',
  InProgress = 'in_progress',
  Wait = 'wait',
}

/**
 * CampaignEventType
 * An enumeration.
 */
export enum CampaignEventType {
  GameHubVisit = 'game_hub_visit',
  GameHubVisitStore = 'game_hub_visit_store',
  GameHubFirstLogin = 'game_hub_first_login',
  GameHubLogin = 'game_hub_login',
  AddSegment = 'add_segment',
  CouponRedeemed = 'coupon_redeemed',
  RegisteredInGame = 'registered_in_game',
  GameLogin = 'game_login',
  PurchasedInGame = 'purchased_in_game',
  PurchasedInWeb = 'purchased_in_web',
  AbandonedCart = 'abandoned_cart',
  LevelUp = 'level_up',
  CustomEvent = 'custom_event',
  FreeItemClaimed = 'free_item_claimed',
  DailyRewardClaimed = 'daily_reward_claimed',
  LoyaltyRewardClaimed = 'loyalty_reward_claimed',
  PaymentInsufficientFunds = 'payment_insufficient_funds',
}

/**
 * BonusDisplayType
 * An enumeration.
 */
export enum BonusDisplayType {
  Default = 'default',
  Strikethrough = 'strikethrough',
  BasePlus = 'base-plus',
}

/**
 * BillingAddressCollection
 * An enumeration.
 */
export enum BillingAddressCollection {
  Full = 'full',
  ZipOnly = 'zip_only',
}

/**
 * BenefitType
 * An enumeration.
 */
export enum BenefitType {
  Discount = 'discount',
  DiscountFixed = 'discount_fixed',
  DiscountRewardPoint = 'discount_reward_point',
  BonusQuantity = 'bonus_quantity',
  BonusItem = 'bonus_item',
  NonBenefit = 'non_benefit',
  RewardPointsPercent = 'reward_points_percent',
  RewardPointsFixed = 'reward_points_fixed',
  LoyaltyPointsFixed = 'loyalty_points_fixed',
  LoyaltyPointsPercent = 'loyalty_points_percent',
}

/**
 * BenefitSourceType
 * An enumeration.
 */
export enum BenefitSourceType {
  Global = 'global',
  Offer = 'offer',
  RangeOffer = 'range_offer',
  SequentialOffer = 'sequential_offer',
  Coupon = 'coupon',
  RewardPoints = 'reward_points',
  BonusItem = 'bonus_item',
  ExtraPromotion = 'extra_promotion',
  RollingOffer = 'rolling_offer',
}

/**
 * BackgroundSize
 * An enumeration.
 */
export enum BackgroundSize {
  Contain = 'contain',
  Repeat = 'repeat',
  Cover = 'cover',
}

/**
 * AttrType
 * An enumeration.
 */
export enum AttrType {
  Number = 'number',
  Date = 'date',
  String = 'string',
  Boolean = 'boolean',
  List = 'list',
}

/**
 * AchievementType
 * An enumeration.
 */
export enum AchievementType {
  FirstVisit = 'first_visit',
  FirstPurchase = 'first_purchase',
  RegularVisit = 'regular_visit',
}

/**
 * APIKeyType
 * An enumeration.
 */
export enum APIKeyType {
  Publishable = 'publishable',
  Secret = 'secret',
}

/** ABTestPoint */
export interface ABTestPoint {
  /** Event Node Id */
  event_node_id?: string
  /** A Revenue */
  A_revenue: number
  /** B Revenue */
  B_revenue: number
  /** A Conversion */
  A_conversion: number
  /** B Conversion */
  B_conversion: number
  /** A Count */
  A_count: number
  /** B Count */
  B_count: number
}

/** APIKeyCreate */
export interface APIKeyCreate {
  /** An enumeration. */
  type: APIKeyType
  /** Expires At */
  expires_at?: number
}

/** APIKeyRedacted */
export interface APIKeyRedacted {
  /** An enumeration. */
  type: APIKeyType
  /** Expires At */
  expires_at?: number
  /** Secret Redacted */
  secret_redacted: string
  /** Id */
  id: string
}

/** APIKeyRevealed */
export interface APIKeyRevealed {
  /** An enumeration. */
  type: APIKeyType
  /** Expires At */
  expires_at?: number
  /** Id */
  id: string
  /** Secret */
  secret: string
}

/** AccountDetails */
export interface AccountDetails {
  authorized_signatory?: AuthorizedSignatoryDetails
  /** Business Owners */
  business_owners?: BusinessOwnerDetails[]
  /** Have No Ubo */
  have_no_ubo?: boolean
  company_legal?: CompanyLegalDetails
  /**
   * Contact Email
   * @format email
   */
  contact_email?: string
  /** Primary Contact Info */
  primary_contact_info?: string
  /**
   * Bank Account Details Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  bank_account_details_url?: string
  /** An enumeration. */
  bank_account_currency?: Currency
}

/** AccountRead */
export interface AccountRead {
  details: AccountDetails
  /** An enumeration. */
  verify_state: VerifyState
}

/** AchievementBulkUpdate */
export interface AchievementBulkUpdate {
  /**
   * Name
   * The name of the achievement
   * @minLength 1
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the achievement
   * @maxLength 512
   */
  description?: string
  /**
   * Image Url
   * The URL of the image for the achievement
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Type
   * The type of the achievement
   */
  type?: AchievementType | string
  /**
   * Position
   * The position of the achievement in the list
   */
  position?: number
  /**
   * Id
   * The unique identifier of the achievement
   */
  id: string
}

/** AchievementCreate */
export interface AchievementCreate {
  /**
   * Name
   * The name of the achievement
   * @minLength 1
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the achievement
   * @maxLength 512
   */
  description: string
  /**
   * Image Url
   * The URL of the image for the achievement
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url: string
  /**
   * Type
   * The type of the achievement
   */
  type: AchievementType | string
  /**
   * Position
   * The position of the achievement in the list
   */
  position: number
}

/** AchievementListBlock */
export interface AchievementListBlock {
  /**
   * Block
   * @default "AchievementListBlock"
   */
  block?: 'AchievementListBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
}

/** AchievementRead */
export interface AchievementRead {
  /**
   * Name
   * The name of the achievement
   * @minLength 1
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the achievement
   * @maxLength 512
   */
  description: string
  /**
   * Image Url
   * The URL of the image for the achievement
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url: string
  /**
   * Type
   * The type of the achievement
   */
  type: AchievementType | string
  /**
   * Position
   * The position of the achievement in the list
   */
  position: number
  /**
   * Id
   * The unique identifier of the achievement
   */
  id: string
}

/** AchievementUpdate */
export interface AchievementUpdate {
  /**
   * Name
   * The name of the achievement
   * @minLength 1
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the achievement
   * @maxLength 512
   */
  description?: string
  /**
   * Image Url
   * The URL of the image for the achievement
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Type
   * The type of the achievement
   */
  type?: AchievementType | string
  /**
   * Position
   * The position of the achievement in the list
   */
  position?: number
}

/** AddStoreItemsNode */
export interface AddStoreItemsNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "AddStoreItemsNode"
   */
  model_type?: 'AddStoreItemsNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  item: StoreItemCreate
}

/** AddStoreNode */
export interface AddStoreNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "AddStoreNode"
   */
  model_type?: 'AddStoreNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Store Id */
  store_id: string
}

/** AddToSegmentNode */
export interface AddToSegmentNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "AddToSegmentNode"
   */
  model_type?: 'AddToSegmentNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Segment Id */
  segment_id?: string
  /** Segment Slug */
  segment_slug?: string
}

/** AgeSettings */
export interface AgeSettings {
  /** Min Age */
  min_age?: number
  /** Icon Url */
  icon_url?: string
}

/** AppsFlyerWebSDKPlugin */
export interface AppsFlyerWebSDKPlugin {
  /**
   * Key
   * @default "appsflyer-websdk"
   */
  key?: 'appsflyer-websdk'
  /** Web Dev Key */
  web_dev_key: string
}

/** AuthorizedSignatoryDetails */
export interface AuthorizedSignatoryDetails {
  /**
   * First Name
   * @minLength 1
   */
  first_name: string
  /**
   * Last Name
   * @minLength 1
   */
  last_name: string
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country: string
  /**
   * Job Title
   * @minLength 1
   */
  job_title: string
  /**
   * Email
   * @format email
   */
  email: string
}

/** BackToGameSettings */
export interface BackToGameSettings {
  /** Ios Custom Url Scheme */
  ios_custom_url_scheme?: string | null
  /** Ios Universal Link */
  ios_universal_link?: string | null
  /** Android App Link */
  android_app_link?: string | null
}

/** BannerBlock */
export interface BannerBlock {
  /**
   * Block
   * @default "BannerBlock"
   */
  block?: 'BannerBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Description */
  description?: string
  /** Image Url */
  image_url?: string
  /** Title */
  title?: string
  /** Background Image Size */
  background_image_size?: string
}

/** Benefit */
export interface Benefit {
  /** An enumeration. */
  type: BenefitType
  source: BenefitSource
  /** Data */
  data:
    | ({
        kind: 'discount'
      } & BenefitDiscountData)
    | ({
        kind: 'bonus'
      } & BenefitBonusQuantityData)
    | ({
        kind: 'bonus_item'
      } & BenefitBonusItemData)
    | ({
        kind: 'discount_fixed'
      } & BenefitDiscountFixedData)
    | ({
        kind: 'reward_points'
      } & BenefitRewardPointsData)
    | ({
        kind: 'loyalty_points'
      } & BenefitLoyaltyPointsData)
    | ({
        kind: 'non_benefit'
      } & NonBenefitData)
}

/** BenefitBonusItemData */
export interface BenefitBonusItemData {
  /**
   * Kind
   * @default "bonus_item"
   */
  kind?: 'bonus_item'
  item: BenefitItem
}

/** BenefitBonusQuantityData */
export interface BenefitBonusQuantityData {
  /**
   * Kind
   * @default "bonus"
   */
  kind?: 'bonus'
  /** Bonus Percent */
  bonus_percent: number
  /** Bonus Value */
  bonus_value: number
}

/** BenefitCouponDetails */
export interface BenefitCouponDetails {
  /** Code */
  code: string
  /** Description */
  description?: string
  /** Name */
  name: string
}

/** BenefitDiscountData */
export interface BenefitDiscountData {
  /** Requires Payment Methods */
  requires_payment_methods?: string[]
  /** Requires Payment Method Save */
  requires_payment_method_save?: boolean
  /**
   * Kind
   * @default "discount"
   */
  kind?: 'discount'
  /** Discount Percent */
  discount_percent: number
  /** Discount Amount */
  discount_amount: number
}

/** BenefitDiscountFixedData */
export interface BenefitDiscountFixedData {
  /**
   * Kind
   * @default "discount_fixed"
   */
  kind?: 'discount_fixed'
  /** Discount Amount */
  discount_amount: number
}

/** BenefitItem */
export interface BenefitItem {
  /** Id */
  id: string
  /** Sku */
  sku: string
  /** Name */
  name: string
  /** Description */
  description: string
  /** Image Url */
  image_url: string | ''
  /** An enumeration. */
  type: ItemType
  /** Quantity */
  quantity: number
}

/** BenefitLoyaltyPointsData */
export interface BenefitLoyaltyPointsData {
  /** Requires Payment Methods */
  requires_payment_methods?: string[]
  /** Requires Payment Method Save */
  requires_payment_method_save?: boolean
  /**
   * Kind
   * @default "loyalty_points"
   */
  kind?: 'loyalty_points'
  /** Loyalty Points Percent */
  loyalty_points_percent?: number
  /** Loyalty Points Fixed */
  loyalty_points_fixed?: number
}

/** BenefitOfferDetails */
export interface BenefitOfferDetails {
  /** Description */
  description: string
}

/** BenefitRewardPointsData */
export interface BenefitRewardPointsData {
  /** Requires Payment Methods */
  requires_payment_methods?: string[]
  /** Requires Payment Method Save */
  requires_payment_method_save?: boolean
  /**
   * Kind
   * @default "reward_points"
   */
  kind?: 'reward_points'
  /** Reward Points Percent */
  reward_points_percent?: number
  /** Reward Points Fixed */
  reward_points_fixed?: number
}

/** BenefitRewardPointsDetails */
export interface BenefitRewardPointsDetails {
  /** Reward Points */
  reward_points: number
}

/** BenefitSource */
export interface BenefitSource {
  /** An enumeration. */
  type: BenefitSourceType
  /** Details */
  details?: BenefitCouponDetails | BenefitOfferDetails | BenefitRewardPointsDetails
}

/** BestTriggersData */
export interface BestTriggersData {
  /** Data */
  data: SeriesValue[]
  /** Prev Data */
  prev_data: SeriesValue[]
  /** Total */
  total: PointValue[]
  /** Prev Total */
  prev_total: PointValue[]
}

/** BillingAddress */
export interface BillingAddress {
  /** Iso Code */
  iso_code?: string
  /** Address1 */
  address1?: string
  /** Address2 */
  address2?: string
  /** Address3 */
  address3?: string
  /** City */
  city?: string
  /** Postal */
  postal?: string
  /** Region */
  region?: string
}

/** Block */
export type Block =
  | ({
      block: 'FullNewsBlock'
    } & FullNewsBlock)
  | ({
      block: 'FeaturedNewsBlock'
    } & FeaturedNewsBlock)
  | ({
      block: 'TwitchBlock'
    } & TwitchBlock)
  | ({
      block: 'YoutubeBlock'
    } & YoutubeBlock)
  | ({
      block: 'TextBlock'
    } & TextBlock)
  | ({
      block: 'BannerBlock'
    } & BannerBlock)
  | ({
      block: 'FeaturedItemBlock'
    } & FeaturedItemBlock)
  | ({
      block: 'RedeemCouponBlock'
    } & RedeemCouponBlock)
  | ({
      block: 'LatestNewsBlock'
    } & LatestNewsBlock)
  | ({
      block: 'LeaderboardCardBlock'
    } & LeaderboardCardBlock)
  | ({
      block: 'LeaderboardFullBlock'
    } & LeaderboardFullBlock)
  | ({
      block: 'LeaderboardCollectionBlock'
    } & LeaderboardCollectionBlock)
  | ({
      block: 'StoreBlock'
    } & StoreBlock)
  | ({
      block: 'LimitedStoreBannerBlock'
    } & LimitedStoreBannerBlock)
  | ({
      block: 'AchievementListBlock'
    } & AchievementListBlock)
  | ({
      block: 'FeaturedPageBlock'
    } & FeaturedPageBlock)
  | ({
      block: 'DailyRewardsBlock'
    } & DailyRewardsBlock)
  | ({
      block: 'LoyaltyProgramBlock'
    } & LoyaltyProgramBlock)
  | ({
      block: 'IFrameBlock'
    } & IFrameBlock)
  | ({
      block: 'ImageBannerBlock'
    } & ImageBannerBlock)
  | ({
      block: 'RichContentBlock'
    } & RichContentBlock)
  | ({
      block: 'CarouselBlock'
    } & CarouselBlock)
  | ({
      block: 'SequentialOfferBlock'
    } & SequentialOfferBlock)
  | ({
      block: 'RangeOfferBlock'
    } & RangeOfferBlock)
  | ({
      block: 'ProgressionProgramBlock'
    } & ProgressionProgramBlock)
  | ({
      block: 'RollingOfferBlock'
    } & RollingOfferBlock)
  | ({
      block: 'CarouselNewsBlock'
    } & CarouselNewsBlock)

/** Bonus */
export interface Bonus {
  /** Bonus Value */
  bonus_value: number
  /** Bonus Percent */
  bonus_percent: number
  coupon: CouponBonus
}

/** BonusDropItem */
export interface BonusDropItem {
  /** Id */
  id: string
  /**
   * Weight
   * @min 0
   * @max 1000000
   */
  weight: number
  /** Bonus Percent */
  bonus_percent: number
}

/** BrowserPopupNotificationActionNode */
export interface BrowserPopupNotificationActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "BrowserPopupNotificationActionNode"
   */
  model_type?: 'BrowserPopupNotificationActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Body */
  body?: string
  /** Item Id */
  item_id?: string
  /** Link Created Offer */
  link_created_offer?: boolean
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** An enumeration. */
  content_type?: HubPopupContentType
  /** Button Text */
  button_text?: string
  /** Button Link */
  button_link?: string
  /** Image Url */
  image_url?: string
}

/** BrowserPushNotificationActionNode */
export interface BrowserPushNotificationActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "BrowserPushNotificationActionNode"
   */
  model_type?: 'BrowserPushNotificationActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Body */
  body?: string
  /** Item Id */
  item_id?: string
  /** Link Created Offer */
  link_created_offer?: boolean
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** An enumeration. */
  content_type?: HubPopupContentType
  /** Button Text */
  button_text?: string
  /** Button Link */
  button_link?: string
  /** Image Url */
  image_url?: string
}

/** BulkCampaignUpdate */
export interface BulkCampaignUpdate {
  /** Id */
  id: string
  /** Position */
  position: number
}

/** BusinessOwnerDetails */
export interface BusinessOwnerDetails {
  /**
   * Entity Legal Name
   * @minLength 1
   */
  entity_legal_name: string
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country: string
}

/** CalcPlayerAttributes */
export interface CalcPlayerAttributes {
  /** Purchases Count */
  purchases_count?: number
  /** Purchases Count Rp */
  purchases_count_rp?: number
  /** Active Offers Count */
  active_offers_count?: number
  /** Active Store Promotion Offers Count */
  active_store_promotion_offers_count?: number
  /** Last Purchase Date */
  last_purchase_date?: number
  /** Last Purchase Item Id */
  last_purchase_item_id?: string
  /** Last Purchase Sku Id */
  last_purchase_sku_id?: string
  /** Last Purchase Amount */
  last_purchase_amount?: number
  /** Last Email Date */
  last_email_date?: number
  /** Last App Popup Date */
  last_app_popup_date?: number
  /** Last App Push Date */
  last_app_push_date?: number
  /** Last Hub Push Date */
  last_hub_push_date?: number
  /** Last Hub Popup Date */
  last_hub_popup_date?: number
  /** Last App Popup Coupon Sent */
  last_app_popup_coupon_sent?: number
  /** Last Communication Date */
  last_communication_date?: number
  /** Email */
  email?: string
  /** User Segments */
  user_segments?: string[]
  /** Communication Count */
  communication_count?: number
  /** Claimed Item Ids */
  claimed_item_ids?: string[]
  /** Ltv */
  ltv?: number
  /** Average Check */
  average_check?: number
  /** Last Hub Visit */
  last_hub_visit?: number
  /** Game Hub Login Count */
  game_hub_login_count?: number
  /** Game Hub First Login */
  game_hub_first_login?: number
  /** Lp Balance */
  lp_balance?: number
  /** Rp Balance */
  rp_balance?: number
  /** Unclaimed Tier Number Loyalty Reward */
  unclaimed_tier_number_loyalty_reward?: number
  /** Last Unblocked Date Loyalty Reward Tier */
  last_unblocked_date_loyalty_reward_tier?: number
}

/** CalculateSegmentArgs */
export interface CalculateSegmentArgs {
  /** Segment Group Id */
  segment_group_id: string
}

/** CalculateSegmentFunction */
export interface CalculateSegmentFunction {
  /**
   * Name
   * @default "calculate_static_segment_group"
   */
  name?: 'calculate_static_segment_group'
  args: CalculateSegmentArgs
}

/** Campaign */
export interface Campaign {
  /** Name */
  name: string
  /** Description */
  description?: string
  /** Enabled */
  enabled: boolean
  /** Type */
  type: CampaignEventType | string
  /**
   * Time Limit
   * @default false
   */
  time_limit?: boolean
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Archived At */
  archived_at?: number
  attributes?: PersistentCampaignAttributes
  /** Position */
  position?: number
  /** Allowed Popups On Store */
  allowed_popups_on_store?: boolean
  /** Is Sync */
  is_sync?: boolean
  /** Id */
  id: string
  /** Version */
  version?: string
  /** Created By Customer Id */
  created_by_customer_id?: string
  /** Created From Id */
  created_from_id?: string
  /** Version Description */
  version_description: string
  /** Modified At */
  modified_at?: number
  /** Created At */
  created_at: number
}

/** CampaignAttributes */
export interface CampaignAttributes {
  /** Datetime */
  datetime?: number
  /** Abandoned Sku */
  abandoned_sku?: string
  /** Abandoned Price */
  abandoned_price?: number
  /** Abandoned Is Stackable */
  abandoned_is_stackable?: boolean
  /** Daily Reward Claimed Day Number */
  daily_reward_claimed_day_number?: number
  /** Daily Reward Is Extra Reward */
  daily_reward_is_extra_reward?: boolean
  /** Loyalty Tier Number */
  loyalty_tier_number?: number
  /** Purchase Item Id */
  purchase_item_id?: string
  /** Purchase Sku */
  purchase_sku?: string
  /** Purchase Price */
  purchase_price?: number
  /** Purchase Is Stackable */
  purchase_is_stackable?: boolean
  /** Is Payment Method Saved */
  is_payment_method_saved?: boolean
  /** Coupon Redeemed Item Sku */
  coupon_redeemed_item_sku?: string
  /** Coupon Redeemed Code */
  coupon_redeemed_code?: string
  /** Is First Login */
  is_first_login?: boolean
  /** Items */
  items?: StoreItemRead[]
  /**
   * Detected Country
   * @pattern ^[A-Z]{2}$
   */
  detected_country?: string
  /** Claimed Item Ids */
  claimed_item_ids?: string[]
  /** Item Id */
  item_id?: string
  /** Item Sku */
  item_sku?: string
  /** Item Price */
  item_price?: number
  /** Item Is Stackable */
  item_is_stackable?: boolean
  /** Order Id */
  order_id?: string
  /** Visit Page Slug */
  visit_page_slug?: string
  /** An enumeration. */
  order_source?: OrderSourceType
  /** Payment Method Meta Name */
  payment_method_meta_name?: string
}

/** CampaignCreate */
export interface CampaignCreate {
  /** Name */
  name: string
  /** Description */
  description?: string
  /** Enabled */
  enabled: boolean
  /** Type */
  type: CampaignEventType | string
  /**
   * Time Limit
   * @default false
   */
  time_limit?: boolean
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Archived At */
  archived_at?: number
  attributes?: PersistentCampaignAttributes
  /** Position */
  position?: number
  /** Allowed Popups On Store */
  allowed_popups_on_store?: boolean
  /** Is Sync */
  is_sync?: boolean
  graph?: GraphRoot
  /**
   * Version Description
   * @default "Initial version"
   */
  version_description?: string
}

/** CampaignSettings */
export interface CampaignSettings {
  /**
   * Email Frequency
   * Sets limit to emails for user
   */
  email_frequency?: CommunicationFrequency | null
  /**
   * Mobile Popup Frequency
   * Sets limit to mobile popups for user
   */
  mobile_popup_frequency?: CommunicationFrequency | null
  /**
   * Mobile Push Frequency
   * Sets limit to mobile push for user
   */
  mobile_push_frequency?: CommunicationFrequency | null
  /**
   * Hub Popup Frequency
   * Sets limit to Game Hub popups for user
   */
  hub_popup_frequency?: CommunicationFrequency | null
  /**
   * Hub Push Frequency
   * Sets limit to mobile push from Game Hub for user
   */
  hub_push_frequency?: CommunicationFrequency | null
  /**
   * All Frequency
   * Sets limit to any message for user
   */
  all_frequency?: CommunicationFrequency | null
  /** Liveops Advanced Mode Enabled */
  liveops_advanced_mode_enabled?: boolean | null
  /** Node Analytics Enabled */
  node_analytics_enabled?: boolean | null
}

/** CampaignTemplateCreate */
export interface CampaignTemplateCreate {
  /** An enumeration. */
  type: CampaignEventType
  /** Graph */
  graph?: any
  /** Source Campaign Id */
  source_campaign_id: string
  /** Description */
  description?: string | null
}

/** CampaignTemplateRead */
export interface CampaignTemplateRead {
  /** An enumeration. */
  type: CampaignEventType
  /** Graph */
  graph?: any
  /** Source Campaign Id */
  source_campaign_id: string
  /** Description */
  description?: string | null
  /** Id */
  id: string
}

/** CampaignUpdate */
export interface CampaignUpdate {
  /** Name */
  name?: string
  /** Description */
  description?: string
  /** Enabled */
  enabled?: boolean
  /** Type */
  type?: CampaignEventType | string
  graph?: GraphRoot
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Time Limit */
  time_limit?: boolean
  /** Archived At */
  archived_at?: number
  attributes?: PersistentCampaignAttributes
  /** Position */
  position?: number
  /** Version Description */
  version_description?: string
  /** Allowed Popups On Store */
  allowed_popups_on_store?: boolean
  /** Is Sync */
  is_sync?: boolean
}

/** CampaignUserHistoryItem */
export interface CampaignUserHistoryItem {
  /** Id */
  id: string
  /** Created At */
  created_at: number
  /** Finish At */
  finish_at?: number
  /** User Id */
  user_id: string
  /** Player Id */
  player_id: string
  /** An enumeration. */
  status: CampaignUserStatus
  /** Error Text */
  error_text?: string
  event_action_body?: EventActionBody
  /** Campaign Version */
  campaign_version?: string
}

/** CampaignVersionGraph */
export interface CampaignVersionGraph {
  /** Graph */
  graph?: GraphRoot | null
  /** Version */
  version: string
  /** Version Description */
  version_description?: string | null
}

/** CampaignVersionUpdate */
export interface CampaignVersionUpdate {
  /** Version Description */
  version_description?: string
}

/** CampaignsCount */
export interface CampaignsCount {
  /** All */
  all: number
  /** Archived */
  archived: number
  /** Enabled */
  enabled: number
  /** Disabled */
  disabled: number
}

/** CardTemplateCreate */
export interface CardTemplateCreate {
  /** Name */
  name: string
  /** An enumeration. */
  card_type: CardType
  /** Settings */
  settings?: any
}

/** CardTemplateRead */
export interface CardTemplateRead {
  /** Name */
  name: string
  /** An enumeration. */
  card_type: CardType
  /** Settings */
  settings?: any
  /** Id */
  id: string
}

/** CardTemplateUpdate */
export interface CardTemplateUpdate {
  /** Name */
  name?: string
  /** An enumeration. */
  card_type?: CardType
  /** Settings */
  settings?: any
}

/** CarouselBlock */
export interface CarouselBlock {
  /**
   * Block
   * @default "CarouselBlock"
   */
  block?: 'CarouselBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** An enumeration. */
  type: CarouselBlockType
  /** Delay */
  delay?: number
  /** Loop */
  loop?: boolean
  /** Autoplay */
  autoplay?: boolean
  /** Show Dots */
  show_dots?: boolean
}

/** CarouselNewsBlock */
export interface CarouselNewsBlock {
  /**
   * Block
   * @default "CarouselNewsBlock"
   */
  block?: 'CarouselNewsBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Delay */
  delay?: number
  /** Loop */
  loop?: boolean
  /** Autoplay */
  autoplay?: boolean
  /** Show Dots */
  show_dots?: boolean
}

/** CashbackRewardCreate */
export interface CashbackRewardCreate {
  /**
   * Item Id
   * The item ID of the virtual currency
   */
  item_id: string
  /** From Usd */
  from_usd: number
  /** Reward Points */
  reward_points: number
  /**
   * Published At
   * The published date of the cashback
   */
  published_at?: number
}

/** CashbackRewardRead */
export interface CashbackRewardRead {
  /**
   * Item Id
   * The item ID of the virtual currency
   */
  item_id: string
  /** From Usd */
  from_usd: number
  /** Reward Points */
  reward_points: number
  /**
   * Published At
   * The published date of the cashback
   */
  published_at?: number
  /** Id */
  id: string
  item: ItemRead
}

/** CashbackRewardUpdate */
export interface CashbackRewardUpdate {
  /**
   * Item Id
   * The item ID of the virtual currency
   */
  item_id?: string
  /** From Usd */
  from_usd?: number
  /** Reward Points */
  reward_points?: number
  /**
   * Published At
   * The published date of the cashback
   */
  published_at?: number
}

/** CheckDocsAccessRequest */
export interface CheckDocsAccessRequest {
  /**
   * Email
   * @format email
   */
  email: string
}

/** CheckWebhookItemRequest */
export interface CheckWebhookItemRequest {
  /** An enumeration. */
  event_type: WebhookEventType
  /** Item Id */
  item_id?: string
  /** Store Item Id */
  store_item_id?: string
  /** Player Id */
  player_id?: string
}

/** CheckWebhookPlayerVerifyRequest */
export interface CheckWebhookPlayerVerifyRequest {
  /** Player Id */
  player_id: string
}

/** CheckWebhookRequest */
export interface CheckWebhookRequest {
  /** An enumeration. */
  event_type: WebhookEventType
}

/** CheckWebhookResponse */
export interface CheckWebhookResponse {
  /** Event Id */
  event_id: string
  /** Detail */
  detail: string
  /** Status Code */
  status_code?: number
  /** Response Text */
  response_text?: string
  /** Is Error */
  is_error: boolean
}

/** CheckoutLink */
export interface CheckoutLink {
  /**
   * Item Ids
   * The item IDs
   */
  item_ids: string[]
  /**
   * Start At
   * The start date of the checkout link
   */
  start_at?: number | null
  /**
   * End At
   * The end date of the checkout link
   */
  end_at?: number | null
  /**
   * Discount Percent
   * Discount on the order being created
   */
  discount_percent?: number | null
  /**
   * Bonus Percent
   * Bonus percent on the order being created
   */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * Fixed bonus on the order being created
   */
  bonus_fixed?: number | null
  /**
   * Id
   * The unique identifier of the checkout link
   */
  id: string
}

/** CheckoutLinkBulkUpdate */
export interface CheckoutLinkBulkUpdate {
  /**
   * Item Ids
   * The item IDs
   */
  item_ids?: string[]
  /**
   * Start At
   * The start date of the checkout link
   */
  start_at?: number | null
  /**
   * End At
   * The end date of the checkout link
   */
  end_at?: number | null
  /**
   * Discount Percent
   * Discount on the order being created
   */
  discount_percent?: number | null
  /**
   * Bonus Percent
   * Bonus percent on the order being created
   */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * Fixed bonus on the order being created
   */
  bonus_fixed?: number | null
  /**
   * Archived At
   * The date when the checkout link was archived
   */
  archived_at?: number | null
  /**
   * Id
   * The unique identifier of the checkout link
   */
  id: string
}

/** CheckoutLinkCreate */
export interface CheckoutLinkCreate {
  /**
   * Item Ids
   * The item IDs
   */
  item_ids: string[]
  /**
   * Start At
   * The start date of the checkout link
   */
  start_at?: number | null
  /**
   * End At
   * The end date of the checkout link
   */
  end_at?: number | null
  /**
   * Discount Percent
   * Discount on the order being created
   */
  discount_percent?: number | null
  /**
   * Bonus Percent
   * Bonus percent on the order being created
   */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * Fixed bonus on the order being created
   */
  bonus_fixed?: number | null
}

/** CheckoutLinkRead */
export interface CheckoutLinkRead {
  /**
   * Item Ids
   * The item IDs
   */
  item_ids: string[]
  /**
   * Start At
   * The start date of the checkout link
   */
  start_at?: number | null
  /**
   * End At
   * The end date of the checkout link
   */
  end_at?: number | null
  /**
   * Discount Percent
   * Discount on the order being created
   */
  discount_percent?: number | null
  /**
   * Bonus Percent
   * Bonus percent on the order being created
   */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * Fixed bonus on the order being created
   */
  bonus_fixed?: number | null
  /**
   * Id
   * The unique identifier of the checkout link
   */
  id: string
  /**
   * Created At
   * The date when the checkout link was created
   */
  created_at: number
  /**
   * Archived At
   * The date when the checkout link was archived
   */
  archived_at?: number | null
  /**
   * Items
   * The items of the checkout link than can be purchased
   */
  items: ItemRead[]
  /**
   * Url
   * The URL of the checkout link that can be used to purchase the items
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
}

/** CheckoutLinkUpdate */
export interface CheckoutLinkUpdate {
  /**
   * Item Ids
   * The item IDs
   */
  item_ids?: string[]
  /**
   * Start At
   * The start date of the checkout link
   */
  start_at?: number | null
  /**
   * End At
   * The end date of the checkout link
   */
  end_at?: number | null
  /**
   * Discount Percent
   * Discount on the order being created
   */
  discount_percent?: number | null
  /**
   * Bonus Percent
   * Bonus percent on the order being created
   */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * Fixed bonus on the order being created
   */
  bonus_fixed?: number | null
  /**
   * Archived At
   * The date when the checkout link was archived
   */
  archived_at?: number | null
}

/** CheckoutSettings */
export interface CheckoutSettings {
  /** An enumeration. */
  billing_address_collection: BillingAddressCollection
}

/** CheckoutUser */
export interface CheckoutUser {
  /** Id */
  id: string
  /** Email */
  email?: string
  /** Phone */
  phone?: string
  /** Balance Rp */
  balance_rp?: number
}

/** CommunicationFrequency */
export interface CommunicationFrequency {
  /** An enumeration. */
  period_type: PeriodType
  /** Limit */
  limit: number
}

/** Company */
export interface Company {
  /**
   * Name
   * Company name
   * @maxLength 254
   */
  name: string
  /**
   * Size
   * Number of employees
   * @min 1
   */
  size: number
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /** Domains */
  domains?: string[]
  /** Viewer Domains */
  viewer_domains?: string[]
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  logo_url?: string
  /** An enumeration. */
  instant_payout_status?: PayoutRequestStatus
  /** Id */
  id: string
}

/** CompanyCreate */
export interface CompanyCreate {
  /**
   * Name
   * Company name
   * @maxLength 254
   */
  name: string
  /**
   * Size
   * Number of employees
   * @min 1
   */
  size: number
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /** Domains */
  domains?: string[]
  /** Viewer Domains */
  viewer_domains?: string[]
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  logo_url?: string
  /** An enumeration. */
  instant_payout_status?: PayoutRequestStatus
}

/** CompanyGame */
export interface CompanyGame {
  /**
   * Name
   * Company name
   * @maxLength 254
   */
  name: string
  /**
   * Size
   * Number of employees
   * @min 1
   */
  size: number
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /** Domains */
  domains?: string[]
  /** Viewer Domains */
  viewer_domains?: string[]
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  logo_url?: string
  /** An enumeration. */
  instant_payout_status?: PayoutRequestStatus
  /** Id */
  id: string
  /** Games */
  games?: AghanimGameSchemasGame[]
  /**
   * Is Demo
   * @default false
   */
  is_demo?: boolean
  /** An enumeration. */
  role: Role
}

/** CompanyLegalDetails */
export interface CompanyLegalDetails {
  /**
   * Business Name
   * @minLength 1
   */
  business_name: string
  /**
   * Tin
   * @minLength 1
   */
  tin: string
  /**
   * Dba
   * @minLength 1
   */
  dba: string
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country: string
  /**
   * Address1
   * @minLength 1
   */
  address1: string
  /** Address2 */
  address2: string
  /**
   * City
   * @minLength 1
   */
  city: string
  /**
   * State
   * @minLength 2
   */
  state: string
  /**
   * Postal
   * @minLength 1
   */
  postal: string
  /**
   * Phone
   * @minLength 1
   */
  phone: string
}

/** CompanyUpdate */
export interface CompanyUpdate {
  /** Name */
  name?: string
  /** Size */
  size?: number
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url?: string
  /** Domains */
  domains?: string[]
  /** Viewer Domains */
  viewer_domains?: string[]
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  logo_url?: string
}

/** ConditionNode */
export interface ConditionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "ConditionNode"
   */
  model_type?: 'ConditionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Expression */
  expression?: string
  expr: Expression
  /** True Node Id */
  true_node_id?: string
  /** False Node Id */
  false_node_id?: string
}

/** ConversionFirstPurchase */
export interface ConversionFirstPurchase {
  /** Data */
  data: ConversionHubValue[]
  /** Prev Data */
  prev_data: ConversionHubValue[]
}

/** ConversionHubValue */
export interface ConversionHubValue {
  /** Date */
  date: string
  /** Users Count */
  users_count: number
  /** Payment Users Count */
  payment_users_count: number
}

/** CouponBonus */
export interface CouponBonus {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Code */
  code: string
  /** Bonus Percent */
  bonus_percent: number
}

/** CouponCreate */
export interface CouponCreate {
  /**
   * Item Id
   * The item ID for the coupon
   */
  item_id?: string
  /**
   * Discount Percent
   * The discount percent for the coupon
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the coupon
   * @min 0
   * @max 1000
   */
  bonus_percent?: number
  /**
   * Discount Amount Usd
   * The discount amount in USD for the coupon
   * @min 0
   */
  discount_amount_usd?: number
  /**
   * Requirements Expression
   * The requirement expression for the coupon
   */
  requirements_expression?: Expression
  /**
   * Expires At
   * The expiration date of the coupon
   */
  expires_at?: number
  /**
   * Applicable Item Ids
   * The applicable item IDs
   */
  applicable_item_ids?: string[]
  /**
   * Min Amount
   * Require a minimum order amount to apply the coupon
   */
  min_amount?: number
  /**
   * Max Redemptions
   * Limit the number of times this code can be redeemed
   */
  max_redemptions?: number
  /**
   * Max Redemptions Per User
   * Limit the number of times a user can redeem the coupon
   */
  max_redemptions_per_user?: number
  /**
   * Is Stackable With Bonus Coupons
   * Allow stacking with bonus coupons
   */
  is_stackable_with_bonus_coupons?: boolean
  /**
   * Stackable Bonus Limit Percent
   * Limit the bonus percent when stacking with bonus coupons
   */
  stackable_bonus_limit_percent?: number
  /**
   * Is Stackable With Discount Coupons
   * Allow stacking with discount coupons
   */
  is_stackable_with_discount_coupons?: boolean
  /**
   * Stackable Discount Limit Percent
   * Limit the discount percent when stacking with discount coupons
   */
  stackable_discount_limit_percent?: number
  /**
   * Start At
   * The timestamp when the coupon becomes valid
   */
  start_at?: number
  /**
   * End At
   * The timestamp when the coupon ceases to be valid
   */
  end_at?: number
  /**
   * Player Ids
   * The player IDs that can redeem the coupon
   */
  player_ids?: string[]
  /**
   * Name
   * The name of the coupon
   * @maxLength 255
   */
  name: string
  /**
   * Code
   * The code of the coupon
   * @maxLength 20
   */
  code: string
  /** The type of the coupon */
  type: CouponType
  /**
   * Creator Program
   * The creator program for the coupon
   */
  creator_program?: CreatorProgramBase
}

/** CouponDiscount */
export interface CouponDiscount {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Code */
  code: string
  /** Discount Percent */
  discount_percent: number
}

/** CouponFixedDiscount */
export interface CouponFixedDiscount {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Code */
  code: string
  /** Discount Amount */
  discount_amount: number
}

/** CouponRead */
export interface CouponRead {
  /**
   * Item Id
   * The item ID for the coupon
   */
  item_id?: string
  /**
   * Discount Percent
   * The discount percent for the coupon
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the coupon
   * @min 0
   * @max 1000
   */
  bonus_percent?: number
  /**
   * Discount Amount Usd
   * The discount amount in USD for the coupon
   * @min 0
   */
  discount_amount_usd?: number
  /**
   * Requirements Expression
   * The requirement expression for the coupon
   */
  requirements_expression?: Expression
  /**
   * Expires At
   * The expiration date of the coupon
   */
  expires_at?: number
  /**
   * Applicable Item Ids
   * The applicable item IDs
   */
  applicable_item_ids?: string[]
  /**
   * Min Amount
   * Require a minimum order amount to apply the coupon
   */
  min_amount?: number
  /**
   * Max Redemptions
   * Limit the number of times this code can be redeemed
   */
  max_redemptions?: number
  /**
   * Max Redemptions Per User
   * Limit the number of times a user can redeem the coupon
   */
  max_redemptions_per_user?: number
  /**
   * Is Stackable With Bonus Coupons
   * Allow stacking with bonus coupons
   */
  is_stackable_with_bonus_coupons?: boolean
  /**
   * Stackable Bonus Limit Percent
   * Limit the bonus percent when stacking with bonus coupons
   */
  stackable_bonus_limit_percent?: number
  /**
   * Is Stackable With Discount Coupons
   * Allow stacking with discount coupons
   */
  is_stackable_with_discount_coupons?: boolean
  /**
   * Stackable Discount Limit Percent
   * Limit the discount percent when stacking with discount coupons
   */
  stackable_discount_limit_percent?: number
  /**
   * Start At
   * The timestamp when the coupon becomes valid
   */
  start_at?: number
  /**
   * End At
   * The timestamp when the coupon ceases to be valid
   */
  end_at?: number
  /**
   * Player Ids
   * The player IDs that can redeem the coupon
   */
  player_ids?: string[]
  /**
   * Name
   * The name of the coupon
   * @maxLength 255
   */
  name: string
  /**
   * Code
   * The code of the coupon
   * @maxLength 20
   */
  code: string
  /** The type of the coupon */
  type: CouponType
  /**
   * Id
   * The unique identifier of the coupon
   */
  id: string
  /**
   * Item
   * The item for the coupon
   */
  item?: ItemRead
  /**
   * Creator Program
   * The creator program for the coupon
   */
  creator_program?: CreatorProgramBase
  /**
   * Current Balance Usd
   * The current balance in USD for fixed discount coupon type
   */
  current_balance_usd?: number
}

/** CouponStat */
export interface CouponStat {
  /**
   * Item Id
   * The item ID for the coupon
   */
  item_id?: string
  /**
   * Discount Percent
   * The discount percent for the coupon
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the coupon
   * @min 0
   * @max 1000
   */
  bonus_percent?: number
  /**
   * Discount Amount Usd
   * The discount amount in USD for the coupon
   * @min 0
   */
  discount_amount_usd?: number
  /**
   * Requirements Expression
   * The requirement expression for the coupon
   */
  requirements_expression?: Expression
  /**
   * Expires At
   * The expiration date of the coupon
   */
  expires_at?: number
  /**
   * Applicable Item Ids
   * The applicable item IDs
   */
  applicable_item_ids?: string[]
  /**
   * Min Amount
   * Require a minimum order amount to apply the coupon
   */
  min_amount?: number
  /**
   * Max Redemptions
   * Limit the number of times this code can be redeemed
   */
  max_redemptions?: number
  /**
   * Max Redemptions Per User
   * Limit the number of times a user can redeem the coupon
   */
  max_redemptions_per_user?: number
  /**
   * Is Stackable With Bonus Coupons
   * Allow stacking with bonus coupons
   */
  is_stackable_with_bonus_coupons?: boolean
  /**
   * Stackable Bonus Limit Percent
   * Limit the bonus percent when stacking with bonus coupons
   */
  stackable_bonus_limit_percent?: number
  /**
   * Is Stackable With Discount Coupons
   * Allow stacking with discount coupons
   */
  is_stackable_with_discount_coupons?: boolean
  /**
   * Stackable Discount Limit Percent
   * Limit the discount percent when stacking with discount coupons
   */
  stackable_discount_limit_percent?: number
  /**
   * Start At
   * The timestamp when the coupon becomes valid
   */
  start_at?: number
  /**
   * End At
   * The timestamp when the coupon ceases to be valid
   */
  end_at?: number
  /**
   * Player Ids
   * The player IDs that can redeem the coupon
   */
  player_ids?: string[]
  /**
   * Name
   * The name of the coupon
   * @maxLength 255
   */
  name: string
  /**
   * Code
   * The code of the coupon
   * @maxLength 20
   */
  code: string
  /** The type of the coupon */
  type: CouponType
  /** Id */
  id: string
  item?: Item
  /** Count */
  count: number
}

/** CouponUpdate */
export interface CouponUpdate {
  /**
   * Item Id
   * The item ID for the coupon
   */
  item_id?: string
  /**
   * Discount Percent
   * The discount percent for the coupon
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the coupon
   * @min 0
   * @max 1000
   */
  bonus_percent?: number
  /**
   * Discount Amount Usd
   * The discount amount in USD for the coupon
   * @min 0
   */
  discount_amount_usd?: number
  /**
   * Requirements Expression
   * The requirement expression for the coupon
   */
  requirements_expression?: Expression
  /**
   * Expires At
   * The expiration date of the coupon
   */
  expires_at?: number
  /**
   * Applicable Item Ids
   * The applicable item IDs
   */
  applicable_item_ids?: string[]
  /**
   * Min Amount
   * Require a minimum order amount to apply the coupon
   */
  min_amount?: number
  /**
   * Max Redemptions
   * Limit the number of times this code can be redeemed
   */
  max_redemptions?: number
  /**
   * Max Redemptions Per User
   * Limit the number of times a user can redeem the coupon
   */
  max_redemptions_per_user?: number
  /**
   * Is Stackable With Bonus Coupons
   * Allow stacking with bonus coupons
   */
  is_stackable_with_bonus_coupons?: boolean
  /**
   * Stackable Bonus Limit Percent
   * Limit the bonus percent when stacking with bonus coupons
   */
  stackable_bonus_limit_percent?: number
  /**
   * Is Stackable With Discount Coupons
   * Allow stacking with discount coupons
   */
  is_stackable_with_discount_coupons?: boolean
  /**
   * Stackable Discount Limit Percent
   * Limit the discount percent when stacking with discount coupons
   */
  stackable_discount_limit_percent?: number
  /**
   * Start At
   * The timestamp when the coupon becomes valid
   */
  start_at?: number
  /**
   * End At
   * The timestamp when the coupon ceases to be valid
   */
  end_at?: number
  /**
   * Player Ids
   * The player IDs that can redeem the coupon
   */
  player_ids?: string[]
  /**
   * Name
   * The name of the coupon
   * @maxLength 255
   */
  name?: string
  /**
   * Creator Program
   * The creator program for the coupon
   */
  creator_program?: CreatorProgramUpdate
}

/** CreateCouponNode */
export interface CreateCouponNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "CreateCouponNode"
   */
  model_type?: 'CreateCouponNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Duration */
  duration?: number
  /** An enumeration. */
  type: CouponType
  /** Item Id */
  item_id?: string
  /**
   * Use Event Item
   * @default false
   */
  use_event_item?: boolean
  /** Discount Percent */
  discount_percent?: number
  /** Bonus Percent */
  bonus_percent?: number
  /**
   * Discount Amount Usd
   * The discount amount in USD for the coupon
   */
  discount_amount_usd?: number
  /** Min Amount */
  min_amount?: number
  /** Stackable Bonus Limit */
  stackable_bonus_limit?: number
  /** Stackable Discount Limit */
  stackable_discount_limit?: number
  /** Code Mask */
  code_mask?: string
  /** Player Bond */
  player_bond?: boolean
  /** Applicable Item Ids */
  applicable_item_ids?: string[]
  /** Payment Method Ids */
  payment_method_ids?: string[]
  /** Max Redemptions */
  max_redemptions?: number
  /** Is Stackable With Bonus Coupons */
  is_stackable_with_bonus_coupons?: boolean
  /** Stackable Bonus Limit Percent */
  stackable_bonus_limit_percent?: number
  /** Is Stackable With Discount Coupons */
  is_stackable_with_discount_coupons?: boolean
  /** Stackable Discount Limit Percent */
  stackable_discount_limit_percent?: number
}

/** CreateImageRequest */
export interface CreateImageRequest {
  /** Prompt */
  prompt: string
  /** Size */
  size: '256x256' | '512x512' | '1024x1024' | '1792x1024' | '1024x1792'
}

/** CreateImageResponse */
export interface CreateImageResponse {
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  url: string
}

/** CreateItemBannerActionNode */
export interface CreateItemBannerActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "CreateItemBannerActionNode"
   */
  model_type?: 'CreateItemBannerActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Page Id */
  page_id?: string
  /** Page Slug */
  page_slug?: string
  config: TranslatableFeaturedBannerConfig
  /** Duration */
  duration?: number
  /** Link Created Offer */
  link_created_offer?: boolean
  /**
   * Use Event Item
   * @default false
   */
  use_event_item?: boolean
}

/** CreateUploadLinkRequest */
export interface CreateUploadLinkRequest {
  /** Bucket */
  bucket: string
  /** An enumeration. */
  file_type: FileType
  /** File Hash */
  file_hash?: string
}

/** CreateUploadLinkResponse */
export interface CreateUploadLinkResponse {
  /** Upload Url */
  upload_url: string
  /** Get Url */
  get_url: string
}

/** CreateUserStoreSettingsNode */
export interface CreateUserStoreSettingsNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "CreateUserStoreSettingsNode"
   */
  model_type?: 'CreateUserStoreSettingsNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Store Id */
  store_id?: string
  /** Store Ids */
  store_ids?: string[]
  /** Item Ids */
  item_ids?: string[]
  /** Category Ids */
  category_ids?: string[]
  /** Duration */
  duration: number
  /** Reward Points Percent */
  reward_points_percent?: number
  /** Discount Percent */
  discount_percent?: number
  /** Bonus Percent */
  bonus_percent?: number
  /** Max Purchase Count */
  max_purchase_count?: number
  /** Exclude Items For Reward Points */
  exclude_items_for_reward_points?: boolean
  /** Bonus Item Quantity */
  bonus_item_quantity?: number
  /** Bonus Item Percent */
  bonus_item_percent?: number
  /** Bonus Item Id */
  bonus_item_id?: string
}

/** CreateVirtualSKUNode */
export interface CreateVirtualSKUNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "CreateVirtualSKUNode"
   */
  model_type?: 'CreateVirtualSKUNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Item Id */
  item_id?: string | null
  /**
   * Use Event Item
   * @default false
   */
  use_event_item?: boolean
  /** Start At */
  start_at?: number | null
  /** End At */
  end_at?: number | null
  /** Duration */
  duration?: number | null
  /** Max Purchases */
  max_purchases?: number | null
  /** Min Amount */
  min_amount?: number | null
  /** Max Reward Points Percent */
  max_reward_points_percent?: number | null
  /** Reward Points Percent */
  reward_points_percent?: number | null
  /** Reward Points Fixed */
  reward_points_fixed?: number | null
  /** Payment Method Ids */
  payment_method_ids?: string[] | null
  /** Discount Percent */
  discount_percent?: number | null
  /** Bonus Percent */
  bonus_percent?: number | null
  /** Bonus Fixed */
  bonus_fixed?: number | null
  /** Is Free Item */
  is_free_item?: boolean | null
  max_purchases_period_type?: PeriodType | null
  /** Max Purchases Period Value */
  max_purchases_period_value?: number | null
  max_purchases_limit_type?: MaxPurchaseLimitPeriodType | null
  /** Custom Badge */
  custom_badge?: string | null
  card_type?: StoreCardType | null
  /** Show First On Category List */
  show_first_on_category_list?: boolean | null
  /**
   * Item Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  item_image_url?: string | null
  /** Item Name */
  item_name?: string | null
  /** Item Description */
  item_description?: string | null
  /** Bonus Item Id */
  bonus_item_id?: string | null
  /** Bonus Item Quantity */
  bonus_item_quantity?: number | null
  /** Bonus Item Percent */
  bonus_item_percent?: number | null
  /** Loyalty Points Percent */
  loyalty_points_percent?: number | null
  /** Loyalty Points Fixed */
  loyalty_points_fixed?: number | null
}

/** CreatorCreate */
export interface CreatorCreate {
  /** Name */
  name: string
  /** Email */
  email: string
  /** Avatar Url */
  avatar_url?: string
  /** Social Medias */
  social_medias: CreatorSocial[]
}

/** CreatorNamedSocialPlatform */
export interface CreatorNamedSocialPlatform {
  /** An enumeration. */
  platform: CreatorSocialPlatform
  /** The display name of the social media platform. */
  name: string
}

/** CreatorProgramBase */
export interface CreatorProgramBase {
  /**
   * Creator Id
   * The creator ID
   */
  creator_id: string
  /**
   * Reward
   * The reward for the coupon
   * @min 0
   * @max 100
   */
  reward: number
  /**
   * Verbal Terms
   * The verbal terms for the creator program
   */
  verbal_terms: string
  /**
   * Message
   * The message for the creator program
   */
  message: string
}

/** CreatorProgramUpdate */
export interface CreatorProgramUpdate {
  /**
   * Verbal Terms
   * The verbal terms for the creator program
   */
  verbal_terms?: string
  /**
   * Message
   * The message for the creator program
   */
  message?: string
  /**
   * Reward
   * The reward for the coupon
   * @min 0
   * @max 100
   */
  reward?: number
}

/** CreatorRead */
export interface CreatorRead {
  /** Name */
  name: string
  /** Email */
  email: string
  /** Avatar Url */
  avatar_url?: string
  /** Social Medias */
  social_medias: CreatorSocial[]
  /** Id */
  id: string
  /**
   * Coupon Count
   * @default 0
   */
  coupon_count?: number
  /**
   * Revenue
   * @default 0
   */
  revenue?: number
  /**
   * Balance
   * @default 0
   */
  balance?: number
  terms?: CreatorTermsRead
}

/** CreatorSocial */
export interface CreatorSocial {
  /** Url */
  url: string
  /** An enumeration. */
  platform?: CreatorSocialPlatform
}

/** CreatorTermsCreate */
export interface CreatorTermsCreate {
  /** Legal Name */
  legal_name: string
  /**
   * Date Of Birth
   * @format date
   */
  date_of_birth: string
  /** An enumeration. */
  country: Country
  /** An enumeration. */
  state?: UnitedStates
}

/** CreatorTermsLegality */
export interface CreatorTermsLegality {
  /** Is Minor */
  is_minor: boolean
}

/** CreatorTermsLegalityCondition */
export interface CreatorTermsLegalityCondition {
  /**
   * Date Of Birth
   * @format date
   */
  date_of_birth: string
  /** An enumeration. */
  country: Country
  /** An enumeration. */
  state?: UnitedStates
}

/** CreatorTermsRead */
export interface CreatorTermsRead {
  /** Id */
  id: string
  /** Accepted At */
  accepted_at: number
  /**
   * Date Of Birth
   * @format date
   */
  date_of_birth?: string
  /** An enumeration. */
  country?: Country
  /** An enumeration. */
  state?: UnitedStates
  /** Age */
  age?: number
}

/** CreatorUpdate */
export interface CreatorUpdate {
  /** Name */
  name?: string
  /** Email */
  email?: string
  /** Avatar Url */
  avatar_url?: string
  /** Social Medias */
  social_medias?: CreatorSocial[]
}

/** CustomAttribute */
export interface CustomAttribute {
  /** Name */
  name: string
  /** Description */
  description?: string
  /** An enumeration. */
  type: AttrType
  /** Min */
  min?: number
  /** Max */
  max?: number
  /** Custom Values */
  custom_values?: string[]
  /**
   * Can Use In Deep Link
   * @default false
   */
  can_use_in_deep_link?: boolean
}

/** Customer */
export interface Customer {
  /** Id */
  id: string
  /** Name */
  name?: string
  /** Email */
  email: string
  /** Created At */
  created_at: number
  /**
   * Avatar Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  avatar_url?: string
  /** Last Login At */
  last_login_at?: number
  /** Last Active At */
  last_active_at?: number
  /** An enumeration. */
  locale?: DashboardLocale
  /** An enumeration. */
  type?: CustomerType
}

/** CustomerCompany */
export interface CustomerCompany {
  /** Id */
  id: string
  /** Name */
  name?: string
  /** Email */
  email: string
  /** Created At */
  created_at: number
  /**
   * Avatar Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  avatar_url?: string
  /** Last Login At */
  last_login_at?: number
  /** Last Active At */
  last_active_at?: number
  /** An enumeration. */
  locale?: DashboardLocale
  /** An enumeration. */
  type?: CustomerType
  /** Role */
  role: Role | 'super_admin'
  /** Mode */
  mode: number
}

/** CustomerCompanyRead */
export interface CustomerCompanyRead {
  /** An enumeration. */
  role: Role
  customer: Customer
}

/** CustomerCompanyUpdate */
export interface CustomerCompanyUpdate {
  /** An enumeration. */
  role: Role
}

/** CustomerRead */
export interface CustomerRead {
  /** Id */
  id: string
  /** Name */
  name?: string
}

/** DailyRewardCreate */
export interface DailyRewardCreate {
  /** Enabled */
  enabled: boolean
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * @maxLength 100000
   */
  description: string
  /** Image Url */
  image_url?: string | ''
  /** An enumeration. */
  mode: DailyRewardMode
  rewards: RewardsSettings
  requirements_expression?: Expression
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Position */
  position?: number
  /** @default "basic" */
  type?: DailyRewardType
}

/** DailyRewardRead */
export interface DailyRewardRead {
  /** Enabled */
  enabled: boolean
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * @maxLength 100000
   */
  description: string
  /** Image Url */
  image_url?: string | ''
  /** An enumeration. */
  mode: DailyRewardMode
  rewards: RewardsSettingsRead
  requirements_expression?: Expression
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Position */
  position?: number
  /** Id */
  id: string
  /** An enumeration. */
  type: DailyRewardType
  /** An enumeration. */
  status: DailyRewardStatus
}

/** DailyRewardUpdate */
export interface DailyRewardUpdate {
  /** Enabled */
  enabled?: boolean
  /**
   * Name
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * @maxLength 100000
   */
  description?: string
  /** Image Url */
  image_url?: string | ''
  /** An enumeration. */
  mode?: DailyRewardMode
  rewards?: RewardsSettings
  requirements_expression?: Expression
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Position */
  position?: number
}

/** DailyRewardsBlock */
export interface DailyRewardsBlock {
  /**
   * Block
   * @default "DailyRewardsBlock"
   */
  block?: 'DailyRewardsBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** @default "expanded" */
  variant?: DailyRewardsBlockVariant
}

/** DashboardPaymentRead */
export interface DashboardPaymentRead {
  /**
   * User Id
   * The user ID of the payment
   */
  user_id?: string
  /**
   * Player Id
   * The player ID of the payment
   */
  player_id?: string
  /**
   * Modified At
   * The time of the last modification
   */
  modified_at?: number
  /**
   * Player Name
   * The name of the player
   */
  player_name?: string
  /**
   * Item Id
   * The ID of the purchased item
   */
  item_id?: string
  /**
   * Item Name
   * The name of the purchased item
   */
  item_name?: string
  /**
   * Payment Method Id
   * The ID of the payment method
   */
  payment_method_id?: string
  /**
   * Payment Method Name
   * The name of the payment method
   */
  payment_method_name?: string
  /**
   * Status
   * The status of the payment
   */
  status?: PaymentStatus | string
  /**
   * Currency
   * The currency of the payment
   */
  currency?: string
  /**
   * Country
   * The ISO code country of the payment
   */
  country?: string
  /**
   * Payment Id
   * The ID of the payment
   */
  payment_id?: string
  /**
   * Ps Tx Id
   * The ID of the payment system transaction
   */
  ps_tx_id?: string
  /**
   * Payment Number
   * The number of the payment in receipt
   */
  payment_number?: string
  /**
   * Checkout Profile Id
   * The ID of the user checkout profile
   */
  checkout_profile_id?: string
  /**
   * Order Id
   * The ID of the order
   */
  order_id?: string
  /**
   * Card Last 4 Digits
   * The last 4 digits of the card
   */
  card_last_4_digits?: string
  /**
   * Card Bin
   * The BIN of the card
   */
  card_bin?: string
  /**
   * Card Scheme
   * The scheme of the card
   */
  card_scheme?: string
  /**
   * Total
   * The total amount of the payment
   */
  total?: number
  /**
   * Total Order Currency Billing
   * The total amount of the payment in the billing currency
   */
  total_order_currency_billing?: number
  /**
   * Total Usd
   * The payment amount converted at the exchange rate into dollars (Sales or GMV)
   */
  total_usd?: number
  /**
   * Total Usd Revenue
   * The profit in dollars, that is total_usd excluding all fees and taxes
   */
  total_usd_revenue?: number
  /**
   * User Local Price
   * The total amount in local currency of the payment before all discounts
   */
  user_local_price?: number
  /**
   * Currency Minor Unit
   * The minor unit of the currency
   */
  currency_minor_unit?: number
  /**
   * Fees
   * This includes all charges related to a payment, including the payment system fee, Aghanim fee, conversion, etc
   */
  fees?: object[]
  /**
   * Taxes
   * These are the taxes that arise from sales (the Withholding Tax is not included)
   */
  taxes?: object[]
  /**
   * Refund Customer Id
   * The ID of the refunded customer
   */
  refund_customer_id?: string
  /**
   * Refund Reason
   * The reason of the refund
   */
  refund_reason?: string
  /**
   * Ip
   * The IP address of the payment
   */
  ip?: any
  /**
   * Created At
   * The time of the payment creation
   */
  created_at?: number
  /**
   * Fail Reason
   * The reason of the payment failure
   */
  fail_reason?: string
  /**
   * Fail Reason Code
   * The code of the payment failure reason
   */
  fail_reason_code?: string
  /**
   * Status Updated At
   * The timestamp of the status update
   */
  status_updated_at?: number
  /**
   * Order Field
   * The transaction's serial number in the status list. Can be used to sort the transaction by the status list
   */
  order_field?: number
  /** Campaign Id */
  campaign_id?: string
  /** User Campaign Id */
  user_campaign_id?: string
  /** Billing Email */
  billing_email?: string
  /** User Billing Address */
  user_billing_address?: string
  /** User Name */
  user_name?: string
  /** Amount */
  amount?: number
}

/** DayReward */
export interface DayReward {
  /**
   * Day Number
   * @exclusiveMin 0
   */
  day_number: number
  /**
   * Items
   * @maxItems 10
   * @minItems 1
   */
  items: NestedItem[]
}

/** DayRewardRead */
export interface DayRewardRead {
  /**
   * Day Number
   * @exclusiveMin 0
   */
  day_number: number
  /**
   * Items
   * @maxItems 10
   * @minItems 1
   */
  items: NestedItem[]
  /** Items Read */
  items_read: RewardItem[]
}

/** Developer */
export interface Developer {
  /** Logo Url */
  logo_url?: string
}

/** DevtodevDeviceId */
export interface DevtodevDeviceId {
  /** Deviceid */
  deviceId?: string
  /** Devtodevid */
  devtodevId?: number
  /** Userid */
  userId?: string
  /** Advertisingid */
  advertisingId?: string
}

/** Discount */
export interface Discount {
  /** Amount */
  amount: number
  /** An enumeration. */
  currency: Currency
  coupon: CouponDiscount
}

/** DiscountFixed */
export interface DiscountFixed {
  /** Amount */
  amount: number
  /** An enumeration. */
  currency: Currency
  coupon: CouponFixedDiscount
}

/** DroppedPack */
export interface DroppedPack {
  /**
   * Id
   * Unique identifier for the pack
   */
  id: string
  /**
   * Base Quantity
   * Base quantity of the pack
   */
  base_quantity: number
  /**
   * Max Purchase
   * Maximum number of times the pack can be opened and purchased
   */
  max_purchase: number
  /**
   * Bonuses
   * List of bonus items that can be dropped from the pack
   */
  bonuses: BonusDropItem[]
  /**
   * Image Url
   * URL to the image of the pack
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Background Image Url
   * URL to the background image of the pack
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
  /**
   * Price
   * Price of the pack
   */
  price: number
  /**
   * Price Point
   * Price point of the pack
   */
  price_point: number
  /**
   * Price Template Id
   * Price template ID of the pack
   */
  price_template_id?: string
  /** Bonus Percent */
  bonus_percent: number
  /** Opened At */
  opened_at: number
  /** Order Id */
  order_id?: string
}

/** EmailActionNode */
export interface EmailActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "EmailActionNode"
   */
  model_type?: 'EmailActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Body */
  body?: string
  /** Item Id */
  item_id?: string
  /** Link Created Offer */
  link_created_offer?: boolean
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** An enumeration. */
  content_type?: HubPopupContentType
  /** Button Text */
  button_text?: string
  /** Button Link */
  button_link?: string
}

/** EmailResponse */
export interface EmailResponse {
  /** Html */
  html: string
}

/** EmailTemplate */
export interface EmailTemplate {
  /** Html */
  html: string
  /** Name */
  name: string
}

/** EmptyBlock */
export interface EmptyBlock {
  /**
   * Model Type
   * @default "EmptyBlock"
   */
  model_type?: 'EmptyBlock'
  /** Message */
  message?: string
}

/** EventActionBody */
export interface EventActionBody {
  /**
   * Calc Attributes
   * @default {}
   */
  calc_attributes?: CalcPlayerAttributes
  /**
   * Persistent Attributes
   * @default {"level":0,"marketplace":"none","saved_ach":false,"saved_card":false,"soft_currency_amount":0,"hard_currency_amount":0}
   */
  persistent_attributes?: PersistentPlayerAttributes
  /** Custom Attributes */
  custom_attributes?: object
  campaign_attributes?: CampaignAttributes
  /** Custom Campaign Attributes Values */
  custom_campaign_attributes_values?: object
  /** Variables */
  variables?: MathExpression[]
  /** Variable Values */
  variable_values?: object
}

/** Expression */
export interface Expression {
  /** Tokens */
  tokens?: Token[]
  /** Variables */
  variables?: MathExpression[]
}

/** FAQ */
export interface FAQ {
  /** Title */
  title: string
  /** Description */
  description: string
  /** Order Id */
  order_id: number
  /** Id */
  id: string
}

/** FAQCreate */
export interface FAQCreate {
  /** Title */
  title: string
  /** Description */
  description: string
  /** Order Id */
  order_id: number
}

/** FAQUpdate */
export interface FAQUpdate {
  /** Title */
  title?: string
  /** Description */
  description?: string
  /** Order Id */
  order_id?: number
}

/** FeatureFlags */
export interface FeatureFlags {
  /** Import Store Enabled */
  import_store_enabled?: boolean
  /** Override Colors Enabled */
  override_colors_enabled?: boolean
  /** Experts Enabled */
  experts_enabled?: boolean
  /** Article As Promo Store Enabled */
  article_as_promo_store_enabled?: boolean
  /** Show Reward Points Balance Enabled */
  show_reward_points_balance_enabled?: boolean
  /** Lootbox Enabled */
  lootbox_enabled?: boolean
  /** Sequential Offer Enabled */
  sequential_offer_enabled?: boolean
  /** Theme Editor Token Studio Enabled */
  theme_editor_token_studio_enabled?: boolean
  /** Preload Users Enabled */
  preload_users_enabled?: boolean
  /** Generate Rp Coupons Enabled */
  generate_rp_coupons_enabled?: boolean
  /** Checkout Links Enabled */
  checkout_links_enabled?: boolean
  /** Checkout Seamless Login On S2S Enabled */
  checkout_seamless_login_on_s2s_enabled?: boolean
  /** Checkout Seamless Login On Hub Enabled */
  checkout_seamless_login_on_hub_enabled?: boolean
  /** Checkout Link Sku Enabled */
  checkout_link_sku_enabled?: boolean
  /** Multi Campaigns Enabled */
  multi_campaigns_enabled?: boolean
  /** Source And Device Filter Dashboard Enabled */
  source_and_device_filter_dashboard_enabled?: boolean
  /** Extra Benefit Promotion Enabled */
  extra_benefit_promotion_enabled?: boolean
  /** Card Templates Enabled */
  card_templates_enabled?: boolean
  /** Auto Refund On Decline Order Enabled */
  auto_refund_on_decline_order_enabled?: boolean
  /** Progression Program Enabled */
  progression_program_enabled?: boolean
  /** Checkout Player Info Enabled */
  checkout_player_info_enabled?: boolean
  /** Issue Rp Without User Enabled */
  issue_rp_without_user_enabled?: boolean
  /** Math Expression Enabled */
  math_expression_enabled?: boolean
}

/** FeaturedBannerConfig */
export interface FeaturedBannerConfig {
  /** Title */
  title?: string
  /** Description */
  description?: string
  /** Image Url */
  image_url?: string
  /** Background Image Size */
  background_image_size?: string
  /** Featured Item Id */
  featured_item_id?: string
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** Replace Item Block */
  replace_item_block?: boolean
  /** Replace Item Block Name */
  replace_item_block_name?: string
}

/** FeaturedItemBlock */
export interface FeaturedItemBlock {
  /**
   * Block
   * @default "FeaturedItemBlock"
   */
  block?: 'FeaturedItemBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Item Id */
  item_id?: string
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** Background Image Size */
  background_image_size?: string
}

/** FeaturedNewsBlock */
export interface FeaturedNewsBlock {
  /**
   * Block
   * @default "FeaturedNewsBlock"
   */
  block?: 'FeaturedNewsBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** News Id */
  news_id?: string
  /** Hide Date */
  hide_date?: boolean
}

/** FeaturedPageBlock */
export interface FeaturedPageBlock {
  /**
   * Block
   * @default "FeaturedPageBlock"
   */
  block?: 'FeaturedPageBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Page Id */
  page_id: string
  /**
   * Is Collection
   * @default false
   */
  is_collection?: boolean
  /** Rotation Period */
  rotation_period?: number
  /** Hide Date */
  hide_date?: boolean
}

/** Fees */
export interface Fees {
  /** Payment System Fee Usd */
  payment_system_fee_usd?: number
  /** Aghanim Fee Usd */
  aghanim_fee_usd?: number
  /** Taxes Usd */
  taxes_usd?: number
}

/** FieldListBlock */
export interface FieldListBlock {
  /**
   * Model Type
   * @default "FieldListBlock"
   */
  model_type?: 'FieldListBlock'
  /** Fields */
  fields: PluginField[]
}

/** FullNewsBlock */
export interface FullNewsBlock {
  /**
   * Block
   * @default "FullNewsBlock"
   */
  block?: 'FullNewsBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** News Id */
  news_id?: string
}

/** GameCreate */
export interface GameCreate {
  /**
   * Name
   * @minLength 2
   * @maxLength 200
   */
  name: string
  /**
   * Description
   * @minLength 2
   * @maxLength 1000
   */
  description: string
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  logo_url: string
  /** Social Medias */
  social_medias: SocialMedia[]
  /** Game Stores */
  game_stores: GameStore[]
  login_methods: LoginType[]
  login_settings?: LoginSettings
  /** Language codes according to ISO 639-1. */
  locale_default: Locale
  /** Use Webhook Response Data Schema */
  use_webhook_response_data_schema?: boolean
}

/** GameSettingsCreate */
export interface GameSettingsCreate {
  /** Player Attributes */
  player_attributes?: CustomAttribute[]
  campaign_settings?: CampaignSettings
  /**
   * Purchase Successful Text
   * @maxLength 255
   */
  purchase_successful_text?: string
  /**
   * Receipt Appreciation Text
   * @maxLength 255
   */
  receipt_appreciation_text?: string
  /** Back To Game Settings */
  back_to_game_settings?: BackToGameSettings | null
  feature_flags?: FeatureFlags
  onboarding_progress?: OnboardingProgress
  /** Enable Reward Points */
  enable_reward_points?: boolean
  reward_points_settings?: RewardPointsSettings
  /** Use Only Game Player Country */
  use_only_game_player_country?: boolean
  /** Ignore Game Player Country */
  ignore_game_player_country?: boolean
  /** @default "none" */
  default_marketplace?: Marketplace
  payment_settings?: PaymentSettings
  /** Layout Back To Game Button Enabled */
  layout_back_to_game_button_enabled?: boolean
  /**
   * Layout Back To Game Button Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  layout_back_to_game_button_image_url?: string
  /** Maintenance Enabled */
  maintenance_enabled?: boolean
  /** Maintenance Page Enabled */
  maintenance_page_enabled?: boolean
  /**
   * Maintenance Text
   * @maxLength 100000
   */
  maintenance_text?: string
  /**
   * Maintenance Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  maintenance_image_url?: string
  /** Game Link Button Text */
  game_link_button_text?: string
  /** Menu Header Subtitle Text */
  menu_header_subtitle_text?: string
  /** Web Game Login Custom Title */
  web_game_login_custom_title?: string
  /** Web Game Login Custom Text */
  web_game_login_custom_text?: string
  forced_authorization_expression?: Expression
  whale_expression?: Expression
  /** App Ads Text */
  app_ads_text?: string
  /** Login Form Title */
  login_form_title?: string
  /** Login Form Subtitle */
  login_form_subtitle?: string
  /** Login Form Input Placeholder */
  login_form_input_placeholder?: string
  /** Login Instruction Enabled */
  login_instruction_enabled?: boolean
  /** Login Instruction Title */
  login_instruction_title?: string
  /** Login Instruction Text */
  login_instruction_text?: string
  /**
   * Login Instruction Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  login_instruction_image_url?: string
  /** Enable Purchase Popup */
  enable_purchase_popup?: boolean
}

/** GameSettingsRead */
export interface GameSettingsRead {
  /** Player Attributes */
  player_attributes?: CustomAttribute[]
  campaign_settings?: CampaignSettings
  /** Purchase Successful Text */
  purchase_successful_text?: string
  /** Receipt Appreciation Text */
  receipt_appreciation_text?: string
  /** Back To Game Settings */
  back_to_game_settings?: BackToGameSettings | null
  feature_flags?: FeatureFlags
  onboarding_progress?: OnboardingProgress
  /** Enable Reward Points */
  enable_reward_points?: boolean
  reward_points_settings?: RewardPointsSettings
  /** Use Only Game Player Country */
  use_only_game_player_country?: boolean
  /** Ignore Game Player Country */
  ignore_game_player_country?: boolean
  /** @default "none" */
  default_marketplace?: Marketplace
  payment_settings?: PaymentSettings
  /** Layout Back To Game Button Enabled */
  layout_back_to_game_button_enabled?: boolean
  /**
   * Layout Back To Game Button Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  layout_back_to_game_button_image_url?: string
  /** Maintenance Enabled */
  maintenance_enabled?: boolean
  /** Maintenance Page Enabled */
  maintenance_page_enabled?: boolean
  /**
   * Maintenance Text
   * @maxLength 100000
   */
  maintenance_text?: string
  /**
   * Maintenance Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  maintenance_image_url?: string
  /** Game Link Button Text */
  game_link_button_text?: string
  /** Menu Header Subtitle Text */
  menu_header_subtitle_text?: string
  /** Web Game Login Custom Title */
  web_game_login_custom_title?: string
  /** Web Game Login Custom Text */
  web_game_login_custom_text?: string
  forced_authorization_expression?: Expression
  whale_expression?: Expression
  /** App Ads Text */
  app_ads_text?: string
  /** Login Form Title */
  login_form_title?: string
  /** Login Form Subtitle */
  login_form_subtitle?: string
  /** Login Form Input Placeholder */
  login_form_input_placeholder?: string
  /** Login Instruction Enabled */
  login_instruction_enabled?: boolean
  /** Login Instruction Title */
  login_instruction_title?: string
  /** Login Instruction Text */
  login_instruction_text?: string
  /**
   * Login Instruction Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  login_instruction_image_url?: string
  /** Enable Purchase Popup */
  enable_purchase_popup?: boolean
  /** Id */
  id: string
  /**
   * Last Import Store Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  last_import_store_url?: string
}

/** GameSettingsUpdate */
export interface GameSettingsUpdate {
  /** Player Attributes */
  player_attributes?: CustomAttribute[]
  campaign_settings?: CampaignSettings
  /**
   * Purchase Successful Text
   * @maxLength 255
   */
  purchase_successful_text?: string
  /**
   * Receipt Appreciation Text
   * @maxLength 255
   */
  receipt_appreciation_text?: string
  /** Back To Game Url */
  back_to_game_url?: string
  /** Back To Game Settings */
  back_to_game_settings?: BackToGameSettings | null
  onboarding_progress?: OnboardingProgress
  /** Enable Reward Points */
  enable_reward_points?: boolean
  reward_points_settings?: RewardPointsSettings
  /** Use Only Game Player Country */
  use_only_game_player_country?: boolean
  payment_settings?: PaymentSettings
  /** Layout Back To Game Button Enabled */
  layout_back_to_game_button_enabled?: boolean
  /**
   * Layout Back To Game Button Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  layout_back_to_game_button_image_url?: string
  /** Maintenance Enabled */
  maintenance_enabled?: boolean
  /** Maintenance Page Enabled */
  maintenance_page_enabled?: boolean
  /**
   * Maintenance Text
   * @maxLength 100000
   */
  maintenance_text?: string
  /**
   * Maintenance Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  maintenance_image_url?: string
  /** Game Link Button Text */
  game_link_button_text?: string
  /** Menu Header Subtitle Text */
  menu_header_subtitle_text?: string
  /** Web Game Login Custom Title */
  web_game_login_custom_title?: string
  /** Web Game Login Custom Text */
  web_game_login_custom_text?: string
  forced_authorization_expression?: Expression
  whale_expression?: Expression
  /** App Ads Text */
  app_ads_text?: string
  /** Login Form Title */
  login_form_title?: string
  /** Login Form Subtitle */
  login_form_subtitle?: string
  /** Login Form Input Placeholder */
  login_form_input_placeholder?: string
  /** Login Instruction Enabled */
  login_instruction_enabled?: boolean
  /** Login Instruction Title */
  login_instruction_title?: string
  /** Login Instruction Text */
  login_instruction_text?: string
  /**
   * Login Instruction Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  login_instruction_image_url?: string
  /** Enable Purchase Popup */
  enable_purchase_popup?: boolean
}

/** GameSettingsUpdateFeatures */
export interface GameSettingsUpdateFeatures {
  /** Player Attributes */
  player_attributes?: CustomAttribute[]
  campaign_settings?: CampaignSettings
  /**
   * Purchase Successful Text
   * @maxLength 255
   */
  purchase_successful_text?: string
  /**
   * Receipt Appreciation Text
   * @maxLength 255
   */
  receipt_appreciation_text?: string
  /** Back To Game Url */
  back_to_game_url?: string
  /** Back To Game Settings */
  back_to_game_settings?: BackToGameSettings | null
  onboarding_progress?: OnboardingProgress
  /** Enable Reward Points */
  enable_reward_points?: boolean
  reward_points_settings?: RewardPointsSettings
  /** Use Only Game Player Country */
  use_only_game_player_country?: boolean
  payment_settings?: PaymentSettings
  /** Layout Back To Game Button Enabled */
  layout_back_to_game_button_enabled?: boolean
  /**
   * Layout Back To Game Button Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  layout_back_to_game_button_image_url?: string
  /** Maintenance Enabled */
  maintenance_enabled?: boolean
  /** Maintenance Page Enabled */
  maintenance_page_enabled?: boolean
  /**
   * Maintenance Text
   * @maxLength 100000
   */
  maintenance_text?: string
  /**
   * Maintenance Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  maintenance_image_url?: string
  /** Game Link Button Text */
  game_link_button_text?: string
  /** Menu Header Subtitle Text */
  menu_header_subtitle_text?: string
  /** Web Game Login Custom Title */
  web_game_login_custom_title?: string
  /** Web Game Login Custom Text */
  web_game_login_custom_text?: string
  forced_authorization_expression?: Expression
  whale_expression?: Expression
  /** App Ads Text */
  app_ads_text?: string
  /** Login Form Title */
  login_form_title?: string
  /** Login Form Subtitle */
  login_form_subtitle?: string
  /** Login Form Input Placeholder */
  login_form_input_placeholder?: string
  /** Login Instruction Enabled */
  login_instruction_enabled?: boolean
  /** Login Instruction Title */
  login_instruction_title?: string
  /** Login Instruction Text */
  login_instruction_text?: string
  /**
   * Login Instruction Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  login_instruction_image_url?: string
  /** Enable Purchase Popup */
  enable_purchase_popup?: boolean
  feature_flags?: FeatureFlags
}

/** GameStore */
export interface GameStore {
  /** An enumeration. */
  name: GameStoreName
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /** Custom Name */
  custom_name?: string
  /** Custom Icon Url */
  custom_icon_url?: string
  /** Custom Hub Button Icon Url */
  custom_hub_button_icon_url?: string
}

/** GameTaskRead */
export interface GameTaskRead {
  /** An enumeration. */
  type: GameTaskType
  /** An enumeration. */
  status: TaskStatus
  /** Id */
  id: string
}

/** GameUpdate */
export interface GameUpdate {
  /**
   * Name
   * @minLength 2
   * @maxLength 200
   */
  name?: string
  /**
   * Description
   * @minLength 2
   * @maxLength 1000
   */
  description?: string
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url?: string
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  logo_url?: string
  /** Social Medias */
  social_medias?: SocialMedia[]
  /** Game Stores */
  game_stores?: GameStore[]
  login_methods?: LoginType[]
  login_settings?: LoginSettings
  /** Use Webhook Response Data Schema */
  use_webhook_response_data_schema?: boolean
}

/** GenerationProgress */
export interface GenerationProgress {
  /** Total */
  total: number
  /** Current */
  current: number
}

/** GenerationProgressState */
export interface GenerationProgressState {
  /** Start At */
  start_at?: number
  colors?: GenerationProgress
  background_image?: GenerationProgress
  screenshots?: GenerationProgress
  news?: GenerationProgress
  sku_items?: GenerationProgress
  best_youtube?: GenerationProgress
}

/** GenerationSettings */
export interface GenerationSettings {
  /** Palette */
  palette?: string
  /** Style Keywords */
  style_keywords?: string
  /**
   * News Count
   * @default 6
   */
  news_count?: number
  /**
   * Items Count
   * @default 8
   */
  items_count?: number
  /**
   * Bundles Count
   * @default 4
   */
  bundles_count?: number
  /**
   * Achievements Count
   * @default 9
   */
  achievements_count?: number
  /**
   * Wiki Sections Count
   * @default 3
   */
  wiki_sections_count?: number
  /**
   * Wiki Articles Count
   * @default 3
   */
  wiki_articles_count?: number
  /**
   * Daily Rewards Count
   * @default 7
   */
  daily_rewards_count?: number
  /**
   * Loyalty Levels Count
   * @default 5
   */
  loyalty_levels_count?: number
  /**
   * News Ref Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  news_ref_image_url?: string
  /**
   * Item Ref Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  item_ref_image_url?: string
  /**
   * Bundle Ref Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  bundle_ref_image_url?: string
}

/** GetCompletionRequest */
export interface GetCompletionRequest {
  /** Prompt */
  prompt: string
  /** Context */
  context: string
}

/** GlobalBonus */
export interface GlobalBonus {
  /** Bonus Value */
  bonus_value: number
  /** Bonus Percent */
  bonus_percent: number
}

/** GlobalDiscount */
export interface GlobalDiscount {
  /** Amount */
  amount: number
  /** An enumeration. */
  currency: Currency
  /** Discount Percent */
  discount_percent: number
}

/** GoogleAnalyticsPlugin */
export interface GoogleAnalyticsPlugin {
  /**
   * Key
   * @default "google-analytics"
   */
  key?: 'google-analytics'
  /** Google Analytics Id */
  google_analytics_id: string
}

/** GoogleTagManagerPlugin */
export interface GoogleTagManagerPlugin {
  /**
   * Key
   * @default "google-tag-manager"
   */
  key?: 'google-tag-manager'
  /** Google Tag Manager Id */
  google_tag_manager_id: string
}

/** GraphRoot */
export interface GraphRoot {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "GraphRoot"
   */
  model_type?: string
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Nodes */
  nodes?: Record<string, Node>
  view_port?: ViewPort
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[]
}

/** IFrameBlock */
export interface IFrameBlock {
  /**
   * Block
   * @default "IFrameBlock"
   */
  block?: 'IFrameBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Width */
  width?: string
  /** Height */
  height?: string
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  url: string
  /** Requires Auth */
  requires_auth?: boolean
  /**
   * Popup Background Image
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  popup_background_image?: string
  /**
   * Loading Background Image
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  loading_background_image?: string
  /** Crossplay Disabled */
  crossplay_disabled?: boolean
  /** Is Web Game Iframe */
  is_web_game_iframe?: boolean
  /** Aspect Ratio */
  aspect_ratio?: number
}

/** ImageBannerBlock */
export interface ImageBannerBlock {
  /**
   * Block
   * @default "ImageBannerBlock"
   */
  block?: 'ImageBannerBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Link */
  link?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url: string
}

/** ImageCrop */
export interface ImageCrop {
  image_size: ImageSize
  /** Aspect Ratio */
  aspect_ratio: '1:1' | '4:3'
  transforms?: ImageTransforms
  visible_area?: Rect
  coordinates?: Rect
}

/** ImageFlip */
export interface ImageFlip {
  /** Horizontal */
  horizontal: boolean
  /** Vertical */
  vertical: boolean
}

/** ImageSize */
export interface ImageSize {
  /** Width */
  width: number
  /** Height */
  height: number
}

/** ImageTransforms */
export interface ImageTransforms {
  /** Rotate */
  rotate: number
  flip: ImageFlip
}

/** ImportStoreArgs */
export interface ImportStoreArgs {
  /**
   * Spreadsheet Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  spreadsheet_url: string
}

/** ImportStoreFunction */
export interface ImportStoreFunction {
  /**
   * Name
   * @default "store.import"
   */
  name?: 'store.import'
  args: ImportStoreArgs
}

/** InfinitePaginatedResponse[CompanyGame] */
export interface InfinitePaginatedResponseCompanyGame {
  /** Data */
  data: CompanyGame[]
  /** Has More */
  has_more: boolean
  /** Next Cursor */
  next_cursor?: string
}

/** InfinitePaginatedResponse[PriceTemplateShort] */
export interface InfinitePaginatedResponsePriceTemplateShort {
  /** Data */
  data: PriceTemplateShort[]
  /** Has More */
  has_more: boolean
  /** Next Cursor */
  next_cursor?: string
}

/** InfinitePaginatedResponse[TranslationGlossaryRead] */
export interface InfinitePaginatedResponseTranslationGlossaryRead {
  /** Data */
  data: TranslationGlossaryRead[]
  /** Has More */
  has_more: boolean
  /** Next Cursor */
  next_cursor?: string
}

/** InfinitePaginatedResponse[TranslationHtmlStrippedRead] */
export interface InfinitePaginatedResponseTranslationHtmlStrippedRead {
  /** Data */
  data: TranslationHtmlStrippedRead[]
  /** Has More */
  has_more: boolean
  /** Next Cursor */
  next_cursor?: string
}

/** InviteAcceptResponse */
export interface InviteAcceptResponse {
  /** Company Id */
  company_id: string
  /** Game Id */
  game_id?: string
}

/** InviteCreate */
export interface InviteCreate {
  /** Email */
  email: string
  /** Name */
  name?: string
  /** An enumeration. */
  role: Role
}

/** InvitePreview */
export interface InvitePreview {
  /** Id */
  id: string
  /** Invited By User */
  invited_by_user: string
  /** Company Name */
  company_name: string
  /** An enumeration. */
  role: Role
  /** Is Claimed */
  is_claimed: boolean
}

/** InviteRead */
export interface InviteRead {
  /** Email */
  email: string
  /** Name */
  name?: string
  /** An enumeration. */
  role: Role
  /** Id */
  id: string
  created_by_user: Customer
  /** Created At */
  created_at: number
}

/** IssueRewardPointsResponse */
export interface IssueRewardPointsResponse {
  /** Issued Reward Points */
  issued_reward_points: number
  /** Current Reward Points */
  current_reward_points: number
}

/** Item */
export interface Item {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
  /**
   * Properties
   * The item properties
   */
  properties?: ItemPropertyRelationRead[]
  /** An enumeration. */
  source?: ItemSource
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  item_rarity?: ItemRarityRead
  /**
   * Discount Percent
   * The discount percent for the item
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @min 0
   */
  bonus_percent?: number
  /**
   * Is Custom
   * @default false
   */
  is_custom?: boolean
}

/** ItemBonusOffer */
export interface ItemBonusOffer {
  /** Bonus Percent */
  bonus_percent: number
  /** Bonus Value */
  bonus_value: number
}

/** ItemBonusOfferActionNode */
export interface ItemBonusOfferActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "ItemBonusOfferActionNode"
   */
  model_type?: 'ItemBonusOfferActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Item Id */
  item_id?: string
  /** Discount Percent */
  discount_percent?: number
  /** Bonus Percent */
  bonus_percent?: number
  /** Duration */
  duration?: number
  /**
   * Use Event Item
   * @default false
   */
  use_event_item?: boolean
  /**
   * Item Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  item_image_url?: string
  /** Item Name */
  item_name?: string
  /** Item Description */
  item_description?: string
}

/** ItemBulkCreateOrUpdate */
export interface ItemBulkCreateOrUpdate {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Nested Items
   * The child items of the bundle
   */
  nested_items?: NestedItem[]
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  /**
   * Fallback Item Id
   * The item that will be given as fallback if the main item can't be given to the player
   */
  fallback_item_id?: string
  /**
   * Fallback Item Quantity
   * The quantity of the fallback item
   * @min 1
   * @max 1000000000000000000
   */
  fallback_item_quantity?: number
}

/** ItemBulkDelete */
export interface ItemBulkDelete {
  /** Id */
  id: string
}

/** ItemBulkUpdate */
export interface ItemBulkUpdate {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description?: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/)
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /**
   * Discount Percent
   * The discount percent for the item
   * @exclusiveMin 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @exclusiveMin 0
   * @max 1000
   */
  bonus_percent?: number
  /** The currency of the item */
  currency?: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku?: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type?: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable?: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency?: boolean
  /**
   * Archived At
   * The timestamp of when the item was archived
   */
  archived_at?: number
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Nested Items
   * Child items of the bundle
   */
  nested_items?: NestedItem[]
  /**
   * Fallback Item Id
   * The item that will be given as fallback if the main item can't be given to the player
   */
  fallback_item_id?: string
  /**
   * Fallback Item Quantity
   * The quantity of the fallback item
   * @min 1
   * @max 1000000000000000000
   */
  fallback_item_quantity?: number
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
}

/** ItemCategoryBulkDelete */
export interface ItemCategoryBulkDelete {
  /** Id */
  id: string
}

/** ItemCategoryBulkUpdate */
export interface ItemCategoryBulkUpdate {
  /** Name */
  name?: string
  /** Description */
  description?: string
  /** Position */
  position?: number
  /** Slug */
  slug?: string
  /** Icon */
  icon?: string
  /** An enumeration. */
  render_type?: StoreCategoryRenderType
  render_options?: StoreCategoryRenderOptions
  /** Id */
  id: string
}

/** ItemCategoryCreate */
export interface ItemCategoryCreate {
  /** Name */
  name: string
  /** Description */
  description: string
  /** Position */
  position: number
  /** Slug */
  slug?: string
  /** Icon */
  icon?: string
  /** An enumeration. */
  render_type?: StoreCategoryRenderType
  render_options?: StoreCategoryRenderOptions
}

/** ItemCategoryRead */
export interface ItemCategoryRead {
  /** Name */
  name: string
  /** Description */
  description: string
  /** Position */
  position: number
  /** Slug */
  slug?: string
  /** Icon */
  icon?: string
  /** An enumeration. */
  render_type?: StoreCategoryRenderType
  render_options?: StoreCategoryRenderOptions
  /** Id */
  id: string
}

/** ItemCategoryUpdate */
export interface ItemCategoryUpdate {
  /** Name */
  name?: string
  /** Description */
  description?: string
  /** Position */
  position?: number
  /** Slug */
  slug?: string
  /** Icon */
  icon?: string
  /** An enumeration. */
  render_type?: StoreCategoryRenderType
  render_options?: StoreCategoryRenderOptions
}

/** ItemCreate */
export interface ItemCreate {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Nested Items
   * The child items of the bundle
   */
  nested_items?: NestedItem[]
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  /**
   * Fallback Item Id
   * The item that will be given as fallback if the main item can't be given to the player
   */
  fallback_item_id?: string
  /**
   * Fallback Item Quantity
   * The quantity of the fallback item
   * @min 1
   * @max 1000000000000000000
   */
  fallback_item_quantity?: number
}

/** ItemDiscountOffer */
export interface ItemDiscountOffer {
  /** Amount */
  amount: number
  /** An enumeration. */
  currency: Currency
  /** Discount Percent */
  discount_percent: number
}

/** ItemDiscountOfferActionNode */
export interface ItemDiscountOfferActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "ItemDiscountOfferActionNode"
   */
  model_type?: 'ItemDiscountOfferActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Item Id */
  item_id?: string
  /** Discount Percent */
  discount_percent?: number
  /** Bonus Percent */
  bonus_percent?: number
  /** Duration */
  duration?: number
  /**
   * Use Event Item
   * @default false
   */
  use_event_item?: boolean
  /**
   * Item Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  item_image_url?: string
  /** Item Name */
  item_name?: string
  /** Item Description */
  item_description?: string
}

/** ItemImageCreate */
export interface ItemImageCreate {
  /** An enumeration. */
  usage_context?: ImageUsageContext
  /**
   * Original Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  original_url: string
  /**
   * Cropped Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  cropped_url?: string
  crop?: ImageCrop
  /** Item Id */
  item_id: string
}

/** ItemImageRead */
export interface ItemImageRead {
  /** An enumeration. */
  usage_context?: ImageUsageContext
  /**
   * Original Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  original_url: string
  /**
   * Cropped Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  cropped_url?: string
  crop?: ImageCrop
  /** Id */
  id: string
  /** Created At */
  created_at: number
  /** Modified At */
  modified_at?: number
}

/** ItemImageUpdate */
export interface ItemImageUpdate {
  /**
   * Cropped Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  cropped_url?: string
  crop?: ImageCrop
}

/** ItemOfferActionNode */
export interface ItemOfferActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "ItemOfferActionNode"
   */
  model_type?: 'ItemOfferActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Item Id */
  item_id?: string
  /** Discount Percent */
  discount_percent?: number
  /** Bonus Percent */
  bonus_percent?: number
  /** Duration */
  duration?: number
  /**
   * Use Event Item
   * @default false
   */
  use_event_item?: boolean
  /**
   * Item Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  item_image_url?: string
  /** Item Name */
  item_name?: string
  /** Item Description */
  item_description?: string
}

/** ItemPrice */
export interface ItemPrice {
  /** An enumeration. */
  country: Country
  /** An enumeration. */
  currency: Currency
  /** An enumeration. */
  platform: Platform
  /**
   * Price
   * @min 0
   * @max 1000000000000
   */
  price: number
  /**
   * Is Custom
   * @default false
   */
  is_custom?: boolean
}

/** ItemPropertyConfigNumber */
export interface ItemPropertyConfigNumber {
  /**
   * Property Type
   * @default "number"
   */
  property_type?: 'number'
}

/** ItemPropertyConfigRange */
export interface ItemPropertyConfigRange {
  /**
   * Property Type
   * @default "range"
   */
  property_type?: 'range'
  /** Max */
  max: number
  /**
   * Min
   * @default 0
   */
  min?: number
}

/** ItemPropertyConfigString */
export interface ItemPropertyConfigString {
  /**
   * Property Type
   * @default "string"
   */
  property_type?: 'string'
}

/** ItemPropertyCreate */
export interface ItemPropertyCreate {
  /**
   * Name
   * The name of the property
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the property
   * @maxLength 512
   */
  description?: string
  /**
   * Icon Url
   * The URL of the icon for the property
   */
  icon_url?: string | ''
  /**
   * Config
   * The config of the property
   */
  config:
    | ({
        property_type: 'range'
      } & ItemPropertyConfigRange)
    | ({
        property_type: 'number'
      } & ItemPropertyConfigNumber)
    | ({
        property_type: 'string'
      } & ItemPropertyConfigString)
}

/** ItemPropertyRead */
export interface ItemPropertyRead {
  /**
   * Name
   * The name of the property
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the property
   * @maxLength 512
   */
  description?: string
  /**
   * Icon Url
   * The URL of the icon for the property
   */
  icon_url?: string | ''
  /**
   * Config
   * The config of the property
   */
  config:
    | ({
        property_type: 'range'
      } & ItemPropertyConfigRange)
    | ({
        property_type: 'number'
      } & ItemPropertyConfigNumber)
    | ({
        property_type: 'string'
      } & ItemPropertyConfigString)
  /**
   * Id
   * The unique identifier of the property
   */
  id: string
}

/** ItemPropertyRelationCreate */
export interface ItemPropertyRelationCreate {
  /** Property Id */
  property_id: string
  data?: ItemPropertyRelationData
  /** Position */
  position: number
}

/** ItemPropertyRelationData */
export interface ItemPropertyRelationData {
  /** Value */
  value?: number | string
}

/** ItemPropertyRelationRead */
export interface ItemPropertyRelationRead {
  /** Property Id */
  property_id: string
  data?: ItemPropertyRelationData
  /** Position */
  position: number
  /** Id */
  id: string
  /** Item Id */
  item_id: string
  item_property: ItemPropertyRead
}

/** ItemPropertyRelationUpdate */
export interface ItemPropertyRelationUpdate {
  data?: ItemPropertyRelationData
  /** Position */
  position?: number
}

/** ItemPropertyUpdate */
export interface ItemPropertyUpdate {
  /**
   * Name
   * The name of the property
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the property
   * @maxLength 512
   */
  description?: string
  /**
   * Icon Url
   * The URL of the icon for the property
   */
  icon_url?: string | ''
  /** Config */
  config?: ItemPropertyConfigRange | ItemPropertyConfigNumber | ItemPropertyConfigString
}

/** ItemRarityCreate */
export interface ItemRarityCreate {
  /**
   * Name
   * Name of the item rarity
   * @maxLength 255
   */
  name: string
  /**
   * Color Background Badge
   * Background color of the badge with this rarity
   */
  color_background_badge?: string
}

/** ItemRarityRead */
export interface ItemRarityRead {
  /**
   * Name
   * Name of the item rarity
   * @maxLength 255
   */
  name: string
  /**
   * Color Background Badge
   * Background color of the badge with this rarity
   */
  color_background_badge?: string
  /** Id */
  id: string
}

/** ItemRarityUpdate */
export interface ItemRarityUpdate {
  /**
   * Name
   * Name of the item rarity
   * @maxLength 255
   */
  name?: string
  /**
   * Color Background Badge
   * Background color of the badge with this rarity
   */
  color_background_badge?: string
}

/** ItemRead */
export interface ItemRead {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
  /**
   * Properties
   * The item properties
   */
  properties?: ItemPropertyRelationRead[]
  /** An enumeration. */
  source?: ItemSource
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  item_rarity?: ItemRarityRead
  /**
   * Discount Percent
   * The discount percent for the item
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @min 0
   */
  bonus_percent?: number
  /**
   * Is Custom
   * @default false
   */
  is_custom?: boolean
  /**
   * Model Type
   * @default "ItemRead"
   */
  model_type?: 'ItemRead'
  /**
   * Created At
   * The timestamp of when the item was created
   */
  created_at: number
  /**
   * Modified At
   * The timestamp of when the item was modified
   */
  modified_at?: number
  /**
   * Archived At
   * The timestamp of when the item was archived
   */
  archived_at?: number
  /** Price Minor Unit */
  price_minor_unit: number
  /** Price Decimal */
  price_decimal?: number
  /**
   * Nested Items
   * The child items of the bundle
   */
  nested_items?: NestedItem[]
  /** Nested Items Read */
  nested_items_read?: ItemRead[]
  /**
   * Fallback Item Id
   * The item that will be given as fallback if the main item can't be given to the player
   */
  fallback_item_id?: string
  /**
   * Fallback Item Quantity
   * The quantity of the fallback item
   */
  fallback_item_quantity?: number
  fallback_item?: ItemRead
  /** Meta */
  meta?: object
}

/** ItemTranslate */
export interface ItemTranslate {
  /**
   * Name
   * Mapping of locale to translated name
   */
  name?: LocaleMapping
  /**
   * Description
   * Mapping of locale to translated description
   */
  description?: LocaleMapping
}

/** ItemUpdate */
export interface ItemUpdate {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description?: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/)
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /**
   * Discount Percent
   * The discount percent for the item
   * @exclusiveMin 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @exclusiveMin 0
   * @max 1000
   */
  bonus_percent?: number
  /** The currency of the item */
  currency?: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku?: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type?: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable?: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency?: boolean
  /**
   * Archived At
   * The timestamp of when the item was archived
   */
  archived_at?: number
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Nested Items
   * Child items of the bundle
   */
  nested_items?: NestedItem[]
  /**
   * Fallback Item Id
   * The item that will be given as fallback if the main item can't be given to the player
   */
  fallback_item_id?: string
  /**
   * Fallback Item Quantity
   * The quantity of the fallback item
   * @min 1
   * @max 1000000000000000000
   */
  fallback_item_quantity?: number
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
}

/** ItemsCreate */
export interface ItemsCreate {
  /**
   * Items
   * @maxItems 50
   * @minItems 1
   */
  items: StoreItemCreate[]
}

/** JobCreate */
export interface JobCreate {
  /** Function */
  function:
    | ({
        name: 'translate.translate_all'
      } & TranslateAllFunction)
    | ({
        name: 'translate.sync_all'
      } & TranslateSyncAllFunction)
    | ({
        name: 'test'
      } & TestFunction)
    | ({
        name: 'store.import'
      } & ImportStoreFunction)
    | ({
        name: 'calculate_static_segment_group'
      } & CalculateSegmentFunction)
    | ({
        name: 'translate.translate_and_sync_all'
      } & TranslateAndSyncAllFunction)
}

/** JobRead */
export interface JobRead {
  /** Id */
  id: string
  /** An enumeration. */
  status: JobStatus
  /** An enumeration. */
  function_name: JobFunctionName
  /** Function Args */
  function_args: Record<string, string>
  /** Progress Total */
  progress_total: number
  /** Progress Done */
  progress_done: number
  /** Progress Name */
  progress_name?: string | null
  /** Created At */
  created_at: number
  /** Modified At */
  modified_at?: number | null
  /** Result Error */
  result_error?: string | null
  /** Is Hidden */
  is_hidden?: boolean | null
}

/** LatestNewsBlock */
export interface LatestNewsBlock {
  /**
   * Block
   * @default "LatestNewsBlock"
   */
  block?: 'LatestNewsBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** @default "standard" */
  variant?: LatestNewsBlockVariant
  /** Hide Controls */
  hide_controls?: boolean
  /** Is Featured */
  is_featured?: boolean
}

/** LeadCreateOrUpdate */
export interface LeadCreateOrUpdate {
  /** Full Name */
  full_name?: string
  /** Know About Us */
  know_about_us?: string
  /** Goal */
  goal?: string
  /** Goal Question */
  goal_question?: string
  /** Website Url */
  website_url?: string
  /** Cell Number */
  cell_number?: string
  /** Utms */
  utms?: object
}

/** LeadRead */
export interface LeadRead {
  /** Full Name */
  full_name?: string
  /** Know About Us */
  know_about_us?: string
  /** Goal */
  goal?: string
  /** Goal Question */
  goal_question?: string
  /** Website Url */
  website_url?: string
  /** Cell Number */
  cell_number?: string
  /** Utms */
  utms?: object
  /** Customer Id */
  customer_id: string
  /** Completed */
  completed: boolean
}

/** LeaderboardCardBlock */
export interface LeaderboardCardBlock {
  /**
   * Block
   * @default "LeaderboardCardBlock"
   */
  block?: 'LeaderboardCardBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Leaderboard Id */
  leaderboard_id?: string
}

/** LeaderboardCollectionBlock */
export interface LeaderboardCollectionBlock {
  /**
   * Block
   * @default "LeaderboardCollectionBlock"
   */
  block?: 'LeaderboardCollectionBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
}

/** LeaderboardCreate */
export interface LeaderboardCreate {
  /**
   * Name
   * The name of the leaderboard.
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the leaderboard.
   * @maxLength 512
   */
  description: string
  /**
   * The visibility of the leaderboard. It can be either 'general' or 'personal'. General leaderboards are visible to all users, while personal leaderboards are only visible to leaderboard participants.
   * @default "general"
   */
  visibility?: LeaderboardVisibility
  /**
   * Start At
   * The start date of the leaderboard in Unix timestamp.If set, the leaderboard will only be visible in game-hub after this date.
   */
  start_at?: number
  /**
   * End At
   * The end date of the leaderboard in Unix timestamp.If set, the leaderboard will only be visible in game-hub before this date.
   */
  end_at?: number
}

/** LeaderboardFullBlock */
export interface LeaderboardFullBlock {
  /**
   * Block
   * @default "LeaderboardFullBlock"
   */
  block?: 'LeaderboardFullBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Leaderboard Id */
  leaderboard_id?: string
}

/** LeaderboardMemberRead */
export interface LeaderboardMemberRead {
  /**
   * Member Id
   * The unique identifier of the member.
   */
  member_id: string
  /**
   * Member Data
   * The data of the member. This might be a members's name.
   */
  member_data: string
  /**
   * Member Subdata
   * The additional subdata related to the member, such as a clan, team or guild they belong to.
   */
  member_subdata?: string
  /**
   * Image Url
   * The image URL of the member.
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Score
   * The score of the member.
   */
  score: number
  /**
   * Id
   * The unique identifier of the leaderboard member.
   */
  id: string
  /**
   * Created At
   * The unix timestamp of when the leaderboard member was created.
   */
  created_at: number
  /**
   * Modified At
   * The unix timestamp of when the leaderboard member was last modified.
   */
  modified_at?: number
}

/** LeaderboardMemberUpdate */
export interface LeaderboardMemberUpdate {
  /**
   * Member Id
   * The unique identifier of the member.
   */
  member_id?: string
  /**
   * Member Data
   * The data of the member.
   */
  member_data?: string
  /**
   * Image Url
   * The image URL of the member.
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Score
   * The score of the member.
   */
  score?: number
}

/** LeaderboardRead */
export interface LeaderboardRead {
  /**
   * Name
   * The name of the leaderboard.
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the leaderboard.
   * @maxLength 512
   */
  description: string
  /**
   * The visibility of the leaderboard. It can be either 'general' or 'personal'. General leaderboards are visible to all users, while personal leaderboards are only visible to leaderboard participants.
   * @default "general"
   */
  visibility?: LeaderboardVisibility
  /**
   * Start At
   * The start date of the leaderboard in Unix timestamp.If set, the leaderboard will only be visible in game-hub after this date.
   */
  start_at?: number
  /**
   * End At
   * The end date of the leaderboard in Unix timestamp.If set, the leaderboard will only be visible in game-hub before this date.
   */
  end_at?: number
  /**
   * Id
   * The unique identifier of the leaderboard.
   */
  id: string
}

/** LeaderboardUpdate */
export interface LeaderboardUpdate {
  /**
   * Name
   * The name of the leaderboard.
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the leaderboard.
   * @maxLength 512
   */
  description?: string
  /** An enumeration. */
  visibility?: LeaderboardVisibility
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
}

/** LimitedStockSettings */
export interface LimitedStockSettings {
  /**
   * Total Quantity
   * @exclusiveMin 0
   */
  total_quantity: number
  /** An enumeration. */
  type: LimitedStockType
}

/** LimitedStoreBannerBlock */
export interface LimitedStoreBannerBlock {
  /**
   * Block
   * @default "LimitedStoreBannerBlock"
   */
  block?: 'LimitedStoreBannerBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Title */
  title?: string
  /** Description */
  description?: string
  /** Button */
  button?: string
  /** Image Url */
  image_url?: string
  /** Background Image Url */
  background_image_url?: string
  /** Link */
  link?: string
  /** Store Id */
  store_id?: string
}

/** LocalTier */
export interface LocalTier {
  /** Id */
  id: string
  /** From Amount */
  from_amount: number
  /** To Amount */
  to_amount: number
  /** Bonus Percent */
  bonus_percent: number
  /**
   * Background Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
  /** From Rate */
  from_rate: number
  /** To Rate */
  to_rate: number
}

/** LocaleCreate */
export interface LocaleCreate {
  /** Language codes according to ISO 639-1. */
  locale: Locale
  /** Published At */
  published_at?: number
}

/** LocaleMapping */
export interface LocaleMapping {
  /** Cs */
  cs?: string
  /** De */
  de?: string
  /** En */
  en?: string
  /** Es */
  es?: string
  /** Fr */
  fr?: string
  /** Hi */
  hi?: string
  /** Id */
  id?: string
  /** It */
  it?: string
  /** Ja */
  ja?: string
  /** Ko */
  ko?: string
  /** Pl */
  pl?: string
  /** Pt */
  pt?: string
  /** Pt-Br */
  'pt-BR'?: string
  /** Ru */
  ru?: string
  /** Th */
  th?: string
  /** Tr */
  tr?: string
  /** Uk */
  uk?: string
  /** Vi */
  vi?: string
  /** Zh */
  zh?: string
  /** Zh-Hant */
  'zh-Hant'?: string
}

/** LocaleRead */
export interface LocaleRead {
  /** Language codes according to ISO 639-1. */
  locale: Locale
  /** Published At */
  published_at?: number
  /** Id */
  id: string
  /**
   * Represents an object in a nested context whose parent can be tracked.
   *
   * The top object in the parent link should be an instance of `Mutable`.
   */
  stats: LocaleStats
  /** An enumeration. */
  status: LocaleStatus
  /** Modified At */
  modified_at?: number
}

/**
 * LocaleStats
 * Represents an object in a nested context whose parent can be tracked.
 *
 * The top object in the parent link should be an instance of `Mutable`.
 */
export interface LocaleStats {
  /**
   * Total
   * @default 0
   */
  total?: number
  /**
   * Done
   * @default 0
   */
  done?: number
}

/** LocaleUpdate */
export type LocaleUpdate = object

/** LoginSettings */
export interface LoginSettings {
  /** Background Image */
  background_image?: string
  /** Welcome Image */
  welcome_image?: string
  /** Age Of Consent */
  age_of_consent?: number
  /** @default "lower" */
  user_id_normalization_method?: NormalizationMethod
  /** Oauth2 Mobile Disable */
  oauth2_mobile_disable?: boolean
  /** Login Form */
  login_form?: string
  /** User Fields */
  user_fields?: string[]
  /** Show Instruction Instead Login Form */
  show_instruction_instead_login_form?: boolean
  /** Game Auth Link */
  game_auth_link?: string
  /** Game Auth Button Icon */
  game_auth_button_icon?: string
  /** User Id Instruction Text */
  user_id_instruction_text?: string
  /** User Id Instruction Image */
  user_id_instruction_image?: string
}

/** LootboxBulkUpdate */
export interface LootboxBulkUpdate {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description?: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/)
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /**
   * Discount Percent
   * The discount percent for the item
   * @exclusiveMin 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @exclusiveMin 0
   * @max 1000
   */
  bonus_percent?: number
  /** The currency of the item */
  currency?: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku?: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type?: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable?: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency?: boolean
  /**
   * Archived At
   * The timestamp of when the item was archived
   */
  archived_at?: number
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Lootbox Settings
   * The settings of the lootbox
   */
  lootbox_settings?: any
  /**
   * Id
   * The unique identifier of the lootbox
   */
  id: string
}

/** LootboxCreate */
export interface LootboxCreate {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Lootbox Settings
   * The settings of the lootbox
   */
  lootbox_settings: LootboxSettings
}

/** LootboxGroup */
export interface LootboxGroup {
  /** Id */
  id: string
  /**
   * Weight
   * @min 0
   * @max 1000000
   */
  weight: number
  /** Name */
  name: string
  /** Nested Items */
  nested_items: (LootboxGroup | LootboxNestedItem)[]
  /**
   * Model Type
   * @default "LootboxGroup"
   */
  model_type?: 'LootboxGroup'
}

/** LootboxGroupRead */
export interface LootboxGroupRead {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Weight */
  weight: number
  /** Nested Items */
  nested_items: LootboxGroupRead[] | LootboxNestedItemRead[]
}

/** LootboxNestedItem */
export interface LootboxNestedItem {
  /** Id */
  id: string
  /**
   * Weight
   * @min 0
   * @max 1000000
   */
  weight: number
  /** Count */
  count: number
  /** Sku */
  sku: string
  /**
   * Model Type
   * @default "LootboxNestedItem"
   */
  model_type?: 'LootboxNestedItem'
}

/** LootboxNestedItemRead */
export interface LootboxNestedItemRead {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
  /**
   * Properties
   * The item properties
   */
  properties?: ItemPropertyRelationRead[]
  /** An enumeration. */
  source?: ItemSource
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  item_rarity?: ItemRarityRead
  /**
   * Discount Percent
   * The discount percent for the item
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @min 0
   */
  bonus_percent?: number
  /**
   * Is Custom
   * @default false
   */
  is_custom?: boolean
  /**
   * Model Type
   * @default "ItemRead"
   */
  model_type?: 'ItemRead'
  /**
   * Created At
   * The timestamp of when the item was created
   */
  created_at: number
  /**
   * Modified At
   * The timestamp of when the item was modified
   */
  modified_at?: number
  /**
   * Archived At
   * The timestamp of when the item was archived
   */
  archived_at?: number
  /** Price Minor Unit */
  price_minor_unit: number
  /** Price Decimal */
  price_decimal?: number
  /**
   * Nested Items
   * The child items of the bundle
   */
  nested_items?: NestedItem[]
  /** Nested Items Read */
  nested_items_read?: ItemRead[]
  /**
   * Fallback Item Id
   * The item that will be given as fallback if the main item can't be given to the player
   */
  fallback_item_id?: string
  /**
   * Fallback Item Quantity
   * The quantity of the fallback item
   */
  fallback_item_quantity?: number
  fallback_item?: ItemRead
  /** Meta */
  meta?: object
  /**
   * Probability
   * The probability of the item appearing
   */
  probability: number
  /** Weight */
  weight: number
}

/** LootboxRead */
export interface LootboxRead {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Lootbox Settings
   * The settings of the lootbox
   */
  lootbox_settings: LootboxSettings
  /**
   * Model Type
   * @default "LootboxRead"
   */
  model_type?: 'LootboxRead'
  /**
   * Id
   * The unique identifier of the lootbox
   */
  id: string
  /**
   * Groups
   * Groups with nested elements that can be dropped
   */
  groups?: (LootboxGroupRead | LootboxNestedItemRead)[]
  /**
   * Archived At
   * The timestamp of when the lootbox was archived
   */
  archived_at?: number
  /**
   * Attempts Count
   * The number of attempts to open this lootbox
   * @default 0
   */
  attempts_count?: number
}

/** LootboxSettings */
export interface LootboxSettings {
  /** Groups */
  groups: (
    | ({
        model_type: 'LootboxGroup'
      } & LootboxGroup)
    | ({
        model_type: 'LootboxNestedItem'
      } & LootboxNestedItem)
  )[]
  /** Claim Video Url */
  claim_video_url?: string
  /** Claimed Video Url */
  claimed_video_url?: string
  /** Claim Video Url Mov */
  claim_video_url_mov?: string
  /** Claimed Video Url Mov */
  claimed_video_url_mov?: string
  /** @default "default" */
  view_type?: LootboxViewType
}

/** LootboxUpdate */
export interface LootboxUpdate {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description?: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/)
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /**
   * Discount Percent
   * The discount percent for the item
   * @exclusiveMin 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @exclusiveMin 0
   * @max 1000
   */
  bonus_percent?: number
  /** The currency of the item */
  currency?: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku?: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type?: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable?: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency?: boolean
  /**
   * Archived At
   * The timestamp of when the item was archived
   */
  archived_at?: number
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Lootbox Settings
   * The settings of the lootbox
   */
  lootbox_settings?: any
}

/** LoyaltyItem */
export interface LoyaltyItem {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
  /**
   * Properties
   * The item properties
   */
  properties?: ItemPropertyRelationRead[]
  /** An enumeration. */
  source?: ItemSource
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  item_rarity?: ItemRarityRead
  /**
   * Discount Percent
   * The discount percent for the item
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @min 0
   */
  bonus_percent?: number
  /**
   * Is Custom
   * @default false
   */
  is_custom?: boolean
  /**
   * Count
   * Optional quantity override for the tier item. If not provided, the item's default quantity is used.
   * @exclusiveMin 0
   */
  count?: number
}

/** LoyaltyItemCreatUpdate */
export interface LoyaltyItemCreatUpdate {
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
  /**
   * Count
   * Optional quantity override for the tier item. If not provided, the item's default quantity is used.
   * @exclusiveMin 0
   */
  count?: number
}

/** LoyaltyProgramBlock */
export interface LoyaltyProgramBlock {
  /**
   * Block
   * @default "LoyaltyProgramBlock"
   */
  block?: 'LoyaltyProgramBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** @default "standard" */
  variant?: LoyaltyProgramBlockVariant
}

/** LoyaltySettings */
export interface LoyaltySettings {
  /**
   * Name
   * The name of the loyalty program
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * A brief description of the loyalty program
   * @maxLength 1024
   */
  description?: string
  /**
   * Image Url
   * The URL of the image associated with the loyalty program
   */
  image_url?: string | ''
  /**
   * Activated At
   * Timestamp when the program was activated (UNIX time)
   */
  activated_at?: number
  /**
   * Period
   * The duration of the loyalty program in days
   */
  period: number
  /**
   * Repeatable
   * Whether the program is repeatable
   * @default false
   */
  repeatable?: boolean
  requirements_expression?: Expression
  /**
   * Points Rate
   * Exchange rate against the dollar
   */
  points_rate: number
  /**
   * Id
   * The unique identifier for the loyalty tier
   */
  id: string
  /**
   * Game Id
   * The unique identifier of the game the accosiated with the loyalty program
   */
  game_id: string
}

/** LoyaltySettingsUpdate */
export interface LoyaltySettingsUpdate {
  /**
   * Name
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * @maxLength 1024
   */
  description?: string
  /** Image Url */
  image_url?: string | ''
  /** Active */
  active?: boolean
  /**
   * Period
   * @min 0
   * @exclusiveMax 365
   */
  period?: number
  /** Repeatable */
  repeatable?: boolean
  requirements_expression?: Expression
  /** Points Rate */
  points_rate?: number
}

/** LoyaltyTier */
export interface LoyaltyTier {
  /**
   * Name
   * The name of the loyalty tier
   * @maxLength 255
   */
  name: string
  /**
   * Points
   * Points required to reach this tier
   */
  points: number
  /**
   * Image Url
   * The image URL for this loyalty tier
   */
  image_url: string | ''
  /**
   * Id
   * The unique identifier for the loyalty tier
   */
  id: string
  /**
   * Items
   * Items associated with this loyalty tier
   */
  items: LoyaltyItem[]
}

/** LoyaltyTierCreateUpdate */
export interface LoyaltyTierCreateUpdate {
  /** Id */
  id?: string
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /**
   * Points
   * @exclusiveMin 0
   */
  points: number
  /** Image Url */
  image_url: string | ''
  /**
   * Items
   * @maxItems 10
   * @minItems 1
   */
  items: LoyaltyItemCreatUpdate[]
}

/** MathExpression */
export interface MathExpression {
  /** Tokens */
  tokens?: Token[]
  /** Name */
  name: string
}

/** MeasureValue */
export interface MeasureValue {
  /** Value */
  value: number
  /** Prev Value */
  prev_value?: number
}

/** MetaPixelPlugin */
export interface MetaPixelPlugin {
  /**
   * Key
   * @default "meta-pixel"
   */
  key?: 'meta-pixel'
  /** Pixel Id */
  pixel_id: string
}

/** MobilePopupActionNode */
export interface MobilePopupActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "MobilePopupActionNode"
   */
  model_type?: 'MobilePopupActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Body */
  body?: string
  /** Item Id */
  item_id?: string
  /** Link Created Offer */
  link_created_offer?: boolean
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** An enumeration. */
  content_type?: HubPopupContentType
  /** Button Text */
  button_text?: string
  /** Button Link */
  button_link?: string
  /** Url */
  url?: string
  /** Response */
  response?: string
  /** Status Code */
  status_code?: number
  /** Image Url */
  image_url?: string
}

/** MobilePushActionNode */
export interface MobilePushActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "MobilePushActionNode"
   */
  model_type?: 'MobilePushActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Body */
  body?: string
  /** Item Id */
  item_id?: string
  /** Link Created Offer */
  link_created_offer?: boolean
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** An enumeration. */
  content_type?: HubPopupContentType
  /** Button Text */
  button_text?: string
  /** Button Link */
  button_link?: string
  /** Url */
  url?: string
  /** Response */
  response?: string
  /** Status Code */
  status_code?: number
  /** Image Url */
  image_url?: string
}

/** NestedItem */
export interface NestedItem {
  /** Id */
  id?: string
  /** Count */
  count?: number
  /** Sku */
  sku?: string
  /** Is Featured */
  is_featured?: boolean
  /** Meta */
  meta?: object
}

/** NewsBannerConfig */
export interface NewsBannerConfig {
  /** Title */
  title?: string
  /** Description */
  description?: string
  /** Image Url */
  image_url?: string
  /** Background Image Size */
  background_image_size?: string
  /** Featured News Id */
  featured_news_id?: string
  /** Featured Item Id */
  featured_item_id?: string
}

/** NewsBulkDelete */
export interface NewsBulkDelete {
  /** Id */
  id: string
}

/** NewsBulkUpdate */
export interface NewsBulkUpdate {
  /**
   * Slug
   * The slug of the news
   * @maxLength 100
   */
  slug?: string
  /**
   * Title
   * The title of the news
   * @maxLength 255
   */
  title?: string
  /**
   * Description
   * The description of the news
   * @maxLength 512
   */
  description?: string
  /**
   * Text
   * The text of the news
   * @maxLength 10000
   */
  text?: string
  /**
   * Html
   * The html content of the news
   * @maxLength 100000
   */
  html?: string
  /**
   * Image Url
   * The URL of the image for the news
   */
  image_url?: string | ''
  /**
   * Tags
   * The tags of the news, separated by commas
   */
  tags?: string
  /**
   * Order Id
   * The order ID of the news
   * @default 0
   */
  order_id?: number
  /** The category of the news */
  category?: NewsCategory
  /**
   * Published At
   * The published date of the news
   */
  published_at?: number
  /**
   * Datetime
   * The date of the news
   */
  datetime?: number
  render_options?: NewsRenderOptions
  /**
   * Video Url
   * The URL of the video for the news
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  video_url?: string
  /**
   * Is Featured
   * Determines the visibility of the news in the Carousel news block
   */
  is_featured?: boolean
  /**
   * Id
   * The unique identifier of the news
   */
  id: string
}

/** NewsCreate */
export interface NewsCreate {
  /**
   * Date
   * The date of the news
   * @format date
   */
  date?: string
  /**
   * Image Url
   * The URL of the image for the news
   */
  image_url: string | ''
  /**
   * Tags
   * The tags of the news, separated by commas
   */
  tags: string
  /**
   * Order Id
   * The order ID of the news
   * @default 0
   */
  order_id?: number
  /** The category of the news */
  category: NewsCategory
  /**
   * Published At
   * The published date of the news
   */
  published_at?: number
  /**
   * Datetime
   * The date of the news
   */
  datetime: number
  render_options?: NewsRenderOptions
  /**
   * Video Url
   * The URL of the video for the news
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  video_url?: string
  /**
   * Is Featured
   * Determines the visibility of the news in the Carousel news block
   */
  is_featured?: boolean
  /**
   * Slug
   * The slug of the news
   * @maxLength 100
   */
  slug: string
  /**
   * Title
   * The title of the news
   * @maxLength 255
   */
  title: string
  /**
   * Description
   * The description of the news
   * @maxLength 512
   */
  description: string
  /**
   * Text
   * The text of the news
   * @maxLength 10000
   */
  text: string
  /**
   * Html
   * The html content of the news
   * @maxLength 100000
   */
  html?: string
}

/** NewsRead */
export interface NewsRead {
  /**
   * Date
   * The date of the news
   * @format date
   */
  date?: string
  /**
   * Image Url
   * The URL of the image for the news
   */
  image_url: string | ''
  /**
   * Tags
   * The tags of the news, separated by commas
   */
  tags: string
  /**
   * Order Id
   * The order ID of the news
   * @default 0
   */
  order_id?: number
  /** The category of the news */
  category: NewsCategory
  /**
   * Published At
   * The published date of the news
   */
  published_at?: number
  /**
   * Datetime
   * The date of the news
   */
  datetime: number
  render_options?: NewsRenderOptions
  /**
   * Video Url
   * The URL of the video for the news
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  video_url?: string
  /**
   * Is Featured
   * Determines the visibility of the news in the Carousel news block
   */
  is_featured?: boolean
  /**
   * Id
   * The unique identifier of the news
   */
  id: string
  /**
   * Slug
   * The slug of the news
   */
  slug: string
  /**
   * Title
   * The title of the news
   */
  title: string
  /**
   * Description
   * The description of the news
   */
  description: string
  /**
   * Text
   * The text of the news
   */
  text: string
  /**
   * Html
   * The html content of the news
   */
  html?: string
}

/** NewsRenderOptions */
export interface NewsRenderOptions {
  /** Is Promo Store */
  is_promo_store?: boolean
}

/** NewsSettings */
export interface NewsSettings {
  /** Default Image Urls */
  default_image_urls?: Record<string, string>
  /** Image Ratio */
  image_ratio?: number
}

/** NewsUpdate */
export interface NewsUpdate {
  /**
   * Slug
   * The slug of the news
   * @maxLength 100
   */
  slug?: string
  /**
   * Title
   * The title of the news
   * @maxLength 255
   */
  title?: string
  /**
   * Description
   * The description of the news
   * @maxLength 512
   */
  description?: string
  /**
   * Text
   * The text of the news
   * @maxLength 10000
   */
  text?: string
  /**
   * Html
   * The html content of the news
   * @maxLength 100000
   */
  html?: string
  /**
   * Image Url
   * The URL of the image for the news
   */
  image_url?: string | ''
  /**
   * Tags
   * The tags of the news, separated by commas
   */
  tags?: string
  /**
   * Order Id
   * The order ID of the news
   * @default 0
   */
  order_id?: number
  /** The category of the news */
  category?: NewsCategory
  /**
   * Published At
   * The published date of the news
   */
  published_at?: number
  /**
   * Datetime
   * The date of the news
   */
  datetime?: number
  render_options?: NewsRenderOptions
  /**
   * Video Url
   * The URL of the video for the news
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  video_url?: string
  /**
   * Is Featured
   * Determines the visibility of the news in the Carousel news block
   */
  is_featured?: boolean
}

/** NoArgs */
export type NoArgs = object

/** Node */
export type Node =
  | ({
      model_type: 'EmailActionNode'
    } & EmailActionNode)
  | ({
      model_type: 'MobilePushActionNode'
    } & MobilePushActionNode)
  | ({
      model_type: 'MobilePopupActionNode'
    } & MobilePopupActionNode)
  | ({
      model_type: 'TimerNode'
    } & TimerNode)
  | ({
      model_type: 'ConditionNode'
    } & ConditionNode)
  | ({
      model_type: 'BrowserPushNotificationActionNode'
    } & BrowserPushNotificationActionNode)
  | ({
      model_type: 'BrowserPopupNotificationActionNode'
    } & BrowserPopupNotificationActionNode)
  | ({
      model_type: 'WebhookActionNode'
    } & WebhookActionNode)
  | ({
      model_type: 'ItemDiscountOfferActionNode'
    } & ItemDiscountOfferActionNode)
  | ({
      model_type: 'ItemBonusOfferActionNode'
    } & ItemBonusOfferActionNode)
  | ({
      model_type: 'SplitNode'
    } & SplitNode)
  | ({
      model_type: 'CreateItemBannerActionNode'
    } & CreateItemBannerActionNode)
  | ({
      model_type: 'AddToSegmentNode'
    } & AddToSegmentNode)
  | ({
      model_type: 'CreateCouponNode'
    } & CreateCouponNode)
  | ({
      model_type: 'AddStoreNode'
    } & AddStoreNode)
  | ({
      model_type: 'RemoveItemsStoreNode'
    } & RemoveItemsStoreNode)
  | ({
      model_type: 'AddStoreItemsNode'
    } & AddStoreItemsNode)
  | ({
      model_type: 'ItemOfferActionNode'
    } & ItemOfferActionNode)
  | ({
      model_type: 'SortStoreItemsNode'
    } & SortStoreItemsNode)
  | ({
      model_type: 'CreateVirtualSKUNode'
    } & CreateVirtualSKUNode)
  | ({
      model_type: 'CreateUserStoreSettingsNode'
    } & CreateUserStoreSettingsNode)
  | ({
      model_type: 'SetAttributeValuesNode'
    } & SetAttributeValuesNode)

/** NonBenefitData */
export interface NonBenefitData {
  /**
   * Kind
   * @default "non_benefit"
   */
  kind?: 'non_benefit'
}

/** Offer */
export interface Offer {
  /** Description */
  description: string
  /** An enumeration. */
  type: AghanimEnumsOfferType
  /** Data */
  data: ItemDiscountOffer | ItemBonusOffer
}

/** OfferRead */
export interface OfferRead {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Description */
  description: string
  /**
   * Start At
   * The Unix timestamp when the offer starts during the offer period
   */
  start_at?: number | null
  /**
   * End At
   * The Unix timestamp when the offer ends during the offer period
   */
  end_at?: number | null
  /**
   * Item Id
   * The item ID
   */
  item_id?: string | null
  /**
   * Item
   * The item information of the offer
   */
  item?: ItemRead | LootboxRead | null
  /** The type of the offer */
  type: AghanimOffersSchemasOfferType
}

/** Offers */
export interface Offers {
  sequential_offer?: PersonalSequentialOffer
  range_offer?: PersonalRangeOffer
  rolling_offer?: PersonalRollingOffer
  pick_one_offer?: PersonalPickOneOffer
}

/** OnBoardingRequest */
export interface OnBoardingRequest {
  /** Url */
  url: string
  /** Company Id */
  company_id?: string
  setting?: GenerationSettings
}

/** OnBoardingResponse */
export interface OnBoardingResponse {
  company: Company
  game: AghanimGameSchemasGame
  website: Website
}

/** OnboardingProgress */
export interface OnboardingProgress {
  /** Visit Game Hub */
  visit_game_hub: boolean
  /** Customize Your Store */
  customize_your_store: boolean
  /** Setup Item Store */
  setup_item_store: boolean
  /** Test Webhook */
  test_webhook: boolean
  /** Account Verified */
  account_verified: boolean
  /** Liveops Published */
  liveops_published: boolean
  /** Setup Webhook */
  setup_webhook: boolean
  /**
   * Invite User
   * @default false
   */
  invite_user?: boolean
}

/** OrderFeatureFlags */
export interface OrderFeatureFlags {
  /**
   * Reward Points Enabled
   * @default false
   */
  reward_points_enabled?: boolean
  /**
   * Country Update Enabled
   * @default true
   */
  country_update_enabled?: boolean
  /**
   * Coupons Enabled
   * @default true
   */
  coupons_enabled?: boolean
  /**
   * Expand Details By Default Enabled
   * @default false
   */
  expand_details_by_default_enabled?: boolean
  /**
   * Item Description Enabled
   * @default true
   */
  item_description_enabled?: boolean
  /**
   * Auto Return Url Timer Enabled
   * @default false
   */
  auto_return_url_timer_enabled?: boolean
  /**
   * Player Info Enabled
   * @default false
   */
  player_info_enabled?: boolean
}

/** OrderGameSettings */
export interface OrderGameSettings {
  /** Purchase Successful Text */
  purchase_successful_text?: string
  /** Receipt Appreciation Text */
  receipt_appreciation_text?: string
  /** Back To Store Url */
  back_to_store_url?: string
  /** Back To Game Url */
  back_to_game_url?: string
  payment_settings?: PaymentSettings
  /** Back To Game Settings */
  back_to_game_settings?: BackToGameSettings | null
}

/** OrderLine */
export interface OrderLine {
  /** Item */
  item:
    | ({
        model_type: 'ItemRead'
      } & ItemRead)
    | ({
        model_type: 'LootboxRead'
      } & LootboxRead)
  store_item?: StoreItemRead
  offers?: Offers
  /** Item Name */
  item_name?: string
  checkout_link?: CheckoutLink
  /** Campaign Version Id */
  campaign_version_id?: string
  /** Campaign Version */
  campaign_version?: string
}

/** OrderPayment */
export interface OrderPayment {
  /** Id */
  id: string
  /** Payment Method Name */
  payment_method_name: string
  /** Payment Method Caption */
  payment_method_caption: string
  /** Payment Method Logo Url */
  payment_method_logo_url?: string
  /** Payment Number */
  payment_number: string
  /** Card Last 4 Digits */
  card_last_4_digits: string
  /** Card Scheme */
  card_scheme: string
  /** Subtotal */
  subtotal: number
  /** Total */
  total: number
  tax: Tax
  /** Currency */
  currency: string
  /** Created At */
  created_at: number
  /** Email */
  email: string
  /** Eu Country */
  eu_country?: boolean
  /** Australia */
  australia?: boolean
  billing_address?: BillingAddress
}

/** OrderReadDashboard */
export interface OrderReadDashboard {
  /** Id */
  id: string
  game: AghanimOrderSchemasGame
  /** Game Id */
  game_id: string
  /** Company Id */
  company_id: string
  /** User Id */
  user_id: string
  /** Player Id */
  player_id: string
  /** Email */
  email?: string
  /** Language codes according to ISO 639-1. */
  locale?: Locale
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country: string
  /** Items */
  items: PersonalItem[]
  player_info?: PlayerInfo
  global_discount?: GlobalDiscount
  global_bonus?: GlobalBonus
  /** Discounts */
  discounts: (Discount | DiscountFixed)[]
  /** Bonuses */
  bonuses: Bonus[]
  /** Offers */
  offers: Offer[]
  /** Benefits */
  benefits: Benefit[]
  /** Amount */
  amount: number
  /** Amount Decimal */
  amount_decimal: number
  /** An enumeration. */
  currency: Currency
  /** An enumeration. */
  status: OrderStatus
  /** Subtotal */
  subtotal: number
  /** Total */
  total: number
  /** Return Url */
  return_url: string
  /** Created At */
  created_at: number
  /** Modified At */
  modified_at?: number
  /** Paid At */
  paid_at?: number
  /** Datahouse User Id */
  datahouse_user_id?: string
  game_settings: OrderGameSettings
  checkout_settings: CheckoutSettings
  /** Ip Address */
  ip_address?: string
  /** User Agent */
  user_agent?: string
  /** Store Item Id */
  store_item_id?: string
  /** Price Minor Unit */
  price_minor_unit: number
  /** Paylink User Id */
  paylink_user_id?: string
  /** Eligible For Reward Points */
  eligible_for_reward_points?: number
  /** An enumeration. */
  reward_points_issue_status?: RPIssueStatus
  feature_flags: OrderFeatureFlags
  /** Eligible For Loyalty Points */
  eligible_for_loyalty_points?: number
  /** Sandbox */
  sandbox: boolean
  /** Handled By Client */
  handled_by_client?: boolean
  /** Receipt Number */
  receipt_number?: string
  /** Revenue Usd */
  revenue_usd?: number
  fees?: Fees
  /** Applied Reward Points */
  applied_reward_points?: number
  reward_point_limits?: RewardPointLimits
  website: OrderWebsite
  /** Meta */
  meta?: object
  /** An enumeration. */
  platform?: Platform
  /** Campaign Id */
  campaign_id?: string
  /** User Campaign Id */
  user_campaign_id?: string
  /** An enumeration. */
  source?: OrderSourceType
  /** An enumeration. */
  sales_channel?: SalesChannel
  payment_methods_enabled?: PublicPaymentMethod[]
  private_payment_methods_enabled?: PrivatePaymentMethod[]
  /** Payment Method */
  payment_method?: string
  /** Campaign Version Id */
  campaign_version_id?: string
  /** Campaign Version */
  campaign_version?: string
  /** Campaign Desc */
  campaign_desc?: string
  /** An enumeration. */
  campaign_event_type?: CampaignEventType
  /** Order Lines */
  order_lines?: OrderLine[]
}

/** OrderWebsite */
export interface OrderWebsite {
  /** Slug */
  slug: string
  /** Plugins */
  plugins: WebsitePlugin[]
}

/** OutdatedAgreements */
export interface OutdatedAgreements {
  /** Terms */
  terms: boolean
  /** Privacy */
  privacy: boolean
}

/** Pack */
export interface Pack {
  /**
   * Id
   * Unique identifier for the pack
   */
  id: string
  /**
   * Base Quantity
   * Base quantity of the pack
   */
  base_quantity: number
  /**
   * Max Purchase
   * Maximum number of times the pack can be opened and purchased
   */
  max_purchase: number
  /**
   * Bonuses
   * List of bonus items that can be dropped from the pack
   */
  bonuses: BonusDropItem[]
  /**
   * Image Url
   * URL to the image of the pack
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Background Image Url
   * URL to the background image of the pack
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
  /**
   * Price
   * Price of the pack
   */
  price: number
  /**
   * Price Point
   * Price point of the pack
   */
  price_point: number
  /**
   * Price Template Id
   * Price template ID of the pack
   */
  price_template_id?: string
}

/** PageBase */
export interface PageBase {
  /**
   * Key
   * External unique page identifier
   */
  key?: string
  /** Title */
  title: string
  /** Text */
  text: string
  /** Description */
  description: string
  /**
   * Slug
   * The slug of the page
   */
  slug: string
  /** Layout */
  layout?: any
  /** Html */
  html?: string
  /** An enumeration. */
  type?: PageLayoutType
  /** Parent Id */
  parent_id?: string
  /**
   * Date
   * The date of the page
   * @format date
   */
  date?: string
  /**
   * Image Url
   * The URL of the image for the page
   */
  image_url?: string | ''
  /**
   * Published At
   * The published date of the Page
   */
  published_at?: number
  /**
   * Position
   * The position of the page in the page list
   */
  position?: number
  render_options?: PageRenderOptions
}

/** PageBulkDelete */
export interface PageBulkDelete {
  /** Id */
  id: string
}

/** PageBulkUpdate */
export interface PageBulkUpdate {
  /**
   * Key
   * External unique page identifier
   */
  key?: string
  /** Title */
  title?: string
  /** Description */
  description?: string
  /** Text */
  text?: string
  /**
   * Slug
   * The slug of the page
   * @minLength 3
   * @maxLength 100
   */
  slug?: string
  layout?: PageLayout
  /** Html */
  html?: string
  /** An enumeration. */
  type?: PageLayoutType
  /** Parent Id */
  parent_id?: string
  /**
   * Date
   * The date of the page
   * @format date
   */
  date?: string
  /**
   * Image Url
   * The URL of the image for the page
   */
  image_url?: string | ''
  /**
   * Published At
   * The published date of the Page
   */
  published_at?: number
  /**
   * Position
   * The position of the page in the page list
   */
  position?: number
  render_options?: PageRenderOptions
  /**
   * Id
   * The unique identifier of the page
   */
  id: string
}

/** PageCreate */
export interface PageCreate {
  /**
   * Key
   * External unique page identifier
   */
  key?: string
  /** Title */
  title: string
  /** Text */
  text: string
  /** Description */
  description: string
  /**
   * Slug
   * The slug of the page
   * @minLength 3
   * @maxLength 100
   */
  slug: string
  /** Layout */
  layout?: any
  /** Html */
  html?: string
  /** An enumeration. */
  type?: PageLayoutType
  /** Parent Id */
  parent_id?: string
  /**
   * Date
   * The date of the page
   * @format date
   */
  date?: string
  /**
   * Image Url
   * The URL of the image for the page
   */
  image_url?: string | ''
  /**
   * Published At
   * The published date of the Page
   */
  published_at?: number
  /**
   * Position
   * The position of the page in the page list
   */
  position?: number
  render_options?: PageRenderOptions
}

/** PageLayout */
export interface PageLayout {
  /** Blocks */
  blocks?: Block[][]
}

/** PageRead */
export interface PageRead {
  /**
   * Key
   * External unique page identifier
   */
  key?: string
  /** Title */
  title: string
  /** Text */
  text: string
  /** Description */
  description: string
  /**
   * Slug
   * The slug of the page
   */
  slug: string
  /** Layout */
  layout?: any
  /** Html */
  html?: string
  /** An enumeration. */
  type?: PageLayoutType
  /** Parent Id */
  parent_id?: string
  /**
   * Date
   * The date of the page
   * @format date
   */
  date?: string
  /**
   * Image Url
   * The URL of the image for the page
   */
  image_url?: string | ''
  /**
   * Published At
   * The published date of the Page
   */
  published_at?: number
  /**
   * Position
   * The position of the page in the page list
   */
  position?: number
  render_options?: PageRenderOptions
  /** Id */
  id: string
  parent?: PageBase
  seo?: PageSeo
}

/** PageRenderOptions */
export interface PageRenderOptions {
  /** Is Promo Store */
  is_promo_store?: boolean
}

/** PageSeo */
export interface PageSeo {
  /** Title */
  title?: string
  /** Description */
  description?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
}

/** PageSeoRead */
export interface PageSeoRead {
  /** Title */
  title?: string
  /** Description */
  description?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /** Page Id */
  page_id: string
}

/** PageSeoUpdate */
export interface PageSeoUpdate {
  /** Title */
  title?: string
  /** Description */
  description?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
}

/** PageUpdate */
export interface PageUpdate {
  /**
   * Key
   * External unique page identifier
   */
  key?: string
  /** Title */
  title?: string
  /** Description */
  description?: string
  /** Text */
  text?: string
  /**
   * Slug
   * The slug of the page
   * @minLength 3
   * @maxLength 100
   */
  slug?: string
  layout?: PageLayout
  /** Html */
  html?: string
  /** An enumeration. */
  type?: PageLayoutType
  /** Parent Id */
  parent_id?: string
  /**
   * Date
   * The date of the page
   * @format date
   */
  date?: string
  /**
   * Image Url
   * The URL of the image for the page
   */
  image_url?: string | ''
  /**
   * Published At
   * The published date of the Page
   */
  published_at?: number
  /**
   * Position
   * The position of the page in the page list
   */
  position?: number
  render_options?: PageRenderOptions
}

/** PaginatedResponse[list[aghanim.creator.schemas.CreatorRead]] */
export interface PaginatedResponseListAghanimCreatorSchemasCreatorRead {
  /** Data */
  data: CreatorRead[]
  /** Total */
  total: number
  /** Limit */
  limit: number
  /** Offset */
  offset: number
  /** Indicates if there are more items to fetch. */
  has_next: boolean
}

/** Palette */
export interface Palette {
  /** Slug */
  slug: string
  /** Name */
  name: string
  /** An enumeration. */
  theme_raw_type: ThemeRawType
  /** Theme Raw Palette Main */
  theme_raw_palette_main: string
  /** Theme Raw Palette Brand A */
  theme_raw_palette_brand_a: string
  /** Theme Raw Palette Brand B */
  theme_raw_palette_brand_b?: string
  /**
   * Theme Raw Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  theme_raw_url?: string
}

/** PaymentMethod */
export interface PaymentMethod {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Caption */
  caption?: string
  /** Meta Name */
  meta_name?: string
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  logo_url?: string
  /** Fee */
  fee?: PaymentMethodFee[]
  settings: PaymentMethodSettings
  /** Supported Countries */
  supported_countries: string[]
  /** Dashboard Show */
  dashboard_show?: boolean
}

/** PaymentMethodFee */
export interface PaymentMethodFee {
  /** Country Code */
  country_code: string
  /** Currency */
  currency: string
  /** Fee Fix */
  fee_fix: number
  /** Fee Prc */
  fee_prc: number
}

/** PaymentMethodSettings */
export interface PaymentMethodSettings {
  /** Enabled */
  enabled: boolean
  /** Global Enabled */
  global_enabled?: boolean
}

/** PaymentRead */
export interface PaymentRead {
  /**
   * User Id
   * The user ID of the payment
   */
  user_id?: string
  /**
   * Player Id
   * The player ID of the payment
   */
  player_id?: string
  /**
   * Modified At
   * The time of the last modification
   */
  modified_at?: number
  /**
   * Player Name
   * The name of the player
   */
  player_name?: string
  /**
   * Item Id
   * The ID of the purchased item
   */
  item_id?: string
  /**
   * Item Name
   * The name of the purchased item
   */
  item_name?: string
  /**
   * Payment Method Id
   * The ID of the payment method
   */
  payment_method_id?: string
  /**
   * Payment Method Name
   * The name of the payment method
   */
  payment_method_name?: string
  /**
   * Status
   * The status of the payment
   */
  status?: PaymentStatus | string
  /**
   * Currency
   * The currency of the payment
   */
  currency?: string
  /**
   * Country
   * The ISO code country of the payment
   */
  country?: string
  /**
   * Payment Id
   * The ID of the payment
   */
  payment_id?: string
  /**
   * Ps Tx Id
   * The ID of the payment system transaction
   */
  ps_tx_id?: string
  /**
   * Payment Number
   * The number of the payment in receipt
   */
  payment_number?: string
  /**
   * Checkout Profile Id
   * The ID of the user checkout profile
   */
  checkout_profile_id?: string
  /**
   * Order Id
   * The ID of the order
   */
  order_id?: string
  /**
   * Card Last 4 Digits
   * The last 4 digits of the card
   */
  card_last_4_digits?: string
  /**
   * Card Bin
   * The BIN of the card
   */
  card_bin?: string
  /**
   * Card Scheme
   * The scheme of the card
   */
  card_scheme?: string
  /**
   * Total
   * The total amount of the payment
   */
  total?: number
  /**
   * Total Order Currency Billing
   * The total amount of the payment in the billing currency
   */
  total_order_currency_billing?: number
  /**
   * Total Usd
   * The payment amount converted at the exchange rate into dollars (Sales or GMV)
   */
  total_usd?: number
  /**
   * Total Usd Revenue
   * The profit in dollars, that is total_usd excluding all fees and taxes
   */
  total_usd_revenue?: number
  /**
   * User Local Price
   * The total amount in local currency of the payment before all discounts
   */
  user_local_price?: number
  /**
   * Currency Minor Unit
   * The minor unit of the currency
   */
  currency_minor_unit?: number
  /**
   * Fees
   * This includes all charges related to a payment, including the payment system fee, Aghanim fee, conversion, etc
   */
  fees?: object[]
  /**
   * Taxes
   * These are the taxes that arise from sales (the Withholding Tax is not included)
   */
  taxes?: object[]
  /**
   * Refund Customer Id
   * The ID of the refunded customer
   */
  refund_customer_id?: string
  /**
   * Refund Reason
   * The reason of the refund
   */
  refund_reason?: string
  /**
   * Ip
   * The IP address of the payment
   */
  ip?: any
  /**
   * Created At
   * The time of the payment creation
   */
  created_at?: number
  /**
   * Fail Reason
   * The reason of the payment failure
   */
  fail_reason?: string
  /**
   * Fail Reason Code
   * The code of the payment failure reason
   */
  fail_reason_code?: string
  /**
   * Status Updated At
   * The timestamp of the status update
   */
  status_updated_at?: number
  /**
   * Order Field
   * The transaction's serial number in the status list. Can be used to sort the transaction by the status list
   */
  order_field?: number
}

/** PaymentSettings */
export interface PaymentSettings {
  /**
   * Descriptor Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  descriptor_image_url?: string
  /** Descriptor Service Name */
  descriptor_service_name?: string
  /**
   * Descriptor Game Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  descriptor_game_url?: string
}

/** PaymentSuccessFail */
export interface PaymentSuccessFail {
  /** Date */
  date: string
  /** Success Payment */
  success_payment?: number
  /** Failed Payment */
  failed_payment?: number
}

/** Payout */
export interface Payout {
  /** Agreement Id */
  agreement_id: string
  /** Currency Code */
  currency_code: string
  /** Ending Balance */
  ending_balance: number
  /** Ending Date */
  ending_date: number
  /** Start Date */
  start_date: number
  /** Payout Amount */
  payout_amount: number
  /** Payout Status */
  payout_status: string
  /** Payout Type */
  payout_type: string
  /** Report Url */
  report_url?: string
  /** Paid Date */
  paid_date: number
}

/** PayoutMonth */
export interface PayoutMonth {
  /** Ending Date */
  ending_date: number
  /** Total */
  total: number
  /** Status */
  status: string
}

/** PayoutRequestPreview */
export interface PayoutRequestPreview {
  /** Balance */
  balance: number
  /** Pending Payments Reserves */
  pending_payments_reserves: number
  /** Transfer Fee */
  transfer_fee: number
  /** Total */
  total: number
}

/** PersistentCampaignAttributes */
export interface PersistentCampaignAttributes {
  /** Custom Attributes */
  custom_attributes?: CustomAttribute[]
  /** Abandoned Cart Duration */
  abandoned_cart_duration?: number
  /** Visit Duration */
  visit_duration?: number
  /** Page Slugs */
  page_slugs?: string[]
  /** Variables */
  variables?: MathExpression[]
}

/** PersistentPlayerAttributes */
export interface PersistentPlayerAttributes {
  /**
   * Level
   * @default 0
   */
  level?: number
  /** An enumeration. */
  platform?: Platform
  /** @default "none" */
  marketplace?: Marketplace
  /**
   * Saved Ach
   * @default false
   */
  saved_ach?: boolean
  /**
   * Saved Card
   * @default false
   */
  saved_card?: boolean
  /**
   * Soft Currency Amount
   * @default 0
   */
  soft_currency_amount?: number
  /**
   * Hard Currency Amount
   * @default 0
   */
  hard_currency_amount?: number
  /** Appsflyer Id */
  appsflyer_id?: string
  /** Appsflyer App Id */
  appsflyer_app_id?: string
  /** Appsflyer Meta */
  appsflyer_meta?: object
  /** Adjust Device Id */
  adjust_device_id?: Record<string, string>
  /** Adjust Adid */
  adjust_adid?: string
  /** Adjust Callback Params */
  adjust_callback_params?: Record<string, string>
  /** Adjust Partner Params */
  adjust_partner_params?: Record<string, string>
  /** Singular Device Id */
  singular_device_id?: Record<string, string>
  /** Singular App Id */
  singular_app_id?: string
  /** Devtodev Appid */
  devtodev_appid?: string
  /** Devtodev Apikey */
  devtodev_apikey?: string
  devtodev_device_id?: DevtodevDeviceId
  /** Game Hub Last Sent Popup Unread */
  game_hub_last_sent_popup_unread?: number
  /** Game Hub Last Sent Popup Read */
  game_hub_last_sent_popup_read?: number
  /** Prev Last Active At */
  prev_last_active_at?: number
  /** Subscriptions */
  subscriptions?: Record<string, number>
}

/** PersonalCompany */
export interface PersonalCompany {
  /**
   * Name
   * Company name
   * @maxLength 254
   */
  name: string
  /**
   * Size
   * Number of employees
   * @min 1
   */
  size: number
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /** Domains */
  domains?: string[]
  /** Viewer Domains */
  viewer_domains?: string[]
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  logo_url?: string
  /** An enumeration. */
  instant_payout_status?: PayoutRequestStatus
  /** Id */
  id: string
  /** An enumeration. */
  role: Role
}

/**
 * PersonalItem
 * An item with additional fields that are specific to the user.
 *
 * This item crafted from database item with some adjustments:
 * 1. price and currency updated based on the user's country and price point
 * 2. price after discount is calculated based on the user's offers and coupons
 */
export interface PersonalItem {
  /**
   * Name
   * The name of the item
   * @maxLength 255
   */
  name: string
  /**
   * Description
   * The description of the item
   * @maxLength 512
   */
  description: string
  /**
   * Price
   * The price of the item in minor [currency units](https://docs.aghanim.com/currencies/). The system will automatically adjust this to the closest available price point. If you want to set a specific price point, use `price_template_id` instead.
   */
  price?: number
  /**
   * Price Point
   * The price point for local prices `DEPRECATED`
   * @exclusiveMin 0
   * @max 5000000
   */
  price_point?: number
  /**
   * Price Template Id
   * The ID of the price template
   */
  price_template_id?: string
  /**
   * Reward Points Price
   * The reward points price for local prices
   */
  reward_points_price?: number
  /** The currency of the item */
  currency: Currency
  /**
   * Sku
   * The SKU of the item
   * @maxLength 100
   */
  sku: string
  /**
   * Image Url
   * The URL of the image for the item
   */
  image_url?: string | ''
  /**
   * Icon Url
   * The URL of the icon for the item
   */
  icon_url?: string | ''
  /**
   * Image Url Featured
   * The URL of the image for the item in the featured card
   */
  image_url_featured?: string | ''
  /**
   * Background Image Url
   * The URL of the background image for the item
   */
  background_image_url?: string | ''
  /**
   * Background Image Color
   * The color of the background image for the item
   */
  background_image_color?: string
  /**
   * Featured Card Background Image Url
   * The URL of the featured card background image for the item
   */
  featured_card_background_image_url?: string | ''
  /** The type of the item */
  type: ItemType
  /**
   * Controls the store appearance of the item
   * @default "default"
   */
  view_option?: ItemViewOption
  /**
   * Quantity
   * The quantity of the item
   * @min 1
   * @max 1000000000000000000
   * @default 1
   */
  quantity?: number
  /**
   * Is Stackable
   * Whether the item is stackable
   */
  is_stackable: boolean
  /**
   * Is Currency
   * Whether the item is a currency.
   */
  is_currency: boolean
  /**
   * Position
   * Position of the item in list
   */
  position?: number
  /**
   * Categories
   * The list of category IDs
   */
  categories?: string[]
  /**
   * Duration
   * Item's in-game action in seconds
   */
  duration?: number
  /**
   * Enable Reward Points Redemption
   * Allows using Reward Points on purchase
   */
  enable_reward_points_redemption?: boolean
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
  /**
   * Properties
   * The item properties
   */
  properties?: ItemPropertyRelationRead[]
  /** An enumeration. */
  source?: ItemSource
  /**
   * Rarity Id
   * The rarity id of the item
   */
  rarity_id?: string
  item_rarity?: ItemRarityRead
  /**
   * Discount Percent
   * The discount percent for the item
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the item
   * @min 0
   */
  bonus_percent?: number
  /**
   * Is Custom
   * @default false
   */
  is_custom?: boolean
  /** Price After Discount */
  price_after_discount?: number
  /** Price After Discount Usd */
  price_after_discount_usd?: number
  /** Quantity After Bonus */
  quantity_after_bonus: number
  /** Quantity Bonus Value */
  quantity_bonus_value?: number
  /** Store Item Id */
  store_item_id?: string
  /** Price Minor Unit */
  price_minor_unit: number
  /** Price Decimal */
  price_decimal?: number
  /** Custom Badge */
  custom_badge?: string
  /** Expires At */
  expires_at?: number
  /** Eligible For Reward Points */
  eligible_for_reward_points?: number
  /** Eligible For Loyalty Points */
  eligible_for_loyalty_points?: number
  /**
   * Is Free Item
   * @default false
   */
  is_free_item?: boolean
  /** An enumeration. */
  card_type?: StoreCardType
  /** Show First On Category List */
  show_first_on_category_list?: boolean
  /** Max Purchases */
  max_purchases?: number
  /** Purchases Left */
  purchases_left?: number
  /** Next Purchase At */
  next_purchase_at?: number
  /**
   * Bonus Fixed
   * The fixed bonus value for the item
   * @min 1
   */
  bonus_fixed?: number
  /** Nested Items Read */
  nested_items_read?: ItemRead[]
  /** Bonus Items */
  bonus_items?: ItemRead[]
  /**
   * Bonus Badge
   * Custom text for bonus badge
   */
  bonus_badge?: string | null
  fallback_item?: ItemRead
  /**
   * Fallback Item Id
   * The item that will be given as fallback if the main item can't be given to the player
   */
  fallback_item_id?: string
  /**
   * Fallback Item Quantity
   * The quantity of the fallback item
   * @min 1
   * @max 1000000000000000000
   */
  fallback_item_quantity?: number
  /** Nested Items */
  nested_items?: any[]
  /**
   * Lootbox Settings
   * The settings of the lootbox
   */
  lootbox_settings?: LootboxSettings
  /**
   * Attempts Count
   * The number of attempts to open this lootbox
   * @default 0
   */
  attempts_count?: number
  offers?: Offers
  /** Meta */
  meta?: object
}

/** PersonalPickOneOffer */
export interface PersonalPickOneOffer {
  /** Id */
  id: string
  /** Item Id */
  item_id: string
}

/** PersonalRangeOffer */
export interface PersonalRangeOffer {
  /**
   * Id
   * The range offer ID
   */
  id: string
  /** Local Amount */
  local_amount: number
  /** Quantity For One Cent */
  quantity_for_one_cent: number
  /** Tiers */
  tiers: RangeOfferTier[]
  /** Local Tiers */
  local_tiers: LocalTier[]
  /**
   * Quantity
   * @default 0
   */
  quantity?: number
  /**
   * Applied Bonus Value
   * @default 0
   */
  applied_bonus_value?: number
  /**
   * Applied Bonus Percent
   * @default 0
   */
  applied_bonus_percent?: number
}

/** PersonalRollingOffer */
export interface PersonalRollingOffer {
  /** Id */
  id: string
  rolling_item: RollingItem
  /** Item Idx */
  item_idx: number
}

/** PersonalSequentialOffer */
export interface PersonalSequentialOffer {
  /**
   * Sequential Offer Id
   * The sequential offer ID
   */
  sequential_offer_id?: string
  /**
   * User Sequential Offer Id
   * The user sequential offer ID
   */
  user_sequential_offer_id?: string
  /**
   * Sequential Pack Id
   * Pack ID of the sequential offer
   */
  sequential_pack_id?: string
  /**
   * Take All Packs
   * Create order with all opened packs
   * @default false
   */
  take_all_packs?: boolean
  /**
   * Dropped Packs
   * Dropped packs information
   */
  dropped_packs?: DroppedPack[]
  /**
   * Applied Bonus Value
   * @default 0
   */
  applied_bonus_value?: number
  /**
   * Applied Bonus Percent
   * @default 0
   */
  applied_bonus_percent?: number
  /** Packs */
  packs: Pack[]
  /** Order Id */
  order_id?: string
}

/** PickOneItem */
export interface PickOneItem {
  /**
   * Item Id
   * The item ID
   */
  item_id: string
  /**
   * Quantity
   * The item quantity
   */
  quantity?: number
}

/** PickOneOfferCreate */
export interface PickOneOfferCreate {
  /**
   * Name
   * Title of the pick one offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the pick one offer shown on the block with offer
   */
  description: string
  /**
   * Start At
   * The start timestamp of the pick one offer when promotion is active
   */
  start_at?: number | null
  /**
   * End At
   * The end timestamp of the pick one offer when promotion is active
   */
  end_at?: number | null
  /**
   * Item Id
   * The item ID
   */
  item_id: string
  /**
   * Settings
   * The settings of the pick one offer
   */
  settings: PickOneOfferSettings
}

/** PickOneOfferRead */
export interface PickOneOfferRead {
  /**
   * Name
   * Title of the pick one offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the pick one offer shown on the block with offer
   */
  description: string
  /**
   * Start At
   * The start timestamp of the pick one offer when promotion is active
   */
  start_at?: number | null
  /**
   * End At
   * The end timestamp of the pick one offer when promotion is active
   */
  end_at?: number | null
  /**
   * Item Id
   * The item ID
   */
  item_id: string
  /**
   * Settings
   * The settings of the pick one offer
   */
  settings: PickOneOfferSettings
  /**
   * Id
   * The unique identifier of the pick one offer
   */
  id: string
}

/** PickOneOfferSettings */
export interface PickOneOfferSettings {
  /**
   * Items
   * List of items to choose from in the offer
   * @minItems 2
   */
  items: PickOneItem[]
  /**
   * Background Image Url
   * URL to the background image of the block with offer
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
  /** Size of the background image of the block with offer */
  background_size?: BackgroundSize
}

/** PickOneOfferUpdate */
export interface PickOneOfferUpdate {
  /**
   * Name
   * Title of the pick one offer shown on the block with offer
   */
  name?: string
  /**
   * Description
   * Description of the pick one offer shown on the block with offer
   */
  description?: string
  /**
   * Start At
   * The start timestamp of the pick one offer when promotion is active
   */
  start_at?: number | null
  /**
   * End At
   * The end timestamp of the pick one offer when promotion is active
   */
  end_at?: number | null
  /**
   * Item Id
   * The item ID
   */
  item_id?: string
  /**
   * Settings
   * The settings of the pick one offer
   */
  settings?: PickOneOfferSettings
}

/** PlayerInfo */
export interface PlayerInfo {
  /**
   * Name
   * The player's name.
   */
  name?: string
  /**
   * Avatar Url
   * The player's avatar URL.
   */
  avatar_url?: string
}

/** PluginConfigSchema */
export interface PluginConfigSchema {
  /** Layout */
  layout: (PluginPageBlock | PluginDivider | PluginSectionHeader | FieldListBlock | EmptyBlock)[]
  /** Install Oauth Link */
  install_oauth_link?: string
}

/** PluginDivider */
export interface PluginDivider {
  /**
   * Model Type
   * @default "PluginDivider"
   */
  model_type?: 'PluginDivider'
}

/** PluginField */
export interface PluginField {
  /**
   * Model Type
   * @default "Field"
   */
  model_type?: 'Field'
  /** Name */
  name: string
  /** Label */
  label: string
  /** Description */
  description?: string
  /** Placeholder */
  placeholder?: string
  /** Dict Value Type */
  dict_value_type?: string
  /** An enumeration. */
  type: PluginFieldType
  /**
   * Is Secret
   * @default false
   */
  is_secret?: boolean
  /**
   * Required
   * @default false
   */
  required?: boolean
  /** Select Options */
  select_options?: SelectOption[]
  /** Value */
  value?: string
}

/** PluginInstanceCreate */
export interface PluginInstanceCreate {
  /** Plugin Config */
  plugin_config: object
  /** Enabled */
  enabled?: boolean | null
  /** Plugin Data */
  plugin_data?: Record<string, string>
  /** Secret Data */
  secret_data?: Record<string, string>
}

/** PluginInstanceRead */
export interface PluginInstanceRead {
  /** Id */
  id: string
  plugin: PluginRead
  /** Plugin Config */
  plugin_config?: object | null
  /** Plugin Instance Config Schema */
  plugin_instance_config_schema?: PluginConfigSchema | null
  /** Enabled */
  enabled: boolean
}

/** PluginInstanceUpdate */
export interface PluginInstanceUpdate {
  /** Plugin Config */
  plugin_config?: object | null
  /** Enabled */
  enabled?: boolean
  /** Plugin Data */
  plugin_data?: Record<string, string>
}

/** PluginPageBlock */
export interface PluginPageBlock {
  /**
   * Model Type
   * @default "PluginPageBlock"
   */
  model_type?: 'PluginPageBlock'
  /** Title */
  title: string
  /** Description */
  description: string
  /** Children */
  children: (FieldListBlock | PluginDivider | PluginSectionHeader | EmptyBlock)[]
}

/** PluginRead */
export interface PluginRead {
  /** Id */
  id: string
  /** Slug */
  slug: string
  /** Name */
  name: string
  /** Description */
  description: string
  /** Author */
  author: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  image_url?: string
  /** An enumeration. */
  type: PluginType
  plugin_config_schema?: PluginConfigSchema
  /** An enumeration. */
  category?: PluginCategory
  /** Subtitle */
  subtitle?: string
}

/** PluginSectionHeader */
export interface PluginSectionHeader {
  /**
   * Model Type
   * @default "PluginSectionHeader"
   */
  model_type?: 'PluginSectionHeader'
  /** Title */
  title: string
  /** Description */
  description?: string
}

/** PointSeriesValue */
export interface PointSeriesValue {
  /** Category */
  category: string
  /** Values */
  values: Record<string, number>
}

/** PointValue */
export interface PointValue {
  /** Category */
  category: string
  /** Value */
  value?: number
}

/** PointValueEx */
export interface PointValueEx {
  /** Category */
  category: string
  /** Value */
  value?: number
  /** Prev Value */
  prev_value?: number
  /** Prev Category */
  prev_category?: string
}

/** Price */
export interface Price {
  /** An enumeration. */
  country: Country
  /** An enumeration. */
  currency: Currency
  /** An enumeration. */
  platform: Platform
  /**
   * Price
   * @min 0
   * @max 1000000000000
   */
  price: number
}

/** PriceItemRead */
export interface PriceItemRead {
  /** Item Id */
  item_id: string
  /** An enumeration. */
  category: PriceCategory
  /** Id */
  id: string
  /** Prices */
  prices: ItemPrice[]
}

/** PriceTemplateCreate */
export interface PriceTemplateCreate {
  /**
   * Name
   * Name of the price template
   */
  name: string
  /**
   * Price
   * Price point used to derive pricing details
   */
  price: number
  /** Category of the price template (e.g., none or platform) */
  category: PriceCategory
  /**
   * Customs
   * List of price customizations overwriting platform suggested prices
   */
  customs: Price[]
}

/** PriceTemplateRead */
export interface PriceTemplateRead {
  /**
   * Name
   * Name of the price template
   */
  name: string
  /**
   * Price
   * Price point used to derive pricing details
   */
  price: number
  /** Category of the price template (e.g., none or platform) */
  category: PriceCategory
  /**
   * Id
   * Unique identifier for the price template
   */
  id: string
  /**
   * Items Count
   * Number of items linked to the template
   * @default 0
   */
  items_count?: number
  /**
   * Created At
   * Timestamp (in epoch seconds) when the template was created
   */
  created_at: number
  /**
   * Modified At
   * Timestamp (in epoch seconds) when the template was last modified
   */
  modified_at?: number
  /**
   * Prices
   * List of prices derived from the template
   */
  prices: TemplatePrice[]
}

/** PriceTemplateShort */
export interface PriceTemplateShort {
  /**
   * Name
   * Name of the price template
   */
  name: string
  /**
   * Price
   * Price point used to derive pricing details
   */
  price: number
  /** Category of the price template (e.g., none or platform) */
  category: PriceCategory
  /**
   * Id
   * Unique identifier for the price template
   */
  id: string
  /**
   * Items Count
   * Number of items linked to the template
   * @default 0
   */
  items_count?: number
  /**
   * Created At
   * Timestamp (in epoch seconds) when the template was created
   */
  created_at: number
  /**
   * Modified At
   * Timestamp (in epoch seconds) when the template was last modified
   */
  modified_at?: number
}

/** PriceTemplateUpdate */
export interface PriceTemplateUpdate {
  /**
   * Name
   * Updated name of the price template
   */
  name?: string
  /**
   * Price
   * Updated price point
   */
  price?: number
  /** Updated category of the price template) */
  category?: PriceCategory
  /**
   * Customs
   * List of price customizations overwriting platform suggested prices
   */
  customs?: Price[]
}

/** ProfileUpdate */
export interface ProfileUpdate {
  /** Name */
  name?: string
  /** Avatar Url */
  avatar_url?: string
  /** An enumeration. */
  locale?: DashboardLocale
}

/** ProgressionProgramBlock */
export interface ProgressionProgramBlock {
  /**
   * Block
   * @default "ProgressionProgramBlock"
   */
  block?: 'ProgressionProgramBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Program Id */
  program_id: string
  /** @default "standard" */
  variant?: LoyaltyProgramBlockVariant
  /** Hide Title */
  hide_title?: boolean
}

/** ProgressionProgramCreate */
export interface ProgressionProgramCreate {
  /**
   * Name
   * Name of the progression program
   */
  name: string
  /**
   * Description
   * Description of the progression program
   */
  description?: string | null
  /**
   * Title
   * The title of the progression program page for display
   */
  title?: string | null
  /**
   * Content
   * The content of the progression program page for display
   */
  content?: string | null
  /**
   * Start At
   * The timestamp when the progression program starts
   */
  start_at?: number | null
  /**
   * End At
   * The timestamp when the progression program ends
   */
  end_at?: number | null
  /**
   * Settings
   * Progression program settings
   */
  settings: ProgressionProgramSettings
  /**
   * Pp Granting Item Ids
   * The list of item IDs that grant progression points when purchased
   * @minItems 1
   */
  pp_granting_item_ids: string[]
  /**
   * Main Item Id
   * The main item ID for the program, used for display progress
   */
  main_item_id?: string | null
}

/** ProgressionProgramItem */
export interface ProgressionProgramItem {
  /**
   * Item Id
   * The reward item ID
   */
  item_id: string
  /**
   * Quantity
   * The reward item quantity
   */
  quantity?: number
}

/** ProgressionProgramRead */
export interface ProgressionProgramRead {
  /**
   * Name
   * Name of the progression program
   */
  name: string
  /**
   * Description
   * Description of the progression program
   */
  description?: string | null
  /**
   * Title
   * The title of the progression program page for display
   */
  title?: string | null
  /**
   * Content
   * The content of the progression program page for display
   */
  content?: string | null
  /**
   * Start At
   * The timestamp when the progression program starts
   */
  start_at?: number | null
  /**
   * End At
   * The timestamp when the progression program ends
   */
  end_at?: number | null
  /**
   * Settings
   * Progression program settings
   */
  settings: ProgressionProgramSettings
  /**
   * Pp Granting Item Ids
   * The list of item IDs that grant progression points when purchased
   * @minItems 1
   */
  pp_granting_item_ids: string[]
  /**
   * Main Item Id
   * The main item ID for the program, used for display progress
   */
  main_item_id?: string | null
  /**
   * Id
   * Progression program identifier
   */
  id: string
  /**
   * Created At
   * The timestamp when the progression program was created
   */
  created_at: number
  /**
   * Modified At
   * The timestamp when the progression program was last modified
   */
  modified_at?: number
}

/** ProgressionProgramSettings */
export interface ProgressionProgramSettings {
  /**
   * Rewards
   * The list of reward tiers
   * @minItems 1
   */
  rewards: ProgressionProgramTier[]
  /**
   * Background Image Url
   * The URL of the background image for the program display
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string | null
  /** The size of the background image for the program display */
  background_size?: BackgroundSize | null
  /** The type of level to display in the program */
  display_level_type?: DisplayLevelType | null
}

/** ProgressionProgramTier */
export interface ProgressionProgramTier {
  /**
   * Items
   * The reward items
   * @minItems 1
   */
  items: ProgressionProgramItem[]
  /**
   * Value
   * The threshold value in progression points for the tier
   * @min 1
   */
  value: number
  /**
   * Rank Name
   * The name of the rank for this tier
   */
  rank_name?: string
  /**
   * Image Url
   * The URL of the tier image
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Background Image Url
   * The URL of the background image for the tier display
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
}

/** ProgressionProgramUpdate */
export interface ProgressionProgramUpdate {
  /**
   * Name
   * Name of the progression program
   */
  name?: string
  /**
   * Description
   * Description of the progression program
   */
  description?: string | null
  /**
   * Title
   * The title of the progression program page for display
   */
  title?: string | null
  /**
   * Content
   * The content of the progression program page for display
   */
  content?: string | null
  /**
   * Start At
   * The timestamp when the progression program starts
   */
  start_at?: number
  /**
   * End At
   * The timestamp when the progression program ends
   */
  end_at?: number
  /**
   * Settings
   * Progression program settings
   */
  settings?: ProgressionProgramSettings
  /**
   * Pp Granting Item Ids
   * The list of item IDs that grant progression points when purchased
   * @minItems 1
   */
  pp_granting_item_ids?: string[]
  /**
   * Main Item Id
   * The main item ID for the program, used for display progress
   */
  main_item_id?: string
}

/** PromotionPaymentLimits */
export interface PromotionPaymentLimits {
  /** Requires Payment Methods */
  requires_payment_methods?: string[]
  /** Requires Payment Method Save */
  requires_payment_method_save?: boolean
}

/** RangeOfferBlock */
export interface RangeOfferBlock {
  /**
   * Block
   * @default "RangeOfferBlock"
   */
  block?: 'RangeOfferBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Range Offer Id */
  range_offer_id: string
}

/** RangeOfferCreate */
export interface RangeOfferCreate {
  /**
   * Item Id
   * The item ID of the range offer
   */
  item_id: string
  /**
   * Start At
   * The start timestamp of the sequenced offer when promotion is active
   */
  start_at?: number
  /**
   * End At
   * The end timestamp of the sequenced offer when promotion is active
   */
  end_at?: number
  /**
   * Settings
   * The settings of the sequential offer
   */
  settings: RangeOfferSettings
  /**
   * Name
   * Title of the sequential offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the sequential offer shown on the block with offer
   */
  description: string
}

/** RangeOfferRead */
export interface RangeOfferRead {
  /**
   * Item Id
   * The item ID of the range offer
   */
  item_id: string
  /**
   * Start At
   * The start timestamp of the sequenced offer when promotion is active
   */
  start_at?: number
  /**
   * End At
   * The end timestamp of the sequenced offer when promotion is active
   */
  end_at?: number
  /**
   * Settings
   * The settings of the sequential offer
   */
  settings: RangeOfferSettings
  /**
   * Name
   * Title of the sequential offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the sequential offer shown on the block with offer
   */
  description: string
  /**
   * Id
   * The unique identifier of the range offer
   */
  id: string
  /**
   * Item
   * The item information of the range offer
   */
  item: ItemRead
}

/** RangeOfferSettings */
export interface RangeOfferSettings {
  /**
   * Tiers
   * List of tiers available in the offer
   * @minItems 1
   */
  tiers: RangeOfferTier[]
  /**
   * Max Purchases
   * Maximum number of times the offer can be purchased per user
   */
  max_purchases?: number
  /**
   * Quantity For One Cent
   * Amount of the offer that will give for one cent USD
   * @exclusiveMin 0
   */
  quantity_for_one_cent: number
  /**
   * Background Image Url
   * The background image for the offer block
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
  /** Size of the background image of the block with offer */
  background_size?: BackgroundSize
  /**
   * Background Tier List Color
   * The background color of the tier list
   */
  background_tier_list_color?: string
}

/** RangeOfferTier */
export interface RangeOfferTier {
  /**
   * Id
   * Unique identifier for the tier
   * @minLength 1
   */
  id: string
  /**
   * From Usd
   * Start amount in USD in cents
   * @min 0
   */
  from_usd: number
  /**
   * To Usd
   * End amount in USD in cents
   * @exclusiveMin 1
   */
  to_usd: number
  /**
   * Bonus Percent
   * Bonus percent for the tier
   */
  bonus_percent: number
  /**
   * Background Image Url
   * The background image of the tier
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
}

/** RangeOfferUpdate */
export interface RangeOfferUpdate {
  /**
   * Item Id
   * The item ID of the range offer
   */
  item_id?: string
  /**
   * Start At
   * The start timestamp of the sequenced offer when promotion is active
   */
  start_at?: number
  /**
   * End At
   * The end timestamp of the sequenced offer when promotion is active
   */
  end_at?: number
  /**
   * Settings
   * The settings of the range offer
   */
  settings?: RangeOfferSettings
  /**
   * Name
   * Title of the range offer shown on the block with offer
   */
  name?: string
  /**
   * Description
   * Description of the range offer shown on the block with offer
   */
  description?: string
}

/** ReceiptParams */
export interface ReceiptParams {
  /** Item Ids */
  item_ids: string[]
  order_payment: OrderPayment
  promocode?: ReceiptParamsPromocode
  /** Benefits */
  benefits: Benefit[]
  /** Appreciation Text */
  appreciation_text: string
  /** An enumeration. */
  currency: Currency
  /** Language codes according to ISO 639-1. */
  locale: Locale
  /** Rewards Visible */
  rewards_visible: boolean
  /** Reward Points */
  reward_points: string
  /** Loyalty Points */
  loyalty_points: string
  /** Sandbox */
  sandbox: boolean
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country?: string
  /** User Name */
  user_name?: string
}

/** ReceiptParamsPromocode */
export interface ReceiptParamsPromocode {
  /** Code */
  code: string
  /** Discount Amount Usd */
  discount_amount_usd: number
}

/** Rect */
export interface Rect {
  /** Left */
  left: number
  /** Top */
  top: number
  /** Width */
  width: number
  /** Height */
  height: number
}

/** RedeemCouponBlock */
export interface RedeemCouponBlock {
  /**
   * Block
   * @default "RedeemCouponBlock"
   */
  block?: 'RedeemCouponBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
}

/** RefundRequest */
export interface RefundRequest {
  /** Reason */
  reason: string
  /** Order Id */
  order_id: string
  /** Payment Number */
  payment_number: string
}

/** RemoveItemsStoreNode */
export interface RemoveItemsStoreNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "RemoveItemsStoreNode"
   */
  model_type?: 'RemoveItemsStoreNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Item Id */
  item_id: string
}

/** RenotifyRequest */
export interface RenotifyRequest {
  /** Order Id */
  order_id: string
}

/** ResendResult */
export interface ResendResult {
  /** Id */
  id: string
}

/** ResourceCount */
export interface ResourceCount {
  /** All Count */
  all_count: number
  /** Active Count */
  active_count: number
  /** Archived Count */
  archived_count: number
}

/** RewardItem */
export interface RewardItem {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Description */
  description: string
  /** Duration */
  duration?: number
  /** Quantity */
  quantity: number
  /** Is Stackable */
  is_stackable: boolean
  /** Image Url */
  image_url: string | ''
  /** Background Image Url */
  background_image_url?: string | ''
  /** Properties */
  properties: ItemPropertyRelationRead[]
  /** Nested Items Read */
  nested_items_read?: ItemRead[]
}

/** RewardPointLimits */
export interface RewardPointLimits {
  /** Max Apply Reward Points */
  max_apply_reward_points: number
  /** Max Apply Reward Points Currency Amount */
  max_apply_reward_points_currency_amount: number
  /** Max Applicable Reward Points Percent */
  max_applicable_reward_points_percent: number
  /** Currency Reward Points Rate */
  currency_reward_points_rate: number
}

/** RewardPointsSettings */
export interface RewardPointsSettings {
  /** Reward Points Rate */
  reward_points_rate?: number
  /** Max Applicable Reward Points Percent */
  max_applicable_reward_points_percent?: number
  /**
   * Source of price for calculating reward points: local_price (convert from local price) or base_price (use base USD price directly)
   * @default "local_price"
   */
  price_source?: RewardPointsPriceSource
}

/** RewardsSettings */
export interface RewardsSettings {
  /** Daily Rewards */
  daily_rewards: DayReward[]
  /** Extra Reward Items */
  extra_reward_items?: NestedItem[]
}

/** RewardsSettingsRead */
export interface RewardsSettingsRead {
  /** Daily Rewards */
  daily_rewards: DayRewardRead[]
  /** Extra Reward Items */
  extra_reward_items?: NestedItem[]
  /** Extra Reward Items Read */
  extra_reward_items_read?: RewardItem[]
}

/** RichContentBlock */
export interface RichContentBlock {
  /**
   * Block
   * @default "RichContentBlock"
   */
  block?: 'RichContentBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Html */
  html: string
}

/** RollingItem */
export interface RollingItem {
  /**
   * Item Id
   * The item ID
   */
  item_id: string
  /**
   * Quantity
   * The item quantity
   */
  quantity?: number
  /**
   * Is Free Item
   * Whether the item is a free item in the offer
   */
  is_free_item?: boolean
}

/** RollingOfferBlock */
export interface RollingOfferBlock {
  /**
   * Block
   * @default "RollingOfferBlock"
   */
  block?: 'RollingOfferBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Rolling Offer Id */
  rolling_offer_id: string
}

/** RollingOfferCreate */
export interface RollingOfferCreate {
  /**
   * Name
   * Title of the rolling offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the rolling offer shown on the block with offer
   */
  description: string
  /**
   * Start At
   * The start timestamp of the rolling offer when promotion is active
   */
  start_at?: number | null
  /**
   * End At
   * The end timestamp of the rolling offer when promotion is active
   */
  end_at?: number | null
  /**
   * Settings
   * The settings of the rolling offer
   */
  settings: RollingOfferSettings
}

/** RollingOfferRead */
export interface RollingOfferRead {
  /**
   * Name
   * Title of the rolling offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the rolling offer shown on the block with offer
   */
  description: string
  /**
   * Start At
   * The start timestamp of the rolling offer when promotion is active
   */
  start_at?: number | null
  /**
   * End At
   * The end timestamp of the rolling offer when promotion is active
   */
  end_at?: number | null
  /**
   * Settings
   * The settings of the rolling offer
   */
  settings: RollingOfferSettings
  /**
   * Id
   * The unique identifier of the rolling offer
   */
  id: string
}

/** RollingOfferSettings */
export interface RollingOfferSettings {
  /**
   * Rolling Items
   * List of items in the offer
   * @minItems 2
   */
  rolling_items: RollingItem[]
  /**
   * Background Image Url
   * URL to the background image of the block with offer
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
  /** Size of the background image of the block with offer */
  background_size?: BackgroundSize
}

/** RollingOfferUpdate */
export interface RollingOfferUpdate {
  /**
   * Name
   * Title of the rolling offer shown on the block with offer
   */
  name?: string
  /**
   * Description
   * Description of the rolling offer shown on the block with offer
   */
  description?: string
  /**
   * Start At
   * The start timestamp of the rolling offer when promotion is active
   */
  start_at?: number | null
  /**
   * End At
   * The end timestamp of the rolling offer when promotion is active
   */
  end_at?: number | null
  /**
   * Settings
   * The settings of the rolling offer
   */
  settings?: RollingOfferSettings
}

/** RotationSettings */
export interface RotationSettings {
  /**
   * Count
   * @exclusiveMin 0
   */
  count: number
  /**
   * Period Value
   * @exclusiveMin 0
   */
  period_value: number
  /** An enumeration. */
  period_type: PeriodType
  /** An enumeration. */
  type: RotationType
}

/** SankeyLinkData */
export interface SankeyLinkData {
  /** From Name */
  from_name: string
  /** To Name */
  to_name: string
  /** Value */
  value: number
}

/** SankeyTopSkuData */
export interface SankeyTopSkuData {
  /** Event To Message */
  event_to_message: SankeyLinkData[]
  /** Message To Sku */
  message_to_sku: SankeyLinkData[]
}

/** Screenshot */
export interface Screenshot {
  /** Src */
  src?: string
  /** Type */
  type?: string
  /** Sizes */
  sizes?: string
  /** @default "wide" */
  form_factor?: ScreenshotFormFactor
}

/** SegmentCreate */
export interface SegmentCreate {
  /** Slug */
  slug: string
  /** Name */
  name: string
  /** Description */
  description?: string
  /** Color */
  color?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /** Segment Group Id */
  segment_group_id?: string
}

/** SegmentGroupCreate */
export interface SegmentGroupCreate {
  /** Name */
  name: string
  /** An enumeration. */
  type: SegmentGroupType
  /** Enabled */
  enabled: boolean
  /** Is Template */
  is_template: boolean
}

/** SegmentGroupRead */
export interface SegmentGroupRead {
  /** Name */
  name: string
  /** An enumeration. */
  type: SegmentGroupType
  /** Enabled */
  enabled: boolean
  /** Is Template */
  is_template: boolean
  /** Id */
  id: string
}

/** SegmentGroupReadStat */
export interface SegmentGroupReadStat {
  /** Name */
  name: string
  /** An enumeration. */
  type: SegmentGroupType
  /** Enabled */
  enabled: boolean
  /** Is Template */
  is_template: boolean
  /** Id */
  id: string
  /** Segment Count */
  segment_count: number
}

/** SegmentGroupUpdate */
export interface SegmentGroupUpdate {
  /** Name */
  name?: string
  graph?: GraphRoot
  /** An enumeration. */
  type?: SegmentGroupType
  /** Enabled */
  enabled?: boolean
  /** Is Template */
  is_template?: boolean
}

/** SegmentRead */
export interface SegmentRead {
  /** Slug */
  slug: string
  /** Name */
  name: string
  /** Description */
  description?: string
  /** Color */
  color?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /** Segment Group Id */
  segment_group_id?: string
  /** Id */
  id: string
  segment_group?: SegmentGroupRead
}

/** SegmentUpdate */
export interface SegmentUpdate {
  /** Name */
  name?: string
  /** Description */
  description?: string
  /** Color */
  color?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /** Segment Group Id */
  segment_group_id?: string
  /** Slug */
  slug?: string
}

/** SelectOption */
export interface SelectOption {
  /** Label */
  label: string
  /** Value */
  value: string
  /** Description */
  description?: string
}

/** SequentialOfferBlock */
export interface SequentialOfferBlock {
  /**
   * Block
   * @default "SequentialOfferBlock"
   */
  block?: 'SequentialOfferBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Sequential Offer Id */
  sequential_offer_id: string
}

/** SequentialOfferCreate */
export interface SequentialOfferCreate {
  /**
   * Item Id
   * The item ID of the sequential offer
   */
  item_id: string
  /**
   * Start At
   * The start timestamp of the sequenced offer when promotion is active
   */
  start_at?: number
  /**
   * End At
   * The end timestamp of the sequenced offer when promotion is active
   */
  end_at?: number
  /**
   * Settings
   * The settings of the sequential offer
   */
  settings: SequentialOfferSettings
  /**
   * Name
   * Title of the sequential offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the sequential offer shown on the block with offer
   */
  description: string
}

/** SequentialOfferRead */
export interface SequentialOfferRead {
  /**
   * Item Id
   * The item ID of the sequential offer
   */
  item_id: string
  /**
   * Start At
   * The start timestamp of the sequenced offer when promotion is active
   */
  start_at?: number
  /**
   * End At
   * The end timestamp of the sequenced offer when promotion is active
   */
  end_at?: number
  /**
   * Settings
   * The settings of the sequential offer
   */
  settings: SequentialOfferSettings
  /**
   * Name
   * Title of the sequential offer shown on the block with offer
   */
  name: string
  /**
   * Description
   * Description of the sequential offer shown on the block with offer
   */
  description: string
  /**
   * Id
   * The unique identifier of the sequential offer
   */
  id: string
  /**
   * Item
   * The item information of the sequential offer
   */
  item: ItemRead
}

/** SequentialOfferSettings */
export interface SequentialOfferSettings {
  /**
   * Packs
   * List of packs available in the offer
   */
  packs: Pack[]
  /**
   * Background Image Url
   * URL to the background image of the block with offer
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  background_image_url?: string
  /** Size of the background image of the block with offer */
  background_size?: BackgroundSize
}

/** SequentialOfferUpdate */
export interface SequentialOfferUpdate {
  /**
   * Item Id
   * The item ID of the sequential offer
   */
  item_id?: string
  /**
   * Start At
   * The start timestamp of the sequenced offer when promotion is active
   */
  start_at?: number
  /**
   * End At
   * The end timestamp of the sequenced offer when promotion is active
   */
  end_at?: number
  /**
   * Settings
   * The settings of the sequential offer
   */
  settings?: SequentialOfferSettings
  /**
   * Name
   * Title of the sequential offer shown on the block with offer
   */
  name?: string
  /**
   * Description
   * Description of the sequential offer shown on the block with offer
   */
  description?: string
}

/** SeriesValue */
export interface SeriesValue {
  /** Category */
  category: string
  /** Value */
  value?: number
  /** Series Name */
  series_name?: string
  /** Prev Value */
  prev_value?: number
}

/** SetAttributeValuesNode */
export interface SetAttributeValuesNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "SetAttributeValuesNode"
   */
  model_type?: 'SetAttributeValuesNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Values */
  values: object
}

/** SocialMedia */
export interface SocialMedia {
  /** An enumeration. */
  name: SocialMediaName
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /** Custom Name */
  custom_name?: string
  /** Custom Icon Url */
  custom_icon_url?: string
}

/** SortStoreItemsNode */
export interface SortStoreItemsNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "SortStoreItemsNode"
   */
  model_type?: 'SortStoreItemsNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** An enumeration. */
  order: SortOrder
  /** An enumeration. */
  sort_by: SortStoreType
}

/** SplitInfo */
export interface SplitInfo {
  /**
   * Title
   * @default ""
   */
  title?: string
  /** Value */
  value: number
  /** Next Node Id */
  next_node_id?: string
}

/** SplitNode */
export interface SplitNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "SplitNode"
   */
  model_type?: 'SplitNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Distribution */
  distribution: SplitInfo[]
  /** Random Value */
  random_value?: number
  /** Value Next Node Id */
  value_next_node_id?: string
}

/** StoreBlock */
export interface StoreBlock {
  /**
   * Block
   * @default "StoreBlock"
   */
  block?: 'StoreBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Store Id */
  store_id?: string
  /** Category Id */
  category_id?: string
}

/** StoreBulkDelete */
export interface StoreBulkDelete {
  /** Id */
  id: string
}

/** StoreCategoryRenderOptions */
export interface StoreCategoryRenderOptions {
  /** Delay */
  delay?: number
  /** Loop */
  loop?: boolean
  /** Autoplay */
  autoplay?: boolean
  /** Show Dots */
  show_dots?: boolean
}

/** StoreCreate */
export interface StoreCreate {
  /** Name */
  name: string
  /** Description */
  description: string
  /** An enumeration. */
  type: StoreType
  rotation_settings?: RotationSettings
  limited_stock_settings?: LimitedStockSettings
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  settings?: AghanimStoreSchemasStoreSettings
}

/** StoreGraph */
export interface StoreGraph {
  /** Game Id */
  game_id: string
  /** Enabled */
  enabled: boolean
  /** Anonymous Allowed */
  anonymous_allowed?: boolean
}

/** StoreGraphResponse */
export interface StoreGraphResponse {
  graph?: StoreGraph
}

/** StoreGraphUpdate */
export interface StoreGraphUpdate {
  graph?: GraphRoot
  /** Enabled */
  enabled?: boolean
  /** Anonymous Allowed */
  anonymous_allowed?: boolean
}

/** StoreItemBenefit */
export interface StoreItemBenefit {
  /** An enumeration. */
  type: StoreItemBenefitType
  /** Discount Percent */
  discount_percent?: number
  /** Bonus Percent */
  bonus_percent?: number
  /** Reward Points Percent */
  reward_points_percent?: number
  /** Reward Points Fixed */
  reward_points_fixed?: number
  /** Bonus Item Percent */
  bonus_item_percent?: number
  /** Bonus Item Id */
  bonus_item_id?: string
  /** Bonus Item Quantity */
  bonus_item_quantity?: number
  /** Store Promotion Id */
  store_promotion_id?: string
  /** Loyalty Points Percent */
  loyalty_points_percent?: number
  /** Loyalty Points Fixed */
  loyalty_points_fixed?: number
  /** Requires Payment Methods */
  requires_payment_methods?: string[]
  /** Requires Payment Method Save */
  requires_payment_method_save?: boolean
}

/** StoreItemBonus */
export interface StoreItemBonus {
  /**
   * Id
   * The ID of the bonus item that will be given to the user when they purchase this item.
   */
  id: string
  /**
   * Quantity Fixed
   * The fixed quantity of the bonus item
   */
  quantity_fixed?: number | null
  /**
   * Quantity Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @min 0
   */
  quantity_percent?: number | null
}

/** StoreItemBonusSettings */
export interface StoreItemBonusSettings {
  /** Items */
  items: StoreItemBonus[]
}

/** StoreItemBulkDelete */
export interface StoreItemBulkDelete {
  /** Id */
  id: string
}

/** StoreItemBulkUpdate */
export interface StoreItemBulkUpdate {
  /** Discount Percent */
  discount_percent?: number | null
  /** Bonus Percent */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * The user will receive a fixed quantity of the item.
   */
  bonus_fixed?: number | null
  /** Position */
  position?: number | null
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string | null
  /** Max Purchases */
  max_purchases?: number | null
  /** Requirements Expression */
  requirements_expression?: Expression | null
  /**
   * Custom Badge
   * The custom badge for the item
   * @minLength 1
   * @maxLength 100
   */
  custom_badge?: string | null
  /** Start At */
  start_at?: number | null
  /** End At */
  end_at?: number | null
  /** Min Amount */
  min_amount?: number | null
  /** Reward Points Percent */
  reward_points_percent?: number | null
  /** Reward Points Fixed */
  reward_points_fixed?: number | null
  /** Loyalty Points Percent */
  loyalty_points_percent?: number | null
  /** Loyalty Points Fixed */
  loyalty_points_fixed?: number | null
  /** Payment Bound */
  payment_bound?: StoreItemPaymentSettings | null
  /** Is Free Item */
  is_free_item?: boolean
  /**
   * Rotation Weight
   * @min 0
   * @max 1000
   */
  rotation_weight?: number | null
  /** Max Reward Points Percent */
  max_reward_points_percent?: number | null
  max_purchases_period_type?: PeriodType | null
  /**
   * Max Purchases Period Value
   * @min 0
   */
  max_purchases_period_value?: number | null
  /** For 'global' limit all users will have the same timer based on max_purchases_period_value.For 'personal' limit each user will have their own timer based on max_purchases_period_value. */
  max_purchases_limit_type?: MaxPurchaseLimitPeriodType | null
  /** Show Disabled By Max Purchases */
  show_disabled_by_max_purchases?: boolean | null
  card_type?: StoreCardType | null
  /** Show First On Category List */
  show_first_on_category_list?: boolean | null
  /**
   * Bonus Item Id
   * @deprecated
   */
  bonus_item_id?: string | null
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   * @deprecated
   */
  bonus_item_quantity?: number | null
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @deprecated
   * @min 0
   */
  bonus_item_percent?: number | null
  /**
   * Bonus Items Settings
   * The bonus settings for the item, including bonus items and their quantities.
   */
  bonus_items_settings?: StoreItemBonusSettings | null
  /**
   * Bonus Badge
   * Custom text for bonus badge
   */
  bonus_badge?: string | null
  /**
   * Id
   * The unique identifier of the item
   */
  id: string
}

/** StoreItemCreate */
export interface StoreItemCreate {
  /** Item Id */
  item_id: string
  /** Discount Percent */
  discount_percent?: number | null
  /** Bonus Percent */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * The user will receive a fixed quantity of the item.
   */
  bonus_fixed?: number | null
  /** Position */
  position: number
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string | null
  /**
   * Max Purchases
   * The maximum number of purchases allowed for the item per user.
   */
  max_purchases?: number | null
  /**
   * Requirements Expression
   * Defines the rules by which an item is shown to the user
   */
  requirements_expression?: Expression | null
  /**
   * Custom Badge
   * The custom badge of the item
   * @maxLength 100
   */
  custom_badge?: string | null
  /** Campaign Id */
  campaign_id?: string | null
  /** User Campaign Id */
  user_campaign_id?: string | null
  /** Bond User Id */
  bond_user_id?: string | null
  /** Start At */
  start_at?: number | null
  /** End At */
  end_at?: number | null
  /** Min Amount */
  min_amount?: number | null
  /** Max Reward Points Percent */
  max_reward_points_percent?: number | null
  /**
   * Reward Points Percent
   * Percentage of reward points for the item.
   */
  reward_points_percent?: number | null
  /**
   * Reward Points Fixed
   * Fixed reward points for the item.
   */
  reward_points_fixed?: number | null
  /**
   * Loyalty Points Percent
   * Percentage of loyalty points for the item.
   */
  loyalty_points_percent?: number | null
  /**
   * Loyalty Points Fixed
   * Fixed loyalty points for the item.
   */
  loyalty_points_fixed?: number | null
  /**
   * Payment Bound
   * Payment settings for the item.
   */
  payment_bound?: StoreItemPaymentSettings | null
  /**
   * Is Free Item
   * @default false
   */
  is_free_item?: boolean
  /**
   * Rotation Weight
   * @min 0
   * @max 1000
   */
  rotation_weight?: number | null
  /** The period type for the max purchases limit. If not set, the limit is global and does not reset. */
  max_purchases_period_type?: PeriodType | null
  /**
   * Max Purchases Period Value
   * @min 0
   */
  max_purchases_period_value?: number | null
  /** For 'global' limit all users will have the same timer based on max_purchases_period_value.For 'personal' limit each user will have their own timer based on max_purchases_period_value and last purchase date. */
  max_purchases_limit_type?: MaxPurchaseLimitPeriodType | null
  /**
   * Show Disabled By Max Purchases
   * Whether to show the item as disabled when max purchases limit is reached.
   */
  show_disabled_by_max_purchases?: boolean | null
  /** The type of the card for the item, used for displaying in the store */
  card_type?: StoreCardType | null
  /**
   * Show First On Category List
   * Whether to show the item first on the category list
   */
  show_first_on_category_list?: boolean | null
  /**
   * Bonus Item Id
   * The ID of the bonus item that will be given to the user when they purchase this item.
   * @deprecated
   */
  bonus_item_id?: string | null
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   * @deprecated
   */
  bonus_item_quantity?: number | null
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @deprecated
   * @min 0
   */
  bonus_item_percent?: number | null
  /**
   * Bonus Items Settings
   * The bonus settings for the item, including bonus items and their quantities.
   */
  bonus_items_settings?: StoreItemBonusSettings | null
  /**
   * Bonus Badge
   * Custom text for bonus badge
   */
  bonus_badge?: string | null
}

/** StoreItemPaymentSettings */
export interface StoreItemPaymentSettings {
  /** Payment Method Ids */
  payment_method_ids?: string[]
}

/** StoreItemRead */
export interface StoreItemRead {
  /** Item Id */
  item_id: string
  /** Discount Percent */
  discount_percent?: number | null
  /** Bonus Percent */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * The user will receive a fixed quantity of the item.
   */
  bonus_fixed?: number | null
  /** Position */
  position: number
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string | null
  /**
   * Max Purchases
   * The maximum number of purchases allowed for the item per user.
   */
  max_purchases?: number | null
  /**
   * Requirements Expression
   * Defines the rules by which an item is shown to the user
   */
  requirements_expression?: Expression | null
  /**
   * Custom Badge
   * The custom badge of the item
   * @maxLength 100
   */
  custom_badge?: string | null
  /** Campaign Id */
  campaign_id?: string | null
  /** User Campaign Id */
  user_campaign_id?: string | null
  /** Bond User Id */
  bond_user_id?: string | null
  /** Start At */
  start_at?: number | null
  /** End At */
  end_at?: number | null
  /** Min Amount */
  min_amount?: number | null
  /** Max Reward Points Percent */
  max_reward_points_percent?: number | null
  /**
   * Reward Points Percent
   * Percentage of reward points for the item.
   */
  reward_points_percent?: number | null
  /**
   * Reward Points Fixed
   * Fixed reward points for the item.
   */
  reward_points_fixed?: number | null
  /**
   * Loyalty Points Percent
   * Percentage of loyalty points for the item.
   */
  loyalty_points_percent?: number | null
  /**
   * Loyalty Points Fixed
   * Fixed loyalty points for the item.
   */
  loyalty_points_fixed?: number | null
  /**
   * Payment Bound
   * Payment settings for the item.
   */
  payment_bound?: StoreItemPaymentSettings | null
  /**
   * Is Free Item
   * @default false
   */
  is_free_item?: boolean
  /**
   * Rotation Weight
   * @min 0
   * @max 1000
   */
  rotation_weight?: number | null
  /** The period type for the max purchases limit. If not set, the limit is global and does not reset. */
  max_purchases_period_type?: PeriodType | null
  /**
   * Max Purchases Period Value
   * @min 0
   */
  max_purchases_period_value?: number | null
  /** For 'global' limit all users will have the same timer based on max_purchases_period_value.For 'personal' limit each user will have their own timer based on max_purchases_period_value and last purchase date. */
  max_purchases_limit_type?: MaxPurchaseLimitPeriodType | null
  /**
   * Show Disabled By Max Purchases
   * Whether to show the item as disabled when max purchases limit is reached.
   */
  show_disabled_by_max_purchases?: boolean | null
  /** The type of the card for the item, used for displaying in the store */
  card_type?: StoreCardType | null
  /**
   * Show First On Category List
   * Whether to show the item first on the category list
   */
  show_first_on_category_list?: boolean | null
  /**
   * Bonus Item Id
   * The ID of the bonus item that will be given to the user when they purchase this item.
   * @deprecated
   */
  bonus_item_id?: string | null
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   * @deprecated
   */
  bonus_item_quantity?: number | null
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @deprecated
   * @min 0
   */
  bonus_item_percent?: number | null
  /**
   * Bonus Items Settings
   * The bonus settings for the item, including bonus items and their quantities.
   */
  bonus_items_settings?: StoreItemBonusSettings | null
  /**
   * Bonus Badge
   * Custom text for bonus badge
   */
  bonus_badge?: string | null
  /** Id */
  id: string
  /** Created At */
  created_at: number
  /** Item */
  item: ItemRead | LootboxRead
  /** Store Id */
  store_id: string
  /** Purchases Left */
  purchases_left?: number
  /** Next Purchase At */
  next_purchase_at?: number
  /** Benefits */
  benefits?: StoreItemBenefit[]
  /** Bonus Items */
  bonus_items?: ItemRead[]
  /** Applied Store Promotion Id */
  applied_store_promotion_id?: string
  /** Applied Store Promotion Ids */
  applied_store_promotion_ids?: string[]
}

/** StoreItemUpdate */
export interface StoreItemUpdate {
  /** Discount Percent */
  discount_percent?: number | null
  /** Bonus Percent */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * The user will receive a fixed quantity of the item.
   */
  bonus_fixed?: number | null
  /** Position */
  position?: number | null
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string | null
  /** Max Purchases */
  max_purchases?: number | null
  /** Requirements Expression */
  requirements_expression?: Expression | null
  /**
   * Custom Badge
   * The custom badge for the item
   * @minLength 1
   * @maxLength 100
   */
  custom_badge?: string | null
  /** Start At */
  start_at?: number | null
  /** End At */
  end_at?: number | null
  /** Min Amount */
  min_amount?: number | null
  /** Reward Points Percent */
  reward_points_percent?: number | null
  /** Reward Points Fixed */
  reward_points_fixed?: number | null
  /** Loyalty Points Percent */
  loyalty_points_percent?: number | null
  /** Loyalty Points Fixed */
  loyalty_points_fixed?: number | null
  /** Payment Bound */
  payment_bound?: StoreItemPaymentSettings | null
  /** Is Free Item */
  is_free_item?: boolean
  /**
   * Rotation Weight
   * @min 0
   * @max 1000
   */
  rotation_weight?: number | null
  /** Max Reward Points Percent */
  max_reward_points_percent?: number | null
  max_purchases_period_type?: PeriodType | null
  /**
   * Max Purchases Period Value
   * @min 0
   */
  max_purchases_period_value?: number | null
  /** For 'global' limit all users will have the same timer based on max_purchases_period_value.For 'personal' limit each user will have their own timer based on max_purchases_period_value. */
  max_purchases_limit_type?: MaxPurchaseLimitPeriodType | null
  /** Show Disabled By Max Purchases */
  show_disabled_by_max_purchases?: boolean | null
  card_type?: StoreCardType | null
  /** Show First On Category List */
  show_first_on_category_list?: boolean | null
  /**
   * Bonus Item Id
   * @deprecated
   */
  bonus_item_id?: string | null
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   * @deprecated
   */
  bonus_item_quantity?: number | null
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @deprecated
   * @min 0
   */
  bonus_item_percent?: number | null
  /**
   * Bonus Items Settings
   * The bonus settings for the item, including bonus items and their quantities.
   */
  bonus_items_settings?: StoreItemBonusSettings | null
  /**
   * Bonus Badge
   * Custom text for bonus badge
   */
  bonus_badge?: string | null
}

/** StoreLimitedStockStat */
export interface StoreLimitedStockStat {
  /** Emulate Remaining Quantity */
  emulate_remaining_quantity: number
  /** Remaining Quantity */
  remaining_quantity: number
}

/** StorePromotionBulkUpdate */
export interface StorePromotionBulkUpdate {
  /**
   * Name
   * The name of the promotion
   */
  name?: string
  /**
   * Start At
   * The start date of the promotion in seconds when the promotion starts to be applied
   */
  start_at?: number
  /**
   * End At
   * The end date of the promotion in seconds when the promotion ends to be applied
   */
  end_at?: number
  /**
   * Discount Percent
   * The discount percent of the promotion
   * @min 0
   * @max 99
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent of the promotion for a stackable items
   * @min 0
   */
  bonus_percent?: number
  /**
   * Max Purchase Count
   * The maximum purchase count of the promotion. If the user exceeds this count, the promotion will not be applied.
   */
  max_purchase_count?: number
  /**
   * Max Purchase Count Per User
   * The maximum purchase count per user. If the user exceeds this count, the promotion will not be applied. This setting is mutually exclusive with 'max_purchase_count'
   */
  max_purchase_count_per_user?: number
  /**
   * Reward Points Percent
   * The rewards points percent of the promotion
   * @min 0
   * @max 100
   */
  reward_points_percent?: number
  /**
   * Reward Points Fixed
   * The fixed rewards points points amount
   * @min 1
   */
  reward_points_fixed?: number
  /**
   * Loyalty Points Percent
   * The loyalty points percent of the promotion
   * @min 0
   * @max 100
   */
  loyalty_points_percent?: number
  /**
   * Loyalty Points Fixed
   * The fixed loyalty points amount
   * @min 1
   */
  loyalty_points_fixed?: number
  /**
   * Exclude Items For Reward Points
   * Turn off discount benefit for items that can be purchased with reward points
   */
  exclude_items_for_reward_points?: boolean
  /**
   * Store Ids
   * Store ids that the promotion is applied to
   */
  store_ids?: string[]
  /**
   * Item Ids
   * Item ids that the promotion is applied to
   */
  item_ids?: string[]
  /**
   * Category Ids
   * Category ids that the promotion is applied to
   */
  category_ids?: string[]
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @min 0
   */
  bonus_item_percent?: number
  /**
   * Bonus Item Id
   * The item ID that the user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   */
  bonus_item_id?: string
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   */
  bonus_item_quantity?: number
  /**
   * Active
   * Allows to enable or disable the promotion
   */
  active?: boolean
  /**
   * Archived At
   * The date when the promotion is archived in seconds
   */
  archived_at?: number
  /**
   * Requirements Expression
   * Defines the conditions under which the promotion is applied. Only applicable for authenticated users.
   */
  requirements_expression?: Expression
  /**
   * Payment Limits
   * Defines the payment methods limits for the promotion. If it set benefits shown only on checkout page
   */
  payment_limits?: PromotionPaymentLimits
  /** Id */
  id: string
}

/** StorePromotionCount */
export interface StorePromotionCount {
  /** All Count */
  all_count: number
  /** Active Count */
  active_count: number
  /** Archived Count */
  archived_count: number
  /** Draft Count */
  draft_count: number
}

/** StorePromotionCreate */
export interface StorePromotionCreate {
  /**
   * Name
   * The name of the promotion
   */
  name?: string
  /**
   * Start At
   * The start date of the promotion in seconds when the promotion starts to be applied
   */
  start_at: number
  /**
   * End At
   * The end date of the promotion in seconds when the promotion ends to be applied
   */
  end_at: number
  /**
   * Discount Percent
   * The discount percent of the promotion
   * @min 0
   * @max 99
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent of the promotion for a stackable items
   * @min 0
   */
  bonus_percent?: number
  /**
   * Max Purchase Count
   * The maximum purchase count of the promotion. If the user exceeds this count, the promotion will not be applied.
   */
  max_purchase_count?: number
  /**
   * Max Purchase Count Per User
   * The maximum purchase count per user. If the user exceeds this count, the promotion will not be applied. This setting is mutually exclusive with 'max_purchase_count'
   */
  max_purchase_count_per_user?: number
  /**
   * Reward Points Percent
   * The rewards points percent of the promotion
   * @min 0
   * @max 100
   */
  reward_points_percent?: number
  /**
   * Reward Points Fixed
   * The fixed rewards points amount
   * @min 1
   */
  reward_points_fixed?: number
  /**
   * Loyalty Points Percent
   * The loyalty points percent of the promotion
   * @min 0
   * @max 100
   */
  loyalty_points_percent?: number
  /**
   * Loyalty Points Fixed
   * The fixed loyalty points amount
   * @min 1
   */
  loyalty_points_fixed?: number
  /**
   * Store Ids
   * Store ids that the promotion is applied to
   */
  store_ids?: string[]
  /**
   * Item Ids
   * Item ids that the promotion is applied to
   */
  item_ids?: string[]
  /**
   * Category Ids
   * Category ids that the promotion is applied to
   */
  category_ids?: string[]
  /**
   * Exclude Items For Reward Points
   * Turn off discount benefit for items that can be purchased with reward points
   */
  exclude_items_for_reward_points?: boolean
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @min 0
   */
  bonus_item_percent?: number
  /**
   * Bonus Item Id
   * The item ID that the user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   */
  bonus_item_id?: string
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   */
  bonus_item_quantity?: number
  /**
   * Active
   * Allows to enable or disable the promotion
   */
  active?: boolean
  /**
   * Archived At
   * The date when the promotion is archived in seconds
   */
  archived_at?: number
  /**
   * Requirements Expression
   * Defines the conditions under which the promotion is applied. Only applicable for authenticated users.
   */
  requirements_expression?: Expression
  /**
   * Payment Limits
   * Defines the payment methods limits for the promotion. If it set benefits shown only on checkout page
   */
  payment_limits?: PromotionPaymentLimits
}

/** StorePromotionRead */
export interface StorePromotionRead {
  /**
   * Name
   * The name of the promotion
   */
  name?: string
  /**
   * Start At
   * The start date of the promotion in seconds when the promotion starts to be applied
   */
  start_at: number
  /**
   * End At
   * The end date of the promotion in seconds when the promotion ends to be applied
   */
  end_at: number
  /**
   * Discount Percent
   * The discount percent of the promotion
   * @min 0
   * @max 99
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent of the promotion for a stackable items
   * @min 0
   */
  bonus_percent?: number
  /**
   * Max Purchase Count
   * The maximum purchase count of the promotion. If the user exceeds this count, the promotion will not be applied.
   */
  max_purchase_count?: number
  /**
   * Max Purchase Count Per User
   * The maximum purchase count per user. If the user exceeds this count, the promotion will not be applied. This setting is mutually exclusive with 'max_purchase_count'
   */
  max_purchase_count_per_user?: number
  /**
   * Reward Points Percent
   * The rewards points percent of the promotion
   * @min 0
   * @max 100
   */
  reward_points_percent?: number
  /**
   * Reward Points Fixed
   * The fixed rewards points amount
   * @min 1
   */
  reward_points_fixed?: number
  /**
   * Loyalty Points Percent
   * The loyalty points percent of the promotion
   * @min 0
   * @max 100
   */
  loyalty_points_percent?: number
  /**
   * Loyalty Points Fixed
   * The fixed loyalty points amount
   * @min 1
   */
  loyalty_points_fixed?: number
  /**
   * Store Ids
   * Store ids that the promotion is applied to
   */
  store_ids?: string[]
  /**
   * Item Ids
   * Item ids that the promotion is applied to
   */
  item_ids?: string[]
  /**
   * Category Ids
   * Category ids that the promotion is applied to
   */
  category_ids?: string[]
  /**
   * Exclude Items For Reward Points
   * Turn off discount benefit for items that can be purchased with reward points
   */
  exclude_items_for_reward_points?: boolean
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @min 0
   */
  bonus_item_percent?: number
  /**
   * Bonus Item Id
   * The item ID that the user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   */
  bonus_item_id?: string
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   */
  bonus_item_quantity?: number
  /**
   * Active
   * Allows to enable or disable the promotion
   */
  active?: boolean
  /**
   * Archived At
   * The date when the promotion is archived in seconds
   */
  archived_at?: number
  /**
   * Requirements Expression
   * Defines the conditions under which the promotion is applied. Only applicable for authenticated users.
   */
  requirements_expression?: Expression
  /**
   * Payment Limits
   * Defines the payment methods limits for the promotion. If it set benefits shown only on checkout page
   */
  payment_limits?: PromotionPaymentLimits
  /** Id */
  id: string
  /** Created At */
  created_at: number
  /** Current Purchase Count */
  current_purchase_count: number
}

/** StorePromotionUpdate */
export interface StorePromotionUpdate {
  /**
   * Name
   * The name of the promotion
   */
  name?: string
  /**
   * Start At
   * The start date of the promotion in seconds when the promotion starts to be applied
   */
  start_at?: number
  /**
   * End At
   * The end date of the promotion in seconds when the promotion ends to be applied
   */
  end_at?: number
  /**
   * Discount Percent
   * The discount percent of the promotion
   * @min 0
   * @max 99
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent of the promotion for a stackable items
   * @min 0
   */
  bonus_percent?: number
  /**
   * Max Purchase Count
   * The maximum purchase count of the promotion. If the user exceeds this count, the promotion will not be applied.
   */
  max_purchase_count?: number
  /**
   * Max Purchase Count Per User
   * The maximum purchase count per user. If the user exceeds this count, the promotion will not be applied. This setting is mutually exclusive with 'max_purchase_count'
   */
  max_purchase_count_per_user?: number
  /**
   * Reward Points Percent
   * The rewards points percent of the promotion
   * @min 0
   * @max 100
   */
  reward_points_percent?: number
  /**
   * Reward Points Fixed
   * The fixed rewards points points amount
   * @min 1
   */
  reward_points_fixed?: number
  /**
   * Loyalty Points Percent
   * The loyalty points percent of the promotion
   * @min 0
   * @max 100
   */
  loyalty_points_percent?: number
  /**
   * Loyalty Points Fixed
   * The fixed loyalty points amount
   * @min 1
   */
  loyalty_points_fixed?: number
  /**
   * Exclude Items For Reward Points
   * Turn off discount benefit for items that can be purchased with reward points
   */
  exclude_items_for_reward_points?: boolean
  /**
   * Store Ids
   * Store ids that the promotion is applied to
   */
  store_ids?: string[]
  /**
   * Item Ids
   * Item ids that the promotion is applied to
   */
  item_ids?: string[]
  /**
   * Category Ids
   * Category ids that the promotion is applied to
   */
  category_ids?: string[]
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @min 0
   */
  bonus_item_percent?: number
  /**
   * Bonus Item Id
   * The item ID that the user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   */
  bonus_item_id?: string
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   */
  bonus_item_quantity?: number
  /**
   * Active
   * Allows to enable or disable the promotion
   */
  active?: boolean
  /**
   * Archived At
   * The date when the promotion is archived in seconds
   */
  archived_at?: number
  /**
   * Requirements Expression
   * Defines the conditions under which the promotion is applied. Only applicable for authenticated users.
   */
  requirements_expression?: Expression
  /**
   * Payment Limits
   * Defines the payment methods limits for the promotion. If it set benefits shown only on checkout page
   */
  payment_limits?: PromotionPaymentLimits
}

/** StoreRead */
export interface StoreRead {
  /** Name */
  name: string
  /** Description */
  description: string
  /** An enumeration. */
  type: StoreType
  rotation_settings?: RotationSettings
  limited_stock_settings?: LimitedStockSettings
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  settings?: AghanimStoreSchemasStoreSettings
  /** Id */
  id: string
}

/** StoreReadStat */
export interface StoreReadStat {
  /** Name */
  name: string
  /** Description */
  description: string
  /** An enumeration. */
  type: StoreType
  rotation_settings?: RotationSettings
  limited_stock_settings?: LimitedStockSettings
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  settings?: AghanimStoreSchemasStoreSettings
  /** Id */
  id: string
  /** Item Count */
  item_count: number
}

/** StoreSettingsCustomTexts */
export interface StoreSettingsCustomTexts {
  /** Item Text */
  item_text?: string
  /** Currency Text */
  currency_text?: string
}

/** StoreUpdate */
export interface StoreUpdate {
  /** Name */
  name?: string
  /** Description */
  description?: string
  /** An enumeration. */
  type?: StoreType
  rotation_settings?: RotationSettings
  limited_stock_settings?: LimitedStockSettings
  settings?: AghanimStoreSchemasStoreSettings
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
}

/** StoreWebhookSettings */
export interface StoreWebhookSettings {
  /** Webhook Id */
  webhook_id: string
  /** An enumeration. */
  cache_period_type?: PeriodType
  /** Cache Period Value */
  cache_period_value?: number
}

/** Tax */
export interface Tax {
  /** Amount */
  amount: number
  /** Amount Eur */
  amount_eur?: number
  /** Amount Aud */
  amount_aud?: number
  /** Name */
  name: string
  /** Included */
  included: boolean
  /** Visible */
  visible: boolean
  /** Prc */
  prc?: string
}

/** TaxByCountry */
export interface TaxByCountry {
  /** Country Iso Code */
  country_iso_code: string
  /** Is Approximate */
  is_approximate: boolean
  /** Tax Included */
  tax_included: boolean
  /** Tax Percent */
  tax_percent: number
}

/** TaxRead */
export interface TaxRead {
  /** An enumeration. */
  country: Country
  /** Rate */
  rate: number
  /** Included */
  included: boolean
  /** Id */
  id: string
}

/** TemplatePrice */
export interface TemplatePrice {
  /** An enumeration. */
  country: Country
  /** An enumeration. */
  currency: Currency
  /** An enumeration. */
  platform: Platform
  /**
   * Price
   * @min 0
   * @max 1000000000000
   */
  price: number
  /**
   * Is Custom
   * Flag indicating whether the price is a custom value
   */
  is_custom: boolean
}

/** TestFunction */
export interface TestFunction {
  /**
   * Name
   * @default "test"
   */
  name?: 'test'
  args: NoArgs
}

/** TextBlock */
export interface TextBlock {
  /**
   * Block
   * @default "TextBlock"
   */
  block?: 'TextBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  /** Text */
  text?: string
  /** Title */
  title?: string
}

/** TimerNode */
export interface TimerNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "TimerNode"
   */
  model_type?: 'TimerNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Delay */
  delay: number
  /** Start Wait */
  start_wait?: number
  /** End Wait */
  end_wait?: number
}

/** Token */
export interface Token {
  /** An enumeration. */
  type: TokenType
  /** Value */
  value?: any
}

/** TopItemData */
export interface TopItemData {
  /** Id */
  id: string
  /** Name */
  name: string
  /** Sku */
  sku: string
  /** Image Url */
  image_url?: string
  /** Sales */
  sales: number
  /** Count Sales */
  count_sales: number
}

/** TotalCountResponse */
export interface TotalCountResponse {
  /** Total Count */
  total_count: number
}

/** TransactionStat */
export interface TransactionStat {
  /**
   * Total
   * The total count of the transactions
   */
  total: number
  /**
   * Category
   * Date of current point data
   */
  category: string
}

/** TransferRequest */
export interface TransferRequest {
  /** To Company Id */
  to_company_id: string
}

/** TranslatableFeaturedBannerConfig */
export interface TranslatableFeaturedBannerConfig {
  /** Title */
  title?: string
  /** Description */
  description?: string
  /** Image Url */
  image_url?: string
  /** Background Image Size */
  background_image_size?: string
  /** Featured Item Id */
  featured_item_id?: string
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** Replace Item Block */
  replace_item_block?: boolean
  /** Replace Item Block Name */
  replace_item_block_name?: string
}

/** TranslateAllFunction */
export interface TranslateAllFunction {
  /**
   * Name
   * @default "translate.translate_all"
   */
  name?: 'translate.translate_all'
  args: TranslateArgs
}

/** TranslateAndSyncAllFunction */
export interface TranslateAndSyncAllFunction {
  /**
   * Name
   * @default "translate.translate_and_sync_all"
   */
  name?: 'translate.translate_and_sync_all'
  args: NoArgs
}

/** TranslateArgs */
export interface TranslateArgs {
  /** Language codes according to ISO 639-1. */
  locale: Locale
  /** Locale Id */
  locale_id: string
}

/** TranslateSyncAllFunction */
export interface TranslateSyncAllFunction {
  /**
   * Name
   * @default "translate.sync_all"
   */
  name?: 'translate.sync_all'
  args: TranslateArgs
}

/** TranslateTextRequest */
export interface TranslateTextRequest {
  /** Language codes according to ISO 639-1. */
  from_locale: Locale
  /** Language codes according to ISO 639-1. */
  to_locale: Locale
  /** Original Text */
  original_text: string
}

/** TranslationCreate */
export interface TranslationCreate {
  /** Object Id */
  object_id: string
  /** An enumeration. */
  object_type: ObjectType
  /** Object Property */
  object_property: string
  /** Language codes according to ISO 639-1. */
  locale: Locale
  /** Content */
  content?: string
  /** Label */
  label?: string
}

/** TranslationGlossaryCreate */
export interface TranslationGlossaryCreate {
  /**
   * Locale Id
   * The unique identifier of the locale
   */
  locale_id: string
  /**
   * Term
   * The glossary term
   * @maxLength 255
   */
  term: string
  /**
   * Translation
   * The translation of the glossary term
   * @maxLength 255
   */
  translation: string
}

/** TranslationGlossaryRead */
export interface TranslationGlossaryRead {
  /**
   * Locale Id
   * The unique identifier of the locale
   */
  locale_id: string
  /**
   * Term
   * The glossary term
   * @maxLength 255
   */
  term: string
  /**
   * Translation
   * The translation of the glossary term
   * @maxLength 255
   */
  translation: string
  /**
   * Id
   * The unique identifier of the glossary
   */
  id: string
}

/** TranslationGlossaryUpdate */
export interface TranslationGlossaryUpdate {
  /**
   * Term
   * The glossary term
   * @maxLength 255
   */
  term?: string
  /**
   * Translation
   * The translation of the glossary term
   * @maxLength 255
   */
  translation?: string
}

/** TranslationHtmlStrippedRead */
export interface TranslationHtmlStrippedRead {
  /** Object Id */
  object_id: string
  /** An enumeration. */
  object_type: ObjectType
  /** Object Property */
  object_property: string
  /** Language codes according to ISO 639-1. */
  locale: Locale
  /** Content */
  content?: string
  /** Label */
  label?: string
  /** Id */
  id?: string
  /** Original Id */
  original_id: string
  /** Original Content */
  original_content?: string
  /** Error Text */
  error_text?: string
  /** Is Truncated */
  is_truncated: boolean
  /** An enumeration. */
  state: State
  /** Synced */
  synced: boolean
  /** Cursor Id */
  cursor_id: string
}

/** TranslationRead */
export interface TranslationRead {
  /** Object Id */
  object_id: string
  /** An enumeration. */
  object_type: ObjectType
  /** Object Property */
  object_property: string
  /** Language codes according to ISO 639-1. */
  locale: Locale
  /** Content */
  content?: string
  /** Label */
  label?: string
  /** Id */
  id?: string
  /** Original Id */
  original_id: string
  /** Original Content */
  original_content?: string
  /** Error Text */
  error_text?: string
  /** Is Truncated */
  is_truncated: boolean
  /** An enumeration. */
  state: State
  /** Synced */
  synced: boolean
  /** Cursor Id */
  cursor_id: string
}

/** TranslationUpdate */
export interface TranslationUpdate {
  /** Content */
  content?: string
}

/** TwitchBlock */
export interface TwitchBlock {
  /**
   * Block
   * @default "TwitchBlock"
   */
  block?: 'TwitchBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  video: VideoBase
}

/** TwitchData */
export interface TwitchData {
  /**
   * Channel
   * The channel of the Twitch video
   */
  channel: string
}

/** UpdateDefaultLocaleRequest */
export interface UpdateDefaultLocaleRequest {
  /** Language codes according to ISO 639-1. */
  locale: Locale
}

/** UpdateTomatoesVersionSchema */
export interface UpdateTomatoesVersionSchema {
  /** Version */
  version: string
}

/** User */
export interface User {
  /** Id */
  id: string
  /** Name */
  name?: string
  /** Email */
  email?: string
  /** Player Id */
  player_id: string
  /** Created At */
  created_at: number
  /** Modified At */
  modified_at?: number
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country?: string
  /** Avatar Url */
  avatar_url?: string
  /** Banned */
  banned?: boolean
  attributes?: PersistentPlayerAttributes
  /** Last Login At */
  last_login_at?: number
  /** Last Verified At */
  last_verified_at?: number
  /** Last Active At */
  last_active_at?: number
  /** Ltv */
  ltv?: number
  /** Average Check */
  average_check?: number
  /** Game Hub Login Count */
  game_hub_login_count?: number
  /** Banned Reason */
  banned_reason?: string
  /** Facebook Id */
  facebook_id?: string
  /** Telegram Id */
  telegram_id?: string
  /** Apple Id */
  apple_id?: string
  calc_attributes?: CalcPlayerAttributes
  /** Custom Attributes */
  custom_attributes?: object
  /** Checkout Users */
  checkout_users?: CheckoutUser[]
  /** Total Order Count */
  total_order_count?: number
  /** Lp Balance */
  lp_balance?: number
}

/** UserBanner */
export interface UserBanner {
  /** Website Id */
  website_id: string
  /** User Id */
  user_id: string
  /** Page Id */
  page_id: string
  /** Campaign Id */
  campaign_id?: string
  /** User Campaign Id */
  user_campaign_id?: string
  /** Expires At */
  expires_at?: number
  config: FeaturedBannerConfig
  /** Created From Campaign Node Id */
  created_from_campaign_node_id?: string
  /** Created From Campaign Version */
  created_from_campaign_version?: string
  /** Id */
  id: string
  /** Created At */
  created_at: number
}

/** UserCouponRead */
export interface UserCouponRead {
  /**
   * Item Id
   * The item ID for the coupon
   */
  item_id?: string
  /**
   * Discount Percent
   * The discount percent for the coupon
   * @min 0
   * @max 100
   */
  discount_percent?: number
  /**
   * Bonus Percent
   * The bonus percent for the coupon
   * @min 0
   * @max 1000
   */
  bonus_percent?: number
  /**
   * Discount Amount Usd
   * The discount amount in USD for the coupon
   * @min 0
   */
  discount_amount_usd?: number
  /**
   * Requirements Expression
   * The requirement expression for the coupon
   */
  requirements_expression?: Expression
  /**
   * Expires At
   * The expiration date of the coupon
   */
  expires_at?: number
  /**
   * Applicable Item Ids
   * The applicable item IDs
   */
  applicable_item_ids?: string[]
  /**
   * Min Amount
   * Require a minimum order amount to apply the coupon
   */
  min_amount?: number
  /**
   * Max Redemptions
   * Limit the number of times this code can be redeemed
   */
  max_redemptions?: number
  /**
   * Max Redemptions Per User
   * Limit the number of times a user can redeem the coupon
   */
  max_redemptions_per_user?: number
  /**
   * Is Stackable With Bonus Coupons
   * Allow stacking with bonus coupons
   */
  is_stackable_with_bonus_coupons?: boolean
  /**
   * Stackable Bonus Limit Percent
   * Limit the bonus percent when stacking with bonus coupons
   */
  stackable_bonus_limit_percent?: number
  /**
   * Is Stackable With Discount Coupons
   * Allow stacking with discount coupons
   */
  is_stackable_with_discount_coupons?: boolean
  /**
   * Stackable Discount Limit Percent
   * Limit the discount percent when stacking with discount coupons
   */
  stackable_discount_limit_percent?: number
  /**
   * Start At
   * The timestamp when the coupon becomes valid
   */
  start_at?: number
  /**
   * End At
   * The timestamp when the coupon ceases to be valid
   */
  end_at?: number
  /**
   * Player Ids
   * The player IDs that can redeem the coupon
   */
  player_ids?: string[]
  /**
   * Name
   * The name of the coupon
   * @maxLength 255
   */
  name: string
  /**
   * Code
   * The code of the coupon
   * @maxLength 20
   */
  code: string
  /** The type of the coupon */
  type: CouponType
  /**
   * Id
   * The unique identifier of the coupon
   */
  id: string
  /**
   * Item
   * The item for the coupon
   */
  item?: ItemRead
  /**
   * Creator Program
   * The creator program for the coupon
   */
  creator_program?: CreatorProgramBase
  /**
   * Current Balance Usd
   * The current balance in USD for fixed discount coupon type
   */
  current_balance_usd?: number
  /** Redeemed At */
  redeemed_at?: number
  /** Order Item Id */
  order_item_id?: string
}

/** UserItemClaimed */
export interface UserItemClaimed {
  /** Created At */
  created_at: number
  /** An enumeration. */
  object_type: ItemClaimedType
  /** Item Id */
  item_id: string
  /** Item Sku */
  item_sku: string
  /** Item Name */
  item_name?: any
  /** Item Image Url */
  item_image_url: string
  /** Item Quantity */
  item_quantity?: number
  /** Item Is Stackable */
  item_is_stackable: boolean
}

/** UserPaymentMethod */
export interface UserPaymentMethod {
  /** Id */
  id: string
  /** Payment Method Id */
  payment_method_id: string
  /** Payment Method Name */
  payment_method_name: string
  data: UserPaymentMethodData
  /** Is Default */
  is_default: boolean
  /** Is Verified */
  is_verified: boolean
  billing_address?: BillingAddress
}

/** UserPaymentMethodData */
export interface UserPaymentMethodData {
  /** Bin */
  bin?: string
  /** Last4 */
  last4?: string
  /** Scheme */
  scheme?: string
  /** Email */
  email?: string
  /** Token Id */
  token_id?: string
  /** Customer Id */
  customer_id?: string
}

/** UserRead */
export interface UserRead {
  /** Id */
  id: string
  /** Name */
  name?: string
  /** Email */
  email?: string
  /** Player Id */
  player_id: string
  /** Created At */
  created_at: number
  /** Modified At */
  modified_at?: number
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country?: string
  /** Avatar Url */
  avatar_url?: string
  /** Banned */
  banned?: boolean
  attributes?: PersistentPlayerAttributes
  /** Last Login At */
  last_login_at?: number
  /** Last Verified At */
  last_verified_at?: number
  /** Last Active At */
  last_active_at?: number
  /** Ltv */
  ltv?: number
  /** Average Check */
  average_check?: number
  /** Game Hub Login Count */
  game_hub_login_count?: number
  /** Banned Reason */
  banned_reason?: string
  /** Facebook Id */
  facebook_id?: string
  /** Telegram Id */
  telegram_id?: string
  /** Apple Id */
  apple_id?: string
}

/** UserSegmentRead */
export interface UserSegmentRead {
  /** Segment Id */
  segment_id: string
  /** Reason */
  reason?: string
  /** Added By Campaign Id */
  added_by_campaign_id?: string
  /** Added By Customer Id */
  added_by_customer_id?: string
  segment?: SegmentRead
  /** Created At */
  created_at?: number
}

/** UserSegmentUpdate */
export interface UserSegmentUpdate {
  /** Ids */
  ids: string[]
}

/** UserUpdate */
export interface UserUpdate {
  /** Name */
  name?: string
  /** Email */
  email?: string
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  country?: string
  /** Banned */
  banned?: boolean
  /** Banned Reason */
  banned_reason?: string
  /** Avatar Url */
  avatar_url?: string
  attributes?: PersistentPlayerAttributes
  /** Custom Attributes */
  custom_attributes?: object
  /** Segments */
  segments?: string[]
  /** Creator Program Id */
  creator_program_id?: string
  /** An enumeration. */
  registration_marketplace?: Marketplace
  /** Balances */
  balances?: VirtualCurrencyShort[]
  /** Custom Attributes From Deeplink */
  custom_attributes_from_deeplink?: object
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[]
  /** Message */
  msg: string
  /** Error Type */
  type: string
}

/** VersionRead */
export interface VersionRead {
  /** Id */
  id: string
  /** Version */
  version: string
  /** Version Description */
  version_description: string
  /** Customer Name */
  customer_name?: string
  /** Customer Email */
  customer_email: string
  /** Created At */
  created_at: number
}

/** VideoBase */
export interface VideoBase {
  /**
   * Title
   * The title of the video
   * @maxLength 255
   */
  title: string
  /**
   * Description
   * The description of the video
   * @maxLength 512
   */
  description: string
  /**
   * Order Id
   * The order ID of the video
   * @default 0
   */
  order_id?: number
  /**
   * Thumbnail Url
   * The URL of the thumbnail for the video
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  thumbnail_url?: string
  /** The platform of the video */
  platform: VideoPlatform
  /**
   * Data
   * The data of the video
   */
  data: YoutubeData | TwitchData
}

/** VideoCreate */
export interface VideoCreate {
  /**
   * Title
   * The title of the video
   * @maxLength 255
   */
  title: string
  /**
   * Description
   * The description of the video
   * @maxLength 512
   */
  description: string
  /**
   * Order Id
   * The order ID of the video
   * @default 0
   */
  order_id?: number
  /**
   * Thumbnail Url
   * The URL of the thumbnail for the video
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  thumbnail_url?: string
  /** The platform of the video */
  platform: VideoPlatform
  /**
   * Data
   * The data of the video
   */
  data: YoutubeData | TwitchData
}

/** VideoFeaturedAdd */
export interface VideoFeaturedAdd {
  /** Video Id */
  video_id: string
}

/** VideoRead */
export interface VideoRead {
  /**
   * Title
   * The title of the video
   * @maxLength 255
   */
  title: string
  /**
   * Description
   * The description of the video
   * @maxLength 512
   */
  description: string
  /**
   * Order Id
   * The order ID of the video
   * @default 0
   */
  order_id?: number
  /**
   * Thumbnail Url
   * The URL of the thumbnail for the video
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  thumbnail_url?: string
  /** The platform of the video */
  platform: VideoPlatform
  /**
   * Data
   * The data of the video
   */
  data: YoutubeData | TwitchData
  /**
   * Id
   * The unique identifier of the video
   */
  id: string
}

/** VideoUpdate */
export interface VideoUpdate {
  /**
   * Title
   * The title of the video
   * @maxLength 255
   */
  title?: string
  /**
   * Description
   * The description of the video
   * @maxLength 512
   */
  description?: string
  /**
   * Order Id
   * The order ID of the video
   */
  order_id?: number
  /**
   * Thumbnail Url
   * The URL of the thumbnail for the video
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  thumbnail_url?: string
}

/** ViewPort */
export interface ViewPort {
  /** X */
  x: number
  /** Y */
  y: number
  /** Zoom */
  zoom: number
}

/** VirtualCurrencyShort */
export interface VirtualCurrencyShort {
  /** Sku */
  sku: string
  /** Quantity */
  quantity: number
}

/** VirtualSkuStat */
export interface VirtualSkuStat {
  /** All Count */
  all_count: number
  /** Purchase Count */
  purchase_count: number
}

/** VirtualStoreItemUser */
export interface VirtualStoreItemUser {
  /** Item Id */
  item_id: string
  /** Discount Percent */
  discount_percent?: number | null
  /** Bonus Percent */
  bonus_percent?: number | null
  /**
   * Bonus Fixed
   * The user will receive a fixed quantity of the item.
   */
  bonus_fixed?: number | null
  /** Position */
  position: number
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string | null
  /**
   * Max Purchases
   * The maximum number of purchases allowed for the item per user.
   */
  max_purchases?: number | null
  /**
   * Requirements Expression
   * Defines the rules by which an item is shown to the user
   */
  requirements_expression?: Expression | null
  /**
   * Custom Badge
   * The custom badge of the item
   * @maxLength 100
   */
  custom_badge?: string | null
  /** Campaign Id */
  campaign_id?: string | null
  /** User Campaign Id */
  user_campaign_id?: string | null
  /** Bond User Id */
  bond_user_id?: string | null
  /** Start At */
  start_at?: number | null
  /** End At */
  end_at?: number | null
  /** Min Amount */
  min_amount?: number | null
  /** Max Reward Points Percent */
  max_reward_points_percent?: number | null
  /**
   * Reward Points Percent
   * Percentage of reward points for the item.
   */
  reward_points_percent?: number | null
  /**
   * Reward Points Fixed
   * Fixed reward points for the item.
   */
  reward_points_fixed?: number | null
  /**
   * Loyalty Points Percent
   * Percentage of loyalty points for the item.
   */
  loyalty_points_percent?: number | null
  /**
   * Loyalty Points Fixed
   * Fixed loyalty points for the item.
   */
  loyalty_points_fixed?: number | null
  /**
   * Payment Bound
   * Payment settings for the item.
   */
  payment_bound?: StoreItemPaymentSettings | null
  /**
   * Is Free Item
   * @default false
   */
  is_free_item?: boolean
  /**
   * Rotation Weight
   * @min 0
   * @max 1000
   */
  rotation_weight?: number | null
  /** The period type for the max purchases limit. If not set, the limit is global and does not reset. */
  max_purchases_period_type?: PeriodType | null
  /**
   * Max Purchases Period Value
   * @min 0
   */
  max_purchases_period_value?: number | null
  /** For 'global' limit all users will have the same timer based on max_purchases_period_value.For 'personal' limit each user will have their own timer based on max_purchases_period_value and last purchase date. */
  max_purchases_limit_type?: MaxPurchaseLimitPeriodType | null
  /**
   * Show Disabled By Max Purchases
   * Whether to show the item as disabled when max purchases limit is reached.
   */
  show_disabled_by_max_purchases?: boolean | null
  /** The type of the card for the item, used for displaying in the store */
  card_type?: StoreCardType | null
  /**
   * Show First On Category List
   * Whether to show the item first on the category list
   */
  show_first_on_category_list?: boolean | null
  /**
   * Bonus Item Id
   * The ID of the bonus item that will be given to the user when they purchase this item.
   * @deprecated
   */
  bonus_item_id?: string | null
  /**
   * Bonus Item Quantity
   * The fixed quantity of the bonus item
   * @deprecated
   */
  bonus_item_quantity?: number | null
  /**
   * Bonus Item Percent
   * The user will receive a quantity equivalent to the set percentage of the total USD (in cents) purchase.
   * @deprecated
   * @min 0
   */
  bonus_item_percent?: number | null
  /**
   * Bonus Items Settings
   * The bonus settings for the item, including bonus items and their quantities.
   */
  bonus_items_settings?: StoreItemBonusSettings | null
  /**
   * Bonus Badge
   * Custom text for bonus badge
   */
  bonus_badge?: string | null
  /** Id */
  id: string
  /** Created At */
  created_at: number
  /** Item */
  item: ItemRead | LootboxRead
  /** Store Id */
  store_id: string
  /** Purchases Left */
  purchases_left?: number
  /** Next Purchase At */
  next_purchase_at?: number
  /** Benefits */
  benefits?: StoreItemBenefit[]
  /** Bonus Items */
  bonus_items?: ItemRead[]
  /** Applied Store Promotion Id */
  applied_store_promotion_id?: string
  /** Applied Store Promotion Ids */
  applied_store_promotion_ids?: string[]
  /** Player Id */
  player_id: string
  /** Player Name */
  player_name?: string
}

/** WebSiteMenuSection */
export interface WebSiteMenuSection {
  /** Left */
  left?: string[]
  /** Right */
  right?: string[]
}

/** WebhookActionNode */
export interface WebhookActionNode {
  /** Id */
  id: string
  /** Next Node Id */
  next_node_id?: string
  /** Title */
  title?: string
  /** Styles */
  styles?: Record<string, string>
  /** X */
  x: number
  /** Y */
  y: number
  /** Result */
  result?: string
  /**
   * Model Type
   * @default "WebhookActionNode"
   */
  model_type?: 'WebhookActionNode'
  /** Break On Error */
  break_on_error?: boolean
  /** Description */
  description?: string
  /** Body */
  body?: string
  /** Item Id */
  item_id?: string
  /** Link Created Offer */
  link_created_offer?: boolean
  /** Store Item Id */
  store_item_id?: string
  /** Store Id */
  store_id?: string
  /** An enumeration. */
  content_type?: HubPopupContentType
  /** Button Text */
  button_text?: string
  /** Button Link */
  button_link?: string
  /** Url */
  url?: string
  /** Response */
  response?: string
  /** Status Code */
  status_code?: number
}

/** WebhookCreate */
export interface WebhookCreate {
  /** The list of events that trigger the webhook. */
  events: WebhookEventType[]
  /**
   * Url
   * The URL where the webhook will be sent.
   */
  url: string
  /**
   * Description
   * The description of a webhook.
   */
  description?: string | null
  /** The HTTP method used to send the webhook. */
  method: WebhookMethod
  /**
   * Enabled
   * The enabled status of the webhook.
   * @default true
   */
  enabled?: boolean
  /**
   * Enabled Logs
   * The enabled logs of the webhook.
   * @default true
   */
  enabled_logs?: boolean
  /**
   * Player Context Enabled
   * Enable send player attributes in context
   */
  player_context_enabled?: boolean | null
}

/** WebhookLog */
export interface WebhookLog {
  /** Id */
  id: string
  /** Webhook Id */
  webhook_id: string
  /** An enumeration. */
  event_type: WebhookEventType
  /** Game Id */
  game_id?: string
  /** User Id */
  user_id?: string
  /** Order Id */
  order_id?: string
  /** Request Status */
  request_status?: string
  /** Request Body */
  request_body?: string
  /** Response Body */
  response_body?: string
  /** Duration */
  duration: number
  /** Status Code */
  status_code: number
  /** Status */
  status?: SendStatus | ''
  /** Detail */
  detail?: string
  /** Created At */
  created_at: number
  /** Is Test */
  is_test?: boolean
}

/** WebhookRedacted */
export interface WebhookRedacted {
  /** The list of events that trigger the webhook. */
  events: WebhookEventType[]
  /**
   * Url
   * The URL where the webhook will be sent.
   */
  url: string
  /**
   * Description
   * The description of a webhook.
   */
  description?: string | null
  /** The HTTP method used to send the webhook. */
  method: WebhookMethod
  /**
   * Enabled
   * The enabled status of the webhook.
   * @default true
   */
  enabled?: boolean
  /**
   * Enabled Logs
   * The enabled logs of the webhook.
   * @default true
   */
  enabled_logs?: boolean
  /**
   * Player Context Enabled
   * Enable send player attributes in context
   */
  player_context_enabled?: boolean | null
  /** Secret Redacted */
  secret_redacted: string
  /**
   * Id
   * The unique identifier of the webhook.
   */
  id: string
  /**
   * Game Id
   * The unique identifier of the game.
   */
  game_id: string
}

/** WebhookRevealed */
export interface WebhookRevealed {
  /** The list of events that trigger the webhook. */
  events: WebhookEventType[]
  /**
   * Url
   * The URL where the webhook will be sent.
   */
  url: string
  /**
   * Description
   * The description of a webhook.
   */
  description?: string | null
  /** The HTTP method used to send the webhook. */
  method: WebhookMethod
  /**
   * Enabled
   * The enabled status of the webhook.
   * @default true
   */
  enabled?: boolean
  /**
   * Enabled Logs
   * The enabled logs of the webhook.
   * @default true
   */
  enabled_logs?: boolean
  /**
   * Player Context Enabled
   * Enable send player attributes in context
   */
  player_context_enabled?: boolean | null
  /**
   * Id
   * The unique identifier of the webhook.
   */
  id: string
  /**
   * Game Id
   * The unique identifier of the game.
   */
  game_id: string
  /**
   * Secret
   * The secret used to sign the webhook.
   */
  secret: string
}

/** WebhookUpdate */
export interface WebhookUpdate {
  /** The list of events that trigger the webhook. */
  events?: WebhookEventType[]
  /**
   * Url
   * The URL where the webhook will be sent.
   */
  url?: string
  /**
   * Description
   * The description of a webhook.
   */
  description?: string
  /** The HTTP method used to send the webhook. */
  method?: WebhookMethod
  /**
   * Enabled
   * The enabled status of the webhook.
   */
  enabled?: boolean
  /**
   * Enabled Logs
   * The enabled logs of the webhook.
   */
  enabled_logs?: boolean
  /**
   * Player Context Enabled
   * Enable player context.
   */
  player_context_enabled?: boolean | null
}

/** Website */
export interface Website {
  /** Title */
  title: string
  /** Description */
  description: string
  config?: WebsiteConfig
  /** Template Id */
  template_id?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /** Id */
  id: string
  /** Slug */
  slug: string
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  url: string
  game: AghanimGameSchemasGame
  /** Created At */
  created_at: number
  /** Modified At */
  modified_at?: number
  /** Published At */
  published_at?: number
  /** Share Token */
  share_token: string
}

/** WebsiteConfig */
export interface WebsiteConfig {
  /**
   * Favicon Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  favicon_url?: string
  /** Base Bg Color */
  base_bg_color?: string
  /** Base Bg Image */
  base_bg_image?: string
  /** Accent Color */
  accent_color?: string
  /** Button Color */
  button_color?: string
  /** Text Color */
  text_color?: string
  /** Dark Bg Color */
  dark_bg_color?: string
  /** Featured Bg Color */
  featured_bg_color?: string
  /** Style Keywords */
  style_keywords?: string
  /** Card Bg Color */
  card_bg_color?: string
  /** Card Image Bg Color */
  card_image_bg_color?: string
  /** Ui Elements Color */
  ui_elements_color?: string
  /** Text Muted */
  text_muted?: string
  /** Left Menu Item Color */
  left_menu_item_color?: string
  /** Login Button Bg */
  login_button_bg?: string
  /** Login Button Color */
  login_button_color?: string
  /** Social Link Bg Color */
  social_link_bg_color?: string
  /** Social Link Color */
  social_link_color?: string
  /** Offer Label Bg Color */
  offer_label_bg_color?: string
  /** Offer Label Color */
  offer_label_color?: string
  /** Offer Price Label Bg */
  offer_price_label_bg?: string
  /** Offer Price Label Color */
  offer_price_label_color?: string
  /** Discount Label Bg Color */
  discount_label_bg_color?: string
  /** Discount Label Text Color */
  discount_label_text_color?: string
  /** Bonus Label Bg Color */
  bonus_label_bg_color?: string
  /** Bonus Label Text Color */
  bonus_label_text_color?: string
  /** Left Label Bg Color */
  left_label_bg_color?: string
  /** Left Label Text Color */
  left_label_text_color?: string
  /** Reward Button Bg */
  reward_button_bg?: string
  /** Reward Button Color */
  reward_button_color?: string
  /** Daily Reward Button Bg */
  daily_reward_button_bg?: string
  /** Daily Reward Button Color */
  daily_reward_button_color?: string
  /** Daily Reward Inactive Button Bg */
  daily_reward_inactive_button_bg?: string
  /** Daily Reward Inactive Button Color */
  daily_reward_inactive_button_color?: string
  /** Daily Reward Card Bg Color */
  daily_reward_card_bg_color?: string
  /** Custom Badge Bg Color */
  custom_badge_bg_color?: string
  /** Custom Badge Color */
  custom_badge_color?: string
  /** Free Item Custom Badge Bg Color */
  free_item_custom_badge_bg_color?: string
  /** Free Item Custom Badge Color */
  free_item_custom_badge_color?: string
  /** Free Item Button Bg */
  free_item_button_bg?: string
  /** Free Item Button Color */
  free_item_button_color?: string
  /** Buy Button Bg Color */
  buy_button_bg_color?: string
  /** Buy Button Color */
  buy_button_color?: string
  /** Item Timer Bg Color */
  item_timer_bg_color?: string
  /** Item Timer Color */
  item_timer_color?: string
  /** Item Name Color */
  item_name_color?: string
  /** Page Title Color */
  page_title_color?: string
  /** Maintenance Panel Bg Color */
  maintenance_panel_bg_color?: string
  /** Maintenance Panel Text Color */
  maintenance_panel_text_color?: string
  /** Bundle List Bg Color */
  bundle_list_bg_color?: string
  /** Outline Button Color */
  outline_button_color?: string
  /** Login Deep Link Button Bg */
  login_deep_link_button_bg?: string
  /** Login Deep Link Button Color */
  login_deep_link_button_color?: string
  /** Dialog Bg Color */
  dialog_bg_color?: string
  /** News Date Color */
  news_date_color?: string
  /** News Title Color */
  news_title_color?: string
  /** News Active Tab Button Bg Color */
  news_active_tab_button_bg_color?: string
  /** Tab Button Bg */
  tab_button_bg?: string
  /** Tab Button Color */
  tab_button_color?: string
  /** Left Menu Bg Color */
  left_menu_bg_color?: string
  /** Right Menu Bg Color */
  right_menu_bg_color?: string
  /** Border Radius */
  border_radius?: string
  /** Font Size */
  font_size?: string
  /** Twitch Video Url */
  twitch_video_url?: string
  /** Youtube Video Url */
  youtube_video_url?: string
  /** Background Image Size */
  background_image_size?: string
  /** Background Image Attachment */
  background_image_attachment?: string
  /** Background Image Position */
  background_image_position?: string
  /** Background Image Repeat */
  background_image_repeat?: string
  /** Background Image Opacity */
  background_image_opacity?: string
  /** Left Aside Width */
  left_aside_width?: string
  /** Right Aside Width */
  right_aside_width?: string
  /** Font Weight */
  font_weight?: string
  /** Base Padding */
  base_padding?: string
  /** Chrome App Icon Url */
  chrome_app_icon_url?: string
  /** Screenshots */
  screenshots?: Screenshot[]
  /** Sections */
  sections?: WebsiteSection[]
  age_settings?: AgeSettings
  developer?: Developer
  /** Trademarks */
  trademarks?: string
  banner_config?: NewsBannerConfig
  featured_banner_config?: FeaturedBannerConfig
  /** An enumeration. */
  events_widget_category?: NewsCategory
  /** An enumeration. */
  mode?: Mode
  menu_sections?: WebSiteMenuSection
  store_settings?: AghanimTypesStoreSettings
  news_settings?: NewsSettings
  /** Avatars */
  avatars?: string[]
  /**
   * Auto Apply Random Avatar
   * @default true
   */
  auto_apply_random_avatar?: boolean
  /** Leaderboard Icons */
  leaderboard_icons?: string[]
  /**
   * Demo Mode
   * @default false
   */
  demo_mode?: boolean
  /** Termly Id */
  termly_id?: string
  /** Cookie Banner Enabled */
  cookie_banner_enabled?: boolean
  sort_item_type?: ItemType[]
  /** Custom Code Js */
  custom_code_js?: string
  /** Palette Name */
  palette_name?: string
  website_links?: WebsiteLinks
  /** An enumeration. */
  font?: WebsiteFont
  /**
   * Theme Raw Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  theme_raw_url?: string
  /** An enumeration. */
  theme_raw_type?: ThemeRawType
  /** Theme Raw Palette Main */
  theme_raw_palette_main?: string
  /** Theme Raw Palette Brand A */
  theme_raw_palette_brand_a?: string
  /** Theme Raw Palette Brand B */
  theme_raw_palette_brand_b?: string
  /** Redirect To Store For Us */
  redirect_to_store_for_us?: boolean
  /** Google Analytics Id */
  google_analytics_id?: string
  /** Google Tag Manager Id */
  google_tag_manager_id?: string
}

/** WebsiteCreate */
export interface WebsiteCreate {
  /** Title */
  title: string
  /** Description */
  description: string
  config?: WebsiteConfig
  /** Template Id */
  template_id?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /** Share Token */
  share_token: string
}

/** WebsiteLinks */
export interface WebsiteLinks {
  /** Play Game Page */
  play_game_page?: string
  /**
   * Customer Support Link
   * The customer support button link.
   */
  customer_support_link?: string | ''
}

/** WebsitePlugin */
export type WebsitePlugin =
  | ({
      key: 'google-analytics'
    } & GoogleAnalyticsPlugin)
  | ({
      key: 'google-tag-manager'
    } & GoogleTagManagerPlugin)
  | ({
      key: 'meta-pixel'
    } & MetaPixelPlugin)
  | ({
      key: 'appsflyer-websdk'
    } & AppsFlyerWebSDKPlugin)

/** WebsiteRead */
export interface WebsiteRead {
  /** Title */
  title: string
  /** Description */
  description: string
  config?: WebsiteConfig
  /** Template Id */
  template_id?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /** Id */
  id: string
  game: AghanimGameSchemasGame
  /** Slug */
  slug: string
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  url: string
  /** Created At */
  created_at: number
  /** Modified At */
  modified_at?: number
  /** Published At */
  published_at?: number
  /** Share Token */
  share_token: string
  /**
   * Custom Domain
   * @format domain
   * @minLength 1
   * @maxLength 253
   */
  custom_domain?: string
}

/** WebsiteSearchRequest */
export interface WebsiteSearchRequest {
  /** Search String */
  search_string: string
}

/** WebsiteSection */
export interface WebsiteSection {
  /** An enumeration. */
  name: SectionType
  /** An enumeration. */
  object_type?: SectionObjectType
  /** Object Id */
  object_id?: string
  /** Visible */
  visible: boolean
  /** Icon */
  icon?: string
  /** Custom Name */
  custom_name?: string
  /**
   * Custom Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  custom_url?: string
}

/** WebsiteTemplateCreate */
export interface WebsiteTemplateCreate {
  /**
   * Name
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * @maxLength 512
   */
  description?: string
  config?: WebsiteConfig
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  requirements_expression?: Expression
}

/** WebsiteTemplateRead */
export interface WebsiteTemplateRead {
  /**
   * Name
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * @maxLength 512
   */
  description?: string
  config?: WebsiteConfig
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  requirements_expression?: Expression
  /** Id */
  id: string
  /** Created At */
  created_at: number
  /** Position */
  position: number
}

/** WebsiteTemplateUpdate */
export interface WebsiteTemplateUpdate {
  /**
   * Name
   * @maxLength 255
   */
  name?: string
  /**
   * Description
   * @maxLength 512
   */
  description?: string
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  config?: WebsiteConfig
  /** Position */
  position?: number
  requirements_expression?: Expression
}

/** WebsiteUpdate */
export interface WebsiteUpdate {
  /**
   * Title
   * @maxLength 200
   */
  title?: string
  /**
   * Description
   * @maxLength 1000
   */
  description?: string
  config?: WebsiteConfig
  /** Published At */
  published_at?: number
  /**
   * Image Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  image_url?: string
  /**
   * Slug
   * @minLength 1
   * @maxLength 100
   * @pattern ^[a-z0-9]+(-[a-z0-9]+)*$
   */
  slug?: string
  /**
   * Custom Domain
   * @format domain
   * @minLength 1
   * @maxLength 253
   */
  custom_domain?: string
}

/** YoutubeBlock */
export interface YoutubeBlock {
  /**
   * Block
   * @default "YoutubeBlock"
   */
  block?: 'YoutubeBlock'
  /** Id */
  id?: string
  /** Name */
  name?: string
  video: VideoBase
}

/** YoutubeData */
export interface YoutubeData {
  /**
   * Video Id
   * The video ID of the YouTube video
   */
  video_id: string
}

/** Game */
export interface AghanimGameSchemasGame {
  /**
   * Name
   * @minLength 2
   * @maxLength 200
   */
  name: string
  /**
   * Description
   * @minLength 2
   * @maxLength 1000
   */
  description: string
  /**
   * Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  logo_url: string
  /** Social Medias */
  social_medias: SocialMedia[]
  /** Game Stores */
  game_stores: GameStore[]
  login_methods: LoginType[]
  login_settings?: LoginSettings
  /** Language codes according to ISO 639-1. */
  locale_default: Locale
  /** Use Webhook Response Data Schema */
  use_webhook_response_data_schema?: boolean
  /** Id */
  id: string
  /** Locales */
  locales: LocaleRead[]
  /** Company Id */
  company_id: string
  /** Sandbox */
  sandbox: boolean
  /** Sandbox Game Id */
  sandbox_game_id?: string
  /** Live Game Id */
  live_game_id?: string
  /** Published At */
  published_at?: number
}

/** Game */
export interface AghanimOrderSchemasGame {
  /** Name */
  name: string
  /**
   * Logo Url
   * @format uri
   * @minLength 1
   * @maxLength 65536
   */
  logo_url: string
}

/** StoreSettings */
export interface AghanimStoreSchemasStoreSettings {
  webhook_settings?: StoreWebhookSettings
}

/** StoreSettings */
export interface AghanimTypesStoreSettings {
  /** Default Image Url */
  default_image_url?: string
  custom_texts?: StoreSettingsCustomTexts
  /** Image Ratio */
  image_ratio?: number
  /** An enumeration. */
  card_version?: StoreCardVersion
  /** Show Item Description */
  show_item_description?: boolean
  /** Show Reward Points Label */
  show_reward_points_label?: boolean
  /** Show Confirmation Popup */
  show_confirmation_popup?: boolean
  /** Show Subscription Agreement */
  show_subscription_agreement?: boolean
  /** An enumeration. */
  image_size?: StoreImageSize
  /** An enumeration. */
  text_size?: StoreTextSize
  /** Mobile Grid Columns */
  mobile_grid_columns?: number
  /** Mobile Landscape Grid Columns */
  mobile_landscape_grid_columns?: number
  /** Tablet Grid Columns */
  tablet_grid_columns?: number
  /** Desktop Grid Columns */
  desktop_grid_columns?: number
  /** Large Desktop Grid Columns */
  large_desktop_grid_columns?: number
  /** Store Version */
  store_version?: string
  /** @default "default" */
  bonus_display?: BonusDisplayType
  /** @default "default" */
  carousel_display?: CarouselDisplayType
  /** @default "hidden" */
  quick_store_button?: QuickStoreButtonMode
  /** Show Sticky Categories */
  show_sticky_categories?: boolean
  /**
   * Default Card Templates
   * Default card templates ids by types
   */
  default_card_templates?: Record<string, string>
}

export interface GetGamesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
}

export interface CopyGameParams {
  /** Company Designation Id */
  company_designation_id: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetAchievementsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetFaqsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetGameTasksParams {
  /**
   * Limit
   * The limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 300
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetItemsParams {
  /** Filter by item state */
  state?: ResourceState
  /** Search String */
  search_string?: string
  /** Category Id */
  category_id?: string | UnsetType
  /** An enumeration. */
  order_by?: ItemOrderType
  /** Is Stackable */
  is_stackable?: boolean
  /** With Price */
  with_price?: boolean
  /** Rarity Id */
  rarity_id?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /**
   * Types
   * Optional comma separated list of types
   */
  types?: string
  /**
   * Ids
   * Optional comma separated list of ids
   */
  ids?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetItemsCountParams {
  /** Filter by item state */
  state?: ResourceState
  /**
   * Types
   * Optional comma separated list of types
   */
  types?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetItemImagesParams {
  /**
   * Item Id
   * Filter by Item ID
   */
  item_id: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetLeaderboardsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetLeaderboardMembersParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Leaderboard Id */
  leaderboardId: string
}

export interface GetNewsListParams {
  /** An enumeration. */
  category?: NewsCategory
  /** An enumeration. */
  group?: NewsGroup
  /** An enumeration. */
  sort_field?: NewsSortField
  /** @default "asc" */
  sort_order?: SortOrder
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /**
   * Ids
   * Optional comma separated list of ids
   */
  ids?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPagesParams {
  /** Parent Id */
  parent_id?: string
  /**
   * Ignore Parent Id
   * @default false
   */
  ignore_parent_id?: boolean
  types?: PageLayoutType[]
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPagesByIdsParams {
  /**
   * Ids
   * Comma separated list of ids
   */
  ids: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetVideosParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignsParams {
  /** An enumeration. */
  resource_state?: ResourceState
  /** Enabled */
  enabled?: boolean
  /** Type */
  type?: CampaignEventType | string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignVersionsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Campaign Id */
  campaignId: string
}

export interface GetWebhooksParams {
  /**
   * Limit
   * The limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 300
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetWebsitesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPayoutsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface CreatePayoutParams {
  /**
   * Is Sandbox
   * @default false
   */
  is_sandbox?: boolean
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetBalanceParams {
  /**
   * Is Sandbox
   * @default false
   */
  is_sandbox?: boolean
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPayoutRequestPreviewParams {
  /**
   * Is Sandbox
   * @default false
   */
  is_sandbox?: boolean
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPaymentsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /**
   * Start At
   * Optional start of the time range to filter, in Unix timestamp format (seconds)
   */
  start_at?: number
  /**
   * End At
   * Optional end of the time range to filter. Mandatory if start_at is specified.
   */
  end_at?: number
  /**
   * Field by which the start_at/end_at range is filtered
   * @default "created_at"
   */
  field?: RangeField
  /** Search String */
  search_string?: string
  /** User Id */
  user_id?: string
  /**
   * Status
   * Optional comma separated list of status
   */
  status?: string
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetRevenueByDatesParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTopMeasuresParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPaymentsSuccessFailByDatesParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPaymentsSuccessPercentParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetRevenueByDateDeviceParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetConversionGameHubFirstPurchaseByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetRevenueByCountryParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetSalesByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetHubVisitDataParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTopItemsParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetBestTriggersByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetSankeyTopSkuParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface ExportTransactionsParams {
  /** Start */
  start: string
  /** End */
  end: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTopClaimedItemsParams {
  /** An enumeration. */
  item_type?: ItemClaimedType
  /**
   * Limit
   * @default 5
   */
  limit?: number
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTopCodesParams {
  /**
   * Limit
   * @default 5
   */
  limit?: number
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetNewUsersDataParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPaymentUsersCountByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPaymentUsersCountParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTotalUsdParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** An enumeration. */
  order_source?: OrderSourceType
  /** An enumeration. */
  user_source?: UserSourceType
  /** An enumeration. */
  device_type?: DeviceType
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignPlayersCountParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignPlayersCountByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignTotalRevenueByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignTotalRevenueParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignAvgCheckParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignAvgCheckByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignPayingUsersCountParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetAbTestDataParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignPayingUsersCountByDateParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetAllCampaignDataParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignCommunicationStatParams {
  /**
   * Last Count Days
   * @max 30
   * @default 30
   */
  last_count_days?: number
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** An enumeration. */
  type?: CommunicationType
  /** Is Read */
  is_read?: boolean
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignCommunicationStatByDateParams {
  /**
   * Last Count Days
   * @max 30
   * @default 30
   */
  last_count_days?: number
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** An enumeration. */
  type?: CommunicationType
  /** Is Read */
  is_read?: boolean
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTransactionStatByDatesParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Search String */
  search_string?: string
  /** User Id */
  user_id?: string
  /**
   * Status
   * Optional comma separated list of status
   */
  status?: string
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTotalTransactionStatParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Search String */
  search_string?: string
  /** User Id */
  user_id?: string
  /**
   * Status
   * Optional comma separated list of status
   */
  status?: string
  /**
   * Countries
   * Optional comma separated list of countries
   */
  countries?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignNodeStatParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /**
   * Campaign Versions
   * Optional comma separated list of campaign_versions
   */
  campaign_versions?: string
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignResultNodeStatParams {
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /**
   * Campaign Versions
   * Optional comma separated list of campaign_versions
   */
  campaign_versions?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Campaign Id */
  campaignId: string
}

export interface DefineCreatorPlatformParams {
  /** Url */
  url?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCreatorsParams {
  /** Q */
  q?: string
  /** An enumeration. */
  platform?: CreatorSocialPlatform
  /** Terms Accepted */
  terms_accepted?: boolean
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetDefaultTemplatePricesParams {
  /**
   * Price
   * @min 0
   */
  price?: number
  /** @default "none" */
  category?: PriceCategory
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPriceTemplatesParams {
  /** Q */
  q?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Starting After
   * The cursor for pagination
   */
  starting_after?: string
  /**
   * Ending Before
   * The cursor for pagination
   */
  ending_before?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetUsersParams {
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface SearchPricesParams {
  /** Item Id */
  item_id?: string
  /**
   * Price
   * @min 0
   */
  price?: number
  /** @default "none" */
  category?: PriceCategory
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface CreateOrUpdatePricesParams {
  /** @default "none" */
  category?: PriceCategory
  /** Item Id */
  itemId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetSegmentsParams {
  /** Segment Group Id */
  segment_group_id?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetUserCouponsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** User Id */
  userId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTotalCouponStatParams {
  /**
   * Ids
   * Comma separated list of ids
   */
  ids: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCouponsParams {
  /** Q */
  q?: string
  /** An enumeration. */
  type?: CouponType
  /** An enumeration. */
  generated_type?: CouponGeneratedType
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCouponStatParams {
  /**
   * Last Count Days
   * @max 30
   * @default 30
   */
  last_count_days?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Coupon Id */
  couponId: string
}

export interface GetTranslationsParams {
  /** Locale Id */
  locale_id: string
  /** Q */
  q?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Starting After
   * The cursor for pagination
   */
  starting_after?: string
  /**
   * Ending Before
   * The cursor for pagination
   */
  ending_before?: string
  /**
   * Object Types
   * Optional comma separated list of object_types
   */
  object_types?: string
  /**
   * States
   * Optional comma separated list of states
   */
  states?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetLocalesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignUsersParams {
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Campaign Id */
  campaignId: string
}

export interface GetStoresParams {
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCampaignStoreItemsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Campaign Id */
  campaignId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetVirtualSkuStatParams {
  /** Campaign Id */
  campaign_id?: string
  /** User Id */
  user_id?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetStoreItemsByIdsParams {
  /**
   * Ids
   * Comma separated list of ids
   */
  ids: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCheckoutLinksParams {
  /** An enumeration. */
  resource_state?: ResourceState
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetItemCategoriesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetWebhookLogByUserParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** User Id */
  userId: string
}

export interface GetAggregateWebhookLogParams {
  /** Search String */
  search_string?: string
  /** An enumeration. */
  status?: SendStatus
  /** An enumeration. */
  event_type?: WebhookEventType
  /** An enumeration. */
  trigger?: WebhookEventTrigger
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Webhook Id */
  webhookId: string
}

export interface GetWebhookTotalDataParams {
  /** Search String */
  search_string?: string
  /** An enumeration. */
  event_type?: WebhookEventType
  /** An enumeration. */
  trigger?: WebhookEventTrigger
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Webhook Id */
  webhookId: string
}

export interface GetWebhookLogsParams {
  /** Search String */
  search_string?: string
  /** An enumeration. */
  status?: SendStatus
  /** An enumeration. */
  event_type?: WebhookEventType
  /** An enumeration. */
  trigger?: WebhookEventTrigger
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /**
   * Tz
   * @default 0
   */
  tz?: number
  /** @default "day" */
  granularity?: DataGranularity
  /** @default "period" */
  type?: FilterType
  /** Start At */
  start_at?: number
  /** End At */
  end_at?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Webhook Id */
  webhookId: string
}

export interface GetItemPropertiesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetItemPropertiesRelationsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
  /** Item Id */
  itemId: string
}

export interface GetCampaignTemplatesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetClaimedItemsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** User Id */
  userId: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetDailyRewardsParams {
  /** Q */
  q?: string
  /** An enumeration. */
  type?: DailyRewardType
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetStorePromotionsParams {
  /** An enumeration. */
  resource_state?: ResourceState
  /** Search String */
  search_string?: string
  /** Active */
  active?: boolean
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPluginsByStateParams {
  /** Enabled */
  enabled?: boolean
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetAllPluginsParams {
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetJobsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /**
   * Statuses
   * Optional comma separated list of statuses
   */
  statuses?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetTranslationGlossariesParams {
  /**
   * Locale Id
   * Filter by locale
   */
  locale_id?: string
  /**
   * Q
   * Filter by search query
   */
  q?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Starting After
   * The cursor for pagination
   */
  starting_after?: string
  /**
   * Ending Before
   * The cursor for pagination
   */
  ending_before?: string
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetWebsiteTemplatesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCashbackRewardsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetItemRaritiesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetLootboxesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetSequentialOffersParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetRangeOffersParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetProgressionProgramsParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCardTemplatesParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetRollingOffersParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetPickOneOffersParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetAllOffersParams {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
  /** Game Id */
  gameId: string
}

export interface GetCompanyInvitesParams {
  /**
   * Limit
   * The limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 300
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  /** Company Id */
  companyId: string
}

export interface GetCompanyGamesParams {
  /**
   * Ids
   * Optional comma separated list of ids
   */
  ids?: string
}

export interface GetAllCompanyGamesParams {
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Starting After
   * The cursor for pagination
   */
  starting_after?: string
  /**
   * Ending Before
   * The cursor for pagination
   */
  ending_before?: string
}

export interface GetCompanyMembersParams {
  /**
   * Limit
   * The limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 300
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
  companyId: string
}

export interface GetAllPlugins2Params {
  /** Search String */
  search_string?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '/dashboard'
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(key => 'undefined' !== typeof query[key])
    return keys
      .map(key => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async response => {
      const r = response.clone() as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then(data => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch(e => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title Aghanim API
 * @version 1.0.0
 * @baseUrl /dashboard
 * @contact Aghanim <integration@aghanim.com>
 *
 * Welcome to the Aghanim API.
 */
export class DashboardClient<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name Index
   * @summary Index
   * @request GET:/
   */
  index = (params: RequestParams = {}) =>
    this.request<Record<string, string>, any>({
      path: `/`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  v1 = {
    /**
     * No description
     *
     * @tags Games
     * @name GetGames
     * @summary Get Games
     * @request GET:/v1/companies/{company_id}/games
     * @secure
     */
    getGames: ({ companyId, ...query }: GetGamesParams, params: RequestParams = {}) =>
      this.request<AghanimGameSchemasGame[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Games
     * @name CreateGame
     * @summary Create Game
     * @request POST:/v1/companies/{company_id}/games
     * @secure
     */
    createGame: (companyId: string, data: GameCreate, params: RequestParams = {}) =>
      this.request<AghanimGameSchemasGame, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Games
     * @name GetGame
     * @summary Get Game
     * @request GET:/v1/companies/{company_id}/games/{game_id}
     * @secure
     */
    getGame: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<AghanimGameSchemasGame, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Games
     * @name UpdateGame
     * @summary Update Game
     * @request PUT:/v1/companies/{company_id}/games/{game_id}
     * @secure
     */
    updateGame: (companyId: string, gameId: string, data: GameUpdate, params: RequestParams = {}) =>
      this.request<AghanimGameSchemasGame, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Games
     * @name DeleteGame
     * @summary Delete Game
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}
     * @secure
     */
    deleteGame: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Games
     * @name CreateSandbox
     * @summary Create Sandbox
     * @request POST:/v1/companies/{company_id}/games/{game_id}/sandbox
     * @secure
     */
    createSandbox: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<AghanimGameSchemasGame, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/sandbox`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Games
     * @name UpdateDefaultLocale
     * @summary Update Default Locale
     * @request POST:/v1/companies/{company_id}/games/{game_id}/update_default_locale
     * @secure
     */
    updateDefaultLocale: (
      companyId: string,
      gameId: string,
      data: UpdateDefaultLocaleRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/update_default_locale`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Games, Private
     * @name CopyGame
     * @summary Copy Game
     * @request POST:/v1/companies/{company_id}/games/{game_id}/copy
     * @secure
     */
    copyGame: ({ companyId, gameId, ...query }: CopyGameParams, params: RequestParams = {}) =>
      this.request<AghanimGameSchemasGame, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/copy`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of achievements.
     *
     * @tags Achievements
     * @name GetAchievements
     * @summary Get Achievements
     * @request GET:/v1/companies/{company_id}/games/{game_id}/achievements
     * @secure
     */
    getAchievements: ({ companyId, gameId, ...query }: GetAchievementsParams, params: RequestParams = {}) =>
      this.request<AchievementRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/achievements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Achievements
     * @name CreateAchievement
     * @summary Create Achievement
     * @request POST:/v1/companies/{company_id}/games/{game_id}/achievements
     * @secure
     */
    createAchievement: (companyId: string, gameId: string, data: AchievementCreate, params: RequestParams = {}) =>
      this.request<AchievementRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/achievements`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates multiple store items.
     *
     * @tags Achievements
     * @name BulkUpdateAchievement
     * @summary Bulk Update Achievement
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/achievements
     * @secure
     */
    bulkUpdateAchievement: (
      companyId: string,
      gameId: string,
      data: AchievementBulkUpdate[],
      params: RequestParams = {},
    ) =>
      this.request<AchievementRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/achievements`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single achievement.
     *
     * @tags Achievements
     * @name GetAchievement
     * @summary Get Achievement
     * @request GET:/v1/companies/{company_id}/games/{game_id}/achievements/{achievement_id}
     * @secure
     */
    getAchievement: (companyId: string, gameId: string, achievementId: string, params: RequestParams = {}) =>
      this.request<AchievementRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/achievements/${achievementId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates an achievement.
     *
     * @tags Achievements
     * @name UpdateAchievement
     * @summary Update Achievement
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/achievements/{achievement_id}
     * @secure
     */
    updateAchievement: (
      companyId: string,
      gameId: string,
      achievementId: string,
      data: AchievementUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AchievementRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/achievements/${achievementId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes an achievement.
     *
     * @tags Achievements
     * @name DeleteAchievement
     * @summary Delete Achievement
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/achievements/{achievement_id}
     * @secure
     */
    deleteAchievement: (companyId: string, gameId: string, achievementId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/achievements/${achievementId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys
     * @name GetApiKeys
     * @summary Get Api Keys
     * @request GET:/v1/companies/{company_id}/games/{game_id}/api_keys
     * @secure
     */
    getApiKeys: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<APIKeyRedacted[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/api_keys`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys
     * @name CreateApiKey
     * @summary Create Api Key
     * @request POST:/v1/companies/{company_id}/games/{game_id}/api_keys
     * @secure
     */
    createApiKey: (companyId: string, gameId: string, data: APIKeyCreate, params: RequestParams = {}) =>
      this.request<APIKeyRevealed, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/api_keys`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys
     * @name GetApiKey
     * @summary Get Api Key
     * @request GET:/v1/companies/{company_id}/games/{game_id}/api_keys/{api_key_id}
     * @secure
     */
    getApiKey: (companyId: string, gameId: string, apiKeyId: string, params: RequestParams = {}) =>
      this.request<APIKeyRedacted, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/api_keys/${apiKeyId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys
     * @name DeleteApiKey
     * @summary Delete Api Key
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/api_keys/{api_key_id}
     * @secure
     */
    deleteApiKey: (companyId: string, gameId: string, apiKeyId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/api_keys/${apiKeyId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys
     * @name RevealApiKey
     * @summary Reveal Api Key
     * @request POST:/v1/companies/{company_id}/games/{game_id}/api_keys/{api_key_id}/reveal
     * @secure
     */
    revealApiKey: (companyId: string, gameId: string, apiKeyId: string, params: RequestParams = {}) =>
      this.request<APIKeyRevealed, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/api_keys/${apiKeyId}/reveal`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name GetFaqs
     * @summary Get Faqs
     * @request GET:/v1/companies/{company_id}/games/{game_id}/faqs
     * @secure
     */
    getFaqs: ({ companyId, gameId, ...query }: GetFaqsParams, params: RequestParams = {}) =>
      this.request<FAQ[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/faqs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name CreateFaq
     * @summary Create Faq
     * @request POST:/v1/companies/{company_id}/games/{game_id}/faqs
     * @secure
     */
    createFaq: (companyId: string, gameId: string, data: FAQCreate, params: RequestParams = {}) =>
      this.request<FAQ, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/faqs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name GetFaq
     * @summary Get Faq
     * @request GET:/v1/companies/{company_id}/games/{game_id}/faqs/{faq_id}
     * @secure
     */
    getFaq: (companyId: string, gameId: string, faqId: string, params: RequestParams = {}) =>
      this.request<FAQ, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/faqs/${faqId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name UpdateFaq
     * @summary Update Faq
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/faqs/{faq_id}
     * @secure
     */
    updateFaq: (companyId: string, gameId: string, faqId: string, data: FAQUpdate, params: RequestParams = {}) =>
      this.request<FAQ, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/faqs/${faqId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name DeleteFaq
     * @summary Delete Faq
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/faqs/{faq_id}
     * @secure
     */
    deleteFaq: (companyId: string, gameId: string, faqId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/faqs/${faqId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Return list of game tasks to complete by a company admin.
     *
     * @tags Tasks
     * @name GetGameTasks
     * @summary Get Game Tasks
     * @request GET:/v1/companies/{company_id}/games/{game_id}/tasks
     * @secure
     */
    getGameTasks: ({ companyId, gameId, ...query }: GetGameTasksParams, params: RequestParams = {}) =>
      this.request<GameTaskRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Items
     * @name GetItems
     * @summary Get Items
     * @request GET:/v1/companies/{company_id}/games/{game_id}/items
     * @secure
     */
    getItems: ({ companyId, gameId, ...query }: GetItemsParams, params: RequestParams = {}) =>
      this.request<(ItemRead | LootboxRead)[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates or updates multiple items.
     *
     * @tags Items
     * @name BulkCreateOrUpdateItems
     * @summary Bulk Create Or Update Items
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/items
     * @secure
     */
    bulkCreateOrUpdateItems: (
      companyId: string,
      gameId: string,
      data: ItemBulkCreateOrUpdate[],
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new item.
     *
     * @tags Items
     * @name CreateItem
     * @summary Create Item
     * @request POST:/v1/companies/{company_id}/games/{game_id}/items
     * @secure
     */
    createItem: (companyId: string, gameId: string, data: ItemCreate, params: RequestParams = {}) =>
      this.request<ItemRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes multiple items.
     *
     * @tags Items
     * @name BulkDeleteItems
     * @summary Bulk Delete Items
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/items
     * @secure
     */
    bulkDeleteItems: (companyId: string, gameId: string, data: ItemBulkDelete[], params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple items.
     *
     * @tags Items
     * @name BulkUpdateItems
     * @summary Bulk Update Items
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/items
     * @secure
     */
    bulkUpdateItems: (companyId: string, gameId: string, data: ItemBulkUpdate[], params: RequestParams = {}) =>
      this.request<ItemRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the count of items.
     *
     * @tags Items, Private
     * @name GetItemsCount
     * @summary Get Items Count
     * @request GET:/v1/companies/{company_id}/games/{game_id}/items/count
     * @secure
     */
    getItemsCount: ({ companyId, gameId, ...query }: GetItemsCountParams, params: RequestParams = {}) =>
      this.request<TotalCountResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items/count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single item.
     *
     * @tags Items
     * @name GetItem
     * @summary Get Item
     * @request GET:/v1/companies/{company_id}/games/{game_id}/items/{item_id}
     * @secure
     */
    getItem: (companyId: string, gameId: string, itemId: string, params: RequestParams = {}) =>
      this.request<ItemRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates an item.
     *
     * @tags Items
     * @name UpdateItem
     * @summary Update Item
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/items/{item_id}
     * @secure
     */
    updateItem: (companyId: string, gameId: string, itemId: string, data: ItemUpdate, params: RequestParams = {}) =>
      this.request<ItemRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items/${itemId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes an item.
     *
     * @tags Items
     * @name DeleteItem
     * @summary Delete Item
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/items/{item_id}
     * @secure
     */
    deleteItem: (companyId: string, gameId: string, itemId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items/${itemId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Translates an item.
     *
     * @tags Items
     * @name TranslateItem
     * @summary Translate Item
     * @request POST:/v1/companies/{company_id}/games/{game_id}/items/{item_id}/translate
     * @secure
     */
    translateItem: (
      companyId: string,
      gameId: string,
      itemId: string,
      data: ItemTranslate,
      params: RequestParams = {},
    ) =>
      this.request<ItemRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/items/${itemId}/translate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Images
     * @name GetItemImages
     * @summary Get Item Images
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_images
     * @secure
     */
    getItemImages: ({ companyId, gameId, ...query }: GetItemImagesParams, params: RequestParams = {}) =>
      this.request<ItemImageRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_images`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Images
     * @name CreateItemImage
     * @summary Create Item Image
     * @request POST:/v1/companies/{company_id}/games/{game_id}/item_images
     * @secure
     */
    createItemImage: (companyId: string, gameId: string, data: ItemImageCreate, params: RequestParams = {}) =>
      this.request<ItemImageRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_images`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Images
     * @name GetItemImage
     * @summary Get Item Image
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_images/{item_image_id}
     * @secure
     */
    getItemImage: (companyId: string, gameId: string, itemImageId: string, params: RequestParams = {}) =>
      this.request<ItemImageRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_images/${itemImageId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Images
     * @name UpdateItemImage
     * @summary Update Item Image
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/item_images/{item_image_id}
     * @secure
     */
    updateItemImage: (
      companyId: string,
      gameId: string,
      itemImageId: string,
      data: ItemImageUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ItemImageRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_images/${itemImageId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Images
     * @name DeleteItemImage
     * @summary Delete Item Image
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/item_images/{item_image_id}
     * @secure
     */
    deleteItemImage: (companyId: string, gameId: string, itemImageId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_images/${itemImageId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a list of leaderboards.
     *
     * @tags Leaderboards
     * @name GetLeaderboards
     * @summary Get Leaderboards
     * @request GET:/v1/companies/{company_id}/games/{game_id}/leaderboards
     * @secure
     */
    getLeaderboards: ({ companyId, gameId, ...query }: GetLeaderboardsParams, params: RequestParams = {}) =>
      this.request<LeaderboardRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/leaderboards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new leaderboard.
     *
     * @tags Leaderboards
     * @name CreateLeaderboard
     * @summary Create Leaderboard
     * @request POST:/v1/companies/{company_id}/games/{game_id}/leaderboards
     * @secure
     */
    createLeaderboard: (companyId: string, gameId: string, data: LeaderboardCreate, params: RequestParams = {}) =>
      this.request<LeaderboardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/leaderboards`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single leaderboard.
     *
     * @tags Leaderboards
     * @name GetLeaderboard
     * @summary Get Leaderboard
     * @request GET:/v1/companies/{company_id}/games/{game_id}/leaderboards/{leaderboard_id}
     * @secure
     */
    getLeaderboard: (companyId: string, gameId: string, leaderboardId: string, params: RequestParams = {}) =>
      this.request<LeaderboardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/leaderboards/${leaderboardId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a leaderboard.
     *
     * @tags Leaderboards
     * @name UpdateLeaderboard
     * @summary Update Leaderboard
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/leaderboards/{leaderboard_id}
     * @secure
     */
    updateLeaderboard: (
      companyId: string,
      gameId: string,
      leaderboardId: string,
      data: LeaderboardUpdate,
      params: RequestParams = {},
    ) =>
      this.request<LeaderboardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/leaderboards/${leaderboardId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a leaderboard.
     *
     * @tags Leaderboards
     * @name DeleteLeaderboard
     * @summary Delete Leaderboard
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/leaderboards/{leaderboard_id}
     * @secure
     */
    deleteLeaderboard: (companyId: string, gameId: string, leaderboardId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/leaderboards/${leaderboardId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a list of leaderboard members.
     *
     * @tags Leaderboards
     * @name GetLeaderboardMembers
     * @summary Get Leaderboard Members
     * @request GET:/v1/companies/{company_id}/games/{game_id}/leaderboards/{leaderboard_id}/members
     * @secure
     */
    getLeaderboardMembers: (
      { companyId, gameId, leaderboardId, ...query }: GetLeaderboardMembersParams,
      params: RequestParams = {},
    ) =>
      this.request<LeaderboardMemberRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/leaderboards/${leaderboardId}/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leaderboards
     * @name UpdateLeaderboardMember
     * @summary Update Leaderboard Member
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/leaderboards/{leaderboard_id}/members/{member_id}
     * @secure
     */
    updateLeaderboardMember: (
      memberId: string,
      companyId: string,
      gameId: string,
      leaderboardId: string,
      data: LeaderboardMemberUpdate,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/leaderboards/${leaderboardId}/members/${memberId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of news posts.
     *
     * @tags News
     * @name GetNewsList
     * @summary Get News List
     * @request GET:/v1/companies/{company_id}/games/{game_id}/news
     * @secure
     */
    getNewsList: ({ companyId, gameId, ...query }: GetNewsListParams, params: RequestParams = {}) =>
      this.request<NewsRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/news`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new news post.
     *
     * @tags News
     * @name CreateNews
     * @summary Create News
     * @request POST:/v1/companies/{company_id}/games/{game_id}/news
     * @secure
     */
    createNews: (companyId: string, gameId: string, data: NewsCreate, params: RequestParams = {}) =>
      this.request<NewsRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/news`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes multiple news.
     *
     * @tags News
     * @name BulkDeleteNews
     * @summary Bulk Delete News
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/news
     * @secure
     */
    bulkDeleteNews: (companyId: string, gameId: string, data: NewsBulkDelete[], params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/news`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple news.
     *
     * @tags News
     * @name BulkUpdateNews
     * @summary Bulk Update News
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/news
     * @secure
     */
    bulkUpdateNews: (companyId: string, gameId: string, data: NewsBulkUpdate[], params: RequestParams = {}) =>
      this.request<NewsRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/news`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single news post.
     *
     * @tags News
     * @name GetNewsPost
     * @summary Get News Post
     * @request GET:/v1/companies/{company_id}/games/{game_id}/news/{news_id}
     * @secure
     */
    getNewsPost: (companyId: string, gameId: string, newsId: string, params: RequestParams = {}) =>
      this.request<NewsRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/news/${newsId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a news post.
     *
     * @tags News
     * @name UpdateNews
     * @summary Update News
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/news/{news_id}
     * @secure
     */
    updateNews: (companyId: string, gameId: string, newsId: string, data: NewsUpdate, params: RequestParams = {}) =>
      this.request<NewsRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/news/${newsId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a news post.
     *
     * @tags News
     * @name DeleteNews
     * @summary Delete News
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/news/{news_id}
     * @secure
     */
    deleteNews: (companyId: string, gameId: string, newsId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/news/${newsId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Private
     * @name GetOrder
     * @summary Get Order
     * @request GET:/v1/companies/{company_id}/games/{game_id}/orders/{order_id}
     * @secure
     */
    getOrder: (orderId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<OrderReadDashboard, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/orders/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Private
     * @name IssueRewardPoints
     * @summary Issue Reward Points
     * @request POST:/v1/companies/{company_id}/games/{game_id}/orders/{order_id}/issue_reward_points
     * @secure
     */
    issueRewardPoints: (orderId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<IssueRewardPointsResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/orders/${orderId}/issue_reward_points`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders, Private
     * @name GiveItem
     * @summary Give Item
     * @request POST:/v1/companies/{company_id}/games/{game_id}/orders/{order_id}/give_item
     * @secure
     */
    giveItem: (orderId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/orders/${orderId}/give_item`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPages
     * @summary Get Pages
     * @request GET:/v1/companies/{company_id}/games/{game_id}/pages
     * @secure
     */
    getPages: ({ companyId, gameId, ...query }: GetPagesParams, params: RequestParams = {}) =>
      this.request<PageRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name CreatePage
     * @summary Create Page
     * @request POST:/v1/companies/{company_id}/games/{game_id}/pages
     * @secure
     */
    createPage: (companyId: string, gameId: string, data: PageCreate, params: RequestParams = {}) =>
      this.request<PageRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes multiple pages.
     *
     * @tags Pages
     * @name BulkDeletePage
     * @summary Bulk Delete Page
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/pages
     * @secure
     */
    bulkDeletePage: (companyId: string, gameId: string, data: PageBulkDelete[], params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple pages.
     *
     * @tags Pages
     * @name BulkUpdatePage
     * @summary Bulk Update Page
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/pages
     * @secure
     */
    bulkUpdatePage: (companyId: string, gameId: string, data: PageBulkUpdate[], params: RequestParams = {}) =>
      this.request<PageRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages, Private
     * @name GetPagesByIds
     * @summary Get Pages By Ids
     * @request GET:/v1/companies/{company_id}/games/{game_id}/pages/by_ids
     * @secure
     */
    getPagesByIds: ({ companyId, gameId, ...query }: GetPagesByIdsParams, params: RequestParams = {}) =>
      this.request<PageRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages/by_ids`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPage
     * @summary Get Page
     * @request GET:/v1/companies/{company_id}/games/{game_id}/pages/{page_id}
     * @secure
     */
    getPage: (companyId: string, gameId: string, pageId: string, params: RequestParams = {}) =>
      this.request<PageRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages/${pageId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdatePage
     * @summary Update Page
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/pages/{page_id}
     * @secure
     */
    updatePage: (companyId: string, gameId: string, pageId: string, data: PageUpdate, params: RequestParams = {}) =>
      this.request<PageRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages/${pageId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name DeletePage
     * @summary Delete Page
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/pages/{page_id}
     * @secure
     */
    deletePage: (companyId: string, gameId: string, pageId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages/${pageId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages, Private
     * @name GetPageSeo
     * @summary Get Page Seo
     * @request GET:/v1/companies/{company_id}/games/{game_id}/pages/{page_id}/seo
     * @secure
     */
    getPageSeo: (companyId: string, gameId: string, pageId: string, params: RequestParams = {}) =>
      this.request<PageSeoRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages/${pageId}/seo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages, Private
     * @name UpdatePageSeo
     * @summary Update Page Seo
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/pages/{page_id}/seo
     * @secure
     */
    updatePageSeo: (
      pageId: string,
      companyId: string,
      gameId: string,
      data: PageSeoUpdate,
      params: RequestParams = {},
    ) =>
      this.request<PageSeoRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pages/${pageId}/seo`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of videos.
     *
     * @tags Videos
     * @name GetVideos
     * @summary Get Videos
     * @request GET:/v1/companies/{company_id}/games/{game_id}/videos
     * @secure
     */
    getVideos: ({ companyId, gameId, ...query }: GetVideosParams, params: RequestParams = {}) =>
      this.request<VideoRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/videos`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new video.
     *
     * @tags Videos
     * @name CreateVideo
     * @summary Create Video
     * @request POST:/v1/companies/{company_id}/games/{game_id}/videos
     * @secure
     */
    createVideo: (companyId: string, gameId: string, data: VideoCreate, params: RequestParams = {}) =>
      this.request<VideoRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/videos`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single video.
     *
     * @tags Videos
     * @name GetVideo
     * @summary Get Video
     * @request GET:/v1/companies/{company_id}/games/{game_id}/videos/{video_id}
     * @secure
     */
    getVideo: (companyId: string, gameId: string, videoId: string, params: RequestParams = {}) =>
      this.request<VideoRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/videos/${videoId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a video.
     *
     * @tags Videos
     * @name UpdateVideo
     * @summary Update Video
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/videos/{video_id}
     * @secure
     */
    updateVideo: (companyId: string, gameId: string, videoId: string, data: VideoUpdate, params: RequestParams = {}) =>
      this.request<VideoRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/videos/${videoId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a video.
     *
     * @tags Videos
     * @name DeleteVideo
     * @summary Delete Video
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/videos/{video_id}
     * @secure
     */
    deleteVideo: (companyId: string, gameId: string, videoId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/videos/${videoId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name GetCampaigns
     * @summary Get Campaigns
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns
     * @secure
     */
    getCampaigns: ({ companyId, gameId, ...query }: GetCampaignsParams, params: RequestParams = {}) =>
      this.request<Campaign[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name CreateCampaign
     * @summary Create Campaign
     * @request POST:/v1/companies/{company_id}/games/{game_id}/campaigns
     * @secure
     */
    createCampaign: (companyId: string, gameId: string, data: CampaignCreate, params: RequestParams = {}) =>
      this.request<Campaign, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates multiple campaigns.
     *
     * @tags LiveOps
     * @name BulkUpdateCampaigns
     * @summary Bulk Update Campaigns
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/campaigns
     * @secure
     */
    bulkUpdateCampaigns: (companyId: string, gameId: string, data: BulkCampaignUpdate[], params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps, Private
     * @name GetCampaignsCount
     * @summary Get Campaigns Count
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns/count
     * @secure
     */
    getCampaignsCount: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<CampaignsCount, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name GetCampaign
     * @summary Get Campaign
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}
     * @secure
     */
    getCampaign: (companyId: string, gameId: string, campaignId: string, params: RequestParams = {}) =>
      this.request<Campaign, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name UpdateCampaign
     * @summary Update Campaign
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}
     * @secure
     */
    updateCampaign: (
      companyId: string,
      gameId: string,
      campaignId: string,
      data: CampaignUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Campaign, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name DeleteCampaign
     * @summary Delete Campaign
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}
     * @secure
     */
    deleteCampaign: (companyId: string, gameId: string, campaignId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps, Private
     * @name GetCurrentCampaignVersion
     * @summary Get Current Campaign Version
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}/current
     * @secure
     */
    getCurrentCampaignVersion: (companyId: string, gameId: string, campaignId: string, params: RequestParams = {}) =>
      this.request<VersionRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps, Private
     * @name GetCampaignVersions
     * @summary Get Campaign Versions
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}/versions
     * @secure
     */
    getCampaignVersions: (
      { companyId, gameId, campaignId, ...query }: GetCampaignVersionsParams,
      params: RequestParams = {},
    ) =>
      this.request<VersionRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}/versions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name GetCampaignGraph
     * @summary Get Campaign Graph
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}/graph
     * @secure
     */
    getCampaignGraph: (companyId: string, gameId: string, campaignId: string, params: RequestParams = {}) =>
      this.request<GraphRoot, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}/graph`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name UpdateCampaignGraph
     * @summary Update Campaign Graph
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}/graph
     * @secure
     */
    updateCampaignGraph: (
      companyId: string,
      gameId: string,
      campaignId: string,
      data: GraphRoot,
      params: RequestParams = {},
    ) =>
      this.request<Campaign, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}/graph`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps, Private
     * @name GetCampaignVersionGraph
     * @summary Get Campaign Version Graph
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}/graph/{campaign_version_id}
     * @secure
     */
    getCampaignVersionGraph: (
      campaignVersionId: string,
      companyId: string,
      gameId: string,
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignVersionGraph, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}/graph/${campaignVersionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps, Private
     * @name UpdateCampaignVersion
     * @summary Update Campaign Version
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}/versions/{campaign_version_id}
     * @secure
     */
    updateCampaignVersion: (
      campaignVersionId: string,
      companyId: string,
      gameId: string,
      campaignId: string,
      data: CampaignVersionUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Campaign, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}/versions/${campaignVersionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOps
     * @name ArchiveCampaignCreatedObjects
     * @summary Archive Campaign Created Objects
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/campaigns/{campaign_id}/objects
     * @secure
     */
    archiveCampaignCreatedObjects: (
      campaignId: string,
      companyId: string,
      gameId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns/${campaignId}/objects`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a list of webhooks.
     *
     * @tags Webhooks
     * @name GetWebhooks
     * @summary Get Webhooks
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhooks
     * @secure
     */
    getWebhooks: ({ companyId, gameId, ...query }: GetWebhooksParams, params: RequestParams = {}) =>
      this.request<WebhookRedacted[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new webhook.
     *
     * @tags Webhooks
     * @name CreateWebhook
     * @summary Create Webhook
     * @request POST:/v1/companies/{company_id}/games/{game_id}/webhooks
     * @secure
     */
    createWebhook: (companyId: string, gameId: string, data: WebhookCreate, params: RequestParams = {}) =>
      this.request<WebhookRevealed, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single webhook.
     *
     * @tags Webhooks
     * @name GetWebhook
     * @summary Get Webhook
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}
     * @secure
     */
    getWebhook: (companyId: string, gameId: string, webhookId: string, params: RequestParams = {}) =>
      this.request<WebhookRedacted, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a webhook.
     *
     * @tags Webhooks
     * @name UpdateWebhook
     * @summary Update Webhook
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}
     * @secure
     */
    updateWebhook: (
      companyId: string,
      gameId: string,
      webhookId: string,
      data: WebhookUpdate,
      params: RequestParams = {},
    ) =>
      this.request<WebhookRedacted, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a webhook.
     *
     * @tags Webhooks
     * @name DeleteWebhook
     * @summary Delete Webhook
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}
     * @secure
     */
    deleteWebhook: (companyId: string, gameId: string, webhookId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Expires the secret of a webhook.
     *
     * @tags Webhooks
     * @name ExpireWebhookSecret
     * @summary Expire Webhook Secret
     * @request POST:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}/expire_secret
     * @secure
     */
    expireWebhookSecret: (companyId: string, gameId: string, webhookId: string, params: RequestParams = {}) =>
      this.request<WebhookRevealed, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}/expire_secret`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reveals the secret of a webhook.
     *
     * @tags Webhooks
     * @name RevealWebhookSecret
     * @summary Reveal Webhook Secret
     * @request POST:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}/reveal
     * @secure
     */
    revealWebhookSecret: (companyId: string, gameId: string, webhookId: string, params: RequestParams = {}) =>
      this.request<WebhookRevealed, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}/reveal`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name GetWebsites
     * @summary Get Websites
     * @request GET:/v1/companies/{company_id}/games/{game_id}/websites
     * @secure
     */
    getWebsites: ({ companyId, gameId, ...query }: GetWebsitesParams, params: RequestParams = {}) =>
      this.request<Website[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name CreateWebsite
     * @summary Create Website
     * @request POST:/v1/companies/{company_id}/games/{game_id}/websites
     * @secure
     */
    createWebsite: (companyId: string, gameId: string, data: WebsiteCreate, params: RequestParams = {}) =>
      this.request<Website, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name GetWebsite
     * @summary Get Website
     * @request GET:/v1/companies/{company_id}/games/{game_id}/websites/{website_id}
     * @secure
     */
    getWebsite: (companyId: string, gameId: string, websiteId: string, params: RequestParams = {}) =>
      this.request<WebsiteRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites/${websiteId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name UpdateWebsite
     * @summary Update Website
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/websites/{website_id}
     * @secure
     */
    updateWebsite: (
      companyId: string,
      gameId: string,
      websiteId: string,
      data: WebsiteUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Website, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites/${websiteId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name DeleteWebsite
     * @summary Delete Website
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/websites/{website_id}
     * @secure
     */
    deleteWebsite: (companyId: string, gameId: string, websiteId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites/${websiteId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name AddFeaturedVideo
     * @summary Add Featured Video
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/websites/{website_id}/featured_videos
     * @secure
     */
    addFeaturedVideo: (
      companyId: string,
      gameId: string,
      websiteId: string,
      data: VideoFeaturedAdd,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites/${websiteId}/featured_videos`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name DeleteFeaturedVideo
     * @summary Delete Featured Video
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/websites/{website_id}/featured_videos/{video_id}
     * @secure
     */
    deleteFeaturedVideo: (
      companyId: string,
      gameId: string,
      websiteId: string,
      videoId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites/${websiteId}/featured_videos/${videoId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name ClearWebsiteCache
     * @summary Clear Website Cache
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/websites/{website_id}/cache
     * @secure
     */
    clearWebsiteCache: (companyId: string, gameId: string, websiteId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/websites/${websiteId}/cache`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name RefundOrder
     * @summary Refund Order
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/{payment_id}/refund
     * @secure
     */
    refundOrder: (
      paymentId: string,
      companyId: string,
      gameId: string,
      data: RefundRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/${paymentId}/refund`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name RenotifyPayment
     * @summary Renotify Payment
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/{payment_id}/renotify
     * @secure
     */
    renotifyPayment: (
      paymentId: string,
      companyId: string,
      gameId: string,
      data: RenotifyRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/${paymentId}/renotify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetPaymentMethods
     * @summary Get Payment Methods
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/payment_methods
     * @secure
     */
    getPaymentMethods: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<PaymentMethod[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payment_methods`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name UpdatePaymentMethods
     * @summary Update Payment Methods
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/payment_methods/{id}
     * @secure
     */
    updatePaymentMethods: (
      id: string,
      companyId: string,
      gameId: string,
      data: PaymentMethodSettings,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payment_methods/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetUserPaymentMethods
     * @summary Get User Payment Methods
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/payment_methods/{paylink_user_id}
     * @secure
     */
    getUserPaymentMethods: (paylinkUserId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<UserPaymentMethod[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payment_methods/${paylinkUserId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name ResendReceiptEmail
     * @summary Resend Receipt Email
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/{order_id}/resend_email
     * @secure
     */
    resendReceiptEmail: (companyId: string, gameId: string, orderId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/${orderId}/resend_email`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetPayouts
     * @summary Get Payouts
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/payouts
     * @secure
     */
    getPayouts: ({ companyId, gameId, ...query }: GetPayoutsParams, params: RequestParams = {}) =>
      this.request<Payout[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payouts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name CreatePayout
     * @summary Create Payout
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/payouts
     * @secure
     */
    createPayout: ({ companyId, gameId, ...query }: CreatePayoutParams, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payouts`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetPayoutsByMonth
     * @summary Get Payouts By Month
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/payouts/monthly_aggregated
     * @secure
     */
    getPayoutsByMonth: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<PayoutMonth[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payouts/monthly_aggregated`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetBalance
     * @summary Get Balance
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/balance
     * @secure
     */
    getBalance: ({ companyId, gameId, ...query }: GetBalanceParams, params: RequestParams = {}) =>
      this.request<MeasureValue, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/balance`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetPayoutRequestPreview
     * @summary Get Payout Request Preview
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/payout_request_preview
     * @secure
     */
    getPayoutRequestPreview: (
      { companyId, gameId, ...query }: GetPayoutRequestPreviewParams,
      params: RequestParams = {},
    ) =>
      this.request<PayoutRequestPreview, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payout_request_preview`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name ApplyInstantPayouts
     * @summary Apply Instant Payouts
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/payouts/apply
     * @secure
     */
    applyInstantPayouts: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/payouts/apply`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing, Private
     * @name MakeReceiptEmailFromParameters
     * @summary Make Receipt Email From Parameters
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/receipt_email_from_parameters
     * @secure
     */
    makeReceiptEmailFromParameters: (
      companyId: string,
      gameId: string,
      data: ReceiptParams,
      params: RequestParams = {},
    ) =>
      this.request<EmailResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/receipt_email_from_parameters`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing, Private
     * @name SendReceiptEmailFromParameters
     * @summary Send Receipt Email From Parameters
     * @request POST:/v1/companies/{company_id}/games/{game_id}/billing/send_receipt_email_from_parameters
     * @secure
     */
    sendReceiptEmailFromParameters: (
      companyId: string,
      gameId: string,
      data: ReceiptParams,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/send_receipt_email_from_parameters`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetReceiptEmail
     * @summary Get Receipt Email
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/{order_id}/email
     * @secure
     */
    getReceiptEmail: (companyId: string, gameId: string, orderId: string, params: RequestParams = {}) =>
      this.request<EmailResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/${orderId}/email`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name GetTaxRates
     * @summary Get Tax Rates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/billing/tax-rates
     * @secure
     */
    getTaxRates: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<TaxByCountry[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/billing/tax-rates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetPayment
     * @summary Get Payment
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/payments/{payment_number}
     * @secure
     */
    getPayment: (paymentNumber: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<DashboardPaymentRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/payments/${paymentNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetPayments
     * @summary Get Payments
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/payments
     * @secure
     */
    getPayments: ({ companyId, gameId, ...query }: GetPaymentsParams, params: RequestParams = {}) =>
      this.request<PaymentRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/payments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetRevenueByDates
     * @summary Get Revenue By Dates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/revenue_by_dates
     * @secure
     */
    getRevenueByDates: ({ companyId, gameId, ...query }: GetRevenueByDatesParams, params: RequestParams = {}) =>
      this.request<PointValueEx[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/revenue_by_dates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetTopMeasures
     * @summary Get Top Measures
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/top_measures
     * @secure
     */
    getTopMeasures: ({ companyId, gameId, ...query }: GetTopMeasuresParams, params: RequestParams = {}) =>
      this.request<Record<string, MeasureValue>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/top_measures`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetPaymentsSuccessFailByDates
     * @summary Get Payments Success Fail By Dates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/payments_success_fail_by_dates
     * @secure
     */
    getPaymentsSuccessFailByDates: (
      { companyId, gameId, ...query }: GetPaymentsSuccessFailByDatesParams,
      params: RequestParams = {},
    ) =>
      this.request<PaymentSuccessFail[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/payments_success_fail_by_dates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetPaymentsSuccessPercent
     * @summary Get Payments Success Percent
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/payments_success_percent
     * @secure
     */
    getPaymentsSuccessPercent: (
      { companyId, gameId, ...query }: GetPaymentsSuccessPercentParams,
      params: RequestParams = {},
    ) =>
      this.request<MeasureValue, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/payments_success_percent`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetRevenueByDateDevice
     * @summary Get Revenue By Date Device
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/revenue_by_date_device
     * @secure
     */
    getRevenueByDateDevice: (
      { companyId, gameId, ...query }: GetRevenueByDateDeviceParams,
      params: RequestParams = {},
    ) =>
      this.request<SeriesValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/revenue_by_date_device`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetConversionGameHubFirstPurchaseByDate
     * @summary Get Conversion Game Hub First Purchase By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/conversion_game_hub_first_purchase_by_date
     * @secure
     */
    getConversionGameHubFirstPurchaseByDate: (
      { companyId, gameId, ...query }: GetConversionGameHubFirstPurchaseByDateParams,
      params: RequestParams = {},
    ) =>
      this.request<ConversionFirstPurchase, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/conversion_game_hub_first_purchase_by_date`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetRevenueByCountry
     * @summary Get Revenue By Country
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/revenue_by_country
     * @secure
     */
    getRevenueByCountry: ({ companyId, gameId, ...query }: GetRevenueByCountryParams, params: RequestParams = {}) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/revenue_by_country`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetSalesByDate
     * @summary Get Sales By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/sales_by_date
     * @secure
     */
    getSalesByDate: ({ companyId, gameId, ...query }: GetSalesByDateParams, params: RequestParams = {}) =>
      this.request<PointSeriesValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/sales_by_date`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetHubVisitData
     * @summary Get Hub Visit Data
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/hub_visit_data
     * @secure
     */
    getHubVisitData: ({ companyId, gameId, ...query }: GetHubVisitDataParams, params: RequestParams = {}) =>
      this.request<Record<string, PointValueEx[] | MeasureValue>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/hub_visit_data`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetTopItems
     * @summary Get Top Items
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/top_items
     * @secure
     */
    getTopItems: ({ companyId, gameId, ...query }: GetTopItemsParams, params: RequestParams = {}) =>
      this.request<TopItemData[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/top_items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetBestTriggersByDate
     * @summary Get Best Triggers By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/best_triggers_by_date
     * @secure
     */
    getBestTriggersByDate: ({ companyId, gameId, ...query }: GetBestTriggersByDateParams, params: RequestParams = {}) =>
      this.request<BestTriggersData, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/best_triggers_by_date`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetSankeyTopSku
     * @summary Get Sankey Top Sku
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/sankey_top_sku
     * @secure
     */
    getSankeyTopSku: ({ companyId, gameId, ...query }: GetSankeyTopSkuParams, params: RequestParams = {}) =>
      this.request<SankeyTopSkuData, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/sankey_top_sku`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name ExportTransactions
     * @summary Export Transactions
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/export_transactions
     * @secure
     */
    exportTransactions: ({ companyId, gameId, ...query }: ExportTransactionsParams, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/export_transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetTopClaimedItems
     * @summary Get Top Claimed Items
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/top_claimed_items
     * @secure
     */
    getTopClaimedItems: ({ companyId, gameId, ...query }: GetTopClaimedItemsParams, params: RequestParams = {}) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/top_claimed_items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetTopCodes
     * @summary Get Top Codes
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/top_codes
     * @secure
     */
    getTopCodes: ({ companyId, gameId, ...query }: GetTopCodesParams, params: RequestParams = {}) =>
      this.request<CouponStat[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/top_codes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetNewUsersData
     * @summary Get New Users Data
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/new_users_data
     * @secure
     */
    getNewUsersData: ({ companyId, gameId, ...query }: GetNewUsersDataParams, params: RequestParams = {}) =>
      this.request<PointValueEx[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/new_users_data`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetPaymentUsersCountByDate
     * @summary Get Payment Users Count By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/payment_users_count_by_date
     * @secure
     */
    getPaymentUsersCountByDate: (
      { companyId, gameId, ...query }: GetPaymentUsersCountByDateParams,
      params: RequestParams = {},
    ) =>
      this.request<PointValueEx[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/payment_users_count_by_date`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetPaymentUsersCount
     * @summary Get Payment Users Count
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/payment_users_count
     * @secure
     */
    getPaymentUsersCount: ({ companyId, gameId, ...query }: GetPaymentUsersCountParams, params: RequestParams = {}) =>
      this.request<MeasureValue, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/payment_users_count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetTotalUsd
     * @summary Get Total Usd
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/total_usd
     * @secure
     */
    getTotalUsd: ({ companyId, gameId, ...query }: GetTotalUsdParams, params: RequestParams = {}) =>
      this.request<MeasureValue, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/total_usd`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignPlayersCount
     * @summary Get Campaign Players Count
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_players_count/{campaign_id}
     * @secure
     */
    getCampaignPlayersCount: (
      { campaignId, companyId, gameId, ...query }: GetCampaignPlayersCountParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, MeasureValue>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_players_count/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignPlayersCountByDate
     * @summary Get Campaign Players Count By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_players_count_by_date/{campaign_id}
     * @secure
     */
    getCampaignPlayersCountByDate: (
      { campaignId, companyId, gameId, ...query }: GetCampaignPlayersCountByDateParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, PointValue[]>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_players_count_by_date/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignTotalRevenueByDate
     * @summary Get Campaign Total Revenue By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_total_revenue_by_date/{campaign_id}
     * @secure
     */
    getCampaignTotalRevenueByDate: (
      { campaignId, companyId, gameId, ...query }: GetCampaignTotalRevenueByDateParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, PointValue[]>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_total_revenue_by_date/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignTotalRevenue
     * @summary Get Campaign Total Revenue
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_total_revenue/{campaign_id}
     * @secure
     */
    getCampaignTotalRevenue: (
      { campaignId, companyId, gameId, ...query }: GetCampaignTotalRevenueParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, MeasureValue>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_total_revenue/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignAvgCheck
     * @summary Get Campaign Avg Check
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_avg_check/{campaign_id}
     * @secure
     */
    getCampaignAvgCheck: (
      { campaignId, companyId, gameId, ...query }: GetCampaignAvgCheckParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, MeasureValue>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_avg_check/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignAvgCheckByDate
     * @summary Get Campaign Avg Check By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_avg_check_by_date/{campaign_id}
     * @secure
     */
    getCampaignAvgCheckByDate: (
      { campaignId, companyId, gameId, ...query }: GetCampaignAvgCheckByDateParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, PointValue[]>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_avg_check_by_date/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignPayingUsersCount
     * @summary Get Campaign Paying Users Count
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_paying_users_count/{campaign_id}
     * @secure
     */
    getCampaignPayingUsersCount: (
      { campaignId, companyId, gameId, ...query }: GetCampaignPayingUsersCountParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, MeasureValue>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_paying_users_count/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetAbTestData
     * @summary Get Ab Test Data
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/ab_test_data/{campaign_id}
     * @secure
     */
    getAbTestData: ({ campaignId, companyId, gameId, ...query }: GetAbTestDataParams, params: RequestParams = {}) =>
      this.request<Record<string, ABTestPoint[]>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/ab_test_data/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignPayingUsersCountByDate
     * @summary Get Campaign Paying Users Count By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_paying_users_count_by_date/{campaign_id}
     * @secure
     */
    getCampaignPayingUsersCountByDate: (
      { campaignId, companyId, gameId, ...query }: GetCampaignPayingUsersCountByDateParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, PointValue[]>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_paying_users_count_by_date/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetAllCampaignData
     * @summary Get All Campaign Data
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/all_campaign_data/{campaign_id}
     * @secure
     */
    getAllCampaignData: (
      { campaignId, companyId, gameId, ...query }: GetAllCampaignDataParams,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/all_campaign_data/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignCommunicationStat
     * @summary Get Campaign Communication Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_communication_stat/{campaign_id}
     * @secure
     */
    getCampaignCommunicationStat: (
      { campaignId, companyId, gameId, ...query }: GetCampaignCommunicationStatParams,
      params: RequestParams = {},
    ) =>
      this.request<MeasureValue, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_communication_stat/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignCommunicationStatByDate
     * @summary Get Campaign Communication Stat By Date
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_communication_stat_by_date/{campaign_id}
     * @secure
     */
    getCampaignCommunicationStatByDate: (
      { campaignId, companyId, gameId, ...query }: GetCampaignCommunicationStatByDateParams,
      params: RequestParams = {},
    ) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_communication_stat_by_date/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetTransactionStatByDates
     * @summary Get Transaction Stat By Dates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/transaction_stat_by_dates
     * @secure
     */
    getTransactionStatByDates: (
      { companyId, gameId, ...query }: GetTransactionStatByDatesParams,
      params: RequestParams = {},
    ) =>
      this.request<TransactionStat[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/transaction_stat_by_dates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetTotalTransactionStat
     * @summary Get Total Transaction Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/total_transaction_stat
     * @secure
     */
    getTotalTransactionStat: (
      { companyId, gameId, ...query }: GetTotalTransactionStatParams,
      params: RequestParams = {},
    ) =>
      this.request<TransactionStat, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/total_transaction_stat`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignNodeStat
     * @summary Get Campaign Node Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_node_stat/{campaign_id}
     * @secure
     */
    getCampaignNodeStat: (
      { campaignId, companyId, gameId, ...query }: GetCampaignNodeStatParams,
      params: RequestParams = {},
    ) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_node_stat/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports, Hidden
     * @name GetCampaignResultNodeStat
     * @summary Get Campaign Result Node Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/reports/campaign_result_node_stat/{campaign_id}
     * @secure
     */
    getCampaignResultNodeStat: (
      { companyId, gameId, campaignId, ...query }: GetCampaignResultNodeStatParams,
      params: RequestParams = {},
    ) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/reports/campaign_result_node_stat/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Game settings
     * @name GetGameSettings
     * @summary Get Game Settings
     * @request GET:/v1/companies/{company_id}/games/{game_id}/game_settings
     * @secure
     */
    getGameSettings: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<GameSettingsRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/game_settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Game settings
     * @name CreateGameSettings
     * @summary Create Game Settings
     * @request POST:/v1/companies/{company_id}/games/{game_id}/game_settings
     * @secure
     */
    createGameSettings: (companyId: string, gameId: string, data: GameSettingsCreate, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/game_settings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Game settings
     * @name UpdateGameSettings
     * @summary Update Game Settings
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/game_settings/{settings_id}
     * @secure
     */
    updateGameSettings: (
      settingsId: string,
      companyId: string,
      gameId: string,
      data: GameSettingsUpdate,
      params: RequestParams = {},
    ) =>
      this.request<GameSettingsRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/game_settings/${settingsId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Game settings
     * @name DeleteGameSettings
     * @summary Delete Game Settings
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/game_settings/{settings_id}
     * @secure
     */
    deleteGameSettings: (settingsId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/game_settings/${settingsId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Game settings
     * @name UpdateGameSettingsFeatureFlags
     * @summary Update Game Settings Feature Flags
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/game_settings/{settings_id}/feature_flags
     * @secure
     */
    updateGameSettingsFeatureFlags: (
      settingsId: string,
      companyId: string,
      gameId: string,
      data: GameSettingsUpdateFeatures,
      params: RequestParams = {},
    ) =>
      this.request<GameSettingsRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/game_settings/${settingsId}/feature_flags`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creators
     * @name GetCreatorPlatforms
     * @summary Get Creator Platforms
     * @request GET:/v1/companies/{company_id}/games/{game_id}/creators/platforms
     * @secure
     */
    getCreatorPlatforms: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<CreatorNamedSocialPlatform[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/creators/platforms`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creators
     * @name DefineCreatorPlatform
     * @summary Define Creator Platform
     * @request GET:/v1/companies/{company_id}/games/{game_id}/creators/platforms/define
     * @secure
     */
    defineCreatorPlatform: ({ companyId, gameId, ...query }: DefineCreatorPlatformParams, params: RequestParams = {}) =>
      this.request<CreatorNamedSocialPlatform, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/creators/platforms/define`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creators
     * @name GetCreators
     * @summary Get Creators
     * @request GET:/v1/companies/{company_id}/games/{game_id}/creators
     * @secure
     */
    getCreators: ({ companyId, gameId, ...query }: GetCreatorsParams, params: RequestParams = {}) =>
      this.request<PaginatedResponseListAghanimCreatorSchemasCreatorRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/creators`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creators
     * @name CreateCreator
     * @summary Create Creator
     * @request POST:/v1/companies/{company_id}/games/{game_id}/creators
     * @secure
     */
    createCreator: (companyId: string, gameId: string, data: CreatorCreate, params: RequestParams = {}) =>
      this.request<CreatorRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/creators`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creators
     * @name GetCreator
     * @summary Get Creator
     * @request GET:/v1/companies/{company_id}/games/{game_id}/creators/{creator_id}
     * @secure
     */
    getCreator: (companyId: string, gameId: string, creatorId: string, params: RequestParams = {}) =>
      this.request<CreatorRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/creators/${creatorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creators
     * @name UpdateCreator
     * @summary Update Creator
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/creators/{creator_id}
     * @secure
     */
    updateCreator: (
      companyId: string,
      gameId: string,
      creatorId: string,
      data: CreatorUpdate,
      params: RequestParams = {},
    ) =>
      this.request<CreatorRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/creators/${creatorId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creators
     * @name DeleteCreator
     * @summary Delete Creator
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/creators/{creator_id}
     * @secure
     */
    deleteCreator: (companyId: string, gameId: string, creatorId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/creators/${creatorId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Price Templates, Private
     * @name GetDefaultTemplatePrices
     * @summary Get Default Template Prices
     * @request GET:/v1/companies/{company_id}/games/{game_id}/price_templates/prices
     * @secure
     */
    getDefaultTemplatePrices: (
      { companyId, gameId, ...query }: GetDefaultTemplatePricesParams,
      params: RequestParams = {},
    ) =>
      this.request<TemplatePrice[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/price_templates/prices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of price templates.
     *
     * @tags Price Templates
     * @name GetPriceTemplates
     * @summary Get Price Templates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/price_templates
     * @secure
     */
    getPriceTemplates: ({ companyId, gameId, ...query }: GetPriceTemplatesParams, params: RequestParams = {}) =>
      this.request<InfinitePaginatedResponsePriceTemplateShort, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/price_templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new price template.
     *
     * @tags Price Templates
     * @name CreatePriceTemplate
     * @summary Create Price Template
     * @request POST:/v1/companies/{company_id}/games/{game_id}/price_templates
     * @secure
     */
    createPriceTemplate: (companyId: string, gameId: string, data: PriceTemplateCreate, params: RequestParams = {}) =>
      this.request<PriceTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/price_templates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single price template.
     *
     * @tags Price Templates
     * @name GetPriceTemplate
     * @summary Get Price Template
     * @request GET:/v1/companies/{company_id}/games/{game_id}/price_templates/{price_template_id}
     * @secure
     */
    getPriceTemplate: (companyId: string, gameId: string, priceTemplateId: string, params: RequestParams = {}) =>
      this.request<PriceTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/price_templates/${priceTemplateId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a price template.
     *
     * @tags Price Templates
     * @name UpdatePriceTemplate
     * @summary Update Price Template
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/price_templates/{price_template_id}
     * @secure
     */
    updatePriceTemplate: (
      companyId: string,
      gameId: string,
      priceTemplateId: string,
      data: PriceTemplateUpdate,
      params: RequestParams = {},
    ) =>
      this.request<PriceTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/price_templates/${priceTemplateId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a price template.
     *
     * @tags Price Templates
     * @name DeletePriceTemplate
     * @summary Delete Price Template
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/price_templates/{price_template_id}
     * @secure
     */
    deletePriceTemplate: (companyId: string, gameId: string, priceTemplateId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/price_templates/${priceTemplateId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUser
     * @summary Get User
     * @request GET:/v1/companies/{company_id}/games/{game_id}/user/{user_id}
     * @secure
     */
    getUser: (companyId: string, gameId: string, userId: string, params: RequestParams = {}) =>
      this.request<UserRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UpdateUser
     * @summary Update User
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/user/{user_id}
     * @secure
     */
    updateUser: (companyId: string, gameId: string, userId: string, data: UserUpdate, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user/${userId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetFullUser
     * @summary Get Full User
     * @request GET:/v1/companies/{company_id}/games/{game_id}/user/{user_id}/full
     * @secure
     */
    getFullUser: (companyId: string, gameId: string, userId: string, params: RequestParams = {}) =>
      this.request<User, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user/${userId}/full`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsers
     * @summary Get Users
     * @request GET:/v1/companies/{company_id}/games/{game_id}/user
     * @secure
     */
    getUsers: ({ companyId, gameId, ...query }: GetUsersParams, params: RequestParams = {}) =>
      this.request<UserRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Prices
     * @name SearchPrices
     * @summary Search Prices
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_prices
     * @secure
     */
    searchPrices: ({ companyId, gameId, ...query }: SearchPricesParams, params: RequestParams = {}) =>
      this.request<ItemPrice[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_prices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Prices
     * @name GetPrices
     * @summary Get Prices
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_prices/{item_id}
     * @secure
     */
    getPrices: (itemId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<PriceItemRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_prices/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Prices
     * @name CreateOrUpdatePrices
     * @summary Create Or Update Prices
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/item_prices/{item_id}
     * @secure
     */
    createOrUpdatePrices: (
      { itemId, companyId, gameId, ...query }: CreateOrUpdatePricesParams,
      data: Price[],
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_prices/${itemId}`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Loyalty Program
     * @name GetLoyaltySettings
     * @summary Get Loyalty Settings
     * @request GET:/v1/companies/{company_id}/games/{game_id}/loyalty
     * @secure
     */
    getLoyaltySettings: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<LoyaltySettings, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/loyalty`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Loyalty Program
     * @name UpdateLoyaltySettings
     * @summary Update Loyalty Settings
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/loyalty/{loyalty_settings_id}
     * @secure
     */
    updateLoyaltySettings: (
      companyId: string,
      gameId: string,
      loyaltySettingsId: string,
      data: LoyaltySettingsUpdate,
      params: RequestParams = {},
    ) =>
      this.request<LoyaltySettings, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/loyalty/${loyaltySettingsId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Loyalty Program
     * @name GetLoyaltyTiers
     * @summary Get Loyalty Tiers
     * @request GET:/v1/companies/{company_id}/games/{game_id}/loyalty/{loyalty_settings_id}/tiers
     * @secure
     */
    getLoyaltyTiers: (companyId: string, gameId: string, loyaltySettingsId: string, params: RequestParams = {}) =>
      this.request<LoyaltyTier[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/loyalty/${loyaltySettingsId}/tiers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Loyalty Program
     * @name UpdateLoyaltyTiers
     * @summary Update Loyalty Tiers
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/loyalty/{loyalty_settings_id}/tiers
     * @secure
     */
    updateLoyaltyTiers: (
      companyId: string,
      gameId: string,
      loyaltySettingsId: string,
      data: LoyaltyTierCreateUpdate[],
      params: RequestParams = {},
    ) =>
      this.request<LoyaltyTier[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/loyalty/${loyaltySettingsId}/tiers`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name GetSegment
     * @summary Get Segment
     * @request GET:/v1/companies/{company_id}/games/{game_id}/segments/{segment_id}
     * @secure
     */
    getSegment: (companyId: string, gameId: string, segmentId: string, params: RequestParams = {}) =>
      this.request<SegmentRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segments/${segmentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name UpdateSegment
     * @summary Update Segment
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/segments/{segment_id}
     * @secure
     */
    updateSegment: (
      companyId: string,
      gameId: string,
      segmentId: string,
      data: SegmentUpdate,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segments/${segmentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name DeleteSegment
     * @summary Delete Segment
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/segments/{segment_id}
     * @secure
     */
    deleteSegment: (companyId: string, gameId: string, segmentId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segments/${segmentId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name GetSegments
     * @summary Get Segments
     * @request GET:/v1/companies/{company_id}/games/{game_id}/segments
     * @secure
     */
    getSegments: ({ companyId, gameId, ...query }: GetSegmentsParams, params: RequestParams = {}) =>
      this.request<SegmentRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name CreateSegment
     * @summary Create Segment
     * @request POST:/v1/companies/{company_id}/games/{game_id}/segments
     * @secure
     */
    createSegment: (companyId: string, gameId: string, data: SegmentCreate, params: RequestParams = {}) =>
      this.request<SegmentRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Segments
     * @name GetUserSegments
     * @summary Get User Segments
     * @request GET:/v1/companies/{company_id}/games/{game_id}/user_segments/{user_id}
     * @secure
     */
    getUserSegments: (companyId: string, gameId: string, userId: string, params: RequestParams = {}) =>
      this.request<UserSegmentRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user_segments/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Segments
     * @name UpdateUserSegments
     * @summary Update User Segments
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/user_segments/{user_id}
     * @secure
     */
    updateUserSegments: (
      companyId: string,
      gameId: string,
      userId: string,
      data: UserSegmentUpdate,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user_segments/${userId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name GetSegmentGroup
     * @summary Get Segment Group
     * @request GET:/v1/companies/{company_id}/games/{game_id}/segment_groups/{segment_group_id}
     * @secure
     */
    getSegmentGroup: (companyId: string, gameId: string, segmentGroupId: string, params: RequestParams = {}) =>
      this.request<SegmentGroupRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segment_groups/${segmentGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name UpdateSegmentGroup
     * @summary Update Segment Group
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/segment_groups/{segment_group_id}
     * @secure
     */
    updateSegmentGroup: (
      companyId: string,
      gameId: string,
      segmentGroupId: string,
      data: SegmentGroupUpdate,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segment_groups/${segmentGroupId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name DeleteSegmentGroup
     * @summary Delete Segment Group
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/segment_groups/{segment_group_id}
     * @secure
     */
    deleteSegmentGroup: (companyId: string, gameId: string, segmentGroupId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segment_groups/${segmentGroupId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name GetSegmentGroupGraph
     * @summary Get Segment Group Graph
     * @request GET:/v1/companies/{company_id}/games/{game_id}/segment_groups/{segment_group_id}/graph
     * @secure
     */
    getSegmentGroupGraph: (companyId: string, gameId: string, segmentGroupId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segment_groups/${segmentGroupId}/graph`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name GetSegmentGroups
     * @summary Get Segment Groups
     * @request GET:/v1/companies/{company_id}/games/{game_id}/segment_groups
     * @secure
     */
    getSegmentGroups: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<SegmentGroupReadStat[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segment_groups`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name CreateSegmentGroup
     * @summary Create Segment Group
     * @request POST:/v1/companies/{company_id}/games/{game_id}/segment_groups
     * @secure
     */
    createSegmentGroup: (companyId: string, gameId: string, data: SegmentGroupCreate, params: RequestParams = {}) =>
      this.request<SegmentGroupRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/segment_groups`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons
     * @name GetUserCoupons
     * @summary Get User Coupons
     * @request GET:/v1/companies/{company_id}/games/{game_id}/coupons/user/{user_id}
     * @secure
     */
    getUserCoupons: ({ userId, companyId, gameId, ...query }: GetUserCouponsParams, params: RequestParams = {}) =>
      this.request<UserCouponRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons/user/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons, Private
     * @name GetTotalCouponStat
     * @summary Get Total Coupon Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/coupons/total_stat
     * @secure
     */
    getTotalCouponStat: ({ companyId, gameId, ...query }: GetTotalCouponStatParams, params: RequestParams = {}) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons/total_stat`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of coupons.
     *
     * @tags Coupons
     * @name GetCoupons
     * @summary Get Coupons
     * @request GET:/v1/companies/{company_id}/games/{game_id}/coupons
     * @secure
     */
    getCoupons: ({ companyId, gameId, ...query }: GetCouponsParams, params: RequestParams = {}) =>
      this.request<CouponRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new coupon.
     *
     * @tags Coupons
     * @name CreateCoupon
     * @summary Create Coupon
     * @request POST:/v1/companies/{company_id}/games/{game_id}/coupons
     * @secure
     */
    createCoupon: (companyId: string, gameId: string, data: CouponCreate, params: RequestParams = {}) =>
      this.request<CouponRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single coupon.
     *
     * @tags Coupons
     * @name GetCoupon
     * @summary Get Coupon
     * @request GET:/v1/companies/{company_id}/games/{game_id}/coupons/{coupon_id}
     * @secure
     */
    getCoupon: (companyId: string, gameId: string, couponId: string, params: RequestParams = {}) =>
      this.request<CouponRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons/${couponId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a coupon.
     *
     * @tags Coupons
     * @name UpdateCoupon
     * @summary Update Coupon
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/coupons/{coupon_id}
     * @secure
     */
    updateCoupon: (
      companyId: string,
      gameId: string,
      couponId: string,
      data: CouponUpdate,
      params: RequestParams = {},
    ) =>
      this.request<CouponRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons/${couponId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a coupon.
     *
     * @tags Coupons
     * @name DeleteCoupon
     * @summary Delete Coupon
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/coupons/{coupon_id}
     * @secure
     */
    deleteCoupon: (companyId: string, gameId: string, couponId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons/${couponId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons, Private
     * @name GetCouponStat
     * @summary Get Coupon Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/coupons/{coupon_id}/stat
     * @secure
     */
    getCouponStat: ({ companyId, gameId, couponId, ...query }: GetCouponStatParams, params: RequestParams = {}) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/coupons/${couponId}/stat`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Email Templates
     * @name GetEmailTemplates
     * @summary Get Email Templates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/email_templates
     * @secure
     */
    getEmailTemplates: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<EmailTemplate[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/email_templates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Check if webhook is working by sending a test payload.
     *
     * @tags Webhooks
     * @name CheckWebhook
     * @summary Check Webhook
     * @request POST:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}/check
     * @secure
     */
    checkWebhook: (
      companyId: string,
      gameId: string,
      webhookId: string,
      data: CheckWebhookRequest,
      params: RequestParams = {},
    ) =>
      this.request<CheckWebhookResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}/check`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhooks
     * @name CheckWebhookItem
     * @summary Check Webhook Item
     * @request POST:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}/check_item
     * @secure
     */
    checkWebhookItem: (
      companyId: string,
      gameId: string,
      webhookId: string,
      data: CheckWebhookItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<CheckWebhookResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}/check_item`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhooks
     * @name CheckWebhookPlayerVerify
     * @summary Check Webhook Player Verify
     * @request POST:/v1/companies/{company_id}/games/{game_id}/webhooks/{webhook_id}/check_player_verify
     * @secure
     */
    checkWebhookPlayerVerify: (
      companyId: string,
      gameId: string,
      webhookId: string,
      data: CheckWebhookPlayerVerifyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CheckWebhookResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhooks/${webhookId}/check_player_verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of translations.
     *
     * @tags Translations, Hidden
     * @name GetTranslations
     * @summary Get Translations
     * @request GET:/v1/companies/{company_id}/games/{game_id}/translations
     * @secure
     */
    getTranslations: ({ companyId, gameId, ...query }: GetTranslationsParams, params: RequestParams = {}) =>
      this.request<InfinitePaginatedResponseTranslationHtmlStrippedRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new translation.
     *
     * @tags Translations, Hidden
     * @name CreateTranslation
     * @summary Create Translation
     * @request POST:/v1/companies/{company_id}/games/{game_id}/translations
     * @secure
     */
    createTranslation: (companyId: string, gameId: string, data: TranslationCreate, params: RequestParams = {}) =>
      this.request<TranslationRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single translation.
     *
     * @tags Translations, Hidden
     * @name GetTranslation
     * @summary Get Translation
     * @request GET:/v1/companies/{company_id}/games/{game_id}/translations/{translation_id}
     * @secure
     */
    getTranslation: (companyId: string, gameId: string, translationId: string, params: RequestParams = {}) =>
      this.request<TranslationRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translations/${translationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a translation.
     *
     * @tags Translations, Hidden
     * @name UpdateTranslation
     * @summary Update Translation
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/translations/{translation_id}
     * @secure
     */
    updateTranslation: (
      companyId: string,
      gameId: string,
      translationId: string,
      data: TranslationUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TranslationRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translations/${translationId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of locales.
     *
     * @tags Locales
     * @name GetLocales
     * @summary Get Locales
     * @request GET:/v1/companies/{company_id}/games/{game_id}/locales
     * @secure
     */
    getLocales: ({ companyId, gameId, ...query }: GetLocalesParams, params: RequestParams = {}) =>
      this.request<LocaleRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/locales`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new locale.
     *
     * @tags Locales
     * @name CreateLocale
     * @summary Create Locale
     * @request POST:/v1/companies/{company_id}/games/{game_id}/locales
     * @secure
     */
    createLocale: (companyId: string, gameId: string, data: LocaleCreate, params: RequestParams = {}) =>
      this.request<LocaleRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/locales`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single locale.
     *
     * @tags Locales
     * @name GetLocale
     * @summary Get Locale
     * @request GET:/v1/companies/{company_id}/games/{game_id}/locales/{locale_id}
     * @secure
     */
    getLocale: (companyId: string, gameId: string, localeId: string, params: RequestParams = {}) =>
      this.request<LocaleRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/locales/${localeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a locale.
     *
     * @tags Locales
     * @name UpdateLocale
     * @summary Update Locale
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/locales/{locale_id}
     * @secure
     */
    updateLocale: (
      companyId: string,
      gameId: string,
      localeId: string,
      data: LocaleUpdate,
      params: RequestParams = {},
    ) =>
      this.request<LocaleRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/locales/${localeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a locale.
     *
     * @tags Locales
     * @name DeleteLocale
     * @summary Delete Locale
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/locales/{locale_id}
     * @secure
     */
    deleteLocale: (companyId: string, gameId: string, localeId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/locales/${localeId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Campaigns
     * @name GetCampaignUsers
     * @summary Get Campaign Users
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns_user/{campaign_id}/users
     * @secure
     */
    getCampaignUsers: (
      { companyId, gameId, campaignId, ...query }: GetCampaignUsersParams,
      params: RequestParams = {},
    ) =>
      this.request<CampaignUserHistoryItem[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns_user/${campaignId}/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Campaigns
     * @name GetUserGraph
     * @summary Get User Graph
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaigns_user/{campaign_id}/{user_campaign_id}
     * @secure
     */
    getUserGraph: (
      userCampaignId: string,
      companyId: string,
      gameId: string,
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<GraphRoot, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaigns_user/${campaignId}/${userCampaignId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Onboarding Progress
     * @name GetOnboardingProgress
     * @summary Get Onboarding Progress
     * @request GET:/v1/companies/{company_id}/games/{game_id}/onboarding_progress
     * @secure
     */
    getOnboardingProgress: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<GenerationProgressState, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/onboarding_progress`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetStoreByStoreItem
     * @summary Get Store By Store Item
     * @request GET:/v1/companies/{company_id}/games/{game_id}/stores/store/{store_item_id}
     * @secure
     */
    getStoreByStoreItem: (storeItemId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<StoreRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores/store/${storeItemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores, Private
     * @name GetStoreLimitedStat
     * @summary Get Store Limited Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/stores/{store_id}/stat
     * @secure
     */
    getStoreLimitedStat: (companyId: string, gameId: string, storeId: string, params: RequestParams = {}) =>
      this.request<StoreLimitedStockStat, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores/${storeId}/stat`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetStores
     * @summary Get Stores
     * @request GET:/v1/companies/{company_id}/games/{game_id}/stores
     * @secure
     */
    getStores: ({ companyId, gameId, ...query }: GetStoresParams, params: RequestParams = {}) =>
      this.request<StoreReadStat[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name CreateStore
     * @summary Create Store
     * @request POST:/v1/companies/{company_id}/games/{game_id}/stores
     * @secure
     */
    createStore: (companyId: string, gameId: string, data: StoreCreate, params: RequestParams = {}) =>
      this.request<StoreRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes multiple stores.
     *
     * @tags Stores
     * @name BulkDeleteStores
     * @summary Bulk Delete Stores
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/stores
     * @secure
     */
    bulkDeleteStores: (companyId: string, gameId: string, data: StoreBulkDelete[], params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetStore
     * @summary Get Store
     * @request GET:/v1/companies/{company_id}/games/{game_id}/stores/{store_id}
     * @secure
     */
    getStore: (companyId: string, gameId: string, storeId: string, params: RequestParams = {}) =>
      this.request<StoreRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores/${storeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name UpdateStore
     * @summary Update Store
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/stores/{store_id}
     * @secure
     */
    updateStore: (companyId: string, gameId: string, storeId: string, data: StoreUpdate, params: RequestParams = {}) =>
      this.request<StoreRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores/${storeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name DeleteStore
     * @summary Delete Store
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/stores/{store_id}
     * @secure
     */
    deleteStore: (companyId: string, gameId: string, storeId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/stores/${storeId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetUserStoreItems
     * @summary Get User Store Items
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_items/user/{user_id}
     * @secure
     */
    getUserStoreItems: (userId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<StoreItemRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/user/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetCampaignStoreItems
     * @summary Get Campaign Store Items
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_items/campaign/{campaign_id}
     * @secure
     */
    getCampaignStoreItems: (
      { campaignId, companyId, gameId, ...query }: GetCampaignStoreItemsParams,
      params: RequestParams = {},
    ) =>
      this.request<VirtualStoreItemUser[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/campaign/${campaignId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetVirtualSkuStat
     * @summary Get Virtual Sku Stat
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_items/report
     * @secure
     */
    getVirtualSkuStat: ({ companyId, gameId, ...query }: GetVirtualSkuStatParams, params: RequestParams = {}) =>
      this.request<VirtualSkuStat, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/report`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetStoreItems
     * @summary Get Store Items
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_items/{store_id}
     * @secure
     */
    getStoreItems: (companyId: string, gameId: string, storeId: string, params: RequestParams = {}) =>
      this.request<StoreItemRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/${storeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name CreateStoreItem
     * @summary Create Store Item
     * @request POST:/v1/companies/{company_id}/games/{game_id}/store_items/{store_id}
     * @secure
     */
    createStoreItem: (
      companyId: string,
      gameId: string,
      storeId: string,
      data: StoreItemCreate,
      params: RequestParams = {},
    ) =>
      this.request<StoreItemRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/${storeId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes multiple store items.
     *
     * @tags Stores
     * @name BulkDeleteStoreItems
     * @summary Bulk Delete Store Items
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/store_items/{store_id}
     * @secure
     */
    bulkDeleteStoreItems: (
      companyId: string,
      gameId: string,
      storeId: string,
      data: StoreItemBulkDelete[],
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/${storeId}`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple store items.
     *
     * @tags Stores
     * @name BulkUpdateStoreItems
     * @summary Bulk Update Store Items
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/store_items/{store_id}
     * @secure
     */
    bulkUpdateStoreItems: (
      companyId: string,
      gameId: string,
      storeId: string,
      data: StoreItemBulkUpdate[],
      params: RequestParams = {},
    ) =>
      this.request<StoreItemRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/${storeId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name GetStoreItemsByIds
     * @summary Get Store Items By Ids
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_items
     * @secure
     */
    getStoreItemsByIds: ({ companyId, gameId, ...query }: GetStoreItemsByIdsParams, params: RequestParams = {}) =>
      this.request<StoreItemRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name BatchCreateStoreItem
     * @summary Batch Create Store Item
     * @request POST:/v1/companies/{company_id}/games/{game_id}/store_items/{store_id}/batch
     * @secure
     */
    batchCreateStoreItem: (
      companyId: string,
      gameId: string,
      storeId: string,
      data: ItemsCreate,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/${storeId}/batch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name UpdateStoreItem
     * @summary Update Store Item
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/store_items/{store_id}/{store_item_id}
     * @secure
     */
    updateStoreItem: (
      storeItemId: string,
      companyId: string,
      gameId: string,
      storeId: string,
      data: StoreItemUpdate,
      params: RequestParams = {},
    ) =>
      this.request<StoreItemRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/${storeId}/${storeItemId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name DeleteStoreItem
     * @summary Delete Store Item
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/store_items/{store_id}/{store_item_id}
     * @secure
     */
    deleteStoreItem: (
      storeItemId: string,
      companyId: string,
      gameId: string,
      storeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/${storeId}/${storeItemId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stores
     * @name DeleteVirtualStoreItem
     * @summary Delete Virtual Store Item
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/store_items/virtual/{store_item_id}
     * @secure
     */
    deleteVirtualStoreItem: (storeItemId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_items/virtual/${storeItemId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckoutLinks
     * @name GetCheckoutLinks
     * @summary Get Checkout Links
     * @request GET:/v1/companies/{company_id}/games/{game_id}/checkout_links
     * @secure
     */
    getCheckoutLinks: ({ companyId, gameId, ...query }: GetCheckoutLinksParams, params: RequestParams = {}) =>
      this.request<CheckoutLinkRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/checkout_links`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckoutLinks
     * @name CreateCheckoutLink
     * @summary Create Checkout Link
     * @request POST:/v1/companies/{company_id}/games/{game_id}/checkout_links
     * @secure
     */
    createCheckoutLink: (companyId: string, gameId: string, data: CheckoutLinkCreate, params: RequestParams = {}) =>
      this.request<CheckoutLinkRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/checkout_links`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckoutLinks
     * @name BulkUpdateCheckoutLinks
     * @summary Bulk Update Checkout Links
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/checkout_links
     * @secure
     */
    bulkUpdateCheckoutLinks: (
      companyId: string,
      gameId: string,
      data: CheckoutLinkBulkUpdate[],
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/checkout_links`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckoutLinks, Private
     * @name GetCountCheckoutLink
     * @summary Get Count Checkout Link
     * @request GET:/v1/companies/{company_id}/games/{game_id}/checkout_links/count
     * @secure
     */
    getCountCheckoutLink: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<ResourceCount, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/checkout_links/count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckoutLinks
     * @name GetCheckoutLink
     * @summary Get Checkout Link
     * @request GET:/v1/companies/{company_id}/games/{game_id}/checkout_links/{checkout_link_id}
     * @secure
     */
    getCheckoutLink: (companyId: string, gameId: string, checkoutLinkId: string, params: RequestParams = {}) =>
      this.request<CheckoutLinkRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/checkout_links/${checkoutLinkId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckoutLinks
     * @name UpdateCheckoutLink
     * @summary Update Checkout Link
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/checkout_links/{checkout_link_id}
     * @secure
     */
    updateCheckoutLink: (
      companyId: string,
      gameId: string,
      checkoutLinkId: string,
      data: CheckoutLinkUpdate,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutLinkRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/checkout_links/${checkoutLinkId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CheckoutLinks
     * @name DeleteCheckoutLink
     * @summary Delete Checkout Link
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/checkout_links/{checkout_link_id}
     * @secure
     */
    deleteCheckoutLink: (companyId: string, gameId: string, checkoutLinkId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/checkout_links/${checkoutLinkId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Graphs
     * @name GetStoreGraph
     * @summary Get Store Graph
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_graphs/graph
     * @secure
     */
    getStoreGraph: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_graphs/graph`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Graphs
     * @name GetBaseStoreGraph
     * @summary Get Base Store Graph
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_graphs
     * @secure
     */
    getBaseStoreGraph: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<StoreGraphResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_graphs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Graphs
     * @name CreateOrUpdateStoreGraph
     * @summary Create Or Update Store Graph
     * @request POST:/v1/companies/{company_id}/games/{game_id}/store_graphs
     * @secure
     */
    createOrUpdateStoreGraph: (companyId: string, gameId: string, data: StoreGraphUpdate, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_graphs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Graphs
     * @name PreviewStore
     * @summary Preview Store
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_graphs/preview/{user_id}
     * @secure
     */
    previewStore: (companyId: string, gameId: string, userId: string, params: RequestParams = {}) =>
      this.request<StoreItemRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_graphs/preview/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Categories
     * @name GetItemCategory
     * @summary Get Item Category
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_categories/{item_category_id}
     * @secure
     */
    getItemCategory: (companyId: string, gameId: string, itemCategoryId: string, params: RequestParams = {}) =>
      this.request<ItemCategoryRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_categories/${itemCategoryId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Categories
     * @name UpdateItemCategory
     * @summary Update Item Category
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/item_categories/{item_category_id}
     * @secure
     */
    updateItemCategory: (
      companyId: string,
      gameId: string,
      itemCategoryId: string,
      data: ItemCategoryUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ItemCategoryRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_categories/${itemCategoryId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Categories
     * @name DeleteItemCategory
     * @summary Delete Item Category
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/item_categories/{item_category_id}
     * @secure
     */
    deleteItemCategory: (companyId: string, gameId: string, itemCategoryId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_categories/${itemCategoryId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Categories
     * @name GetItemCategories
     * @summary Get Item Categories
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_categories
     * @secure
     */
    getItemCategories: ({ companyId, gameId, ...query }: GetItemCategoriesParams, params: RequestParams = {}) =>
      this.request<ItemCategoryRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Categories
     * @name CreateItemCategory
     * @summary Create Item Category
     * @request POST:/v1/companies/{company_id}/games/{game_id}/item_categories
     * @secure
     */
    createItemCategory: (companyId: string, gameId: string, data: ItemCategoryCreate, params: RequestParams = {}) =>
      this.request<ItemCategoryRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_categories`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes multiple item_categories.
     *
     * @tags Item Categories
     * @name BulkDeleteItemCategories
     * @summary Bulk Delete Item Categories
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/item_categories
     * @secure
     */
    bulkDeleteItemCategories: (
      companyId: string,
      gameId: string,
      data: ItemCategoryBulkDelete[],
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_categories`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple categories.
     *
     * @tags Item Categories
     * @name BulkUpdateItemCategories
     * @summary Bulk Update Item Categories
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/item_categories
     * @secure
     */
    bulkUpdateItemCategories: (
      companyId: string,
      gameId: string,
      data: ItemCategoryBulkUpdate[],
      params: RequestParams = {},
    ) =>
      this.request<ItemCategoryRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_categories`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook Logs
     * @name GetWebhookLogByOrder
     * @summary Get Webhook Log By Order
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhook_logs/order_log/{order_id}
     * @secure
     */
    getWebhookLogByOrder: (companyId: string, gameId: string, orderId: string, params: RequestParams = {}) =>
      this.request<WebhookLog[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhook_logs/order_log/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook Logs
     * @name GetWebhookLogByUser
     * @summary Get Webhook Log By User
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhook_logs/user_log/{user_id}
     * @secure
     */
    getWebhookLogByUser: (
      { companyId, gameId, userId, ...query }: GetWebhookLogByUserParams,
      params: RequestParams = {},
    ) =>
      this.request<WebhookLog[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhook_logs/user_log/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook Logs
     * @name GetAggregateWebhookLog
     * @summary Get Aggregate Webhook Log
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhook_logs/{webhook_id}/aggregates
     * @secure
     */
    getAggregateWebhookLog: (
      { companyId, gameId, webhookId, ...query }: GetAggregateWebhookLogParams,
      params: RequestParams = {},
    ) =>
      this.request<PointValue[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhook_logs/${webhookId}/aggregates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook Logs
     * @name GetWebhookTotalData
     * @summary Get Webhook Total Data
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhook_logs/{webhook_id}/total
     * @secure
     */
    getWebhookTotalData: (
      { companyId, gameId, webhookId, ...query }: GetWebhookTotalDataParams,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, MeasureValue>, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhook_logs/${webhookId}/total`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook Logs
     * @name GetWebhookLogs
     * @summary Get Webhook Logs
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhook_logs/all/{webhook_id}
     * @secure
     */
    getWebhookLogs: ({ companyId, gameId, webhookId, ...query }: GetWebhookLogsParams, params: RequestParams = {}) =>
      this.request<WebhookLog[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhook_logs/all/${webhookId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook Logs
     * @name GetWebhookLogById
     * @summary Get Webhook Log By Id
     * @request GET:/v1/companies/{company_id}/games/{game_id}/webhook_logs/{webhook_log_id}
     * @secure
     */
    getWebhookLogById: (webhookLogId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<WebhookLog, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhook_logs/${webhookLogId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook Logs
     * @name ResendWebhook
     * @summary Resend Webhook
     * @request POST:/v1/companies/{company_id}/games/{game_id}/webhook_logs/{webhook_id}/resend/{webhook_log_id}
     * @secure
     */
    resendWebhook: (
      webhookLogId: string,
      companyId: string,
      gameId: string,
      webhookId: string,
      params: RequestParams = {},
    ) =>
      this.request<ResendResult, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/webhook_logs/${webhookId}/resend/${webhookLogId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of properties.
     *
     * @tags Item Properties
     * @name GetItemProperties
     * @summary Get Item Properties
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_properties
     * @secure
     */
    getItemProperties: ({ companyId, gameId, ...query }: GetItemPropertiesParams, params: RequestParams = {}) =>
      this.request<ItemPropertyRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new property.
     *
     * @tags Item Properties
     * @name CreateItemProperty
     * @summary Create Item Property
     * @request POST:/v1/companies/{company_id}/games/{game_id}/item_properties
     * @secure
     */
    createItemProperty: (companyId: string, gameId: string, data: ItemPropertyCreate, params: RequestParams = {}) =>
      this.request<ItemPropertyRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single property.
     *
     * @tags Item Properties
     * @name GetItemProperty
     * @summary Get Item Property
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_properties/{property_id}
     * @secure
     */
    getItemProperty: (companyId: string, gameId: string, propertyId: string, params: RequestParams = {}) =>
      this.request<ItemPropertyRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties/${propertyId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a property.
     *
     * @tags Item Properties
     * @name UpdateItemProperty
     * @summary Update Item Property
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/item_properties/{property_id}
     * @secure
     */
    updateItemProperty: (
      companyId: string,
      gameId: string,
      propertyId: string,
      data: ItemPropertyUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ItemPropertyRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties/${propertyId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a property.
     *
     * @tags Item Properties
     * @name DeleteItemProperty
     * @summary Delete Item Property
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/item_properties/{property_id}
     * @secure
     */
    deleteItemProperty: (companyId: string, gameId: string, propertyId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties/${propertyId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a list of properties for an item.
     *
     * @tags Item Properties Relations
     * @name GetItemPropertiesRelations
     * @summary Get Item Properties Relations
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_properties_relations/{item_id}
     * @secure
     */
    getItemPropertiesRelations: (
      { companyId, gameId, itemId, ...query }: GetItemPropertiesRelationsParams,
      params: RequestParams = {},
    ) =>
      this.request<ItemPropertyRelationRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties_relations/${itemId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new property for an item.
     *
     * @tags Item Properties Relations
     * @name CreateItemPropertyRelation
     * @summary Create Item Property Relation
     * @request POST:/v1/companies/{company_id}/games/{game_id}/item_properties_relations/{item_id}
     * @secure
     */
    createItemPropertyRelation: (
      companyId: string,
      gameId: string,
      itemId: string,
      data: ItemPropertyRelationCreate,
      params: RequestParams = {},
    ) =>
      this.request<ItemPropertyRelationRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties_relations/${itemId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates an existing property for an item.
     *
     * @tags Item Properties Relations
     * @name UpdateItemPropertyRelation
     * @summary Update Item Property Relation
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/item_properties_relations/{item_id}/{item_propery_relation_id}
     * @secure
     */
    updateItemPropertyRelation: (
      companyId: string,
      gameId: string,
      itemId: string,
      itemProperyRelationId: string,
      data: ItemPropertyRelationUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ItemPropertyRelationRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties_relations/${itemId}/${itemProperyRelationId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes an existing property for an item.
     *
     * @tags Item Properties Relations
     * @name DeleteItemPropertyRelation
     * @summary Delete Item Property Relation
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/item_properties_relations/{item_id}/{item_propery_relation_id}
     * @secure
     */
    deleteItemPropertyRelation: (
      companyId: string,
      gameId: string,
      itemId: string,
      itemProperyRelationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_properties_relations/${itemId}/${itemProperyRelationId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign Templates
     * @name GetCampaignTemplates
     * @summary Get Campaign Templates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/campaign_templates
     * @secure
     */
    getCampaignTemplates: ({ companyId, gameId, ...query }: GetCampaignTemplatesParams, params: RequestParams = {}) =>
      this.request<CampaignTemplateRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaign_templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign Templates
     * @name CreateOrUpdateCampaignTemplate
     * @summary Create Or Update Campaign Template
     * @request POST:/v1/companies/{company_id}/games/{game_id}/campaign_templates
     * @secure
     */
    createOrUpdateCampaignTemplate: (
      companyId: string,
      gameId: string,
      data: CampaignTemplateCreate,
      params: RequestParams = {},
    ) =>
      this.request<CampaignTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaign_templates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaign Templates
     * @name DeleteCampaignTemplate
     * @summary Delete Campaign Template
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/campaign_templates/{campaign_template_id}
     * @secure
     */
    deleteCampaignTemplate: (
      companyId: string,
      gameId: string,
      campaignTemplateId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/campaign_templates/${campaignTemplateId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Claimed
     * @name GetClaimedItems
     * @summary Get Claimed Items
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_claimed/user/{user_id}
     * @secure
     */
    getClaimedItems: ({ userId, companyId, gameId, ...query }: GetClaimedItemsParams, params: RequestParams = {}) =>
      this.request<UserItemClaimed[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_claimed/user/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Rewards
     * @name GetDailyRewards
     * @summary Get Daily Rewards
     * @request GET:/v1/companies/{company_id}/games/{game_id}/daily_rewards
     * @secure
     */
    getDailyRewards: ({ companyId, gameId, ...query }: GetDailyRewardsParams, params: RequestParams = {}) =>
      this.request<DailyRewardRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/daily_rewards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Rewards
     * @name CreateDailyReward
     * @summary Create Daily Reward
     * @request POST:/v1/companies/{company_id}/games/{game_id}/daily_rewards
     * @secure
     */
    createDailyReward: (companyId: string, gameId: string, data: DailyRewardCreate, params: RequestParams = {}) =>
      this.request<DailyRewardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/daily_rewards`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Rewards
     * @name GetDailyReward
     * @summary Get Daily Reward
     * @request GET:/v1/companies/{company_id}/games/{game_id}/daily_rewards/{daily_reward_id}
     * @secure
     */
    getDailyReward: (companyId: string, gameId: string, dailyRewardId: string, params: RequestParams = {}) =>
      this.request<DailyRewardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/daily_rewards/${dailyRewardId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Rewards
     * @name UpdateDailyReward
     * @summary Update Daily Reward
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/daily_rewards/{daily_reward_id}
     * @secure
     */
    updateDailyReward: (
      companyId: string,
      gameId: string,
      dailyRewardId: string,
      data: DailyRewardUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DailyRewardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/daily_rewards/${dailyRewardId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Daily Rewards
     * @name DeleteDailyReward
     * @summary Delete Daily Reward
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/daily_rewards/{daily_reward_id}
     * @secure
     */
    deleteDailyReward: (companyId: string, gameId: string, dailyRewardId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/daily_rewards/${dailyRewardId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Banners
     * @name GetUserBanners
     * @summary Get User Banners
     * @request GET:/v1/companies/{company_id}/games/{game_id}/user_banners/{user_id}
     * @secure
     */
    getUserBanners: (userId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<UserBanner[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user_banners/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Banners
     * @name DeleteUserBanner
     * @summary Delete User Banner
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/user_banners/{user_banner_id}
     * @secure
     */
    deleteUserBanner: (userBannerId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/user_banners/${userBannerId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Promotions
     * @name GetUserPromotions
     * @summary Get User Promotions
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_promotions/user/{user_id}
     * @secure
     */
    getUserPromotions: (userId: string, companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<StorePromotionRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions/user/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Promotions
     * @name GetStorePromotion
     * @summary Get Store Promotion
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_promotions/{store_promotion_id}
     * @secure
     */
    getStorePromotion: (companyId: string, gameId: string, storePromotionId: string, params: RequestParams = {}) =>
      this.request<StorePromotionRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions/${storePromotionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Promotions
     * @name UpdateStorePromotion
     * @summary Update Store Promotion
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/store_promotions/{store_promotion_id}
     * @secure
     */
    updateStorePromotion: (
      companyId: string,
      gameId: string,
      storePromotionId: string,
      data: StorePromotionUpdate,
      params: RequestParams = {},
    ) =>
      this.request<StorePromotionRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions/${storePromotionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Promotions
     * @name DeleteStorePromotion
     * @summary Delete Store Promotion
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/store_promotions/{store_promotion_id}
     * @secure
     */
    deleteStorePromotion: (companyId: string, gameId: string, storePromotionId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions/${storePromotionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Promotions
     * @name GetStorePromotions
     * @summary Get Store Promotions
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_promotions
     * @secure
     */
    getStorePromotions: ({ companyId, gameId, ...query }: GetStorePromotionsParams, params: RequestParams = {}) =>
      this.request<StorePromotionRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Promotions
     * @name CreateStorePromotion
     * @summary Create Store Promotion
     * @request POST:/v1/companies/{company_id}/games/{game_id}/store_promotions
     * @secure
     */
    createStorePromotion: (companyId: string, gameId: string, data: StorePromotionCreate, params: RequestParams = {}) =>
      this.request<StorePromotionRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates multiple items.
     *
     * @tags Store Promotions
     * @name BulkUpdateStorePromotions
     * @summary Bulk Update Store Promotions
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/store_promotions
     * @secure
     */
    bulkUpdateStorePromotions: (
      companyId: string,
      gameId: string,
      data: StorePromotionBulkUpdate[],
      params: RequestParams = {},
    ) =>
      this.request<StorePromotionRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Store Promotions, Private
     * @name GetCountStorePromotions
     * @summary Get Count Store Promotions
     * @request GET:/v1/companies/{company_id}/games/{game_id}/store_promotions/count
     * @secure
     */
    getCountStorePromotions: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<StorePromotionCount, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/store_promotions/count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugin Instance
     * @name GetPluginsByState
     * @summary Get Plugins By State
     * @request GET:/v1/companies/{company_id}/games/{game_id}/plugin_instances
     * @secure
     */
    getPluginsByState: ({ companyId, gameId, ...query }: GetPluginsByStateParams, params: RequestParams = {}) =>
      this.request<PluginInstanceRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugin_instances`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugin Instance
     * @name GetPluginInstance
     * @summary Get Plugin Instance
     * @request GET:/v1/companies/{company_id}/games/{game_id}/plugin_instances/{plugin_slug}
     * @secure
     */
    getPluginInstance: (companyId: string, gameId: string, pluginSlug: string, params: RequestParams = {}) =>
      this.request<PluginInstanceRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugin_instances/${pluginSlug}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugin Instance
     * @name UpdatePlugin
     * @summary Update Plugin
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/plugin_instances/{plugin_slug}
     * @secure
     */
    updatePlugin: (
      companyId: string,
      gameId: string,
      pluginSlug: string,
      data: PluginInstanceUpdate,
      params: RequestParams = {},
    ) =>
      this.request<PluginInstanceRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugin_instances/${pluginSlug}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugin Instance
     * @name InstallPlugin
     * @summary Install Plugin
     * @request POST:/v1/companies/{company_id}/games/{game_id}/plugin_instances/{plugin_slug}
     * @secure
     */
    installPlugin: (
      companyId: string,
      gameId: string,
      pluginSlug: string,
      data: PluginInstanceCreate,
      params: RequestParams = {},
    ) =>
      this.request<PluginInstanceRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugin_instances/${pluginSlug}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugin Instance
     * @name UninstallPlugin
     * @summary Uninstall Plugin
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/plugin_instances/{plugin_slug}
     * @secure
     */
    uninstallPlugin: (companyId: string, gameId: string, pluginSlug: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugin_instances/${pluginSlug}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugin Instance
     * @name RunPlugin
     * @summary Run Plugin
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/plugin_instances/{plugin_slug}
     * @secure
     */
    runPlugin: (companyId: string, gameId: string, pluginSlug: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugin_instances/${pluginSlug}`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugins
     * @name GetAllPlugins
     * @summary Get All Plugins
     * @request GET:/v1/companies/{company_id}/games/{game_id}/plugins
     * @secure
     */
    getAllPlugins: ({ companyId, gameId, ...query }: GetAllPluginsParams, params: RequestParams = {}) =>
      this.request<PluginRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugins`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugins
     * @name GetPluginBySlug
     * @summary Get Plugin By Slug
     * @request GET:/v1/companies/{company_id}/games/{game_id}/plugins/{plugin_slug}
     * @secure
     */
    getPluginBySlug: (companyId: string, gameId: string, pluginSlug: string, params: RequestParams = {}) =>
      this.request<PluginRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/plugins/${pluginSlug}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list jobs.
     *
     * @tags Jobs
     * @name GetJobs
     * @summary Get Jobs
     * @request GET:/v1/companies/{company_id}/games/{game_id}/jobs
     * @secure
     */
    getJobs: ({ companyId, gameId, ...query }: GetJobsParams, params: RequestParams = {}) =>
      this.request<JobRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/jobs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new job.
     *
     * @tags Jobs
     * @name CreateJob
     * @summary Create Job
     * @request POST:/v1/companies/{company_id}/games/{game_id}/jobs
     * @secure
     */
    createJob: (companyId: string, gameId: string, data: JobCreate, params: RequestParams = {}) =>
      this.request<JobRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/jobs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a job.
     *
     * @tags Jobs
     * @name GetJob
     * @summary Get Job
     * @request GET:/v1/companies/{company_id}/games/{game_id}/jobs/{job_id}
     * @secure
     */
    getJob: (companyId: string, gameId: string, jobId: string, params: RequestParams = {}) =>
      this.request<JobRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/jobs/${jobId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancels a job.
     *
     * @tags Jobs
     * @name CancelJob
     * @summary Cancel Job
     * @request POST:/v1/companies/{company_id}/games/{game_id}/jobs/{job_id}/cancel
     * @secure
     */
    cancelJob: (companyId: string, gameId: string, jobId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/jobs/${jobId}/cancel`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Returns a list of translation glossaries.
     *
     * @tags Translation Glossaries
     * @name GetTranslationGlossaries
     * @summary Get Translation Glossaries
     * @request GET:/v1/companies/{company_id}/games/{game_id}/translation_glossaries
     * @secure
     */
    getTranslationGlossaries: (
      { companyId, gameId, ...query }: GetTranslationGlossariesParams,
      params: RequestParams = {},
    ) =>
      this.request<InfinitePaginatedResponseTranslationGlossaryRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translation_glossaries`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new translation glossary.
     *
     * @tags Translation Glossaries
     * @name CreateTranslationGlossary
     * @summary Create Translation Glossary
     * @request POST:/v1/companies/{company_id}/games/{game_id}/translation_glossaries
     * @secure
     */
    createTranslationGlossary: (
      companyId: string,
      gameId: string,
      data: TranslationGlossaryCreate,
      params: RequestParams = {},
    ) =>
      this.request<TranslationGlossaryRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translation_glossaries`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single translation glossary.
     *
     * @tags Translation Glossaries
     * @name GetTranslationGlossary
     * @summary Get Translation Glossary
     * @request GET:/v1/companies/{company_id}/games/{game_id}/translation_glossaries/{translation_glossary_id}
     * @secure
     */
    getTranslationGlossary: (
      companyId: string,
      gameId: string,
      translationGlossaryId: string,
      params: RequestParams = {},
    ) =>
      this.request<TranslationGlossaryRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translation_glossaries/${translationGlossaryId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a translation glossary.
     *
     * @tags Translation Glossaries
     * @name UpdateTranslationGlossary
     * @summary Update Translation Glossary
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/translation_glossaries/{translation_glossary_id}
     * @secure
     */
    updateTranslationGlossary: (
      companyId: string,
      gameId: string,
      translationGlossaryId: string,
      data: TranslationGlossaryUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TranslationGlossaryRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translation_glossaries/${translationGlossaryId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a translation glossary.
     *
     * @tags Translation Glossaries
     * @name DeleteTranslationGlossary
     * @summary Delete Translation Glossary
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/translation_glossaries/{translation_glossary_id}
     * @secure
     */
    deleteTranslationGlossary: (
      companyId: string,
      gameId: string,
      translationGlossaryId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/translation_glossaries/${translationGlossaryId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI
     * @name CreateImage
     * @summary Create Image
     * @request POST:/v1/companies/{company_id}/games/{game_id}/ai/create_image
     * @secure
     */
    createImage: (companyId: string, gameId: string, data: CreateImageRequest, params: RequestParams = {}) =>
      this.request<CreateImageResponse, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/ai/create_image`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI
     * @name GetCompletion
     * @summary Get Completion
     * @request POST:/v1/companies/{company_id}/games/{game_id}/ai/get_completion
     * @secure
     */
    getCompletion: (companyId: string, gameId: string, data: GetCompletionRequest, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/ai/get_completion`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI
     * @name GetTranslation2
     * @summary Get Translation
     * @request POST:/v1/companies/{company_id}/games/{game_id}/ai/get_translation
     * @originalName getTranslation
     * @duplicate
     * @secure
     */
    getTranslation2: (companyId: string, gameId: string, data: TranslateTextRequest, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/ai/get_translation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Website Templates
     * @name GetWebsiteTemplates
     * @summary Get Website Templates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/website_templates
     * @secure
     */
    getWebsiteTemplates: ({ companyId, gameId, ...query }: GetWebsiteTemplatesParams, params: RequestParams = {}) =>
      this.request<WebsiteTemplateRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/website_templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Website Templates
     * @name CreateWebsiteTemplate
     * @summary Create Website Template
     * @request POST:/v1/companies/{company_id}/games/{game_id}/website_templates
     * @secure
     */
    createWebsiteTemplate: (
      companyId: string,
      gameId: string,
      data: WebsiteTemplateCreate,
      params: RequestParams = {},
    ) =>
      this.request<WebsiteTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/website_templates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Website Templates
     * @name GetWebsiteTemplate
     * @summary Get Website Template
     * @request GET:/v1/companies/{company_id}/games/{game_id}/website_templates/{website_template_id}
     * @secure
     */
    getWebsiteTemplate: (companyId: string, gameId: string, websiteTemplateId: string, params: RequestParams = {}) =>
      this.request<WebsiteTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/website_templates/${websiteTemplateId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Website Templates
     * @name UpdateWebsiteTemplate
     * @summary Update Website Template
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/website_templates/{website_template_id}
     * @secure
     */
    updateWebsiteTemplate: (
      companyId: string,
      gameId: string,
      websiteTemplateId: string,
      data: WebsiteTemplateUpdate,
      params: RequestParams = {},
    ) =>
      this.request<WebsiteTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/website_templates/${websiteTemplateId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Website Templates
     * @name DeleteWebsiteTemplate
     * @summary Delete Website Template
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/website_templates/{website_template_id}
     * @secure
     */
    deleteWebsiteTemplate: (companyId: string, gameId: string, websiteTemplateId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/website_templates/${websiteTemplateId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cashback Reward
     * @name GetCashbackRewards
     * @summary Get Cashback Rewards
     * @request GET:/v1/companies/{company_id}/games/{game_id}/cashback_rewards
     * @secure
     */
    getCashbackRewards: ({ companyId, gameId, ...query }: GetCashbackRewardsParams, params: RequestParams = {}) =>
      this.request<CashbackRewardRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/cashback_rewards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cashback Reward
     * @name CreateCashbackReward
     * @summary Create Cashback Reward
     * @request POST:/v1/companies/{company_id}/games/{game_id}/cashback_rewards
     * @secure
     */
    createCashbackReward: (companyId: string, gameId: string, data: CashbackRewardCreate, params: RequestParams = {}) =>
      this.request<CashbackRewardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/cashback_rewards`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cashback Reward
     * @name GetCashbackReward
     * @summary Get Cashback Reward
     * @request GET:/v1/companies/{company_id}/games/{game_id}/cashback_rewards/{cashback_reward_id}
     * @secure
     */
    getCashbackReward: (companyId: string, gameId: string, cashbackRewardId: string, params: RequestParams = {}) =>
      this.request<CashbackRewardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/cashback_rewards/${cashbackRewardId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cashback Reward
     * @name UpdateCashbackReward
     * @summary Update Cashback Reward
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/cashback_rewards/{cashback_reward_id}
     * @secure
     */
    updateCashbackReward: (
      companyId: string,
      gameId: string,
      cashbackRewardId: string,
      data: CashbackRewardUpdate,
      params: RequestParams = {},
    ) =>
      this.request<CashbackRewardRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/cashback_rewards/${cashbackRewardId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cashback Reward
     * @name DeleteCashbackReward
     * @summary Delete Cashback Reward
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/cashback_rewards/{cashback_reward_id}
     * @secure
     */
    deleteCashbackReward: (companyId: string, gameId: string, cashbackRewardId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/cashback_rewards/${cashbackRewardId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Rarity
     * @name GetItemRarities
     * @summary Get Item Rarities
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_rarities
     * @secure
     */
    getItemRarities: ({ companyId, gameId, ...query }: GetItemRaritiesParams, params: RequestParams = {}) =>
      this.request<ItemRarityRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_rarities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Rarity
     * @name CreateItemRarity
     * @summary Create Item Rarity
     * @request POST:/v1/companies/{company_id}/games/{game_id}/item_rarities
     * @secure
     */
    createItemRarity: (companyId: string, gameId: string, data: ItemRarityCreate, params: RequestParams = {}) =>
      this.request<ItemRarityRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_rarities`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Rarity
     * @name GetItemRarity
     * @summary Get Item Rarity
     * @request GET:/v1/companies/{company_id}/games/{game_id}/item_rarities/{item_rarity_id}
     * @secure
     */
    getItemRarity: (companyId: string, gameId: string, itemRarityId: string, params: RequestParams = {}) =>
      this.request<ItemRarityRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_rarities/${itemRarityId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Rarity
     * @name UpdateItemRarity
     * @summary Update Item Rarity
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/item_rarities/{item_rarity_id}
     * @secure
     */
    updateItemRarity: (
      companyId: string,
      gameId: string,
      itemRarityId: string,
      data: ItemRarityUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ItemRarityRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_rarities/${itemRarityId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item Rarity
     * @name DeleteItemRarity
     * @summary Delete Item Rarity
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/item_rarities/{item_rarity_id}
     * @secure
     */
    deleteItemRarity: (companyId: string, gameId: string, itemRarityId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/item_rarities/${itemRarityId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lootboxes
     * @name GetLootboxes
     * @summary Get Lootboxes
     * @request GET:/v1/companies/{company_id}/games/{game_id}/lootboxes
     * @secure
     */
    getLootboxes: ({ companyId, gameId, ...query }: GetLootboxesParams, params: RequestParams = {}) =>
      this.request<LootboxRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/lootboxes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lootboxes
     * @name CreateLootbox
     * @summary Create Lootbox
     * @request POST:/v1/companies/{company_id}/games/{game_id}/lootboxes
     * @secure
     */
    createLootbox: (companyId: string, gameId: string, data: LootboxCreate, params: RequestParams = {}) =>
      this.request<LootboxRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/lootboxes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates multiple items.
     *
     * @tags Lootboxes
     * @name BulkUpdateLootboxes
     * @summary Bulk Update Lootboxes
     * @request PATCH:/v1/companies/{company_id}/games/{game_id}/lootboxes
     * @secure
     */
    bulkUpdateLootboxes: (companyId: string, gameId: string, data: LootboxBulkUpdate[], params: RequestParams = {}) =>
      this.request<LootboxRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/lootboxes`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lootboxes
     * @name GetLootbox
     * @summary Get Lootbox
     * @request GET:/v1/companies/{company_id}/games/{game_id}/lootboxes/{lootbox_id}
     * @secure
     */
    getLootbox: (companyId: string, gameId: string, lootboxId: string, params: RequestParams = {}) =>
      this.request<LootboxRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/lootboxes/${lootboxId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lootboxes
     * @name UpdateLootbox
     * @summary Update Lootbox
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/lootboxes/{lootbox_id}
     * @secure
     */
    updateLootbox: (
      companyId: string,
      gameId: string,
      lootboxId: string,
      data: LootboxUpdate,
      params: RequestParams = {},
    ) =>
      this.request<LootboxRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/lootboxes/${lootboxId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lootboxes
     * @name DeleteLootbox
     * @summary Delete Lootbox
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/lootboxes/{lootbox_id}
     * @secure
     */
    deleteLootbox: (companyId: string, gameId: string, lootboxId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/lootboxes/${lootboxId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sequential offers
     * @name GetSequentialOffer
     * @summary Get Sequential Offer
     * @request GET:/v1/companies/{company_id}/games/{game_id}/sequential_offers/{sequential_offer_id}
     * @secure
     */
    getSequentialOffer: (companyId: string, gameId: string, sequentialOfferId: string, params: RequestParams = {}) =>
      this.request<SequentialOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/sequential_offers/${sequentialOfferId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sequential offers
     * @name UpdateSequentialOffer
     * @summary Update Sequential Offer
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/sequential_offers/{sequential_offer_id}
     * @secure
     */
    updateSequentialOffer: (
      companyId: string,
      gameId: string,
      sequentialOfferId: string,
      data: SequentialOfferUpdate,
      params: RequestParams = {},
    ) =>
      this.request<SequentialOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/sequential_offers/${sequentialOfferId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sequential offers
     * @name DeleteSequentialOffer
     * @summary Delete Sequential Offer
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/sequential_offers/{sequential_offer_id}
     * @secure
     */
    deleteSequentialOffer: (companyId: string, gameId: string, sequentialOfferId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/sequential_offers/${sequentialOfferId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sequential offers
     * @name GetSequentialOffers
     * @summary Get Sequential Offers
     * @request GET:/v1/companies/{company_id}/games/{game_id}/sequential_offers
     * @secure
     */
    getSequentialOffers: ({ companyId, gameId, ...query }: GetSequentialOffersParams, params: RequestParams = {}) =>
      this.request<SequentialOfferRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/sequential_offers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sequential offers
     * @name CreateSequentialOffer
     * @summary Create Sequential Offer
     * @request POST:/v1/companies/{company_id}/games/{game_id}/sequential_offers
     * @secure
     */
    createSequentialOffer: (
      companyId: string,
      gameId: string,
      data: SequentialOfferCreate,
      params: RequestParams = {},
    ) =>
      this.request<SequentialOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/sequential_offers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Range offers
     * @name GetRangeOffer
     * @summary Get Range Offer
     * @request GET:/v1/companies/{company_id}/games/{game_id}/range_offers/{range_offer_id}
     * @secure
     */
    getRangeOffer: (companyId: string, gameId: string, rangeOfferId: string, params: RequestParams = {}) =>
      this.request<RangeOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/range_offers/${rangeOfferId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Range offers
     * @name UpdateRangeOffer
     * @summary Update Range Offer
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/range_offers/{range_offer_id}
     * @secure
     */
    updateRangeOffer: (
      companyId: string,
      gameId: string,
      rangeOfferId: string,
      data: RangeOfferUpdate,
      params: RequestParams = {},
    ) =>
      this.request<RangeOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/range_offers/${rangeOfferId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Range offers
     * @name DeleteRangeOffer
     * @summary Delete Range Offer
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/range_offers/{range_offer_id}
     * @secure
     */
    deleteRangeOffer: (companyId: string, gameId: string, rangeOfferId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/range_offers/${rangeOfferId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Range offers
     * @name GetRangeOffers
     * @summary Get Range Offers
     * @request GET:/v1/companies/{company_id}/games/{game_id}/range_offers
     * @secure
     */
    getRangeOffers: ({ companyId, gameId, ...query }: GetRangeOffersParams, params: RequestParams = {}) =>
      this.request<RangeOfferRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/range_offers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Range offers
     * @name CreateRangeOffer
     * @summary Create Range Offer
     * @request POST:/v1/companies/{company_id}/games/{game_id}/range_offers
     * @secure
     */
    createRangeOffer: (companyId: string, gameId: string, data: RangeOfferCreate, params: RequestParams = {}) =>
      this.request<RangeOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/range_offers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Progression Programs
     * @name GetProgressionPrograms
     * @summary Get Progression Programs
     * @request GET:/v1/companies/{company_id}/games/{game_id}/progression_programs
     * @secure
     */
    getProgressionPrograms: (
      { companyId, gameId, ...query }: GetProgressionProgramsParams,
      params: RequestParams = {},
    ) =>
      this.request<ProgressionProgramRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/progression_programs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Progression Programs
     * @name CreateProgressionProgram
     * @summary Create Progression Program
     * @request POST:/v1/companies/{company_id}/games/{game_id}/progression_programs
     * @secure
     */
    createProgressionProgram: (
      companyId: string,
      gameId: string,
      data: ProgressionProgramCreate,
      params: RequestParams = {},
    ) =>
      this.request<ProgressionProgramRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/progression_programs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Progression Programs
     * @name GetProgressionProgram
     * @summary Get Progression Program
     * @request GET:/v1/companies/{company_id}/games/{game_id}/progression_programs/{progression_program_id}
     * @secure
     */
    getProgressionProgram: (
      companyId: string,
      gameId: string,
      progressionProgramId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProgressionProgramRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/progression_programs/${progressionProgramId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Progression Programs
     * @name UpdateProgressionProgram
     * @summary Update Progression Program
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/progression_programs/{progression_program_id}
     * @secure
     */
    updateProgressionProgram: (
      companyId: string,
      gameId: string,
      progressionProgramId: string,
      data: ProgressionProgramUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ProgressionProgramRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/progression_programs/${progressionProgramId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Progression Programs
     * @name DeleteProgressionProgram
     * @summary Delete Progression Program
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/progression_programs/{progression_program_id}
     * @secure
     */
    deleteProgressionProgram: (
      companyId: string,
      gameId: string,
      progressionProgramId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/progression_programs/${progressionProgramId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Card templates
     * @name GetCardTemplate
     * @summary Get Card Template
     * @request GET:/v1/companies/{company_id}/games/{game_id}/card_templates/{card_template_id}
     * @secure
     */
    getCardTemplate: (companyId: string, gameId: string, cardTemplateId: string, params: RequestParams = {}) =>
      this.request<CardTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/card_templates/${cardTemplateId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Card templates
     * @name UpdateCardTemplate
     * @summary Update Card Template
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/card_templates/{card_template_id}
     * @secure
     */
    updateCardTemplate: (
      companyId: string,
      gameId: string,
      cardTemplateId: string,
      data: CardTemplateUpdate,
      params: RequestParams = {},
    ) =>
      this.request<CardTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/card_templates/${cardTemplateId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Card templates
     * @name DeleteCardTemplate
     * @summary Delete Card Template
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/card_templates/{card_template_id}
     * @secure
     */
    deleteCardTemplate: (companyId: string, gameId: string, cardTemplateId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/card_templates/${cardTemplateId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Card templates
     * @name GetCardTemplates
     * @summary Get Card Templates
     * @request GET:/v1/companies/{company_id}/games/{game_id}/card_templates
     * @secure
     */
    getCardTemplates: ({ companyId, gameId, ...query }: GetCardTemplatesParams, params: RequestParams = {}) =>
      this.request<CardTemplateRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/card_templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Card templates
     * @name CreateCardTemplate
     * @summary Create Card Template
     * @request POST:/v1/companies/{company_id}/games/{game_id}/card_templates
     * @secure
     */
    createCardTemplate: (companyId: string, gameId: string, data: CardTemplateCreate, params: RequestParams = {}) =>
      this.request<CardTemplateRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/card_templates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rolling offers
     * @name GetRollingOffer
     * @summary Get Rolling Offer
     * @request GET:/v1/companies/{company_id}/games/{game_id}/rolling_offers/{rolling_offer_id}
     * @secure
     */
    getRollingOffer: (companyId: string, gameId: string, rollingOfferId: string, params: RequestParams = {}) =>
      this.request<RollingOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/rolling_offers/${rollingOfferId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rolling offers
     * @name UpdateRollingOffer
     * @summary Update Rolling Offer
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/rolling_offers/{rolling_offer_id}
     * @secure
     */
    updateRollingOffer: (
      companyId: string,
      gameId: string,
      rollingOfferId: string,
      data: RollingOfferUpdate,
      params: RequestParams = {},
    ) =>
      this.request<RollingOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/rolling_offers/${rollingOfferId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rolling offers
     * @name DeleteRollingOffer
     * @summary Delete Rolling Offer
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/rolling_offers/{rolling_offer_id}
     * @secure
     */
    deleteRollingOffer: (companyId: string, gameId: string, rollingOfferId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/rolling_offers/${rollingOfferId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rolling offers
     * @name GetRollingOffers
     * @summary Get Rolling Offers
     * @request GET:/v1/companies/{company_id}/games/{game_id}/rolling_offers
     * @secure
     */
    getRollingOffers: ({ companyId, gameId, ...query }: GetRollingOffersParams, params: RequestParams = {}) =>
      this.request<RollingOfferRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/rolling_offers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Rolling offers
     * @name CreateRollingOffer
     * @summary Create Rolling Offer
     * @request POST:/v1/companies/{company_id}/games/{game_id}/rolling_offers
     * @secure
     */
    createRollingOffer: (companyId: string, gameId: string, data: RollingOfferCreate, params: RequestParams = {}) =>
      this.request<RollingOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/rolling_offers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pick One offers
     * @name GetPickOneOffer
     * @summary Get Pick One Offer
     * @request GET:/v1/companies/{company_id}/games/{game_id}/pick_one_offers/{pick_one_offer_id}
     * @secure
     */
    getPickOneOffer: (companyId: string, gameId: string, pickOneOfferId: string, params: RequestParams = {}) =>
      this.request<PickOneOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pick_one_offers/${pickOneOfferId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pick One offers
     * @name UpdatePickOneOffer
     * @summary Update Pick One Offer
     * @request PUT:/v1/companies/{company_id}/games/{game_id}/pick_one_offers/{pick_one_offer_id}
     * @secure
     */
    updatePickOneOffer: (
      companyId: string,
      gameId: string,
      pickOneOfferId: string,
      data: PickOneOfferUpdate,
      params: RequestParams = {},
    ) =>
      this.request<PickOneOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pick_one_offers/${pickOneOfferId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pick One offers
     * @name DeletePickOneOffer
     * @summary Delete Pick One Offer
     * @request DELETE:/v1/companies/{company_id}/games/{game_id}/pick_one_offers/{pick_one_offer_id}
     * @secure
     */
    deletePickOneOffer: (companyId: string, gameId: string, pickOneOfferId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pick_one_offers/${pickOneOfferId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pick One offers
     * @name GetPickOneOffers
     * @summary Get Pick One Offers
     * @request GET:/v1/companies/{company_id}/games/{game_id}/pick_one_offers
     * @secure
     */
    getPickOneOffers: ({ companyId, gameId, ...query }: GetPickOneOffersParams, params: RequestParams = {}) =>
      this.request<PickOneOfferRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pick_one_offers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pick One offers
     * @name CreatePickOneOffer
     * @summary Create Pick One Offer
     * @request POST:/v1/companies/{company_id}/games/{game_id}/pick_one_offers
     * @secure
     */
    createPickOneOffer: (companyId: string, gameId: string, data: PickOneOfferCreate, params: RequestParams = {}) =>
      this.request<PickOneOfferRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/pick_one_offers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name GetAllOffers
     * @summary Get All Offers
     * @request GET:/v1/companies/{company_id}/games/{game_id}/offers
     * @secure
     */
    getAllOffers: ({ companyId, gameId, ...query }: GetAllOffersParams, params: RequestParams = {}) =>
      this.request<OfferRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/games/${gameId}/offers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company Profile
     * @name GetCompanyProfile
     * @summary Get Company Profile
     * @request GET:/v1/companies/{company_id}/profiles/me
     * @secure
     */
    getCompanyProfile: (companyId: string, params: RequestParams = {}) =>
      this.request<CustomerCompany, HTTPValidationError>({
        path: `/v1/companies/${companyId}/profiles/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name GetCompanyInvites
     * @summary Get Company Invites
     * @request GET:/v1/companies/{company_id}/invites
     * @secure
     */
    getCompanyInvites: ({ companyId, ...query }: GetCompanyInvitesParams, params: RequestParams = {}) =>
      this.request<InviteRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/invites`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name GetOrCreateInvites
     * @summary Get Or Create Invites
     * @request POST:/v1/companies/{company_id}/invites
     * @secure
     */
    getOrCreateInvites: (companyId: string, data: InviteCreate[] | InviteCreate, params: RequestParams = {}) =>
      this.request<InviteRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/invites`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name ResendInvite
     * @summary Resend Invite
     * @request POST:/v1/companies/{company_id}/invites/{invite_id}/resend
     * @secure
     */
    resendInvite: (companyId: string, inviteId: string, params: RequestParams = {}) =>
      this.request<InviteRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/invites/${inviteId}/resend`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name RemoveInvite
     * @summary Remove Invite
     * @request DELETE:/v1/companies/{company_id}/invites/{invite_id}
     * @secure
     */
    removeInvite: (companyId: string, inviteId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/invites/${inviteId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompanies
     * @summary Get Companies
     * @request GET:/v1/companies
     * @secure
     */
    getCompanies: (params: RequestParams = {}) =>
      this.request<PersonalCompany[], any>({
        path: `/v1/companies`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name CreateCompany
     * @summary Create Company
     * @request POST:/v1/companies
     * @secure
     */
    createCompany: (data: CompanyCreate, params: RequestParams = {}) =>
      this.request<Company, HTTPValidationError>({
        path: `/v1/companies`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompanyGames
     * @summary Get Company Games
     * @request GET:/v1/companies/games
     * @secure
     */
    getCompanyGames: (query: GetCompanyGamesParams, params: RequestParams = {}) =>
      this.request<CompanyGame[], HTTPValidationError>({
        path: `/v1/companies/games`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetAllCompanyGames
     * @summary Get All Company Games
     * @request GET:/v1/companies/all_games
     * @secure
     */
    getAllCompanyGames: (query: GetAllCompanyGamesParams, params: RequestParams = {}) =>
      this.request<InfinitePaginatedResponseCompanyGame, HTTPValidationError>({
        path: `/v1/companies/all_games`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompany
     * @summary Get Company
     * @request GET:/v1/companies/{company_id}
     * @secure
     */
    getCompany: (companyId: string, params: RequestParams = {}) =>
      this.request<PersonalCompany, any>({
        path: `/v1/companies/${companyId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name UpdateCompany
     * @summary Update Company
     * @request PUT:/v1/companies/{company_id}
     * @secure
     */
    updateCompany: (companyId: string, data: CompanyUpdate, params: RequestParams = {}) =>
      this.request<Company, HTTPValidationError>({
        path: `/v1/companies/${companyId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name DeleteCompany
     * @summary Delete Company
     * @request DELETE:/v1/companies/{company_id}
     * @secure
     */
    deleteCompany: (companyId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/companies/${companyId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompanyMembers
     * @summary Get Company Members
     * @request GET:/v1/companies/{company_id}/members
     * @secure
     */
    getCompanyMembers: ({ companyId, ...query }: GetCompanyMembersParams, params: RequestParams = {}) =>
      this.request<CustomerCompanyRead[], HTTPValidationError>({
        path: `/v1/companies/${companyId}/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompanyMember
     * @summary Get Company Member
     * @request GET:/v1/companies/{company_id}/members/{member_id}
     * @secure
     */
    getCompanyMember: (memberId: string, companyId: string, params: RequestParams = {}) =>
      this.request<CustomerCompanyRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/members/${memberId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name UpdateMember
     * @summary Update Member
     * @request PUT:/v1/companies/{company_id}/members/{member_id}
     * @secure
     */
    updateMember: (memberId: string, companyId: string, data: CustomerCompanyUpdate, params: RequestParams = {}) =>
      this.request<CustomerCompanyRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/members/${memberId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name RemoveMemberFromCompany
     * @summary Remove Member From Company
     * @request DELETE:/v1/companies/{company_id}/members/{member_id}
     * @secure
     */
    removeMemberFromCompany: (memberId: string, companyId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/companies/${companyId}/members/${memberId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name CreateFileUploadLink
     * @summary Create File Upload Link
     * @request POST:/v1/files/create_upload_link
     * @secure
     */
    createFileUploadLink: (data: CreateUploadLinkRequest, params: RequestParams = {}) =>
      this.request<CreateUploadLinkResponse, HTTPValidationError>({
        path: `/v1/files/create_upload_link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Details
     * @name GetAccountDetails
     * @summary Get Account Details
     * @request GET:/v1/companies/{company_id}/account_details
     * @secure
     */
    getAccountDetails: (companyId: string, params: RequestParams = {}) =>
      this.request<AccountRead, HTTPValidationError>({
        path: `/v1/companies/${companyId}/account_details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Details
     * @name EditAccountDetails
     * @summary Edit Account Details
     * @request PUT:/v1/companies/{company_id}/account_details
     * @secure
     */
    editAccountDetails: (companyId: string, data: AccountDetails, params: RequestParams = {}) =>
      this.request<AccountDetails, HTTPValidationError>({
        path: `/v1/companies/${companyId}/account_details`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Details
     * @name SubmitAccountDetailsForReview
     * @summary Submit Account Details For Review
     * @request POST:/v1/companies/{company_id}/account_details/submit_for_review
     * @secure
     */
    submitAccountDetailsForReview: (companyId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/companies/${companyId}/account_details/submit_for_review`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Onboarding
     * @name OnboardGame
     * @summary Onboard Game
     * @request POST:/v1/companies/onboarding
     * @secure
     */
    onboardGame: (data: OnBoardingRequest, params: RequestParams = {}) =>
      this.request<OnBoardingResponse, HTTPValidationError>({
        path: `/v1/companies/onboarding`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Onboarding
     * @name GetPalettes
     * @summary Get Palettes
     * @request GET:/v1/companies/onboarding/palettes
     * @secure
     */
    getPalettes: (params: RequestParams = {}) =>
      this.request<Palette[], any>({
        path: `/v1/companies/onboarding/palettes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name GetMyProfile
     * @summary Get My Profile
     * @request GET:/v1/profiles/me
     * @secure
     */
    getMyProfile: (params: RequestParams = {}) =>
      this.request<Customer, any>({
        path: `/v1/profiles/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profiles
     * @name UpdateProfile
     * @summary Update Profile
     * @request PUT:/v1/profiles/me
     * @secure
     */
    updateProfile: (data: ProfileUpdate, params: RequestParams = {}) =>
      this.request<Customer, HTTPValidationError>({
        path: `/v1/profiles/me`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name PostLogin
     * @summary Post Login
     * @request POST:/v1/auth/post_login
     * @secure
     */
    postLogin: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/auth/post_login`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Private, Hidden
     * @name UpdateTomatoesVersion
     * @summary Update Tomatoes Version
     * @request POST:/v1/admin/tomatoes
     * @secure
     */
    updateTomatoesVersion: (data: UpdateTomatoesVersionSchema, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/admin/tomatoes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Private, Hidden
     * @name ClearAnalyticsCache
     * @summary Clear Analytics Cache
     * @request POST:/v1/admin/clear_cache
     * @secure
     */
    clearAnalyticsCache: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/admin/clear_cache`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Private, Hidden
     * @name ClearAnalyticsCacheByGame
     * @summary Clear Analytics Cache By Game
     * @request POST:/v1/admin/{company_id}/{game_id}/clear_cache
     * @secure
     */
    clearAnalyticsCacheByGame: (gameId: string, companyId: string, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/admin/${companyId}/${gameId}/clear_cache`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Private, Hidden
     * @name ResetLeaderboardAvatars
     * @summary Reset Leaderboard Avatars
     * @request POST:/v1/admin/{company_id}/{game_id}/reset_leaderboard_avatars
     * @secure
     */
    resetLeaderboardAvatars: (companyId: string, gameId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/admin/${companyId}/${gameId}/reset_leaderboard_avatars`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin, Private, Hidden
     * @name TransferGame
     * @summary Transfer Game
     * @request POST:/v1/admin/{company_id}/{game_id}/transfer
     * @secure
     */
    transferGame: (companyId: string, gameId: string, data: TransferRequest, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/admin/${companyId}/${gameId}/transfer`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Websites
     * @name SearchWebsite
     * @summary Search Website
     * @request POST:/v1/websites/search_website
     * @secure
     */
    searchWebsite: (data: WebsiteSearchRequest, params: RequestParams = {}) =>
      this.request<WebsiteRead, HTTPValidationError>({
        path: `/v1/websites/search_website`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer display taxation
     * @name GetTaxes
     * @summary Get Taxes
     * @request GET:/v1/tax
     */
    getTaxes: (params: RequestParams = {}) =>
      this.request<TaxRead[], any>({
        path: `/v1/tax`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetMe
     * @summary Get Me
     * @request GET:/v1/customers/me
     * @secure
     */
    getMe: (params: RequestParams = {}) =>
      this.request<CustomerRead, any>({
        path: `/v1/customers/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetOutdatedAgreements
     * @summary Get Outdated Agreements
     * @request GET:/v1/customers/me/outdated_agreements
     * @secure
     */
    getOutdatedAgreements: (params: RequestParams = {}) =>
      this.request<OutdatedAgreements, any>({
        path: `/v1/customers/me/outdated_agreements`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of coupons.
     *
     * @tags Customers
     * @name AcceptAgreements
     * @summary Accept Agreements
     * @request POST:/v1/customers/me/accept_agreements
     * @secure
     */
    acceptAgreements: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/customers/me/accept_agreements`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name CheckDocsAccess
     * @summary Check Docs Access
     * @request POST:/v1/customers/check_docs_access
     */
    checkDocsAccess: (data: CheckDocsAccessRequest, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/v1/customers/check_docs_access`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name GetMyLead
     * @summary Get My Lead
     * @request GET:/v1/leads/me
     * @secure
     */
    getMyLead: (params: RequestParams = {}) =>
      this.request<LeadRead, any>({
        path: `/v1/leads/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Leads
     * @name CreateOrUpdateLead
     * @summary Create Or Update Lead
     * @request PUT:/v1/leads
     * @secure
     */
    createOrUpdateLead: (data: LeadCreateOrUpdate, params: RequestParams = {}) =>
      this.request<LeadRead, HTTPValidationError>({
        path: `/v1/leads`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name DeclineInvite
     * @summary Decline Invite
     * @request DELETE:/v1/invites/decline/{invite_id}
     * @secure
     */
    declineInvite: (inviteId: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/invites/decline/${inviteId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name AcceptInvite
     * @summary Accept Invite
     * @request POST:/v1/invites/{invite_id}/accept
     * @secure
     */
    acceptInvite: (inviteId: string, params: RequestParams = {}) =>
      this.request<InviteAcceptResponse, HTTPValidationError>({
        path: `/v1/invites/${inviteId}/accept`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name GetMyInvite
     * @summary Get My Invite
     * @request GET:/v1/invites/me
     * @secure
     */
    getMyInvite: (params: RequestParams = {}) =>
      this.request<InvitePreview, any>({
        path: `/v1/invites/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name GetInvitePreview
     * @summary Get Invite Preview
     * @request GET:/v1/invites/{invite_id}
     * @secure
     */
    getInvitePreview: (inviteId: string, params: RequestParams = {}) =>
      this.request<InvitePreview, HTTPValidationError>({
        path: `/v1/invites/${inviteId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugins
     * @name GetAllPlugins2
     * @summary Get All Plugins
     * @request GET:/v1/plugins
     * @originalName getAllPlugins
     * @duplicate
     */
    getAllPlugins2: (query: GetAllPlugins2Params, params: RequestParams = {}) =>
      this.request<PluginRead[], HTTPValidationError>({
        path: `/v1/plugins`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plugins
     * @name GetPluginBySlug2
     * @summary Get Plugin By Slug
     * @request GET:/v1/plugins/{plugin_slug}
     * @originalName getPluginBySlug
     * @duplicate
     * @secure
     */
    getPluginBySlug2: (pluginSlug: string, params: RequestParams = {}) =>
      this.request<PluginRead, HTTPValidationError>({
        path: `/v1/plugins/${pluginSlug}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name CreatorRequestPayout
     * @summary Creator Request Payout
     * @request PATCH:/v1/creators/payout-request
     */
    creatorRequestPayout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/creators/payout-request`,
        method: 'PATCH',
        ...params,
      }),

    /**
     * No description
     *
     * @name CreatorGetLegality
     * @summary Creator Get Legality
     * @request PATCH:/v1/creators/terms/legality
     */
    creatorGetLegality: (data: CreatorTermsLegalityCondition, params: RequestParams = {}) =>
      this.request<CreatorTermsLegality, HTTPValidationError>({
        path: `/v1/creators/terms/legality`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name CreatorGetTerms
     * @summary Creator Get Terms
     * @request GET:/v1/creators/terms
     */
    creatorGetTerms: (params: RequestParams = {}) =>
      this.request<CreatorTermsRead, any>({
        path: `/v1/creators/terms`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name CreatorAcceptTerms
     * @summary Creator Accept Terms
     * @request PATCH:/v1/creators/terms
     */
    creatorAcceptTerms: (data: CreatorTermsCreate, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/v1/creators/terms`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
}
